/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * API V1
 * <h3>ページネーションについて</h3>
 *         ページ番号を指定する形式を採用しています。ページネーションに関するメタデータはヘッダーレスポンスに以下のように含まれます。<br>
 *         <a href="https://ddnexus.github.io/pagy/docs/extras/headers/#headers" target="_blank">https://ddnexus.github.io/pagy/docs/extras/headers/#headers</a><br>
 *         <br>
 *         <h3>画像について</h3>
 *         <a href="https://developer.mozilla.org/ja/docs/Web/URI/Schemes/data" target="_blank">Data URI</a>の形式で送信してください。
 * OpenAPI spec version: v1
 */
import useSwr from 'swr';
import type {
  Arguments,
  Key,
  SWRConfiguration
} from 'swr';

import useSWRMutation from 'swr/mutation';
import type {
  SWRMutationConfiguration
} from 'swr/mutation';

import type {
  BankAccount,
  DeleteApiV1ThreeLetterCodeInternalAdminsCategoriesId422,
  DeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId422,
  DeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdParams,
  Errors,
  GetApiV1DEFCompanyAdminsCompanyDepositsProvisional200,
  GetApiV1SdksPartner200,
  GetApiV1ThreeLetterCodeAppsAgreements200,
  GetApiV1ThreeLetterCodeAppsApplicationConfiguration200,
  GetApiV1ThreeLetterCodeAppsCategories200,
  GetApiV1ThreeLetterCodeAppsCategoriesCategoryIdServices200,
  GetApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesParams,
  GetApiV1ThreeLetterCodeAppsCategoriesParams,
  GetApiV1ThreeLetterCodeAppsClientFeatureFlags200,
  GetApiV1ThreeLetterCodeAppsClientNewsletters200,
  GetApiV1ThreeLetterCodeAppsClientNewslettersId200,
  GetApiV1ThreeLetterCodeAppsClientPortalItems200,
  GetApiV1ThreeLetterCodeAppsClients200,
  GetApiV1ThreeLetterCodeAppsCustomFieldDefinitions200,
  GetApiV1ThreeLetterCodeAppsCustomFieldDefinitionsParams,
  GetApiV1ThreeLetterCodeAppsGiftCardConfigs200,
  GetApiV1ThreeLetterCodeAppsGifteeBenefitOrders200,
  GetApiV1ThreeLetterCodeAppsGifteeBenefitOrdersParams,
  GetApiV1ThreeLetterCodeAppsGifteeBenefitVouchers200,
  GetApiV1ThreeLetterCodeAppsGifteeBenefitVouchersParams,
  GetApiV1ThreeLetterCodeAppsGifteeShopItems200,
  GetApiV1ThreeLetterCodeAppsGifteeShopItemsItemCode200,
  GetApiV1ThreeLetterCodeAppsGifteeShopItemsParams,
  GetApiV1ThreeLetterCodeAppsGifteeStoreUser200,
  GetApiV1ThreeLetterCodeAppsInesusStores200,
  GetApiV1ThreeLetterCodeAppsInesusStoresId200,
  GetApiV1ThreeLetterCodeAppsLinkUrls200,
  GetApiV1ThreeLetterCodeAppsMapsStores200,
  GetApiV1ThreeLetterCodeAppsMapsStoresParams,
  GetApiV1ThreeLetterCodeAppsPartnerFeatureFlags200,
  GetApiV1ThreeLetterCodeAppsPartnersSubdomain200,
  GetApiV1ThreeLetterCodeAppsPrefectures200,
  GetApiV1ThreeLetterCodeAppsServices200,
  GetApiV1ThreeLetterCodeAppsServicesFavorites200,
  GetApiV1ThreeLetterCodeAppsServicesId200,
  GetApiV1ThreeLetterCodeAppsServicesParams,
  GetApiV1ThreeLetterCodeAppsServicesSearch200,
  GetApiV1ThreeLetterCodeAppsServicesSearchParams,
  GetApiV1ThreeLetterCodeAppsServicesServiceIdAvailability200,
  GetApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatus200,
  GetApiV1ThreeLetterCodeAppsServicesUsages200,
  GetApiV1ThreeLetterCodeAppsStressAssessments200,
  GetApiV1ThreeLetterCodeAppsStressAssessmentsIdCategories200,
  GetApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesParams,
  GetApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestions200,
  GetApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsParams,
  GetApiV1ThreeLetterCodeAppsStressAssessmentsIdResult200,
  GetApiV1ThreeLetterCodeAppsStressAssessmentsIdResultParams,
  GetApiV1ThreeLetterCodeAppsStressAssessmentsParams,
  GetApiV1ThreeLetterCodeAppsTopBanners200,
  GetApiV1ThreeLetterCodeAppsUser200,
  GetApiV1ThreeLetterCodeAppsUserGifts200,
  GetApiV1ThreeLetterCodeAppsUserGiftsEligibility200,
  GetApiV1ThreeLetterCodeAppsUserGiftsParams,
  GetApiV1ThreeLetterCodeAppsUserProfile200,
  GetApiV1ThreeLetterCodeAppsUsersInvitationsInvitees200,
  GetApiV1ThreeLetterCodeAppsUsersNotifications200,
  GetApiV1ThreeLetterCodeAppsUsersNotificationsParams,
  GetApiV1ThreeLetterCodeAppsUsersPrompts200,
  GetApiV1ThreeLetterCodeAppsUsersPromptsParams,
  GetApiV1ThreeLetterCodeClientAdminsApplicationConfiguration200,
  GetApiV1ThreeLetterCodeClientAdminsBranches200,
  GetApiV1ThreeLetterCodeClientAdminsBranchesId200,
  GetApiV1ThreeLetterCodeClientAdminsBranchesParams,
  GetApiV1ThreeLetterCodeClientAdminsClient200,
  GetApiV1ThreeLetterCodeClientAdminsClientAdminUsers200,
  GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersId200,
  GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersParams,
  GetApiV1ThreeLetterCodeClientAdminsClientNewsletters200,
  GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatistics200,
  GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsParams,
  GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsers200,
  GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersParams,
  GetApiV1ThreeLetterCodeClientAdminsClientNewslettersId200,
  GetApiV1ThreeLetterCodeClientAdminsClientNewslettersParams,
  GetApiV1ThreeLetterCodeClientAdminsClientPortalItems200,
  GetApiV1ThreeLetterCodeClientAdminsClientPortalItemsId200,
  GetApiV1ThreeLetterCodeClientAdminsLinkUrls200,
  GetApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlags200,
  GetApiV1ThreeLetterCodeClientAdminsServiceUsages200One,
  GetApiV1ThreeLetterCodeClientAdminsServiceUsagesParams,
  GetApiV1ThreeLetterCodeClientAdminsStressAssessments200,
  GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategories200,
  GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummary200,
  GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsParams,
  GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatus200,
  GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStats200,
  GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResults200,
  GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsId200,
  GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsParams,
  GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswers200,
  GetApiV1ThreeLetterCodeClientAdminsStressCheckSchedule200,
  GetApiV1ThreeLetterCodeClientAdminsStripeCreditCard200,
  GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequests200,
  GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId200,
  GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsParams,
  GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRows200,
  GetApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogs200One,
  GetApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsParams,
  GetApiV1ThreeLetterCodeClientAdminsUsers200One,
  GetApiV1ThreeLetterCodeClientAdminsUsersId200,
  GetApiV1ThreeLetterCodeClientAdminsUsersParams,
  GetApiV1ThreeLetterCodeClientAdminsUsersUserIdProfile200,
  GetApiV1ThreeLetterCodeCompanyAdminsCompany200,
  GetApiV1ThreeLetterCodeCompanyAdminsCompanyDeposits200One,
  GetApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsParams,
  GetApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCoupons200,
  GetApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsParams,
  GetApiV1ThreeLetterCodeExternalsClients200One,
  GetApiV1ThreeLetterCodeExternalsClientsExternalClientId200,
  GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId200,
  GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers200,
  GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId200,
  GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersParams,
  GetApiV1ThreeLetterCodeExternalsClientsParams,
  GetApiV1ThreeLetterCodeExternalsGiftPlans200,
  GetApiV1ThreeLetterCodeExternalsGiftPlansParams,
  GetApiV1ThreeLetterCodeExternalsGifteePlans200,
  GetApiV1ThreeLetterCodeFreeeCallbackParams,
  GetApiV1ThreeLetterCodeInternalAdminsAgreements200,
  GetApiV1ThreeLetterCodeInternalAdminsAgreementsId200,
  GetApiV1ThreeLetterCodeInternalAdminsCategories200,
  GetApiV1ThreeLetterCodeInternalAdminsClientApplications200,
  GetApiV1ThreeLetterCodeInternalAdminsClientApplicationsParams,
  GetApiV1ThreeLetterCodeInternalAdminsClientsId200,
  GetApiV1ThreeLetterCodeInternalAdminsCompanies200,
  GetApiV1ThreeLetterCodeInternalAdminsCompaniesId200,
  GetApiV1ThreeLetterCodeInternalAdminsCompaniesParams,
  GetApiV1ThreeLetterCodeInternalAdminsFeaturedIds200,
  GetApiV1ThreeLetterCodeInternalAdminsGiftTypes200,
  GetApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrders200One,
  GetApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersParams,
  GetApiV1ThreeLetterCodeInternalAdminsGifteePlans200,
  GetApiV1ThreeLetterCodeInternalAdminsLinkUrls200,
  GetApiV1ThreeLetterCodeInternalAdminsLinkUrlsId200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId200,
  GetApiV1ThreeLetterCodeInternalAdminsPartners200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersId200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersParams,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContracts200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsId200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsParams,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClients200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsParams,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsParams,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansParams,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId404,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansParams,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches200One,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId200,
  GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesParams,
  GetApiV1ThreeLetterCodeInternalAdminsServices200,
  GetApiV1ThreeLetterCodeInternalAdminsServicesId200,
  GetApiV1ThreeLetterCodeInternalAdminsServicesParams,
  GetApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices200,
  GetApiV1ThreeLetterCodeInternalAdminsStores200,
  GetApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateParams,
  GetApiV1ThreeLetterCodeInternalAdminsStoresId200,
  GetApiV1ThreeLetterCodeInternalAdminsStoresParams,
  GetApiV1ThreeLetterCodePartnerAdminsApplicationConfiguration200,
  GetApiV1ThreeLetterCodePartnerAdminsBankAccounts200One,
  GetApiV1ThreeLetterCodePartnerAdminsBankAccountsParams,
  GetApiV1ThreeLetterCodePartnerAdminsCategories200,
  GetApiV1ThreeLetterCodePartnerAdminsCategoriesParams,
  GetApiV1ThreeLetterCodePartnerAdminsClientAdminUsers200,
  GetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId200,
  GetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersParams,
  GetApiV1ThreeLetterCodePartnerAdminsClientContracts200,
  GetApiV1ThreeLetterCodePartnerAdminsClientContractsParams,
  GetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags200,
  GetApiV1ThreeLetterCodePartnerAdminsClients200One,
  GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200,
  GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts200,
  GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId200,
  GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsParams,
  GetApiV1ThreeLetterCodePartnerAdminsClientsParams,
  GetApiV1ThreeLetterCodePartnerAdminsContractPlans200,
  GetApiV1ThreeLetterCodePartnerAdminsContractPlansId200,
  GetApiV1ThreeLetterCodePartnerAdminsContractPlansParams,
  GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions200,
  GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId200,
  GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsParams,
  GetApiV1ThreeLetterCodePartnerAdminsGiftPlans200,
  GetApiV1ThreeLetterCodePartnerAdminsGiftPlansParams,
  GetApiV1ThreeLetterCodePartnerAdminsGifteePlans200,
  GetApiV1ThreeLetterCodePartnerAdminsGroups200,
  GetApiV1ThreeLetterCodePartnerAdminsGroupsId200,
  GetApiV1ThreeLetterCodePartnerAdminsNotifications200,
  GetApiV1ThreeLetterCodePartnerAdminsNotificationsId200,
  GetApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsers200,
  GetApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsers200,
  GetApiV1ThreeLetterCodePartnerAdminsPartnerBranches200,
  GetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags200,
  GetApiV1ThreeLetterCodePartnerAdminsServiceUsages200One,
  GetApiV1ThreeLetterCodePartnerAdminsServiceUsagesParams,
  GetApiV1ThreeLetterCodePartnerAdminsServices200,
  GetApiV1ThreeLetterCodePartnerAdminsServicesId200,
  GetApiV1ThreeLetterCodePartnerAdminsServicesParams,
  GetApiV1ThreeLetterCodePartnerAdminsTopBanners200,
  GetApiV1ThreeLetterCodePartnerAdminsTopBannersId200,
  GetApiV1ThreeLetterCodePartnerAdminsTopBannersParams,
  GetApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogs200One,
  GetApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsParams,
  GetApiV1ThreeLetterCodePartnerAdminsUsers200,
  GetApiV1ThreeLetterCodePartnerAdminsUsersParams,
  GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200,
  GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccount200,
  GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile200,
  GetApiV1ThreeLetterCodePublicClientApplicationAgreements200,
  GetApiV1ThreeLetterCodePublicContractPlans200,
  GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode400,
  GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode401,
  GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode404,
  GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode500,
  GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeParams,
  GetApiV1ThreeLetterCodePublicPartnerBranches200,
  GetApiV1ThreeLetterCodePublicPartnersSubdomain200,
  GetApiV1ThreeLetterCodePublicPrefectures200,
  JpostSearchcode,
  JpostToken,
  PatchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersId200,
  PatchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdBody,
  PatchApiV1ThreeLetterCodeClientAdminsClientNewslettersId200,
  PatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdBody,
  PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsId200,
  PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdBody,
  PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorder200,
  PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderBody,
  PatchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId200,
  PatchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdBody,
  PatchApiV1ThreeLetterCodeInternalAdminsCategoriesId200,
  PatchApiV1ThreeLetterCodeInternalAdminsCategoriesId422,
  PatchApiV1ThreeLetterCodeInternalAdminsCategoriesIdBody,
  PatchApiV1ThreeLetterCodeInternalAdminsPartnersIdBody,
  PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApprove200,
  PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPending200,
  PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdReject200,
  PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId200,
  PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdBody,
  PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId200,
  PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdBody,
  PostApiV1ClientAdminsSignIn200,
  PostApiV1ClientAdminsSignInBody,
  PostApiV1CompanyAdminsSignIn200,
  PostApiV1CompanyAdminsSignInBody,
  PostApiV1InternalAdminsNotificationsBody,
  PostApiV1InternalAdminsSignIn200,
  PostApiV1InternalAdminsSignInBody,
  PostApiV1PartnerAdminsSignIn200,
  PostApiV1PartnerAdminsSignInBody,
  PostApiV1SFRAppsUsersAuthFreeeCallbackParams,
  PostApiV1SFRAppsUsersAuthFreeeLogin200,
  PostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreations422,
  PostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsBody,
  PostApiV1SdksOtpVerifications200,
  PostApiV1SdksOtpVerificationsBody,
  PostApiV1SdksOtps201,
  PostApiV1SdksOtpsBody,
  PostApiV1SlackClientApplicationInteractionsBody,
  PostApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntents201,
  PostApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsBody,
  PostApiV1ThreeLetterCodeAppsGifteeBenefitPurchases200,
  PostApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesBody,
  PostApiV1ThreeLetterCodeAppsServicesServiceIdFavorite201,
  PostApiV1ThreeLetterCodeAppsServicesUsages201,
  PostApiV1ThreeLetterCodeAppsSignIn200,
  PostApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersBody,
  PostApiV1ThreeLetterCodeAppsUserGifts201,
  PostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCards201,
  PostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxes201,
  PostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydons201,
  PostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons201,
  PostApiV1ThreeLetterCodeAppsUsersActivationBody,
  PostApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrations201,
  PostApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrations201,
  PostApiV1ThreeLetterCodeClientAdminsBlobs201,
  PostApiV1ThreeLetterCodeClientAdminsBlobsBody,
  PostApiV1ThreeLetterCodeClientAdminsBranches201,
  PostApiV1ThreeLetterCodeClientAdminsBranchesBody,
  PostApiV1ThreeLetterCodeClientAdminsCardRegistrations201,
  PostApiV1ThreeLetterCodeClientAdminsClientAdminUsers201,
  PostApiV1ThreeLetterCodeClientAdminsClientAdminUsersBody,
  PostApiV1ThreeLetterCodeClientAdminsClientNewsletters201,
  PostApiV1ThreeLetterCodeClientAdminsClientNewslettersBody,
  PostApiV1ThreeLetterCodeClientAdminsClientPortalItems201,
  PostApiV1ThreeLetterCodeClientAdminsClientPortalItemsBody,
  PostApiV1ThreeLetterCodeClientAdminsStressAssessments201,
  PostApiV1ThreeLetterCodeClientAdminsStressAssessmentsBody,
  PostApiV1ThreeLetterCodeClientAdminsStressCheckSchedule201,
  PostApiV1ThreeLetterCodeClientAdminsStressCheckScheduleBody,
  PostApiV1ThreeLetterCodeClientAdminsUsers201,
  PostApiV1ThreeLetterCodeClientAdminsUsersBody,
  PostApiV1ThreeLetterCodeClientAdminsUsersBulkCreations201,
  PostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletions201,
  PostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginReminders201,
  PostApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginReminders201,
  PostApiV1ThreeLetterCodeExternalsClients201,
  PostApiV1ThreeLetterCodeExternalsClientsBody,
  PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsers201,
  PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersBody,
  PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivate200,
  PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers201,
  PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersBody,
  PostApiV1ThreeLetterCodeExternalsPaydonsStatusUpdates200,
  PostApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesBody,
  PostApiV1ThreeLetterCodeInternalAdminsAgreements201,
  PostApiV1ThreeLetterCodeInternalAdminsAgreements422,
  PostApiV1ThreeLetterCodeInternalAdminsAgreementsBody,
  PostApiV1ThreeLetterCodeInternalAdminsAttachments201,
  PostApiV1ThreeLetterCodeInternalAdminsAttachmentsBody,
  PostApiV1ThreeLetterCodeInternalAdminsCategories201,
  PostApiV1ThreeLetterCodeInternalAdminsCategoriesBody,
  PostApiV1ThreeLetterCodeInternalAdminsClients201,
  PostApiV1ThreeLetterCodeInternalAdminsClientsBody,
  PostApiV1ThreeLetterCodeInternalAdminsCompanies201,
  PostApiV1ThreeLetterCodeInternalAdminsCompanies422,
  PostApiV1ThreeLetterCodeInternalAdminsCompaniesBody,
  PostApiV1ThreeLetterCodeInternalAdminsLinkUrls201,
  PostApiV1ThreeLetterCodeInternalAdminsLinkUrls422,
  PostApiV1ThreeLetterCodeInternalAdminsLinkUrlsBody,
  PostApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers201,
  PostApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersBody,
  PostApiV1ThreeLetterCodeInternalAdminsPartnersBody,
  PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements201,
  PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements422,
  PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsBody,
  PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts201,
  PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsBody,
  PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans201,
  PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansBody,
  PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans201,
  PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans422,
  PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansBody,
  PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches201,
  PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBody,
  PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreation201,
  PostApiV1ThreeLetterCodeInternalAdminsServices201,
  PostApiV1ThreeLetterCodeInternalAdminsServices422,
  PostApiV1ThreeLetterCodeInternalAdminsServicesBody,
  PostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices201,
  PostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesBody,
  PostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreation201,
  PostApiV1ThreeLetterCodeInternalAdminsStores201,
  PostApiV1ThreeLetterCodeInternalAdminsStores422,
  PostApiV1ThreeLetterCodeInternalAdminsStoresBody,
  PostApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistration201,
  PostApiV1ThreeLetterCodeInternalAdminsUsersBulkCreations201,
  PostApiV1ThreeLetterCodePartnerAdminsClientAdminUsers201,
  PostApiV1ThreeLetterCodePartnerAdminsClientAdminUsersBody,
  PostApiV1ThreeLetterCodePartnerAdminsClients201,
  PostApiV1ThreeLetterCodePartnerAdminsClientsBody,
  PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreation202,
  PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationBody,
  PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts201,
  PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsBody,
  PostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsBody,
  PostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsParams,
  PostApiV1ThreeLetterCodePartnerAdminsGroups201,
  PostApiV1ThreeLetterCodePartnerAdminsGroupsBody,
  PostApiV1ThreeLetterCodePartnerAdminsNotificationsBody,
  PostApiV1ThreeLetterCodePartnerAdminsTopBannersBody,
  PostApiV1ThreeLetterCodePartnerAdminsUsers201,
  PostApiV1ThreeLetterCodePartnerAdminsUsersBody,
  PostApiV1ThreeLetterCodePublicCardRegistrations201,
  PostApiV1ThreeLetterCodePublicClientApplications201,
  PostApiV1ThreeLetterCodePublicClientApplicationsBody,
  PostApiV1ThreeLetterCodeSdksUsers200,
  PostApiV1ThreeLetterCodeSdksUsersBody,
  PostApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletions202,
  PostApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsBody,
  PostApiV1WebhooksStripeAccountBody,
  PutApiV1ThreeLetterCodeAppsStressAssessmentsIdResultBody,
  PutApiV1ThreeLetterCodeAppsUser200,
  PutApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons200,
  PutApiV1ThreeLetterCodeAppsUserProfile200,
  PutApiV1ThreeLetterCodeAppsUsersActivation200,
  PutApiV1ThreeLetterCodeAppsUsersActivationBody,
  PutApiV1ThreeLetterCodeAppsUsersPasswordResetsBody,
  PutApiV1ThreeLetterCodeClientAdminsBranchesId200,
  PutApiV1ThreeLetterCodeClientAdminsBranchesIdBody,
  PutApiV1ThreeLetterCodeClientAdminsClientAdminUsersId200,
  PutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdBody,
  PutApiV1ThreeLetterCodeClientAdminsUsersId200,
  PutApiV1ThreeLetterCodeClientAdminsUsersIdBody,
  PutApiV1ThreeLetterCodeExternalsClientsExternalClientId200,
  PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId200,
  PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdBody,
  PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdBody,
  PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId200,
  PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdBody,
  PutApiV1ThreeLetterCodeInternalAdminsAgreementsId200,
  PutApiV1ThreeLetterCodeInternalAdminsAgreementsId422,
  PutApiV1ThreeLetterCodeInternalAdminsAgreementsIdBody,
  PutApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKey200,
  PutApiV1ThreeLetterCodeInternalAdminsClientsClientIdStates200,
  PutApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesBody,
  PutApiV1ThreeLetterCodeInternalAdminsClientsId200,
  PutApiV1ThreeLetterCodeInternalAdminsClientsIdBody,
  PutApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStates200,
  PutApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesBody,
  PutApiV1ThreeLetterCodeInternalAdminsCompaniesId200,
  PutApiV1ThreeLetterCodeInternalAdminsCompaniesId422,
  PutApiV1ThreeLetterCodeInternalAdminsCompaniesIdBody,
  PutApiV1ThreeLetterCodeInternalAdminsLinkUrlsId200,
  PutApiV1ThreeLetterCodeInternalAdminsLinkUrlsId422,
  PutApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdBody,
  PutApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId200,
  PutApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdBody,
  PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId200,
  PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId422,
  PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdBody,
  PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorder200,
  PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorder400,
  PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorder422,
  PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderBody,
  PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsId200,
  PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdBody,
  PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId200,
  PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdBody,
  PutApiV1ThreeLetterCodeInternalAdminsServicesId200,
  PutApiV1ThreeLetterCodeInternalAdminsServicesId422,
  PutApiV1ThreeLetterCodeInternalAdminsServicesIdBody,
  PutApiV1ThreeLetterCodeInternalAdminsStoresId200,
  PutApiV1ThreeLetterCodeInternalAdminsStoresId422,
  PutApiV1ThreeLetterCodeInternalAdminsStoresIdBody,
  PutApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId200,
  PutApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdBody,
  PutApiV1ThreeLetterCodePartnerAdminsClientsClientId200,
  PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdBody,
  PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId200,
  PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdBody,
  PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKey200,
  PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCredit200,
  PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCount200,
  PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountBody,
  PutApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdBody,
  PutApiV1ThreeLetterCodePartnerAdminsGroupsId200,
  PutApiV1ThreeLetterCodePartnerAdminsGroupsIdBody,
  PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody,
  PutApiV1ThreeLetterCodePartnerAdminsUsersUserId200,
  PutApiV1ThreeLetterCodePartnerAdminsUsersUserIdBody,
  RequestAppsCreateInvitationUser,
  RequestAppsGiftCard,
  RequestAppsServiceUsage,
  RequestAppsSession,
  RequestAppsUpdateRedeemableStoreCoupon,
  RequestAppsUserPasswordReset,
  RequestAppsUserPasswordUpdate,
  RequestAppsUserProfileUpdate,
  RequestAppsUserRegistration,
  RequestAppsUserUpdate,
  RequestClientAdminsBulkCreation,
  RequestClientAdminsBulkDeletion,
  RequestInternalAdminsPartnerBranchesBulkCreationCsvFile,
  RequestInternalAdminsStoresBulkCreationCsvFile,
  RequestInternalAdminsStoresBulkRegistrationCsvFile,
  RequestInternalAdminsUsersBulkCreation,
  SimpleMessage
} from '../model';

import { customInstance } from '../../base/axiosInstance';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



 export type getApiV1ThreeLetterCodeAppsAgreementsResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsAgreements200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsAgreementsResponseSuccess = (getApiV1ThreeLetterCodeAppsAgreementsResponse200) & {
  headers: Headers;
};
;

export type getApiV1ThreeLetterCodeAppsAgreementsResponse = (getApiV1ThreeLetterCodeAppsAgreementsResponseSuccess)

export const getGetApiV1ThreeLetterCodeAppsAgreementsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/agreements`
}

/**
 * アプリ利用に必要な同意項目（利用規約等）の一覧を取得する
 * @summary Get Agreements
 */
export const getApiV1ThreeLetterCodeAppsAgreements = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsAgreementsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsAgreementsResponse>(getGetApiV1ThreeLetterCodeAppsAgreementsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsAgreementsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/agreements`] as const;

export type GetApiV1ThreeLetterCodeAppsAgreementsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsAgreements>>>

/**
 * @summary Get Agreements
 */
export const useGetApiV1ThreeLetterCodeAppsAgreements = <TError = unknown>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsAgreements>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsAgreementsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsAgreements(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsApplicationConfigurationResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsApplicationConfiguration200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsApplicationConfigurationResponseSuccess = (getApiV1ThreeLetterCodeAppsApplicationConfigurationResponse200) & {
  headers: Headers;
};
;

export type getApiV1ThreeLetterCodeAppsApplicationConfigurationResponse = (getApiV1ThreeLetterCodeAppsApplicationConfigurationResponseSuccess)

export const getGetApiV1ThreeLetterCodeAppsApplicationConfigurationUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/application_configuration`
}

/**
 * アプリケーションの設定情報（名称・ロゴ・登録URL等）を取得する
 * @summary Get ApplicationConfiguration
 */
export const getApiV1ThreeLetterCodeAppsApplicationConfiguration = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsApplicationConfigurationResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsApplicationConfigurationResponse>(getGetApiV1ThreeLetterCodeAppsApplicationConfigurationUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsApplicationConfigurationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/application_configuration`] as const;

export type GetApiV1ThreeLetterCodeAppsApplicationConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsApplicationConfiguration>>>

/**
 * @summary Get ApplicationConfiguration
 */
export const useGetApiV1ThreeLetterCodeAppsApplicationConfiguration = <TError = unknown>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsApplicationConfiguration>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsApplicationConfigurationKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsApplicationConfiguration(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsCategoriesCategoryIdServices200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesResponseSuccess = (getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesResponseError = (getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesResponse = (getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesResponseSuccess | getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesResponseError)

export const getGetApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesUrl = (threeLetterCode: string,
    categoryId: string,
    params?: GetApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/categories/${categoryId}/services?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/categories/${categoryId}/services`
}

/**
 * 指定カテゴリ配下のサービス一覧を取得する。`sort=distance` を指定すると、リクエストの `longitude`/`latitude` から最寄り店舗の距離が近い順に並び替える（店舗のないサービスは末尾）。`sort=hot` を指定すると利用回数（`usage_count`）の多い順に並び替える（同点は更新日新しい順）。未指定または座標欠落時は利用回数の多い順（同点は作成日新しい順）にフォールバックする
 * @summary Get Services
 */
export const getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServices = async (threeLetterCode: string,
    categoryId: string,
    params?: GetApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesResponse>(getGetApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesUrl(threeLetterCode,categoryId,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesKey = (threeLetterCode: string,
    categoryId: string,
    params?: GetApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesParams,) => [`/api/v1/${threeLetterCode}/apps/categories/${categoryId}/services`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServices>>>

/**
 * @summary Get Services
 */
export const useGetApiV1ThreeLetterCodeAppsCategoriesCategoryIdServices = <TError = Errors>(
  threeLetterCode: string,
    categoryId: string,
    params?: GetApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServices>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && categoryId !== null && categoryId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsCategoriesCategoryIdServicesKey(threeLetterCode,categoryId,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsCategoriesCategoryIdServices(threeLetterCode,categoryId,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsCategoriesResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsCategories200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsCategoriesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsCategoriesResponseSuccess = (getApiV1ThreeLetterCodeAppsCategoriesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsCategoriesResponseError = (getApiV1ThreeLetterCodeAppsCategoriesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsCategoriesResponse = (getApiV1ThreeLetterCodeAppsCategoriesResponseSuccess | getApiV1ThreeLetterCodeAppsCategoriesResponseError)

export const getGetApiV1ThreeLetterCodeAppsCategoriesUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsCategoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/categories?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/categories`
}

/**
 * パートナーで利用可能なサービスのカテゴリ一覧を取得する
 * @summary Get categories
 */
export const getApiV1ThreeLetterCodeAppsCategories = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsCategoriesParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsCategoriesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsCategoriesResponse>(getGetApiV1ThreeLetterCodeAppsCategoriesUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsCategoriesKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsCategoriesParams,) => [`/api/v1/${threeLetterCode}/apps/categories`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsCategories>>>

/**
 * @summary Get categories
 */
export const useGetApiV1ThreeLetterCodeAppsCategories = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsCategoriesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsCategories>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsCategoriesKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsCategories(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsClientFeatureFlagsResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsClientFeatureFlags200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsClientFeatureFlagsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsClientFeatureFlagsResponseSuccess = (getApiV1ThreeLetterCodeAppsClientFeatureFlagsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsClientFeatureFlagsResponseError = (getApiV1ThreeLetterCodeAppsClientFeatureFlagsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsClientFeatureFlagsResponse = (getApiV1ThreeLetterCodeAppsClientFeatureFlagsResponseSuccess | getApiV1ThreeLetterCodeAppsClientFeatureFlagsResponseError)

export const getGetApiV1ThreeLetterCodeAppsClientFeatureFlagsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/client_feature_flags`
}

/**
 * ログインユーザーが所属するクライアントの機能フラグ一覧を取得する
 * @summary Get client feature flags
 */
export const getApiV1ThreeLetterCodeAppsClientFeatureFlags = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsClientFeatureFlagsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsClientFeatureFlagsResponse>(getGetApiV1ThreeLetterCodeAppsClientFeatureFlagsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsClientFeatureFlagsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/client_feature_flags`] as const;

export type GetApiV1ThreeLetterCodeAppsClientFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsClientFeatureFlags>>>

/**
 * @summary Get client feature flags
 */
export const useGetApiV1ThreeLetterCodeAppsClientFeatureFlags = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsClientFeatureFlags>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsClientFeatureFlagsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsClientFeatureFlags(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadResponse201 = {
  data: void
  status: 201
}

export type postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadResponse403 = {
  data: Errors
  status: 403
}

export type postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadResponseSuccess = (postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadResponseError = (postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadResponse401 | postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadResponse403) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadResponse = (postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadResponseSuccess | postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadResponseError)

export const getPostApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadUrl = (threeLetterCode: string,
    clientNewsletterId: number,) => {




  return `/api/v1/${threeLetterCode}/apps/client_newsletters/${clientNewsletterId}/read`
}

/**
 * クライアントお知らせの既読履歴を記録する
 * @summary Create ClientNewsletterReadHistory
 */
export const postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdRead = async (threeLetterCode: string,
    clientNewsletterId: number, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadResponse>(getPostApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadUrl(threeLetterCode,clientNewsletterId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadMutationFetcher = (threeLetterCode: string,
    clientNewsletterId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdRead(threeLetterCode, clientNewsletterId, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadMutationKey = (threeLetterCode: string,
    clientNewsletterId: number,) => [`/api/v1/${threeLetterCode}/apps/client_newsletters/${clientNewsletterId}/read`] as const;

export type PostApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdRead>>>

/**
 * @summary Create ClientNewsletterReadHistory
 */
export const usePostApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdRead = <TError = Errors>(
  threeLetterCode: string,
    clientNewsletterId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdRead>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdRead>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadMutationKey(threeLetterCode,clientNewsletterId);
  const swrFn = getPostApiV1ThreeLetterCodeAppsClientNewslettersClientNewsletterIdReadMutationFetcher(threeLetterCode,clientNewsletterId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsClientNewslettersResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsClientNewsletters200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsClientNewslettersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsClientNewslettersResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeAppsClientNewslettersResponseSuccess = (getApiV1ThreeLetterCodeAppsClientNewslettersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsClientNewslettersResponseError = (getApiV1ThreeLetterCodeAppsClientNewslettersResponse401 | getApiV1ThreeLetterCodeAppsClientNewslettersResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsClientNewslettersResponse = (getApiV1ThreeLetterCodeAppsClientNewslettersResponseSuccess | getApiV1ThreeLetterCodeAppsClientNewslettersResponseError)

export const getGetApiV1ThreeLetterCodeAppsClientNewslettersUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/client_newsletters`
}

/**
 * ログインユーザー向けに公開されているクライアントお知らせ一覧を取得する
 * @summary Get client newsletters
 */
export const getApiV1ThreeLetterCodeAppsClientNewsletters = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsClientNewslettersResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsClientNewslettersResponse>(getGetApiV1ThreeLetterCodeAppsClientNewslettersUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsClientNewslettersKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/client_newsletters`] as const;

export type GetApiV1ThreeLetterCodeAppsClientNewslettersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsClientNewsletters>>>

/**
 * @summary Get client newsletters
 */
export const useGetApiV1ThreeLetterCodeAppsClientNewsletters = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsClientNewsletters>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsClientNewslettersKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsClientNewsletters(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsClientNewslettersIdResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsClientNewslettersId200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsClientNewslettersIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsClientNewslettersIdResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeAppsClientNewslettersIdResponseSuccess = (getApiV1ThreeLetterCodeAppsClientNewslettersIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsClientNewslettersIdResponseError = (getApiV1ThreeLetterCodeAppsClientNewslettersIdResponse401 | getApiV1ThreeLetterCodeAppsClientNewslettersIdResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsClientNewslettersIdResponse = (getApiV1ThreeLetterCodeAppsClientNewslettersIdResponseSuccess | getApiV1ThreeLetterCodeAppsClientNewslettersIdResponseError)

export const getGetApiV1ThreeLetterCodeAppsClientNewslettersIdUrl = (threeLetterCode: string,
    id: string,) => {




  return `/api/v1/${threeLetterCode}/apps/client_newsletters/${id}`
}

/**
 * 指定IDのクライアントお知らせを取得する
 * @summary Get client newsletter
 */
export const getApiV1ThreeLetterCodeAppsClientNewslettersId = async (threeLetterCode: string,
    id: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsClientNewslettersIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsClientNewslettersIdResponse>(getGetApiV1ThreeLetterCodeAppsClientNewslettersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsClientNewslettersIdKey = (threeLetterCode: string,
    id: string,) => [`/api/v1/${threeLetterCode}/apps/client_newsletters/${id}`] as const;

export type GetApiV1ThreeLetterCodeAppsClientNewslettersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsClientNewslettersId>>>

/**
 * @summary Get client newsletter
 */
export const useGetApiV1ThreeLetterCodeAppsClientNewslettersId = <TError = Errors>(
  threeLetterCode: string,
    id: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsClientNewslettersId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsClientNewslettersIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsClientNewslettersId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsClientPortalItemsResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsClientPortalItems200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsClientPortalItemsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsClientPortalItemsResponseSuccess = (getApiV1ThreeLetterCodeAppsClientPortalItemsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsClientPortalItemsResponseError = (getApiV1ThreeLetterCodeAppsClientPortalItemsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsClientPortalItemsResponse = (getApiV1ThreeLetterCodeAppsClientPortalItemsResponseSuccess | getApiV1ThreeLetterCodeAppsClientPortalItemsResponseError)

export const getGetApiV1ThreeLetterCodeAppsClientPortalItemsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/client_portal_items`
}

/**
 * クライアントポータルに表示するリンク・ファイル項目の一覧を取得する
 * @summary Get client portal items
 */
export const getApiV1ThreeLetterCodeAppsClientPortalItems = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsClientPortalItemsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsClientPortalItemsResponse>(getGetApiV1ThreeLetterCodeAppsClientPortalItemsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsClientPortalItemsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/client_portal_items`] as const;

export type GetApiV1ThreeLetterCodeAppsClientPortalItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsClientPortalItems>>>

/**
 * @summary Get client portal items
 */
export const useGetApiV1ThreeLetterCodeAppsClientPortalItems = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsClientPortalItems>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsClientPortalItemsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsClientPortalItems(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsClientsResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsClients200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsClientsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsClientsResponseSuccess = (getApiV1ThreeLetterCodeAppsClientsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsClientsResponseError = (getApiV1ThreeLetterCodeAppsClientsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsClientsResponse = (getApiV1ThreeLetterCodeAppsClientsResponseSuccess | getApiV1ThreeLetterCodeAppsClientsResponseError)

export const getGetApiV1ThreeLetterCodeAppsClientsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/clients`
}

/**
 * ログインユーザーが所属するクライアントの情報を取得する
 * @summary Get clients
 */
export const getApiV1ThreeLetterCodeAppsClients = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsClientsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsClientsResponse>(getGetApiV1ThreeLetterCodeAppsClientsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsClientsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/clients`] as const;

export type GetApiV1ThreeLetterCodeAppsClientsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsClients>>>

/**
 * @summary Get clients
 */
export const useGetApiV1ThreeLetterCodeAppsClients = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsClients>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsClientsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsClients(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsCustomFieldDefinitionsResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsCustomFieldDefinitions200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsCustomFieldDefinitionsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsCustomFieldDefinitionsResponseSuccess = (getApiV1ThreeLetterCodeAppsCustomFieldDefinitionsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsCustomFieldDefinitionsResponseError = (getApiV1ThreeLetterCodeAppsCustomFieldDefinitionsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsCustomFieldDefinitionsResponse = (getApiV1ThreeLetterCodeAppsCustomFieldDefinitionsResponseSuccess | getApiV1ThreeLetterCodeAppsCustomFieldDefinitionsResponseError)

export const getGetApiV1ThreeLetterCodeAppsCustomFieldDefinitionsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsCustomFieldDefinitionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/custom_field_definitions?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/custom_field_definitions`
}

/**
 * 指定モデル向けに定義されたカスタムフィールドの一覧を取得する
 * @summary Get custom field definitions
 */
export const getApiV1ThreeLetterCodeAppsCustomFieldDefinitions = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsCustomFieldDefinitionsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsCustomFieldDefinitionsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsCustomFieldDefinitionsResponse>(getGetApiV1ThreeLetterCodeAppsCustomFieldDefinitionsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsCustomFieldDefinitionsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsCustomFieldDefinitionsParams,) => [`/api/v1/${threeLetterCode}/apps/custom_field_definitions`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsCustomFieldDefinitionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsCustomFieldDefinitions>>>

/**
 * @summary Get custom field definitions
 */
export const useGetApiV1ThreeLetterCodeAppsCustomFieldDefinitions = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsCustomFieldDefinitionsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsCustomFieldDefinitions>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsCustomFieldDefinitionsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsCustomFieldDefinitions(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsGiftCardConfigsResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsGiftCardConfigs200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsGiftCardConfigsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsGiftCardConfigsResponseSuccess = (getApiV1ThreeLetterCodeAppsGiftCardConfigsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsGiftCardConfigsResponseError = (getApiV1ThreeLetterCodeAppsGiftCardConfigsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsGiftCardConfigsResponse = (getApiV1ThreeLetterCodeAppsGiftCardConfigsResponseSuccess | getApiV1ThreeLetterCodeAppsGiftCardConfigsResponseError)

export const getGetApiV1ThreeLetterCodeAppsGiftCardConfigsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/gift_card_configs`
}

/**
 * 利用可能なギフトカード設定の一覧を取得する
 * @summary Get gift_card_configs
 */
export const getApiV1ThreeLetterCodeAppsGiftCardConfigs = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsGiftCardConfigsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsGiftCardConfigsResponse>(getGetApiV1ThreeLetterCodeAppsGiftCardConfigsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsGiftCardConfigsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/gift_card_configs`] as const;

export type GetApiV1ThreeLetterCodeAppsGiftCardConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsGiftCardConfigs>>>

/**
 * @summary Get gift_card_configs
 */
export const useGetApiV1ThreeLetterCodeAppsGiftCardConfigs = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsGiftCardConfigs>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsGiftCardConfigsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsGiftCardConfigs(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse201 = {
  data: PostApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntents201
  status: 201
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse502 = {
  data: Errors
  status: 502
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponseSuccess = (postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponseError = (postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse400 | postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse401 | postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse404 | postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse422 | postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse502) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse = (postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponseSuccess | postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponseError)

export const getPostApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/giftee_benefit/payment_intents`
}

/**
 * コンビニ割引の購入開始時に、モバイル PaymentSheet の初期化に必要な値一式を返す。フロントから送られた giftee_price_id を受け取り、決済直前に再取得したカタログの価格一覧（額面選択型の商品も含む）に属することを検証し、その価格 × quantity（購入枚数）の金額で決済する。ユーザーの Stripe Customer が無ければ作成して保持し、カードは支払いと同時に Stripe 側へ保存される（次回以降 PaymentSheet で選択可能）。注文レコードの作成やギフト発行は行わない
 * @summary Create payment intent for PaymentSheet
 */
export const postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntents = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsBody: PostApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsResponse>(getPostApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsBody)
  }
);}




export const getPostApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsBody }) => {
    return postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntents(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/giftee_benefit/payment_intents`] as const;

export type PostApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntents>>>

/**
 * @summary Create payment intent for PaymentSheet
 */
export const usePostApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntents = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntents>>, TError, Key, PostApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsBody, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntents>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeAppsGifteeBenefitPaymentIntentsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse200 = {
  data: PostApiV1ThreeLetterCodeAppsGifteeBenefitPurchases200
  status: 200
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse403 = {
  data: Errors
  status: 403
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse502 = {
  data: Errors
  status: 502
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse503 = {
  data: Errors
  status: 503
}

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponseSuccess = (postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse200) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponseError = (postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse400 | postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse401 | postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse403 | postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse422 | postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse502 | postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse503) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse = (postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponseSuccess | postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponseError)

export const getPostApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/giftee_benefit/purchases`
}

/**
 * コンビニ割引の決済確定後にモバイルが叩き、購入を成立させる EP。渡された PaymentIntent id を サーバ側で retrieve し、決済成功と本人所有（metadata.user_id == 認証ユーザー）を検証したうえで、注文記録 → ギフト発行を同期実行し発行したギフトチケット（quantity 枚）を返す。既に発行済みの場合は再発行せず現状態を返す。
 * @summary Complete a purchase after payment
 */
export const postApiV1ThreeLetterCodeAppsGifteeBenefitPurchases = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesBody: PostApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesResponse>(getPostApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesBody)
  }
);}




export const getPostApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesBody }) => {
    return postApiV1ThreeLetterCodeAppsGifteeBenefitPurchases(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/giftee_benefit/purchases`] as const;

export type PostApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsGifteeBenefitPurchases>>>

/**
 * @summary Complete a purchase after payment
 */
export const usePostApiV1ThreeLetterCodeAppsGifteeBenefitPurchases = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsGifteeBenefitPurchases>>, TError, Key, PostApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesBody, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsGifteeBenefitPurchases>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeAppsGifteeBenefitPurchasesMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsGifteeBenefitOrdersResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsGifteeBenefitOrders200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsGifteeBenefitOrdersResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeAppsGifteeBenefitOrdersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsGifteeBenefitOrdersResponseSuccess = (getApiV1ThreeLetterCodeAppsGifteeBenefitOrdersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsGifteeBenefitOrdersResponseError = (getApiV1ThreeLetterCodeAppsGifteeBenefitOrdersResponse400 | getApiV1ThreeLetterCodeAppsGifteeBenefitOrdersResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsGifteeBenefitOrdersResponse = (getApiV1ThreeLetterCodeAppsGifteeBenefitOrdersResponseSuccess | getApiV1ThreeLetterCodeAppsGifteeBenefitOrdersResponseError)

export const getGetApiV1ThreeLetterCodeAppsGifteeBenefitOrdersUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsGifteeBenefitOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/giftee_benefit_orders?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/giftee_benefit_orders`
}

/**
 * ログインユーザーの購入履歴を購入日時の降順で取得する。発行に失敗した注文も含む。is_issuance_retryable が true の注文は stripe_payment_intent_id を購入APIへ渡して発行を再実行できる。
 * @summary Get GifteeBenefitOrders
 */
export const getApiV1ThreeLetterCodeAppsGifteeBenefitOrders = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsGifteeBenefitOrdersParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsGifteeBenefitOrdersResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsGifteeBenefitOrdersResponse>(getGetApiV1ThreeLetterCodeAppsGifteeBenefitOrdersUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsGifteeBenefitOrdersKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsGifteeBenefitOrdersParams,) => [`/api/v1/${threeLetterCode}/apps/giftee_benefit_orders`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsGifteeBenefitOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsGifteeBenefitOrders>>>

/**
 * @summary Get GifteeBenefitOrders
 */
export const useGetApiV1ThreeLetterCodeAppsGifteeBenefitOrders = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsGifteeBenefitOrdersParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsGifteeBenefitOrders>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsGifteeBenefitOrdersKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsGifteeBenefitOrders(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsGifteeBenefitVouchersResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsGifteeBenefitVouchers200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsGifteeBenefitVouchersResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeAppsGifteeBenefitVouchersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsGifteeBenefitVouchersResponseSuccess = (getApiV1ThreeLetterCodeAppsGifteeBenefitVouchersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsGifteeBenefitVouchersResponseError = (getApiV1ThreeLetterCodeAppsGifteeBenefitVouchersResponse400 | getApiV1ThreeLetterCodeAppsGifteeBenefitVouchersResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsGifteeBenefitVouchersResponse = (getApiV1ThreeLetterCodeAppsGifteeBenefitVouchersResponseSuccess | getApiV1ThreeLetterCodeAppsGifteeBenefitVouchersResponseError)

export const getGetApiV1ThreeLetterCodeAppsGifteeBenefitVouchersUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsGifteeBenefitVouchersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/giftee_benefit_vouchers?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/giftee_benefit_vouchers`
}

/**
 * ログインユーザーの優待券一覧を発行日時の降順で取得する。「利用可能」タブは used=0、「利用済み」タブは used=1 で取得する（期限切れは絞り込みに影響せず、未使用であれば used=0 に含まれる）。
 * @summary Get GifteeBenefitVouchers
 */
export const getApiV1ThreeLetterCodeAppsGifteeBenefitVouchers = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsGifteeBenefitVouchersParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsGifteeBenefitVouchersResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsGifteeBenefitVouchersResponse>(getGetApiV1ThreeLetterCodeAppsGifteeBenefitVouchersUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsGifteeBenefitVouchersKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsGifteeBenefitVouchersParams,) => [`/api/v1/${threeLetterCode}/apps/giftee_benefit_vouchers`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsGifteeBenefitVouchersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsGifteeBenefitVouchers>>>

/**
 * @summary Get GifteeBenefitVouchers
 */
export const useGetApiV1ThreeLetterCodeAppsGifteeBenefitVouchers = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsGifteeBenefitVouchersParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsGifteeBenefitVouchers>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsGifteeBenefitVouchersKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsGifteeBenefitVouchers(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse200 = {
  data: PatchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersId200
  status: 200
}

export type patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse400 = {
  data: Errors
  status: 400
}

export type patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse401 = {
  data: Errors
  status: 401
}

export type patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse403 = {
  data: Errors
  status: 403
}

export type patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse404 = {
  data: Errors
  status: 404
}

export type patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse409 = {
  data: Errors
  status: 409
}

export type patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponseSuccess = (patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse200) & {
  headers: Headers;
};
export type patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponseError = (patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse400 | patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse401 | patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse403 | patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse404 | patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse409) & {
  headers: Headers;
};

export type patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse = (patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponseSuccess | patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponseError)

export const getPatchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdUrl = (threeLetterCode: string,
    id: string,) => {




  return `/api/v1/${threeLetterCode}/apps/giftee_benefit_vouchers/${id}`
}

/**
 * 優待券の利用済みメモ（used_at）を更新する。used: true で現在時刻を打刻し、false で取り消して未使用に戻す
 * @summary Update GifteeBenefitVoucher (mark as used / unused)
 */
export const patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersId = async (threeLetterCode: string,
    id: string,
    patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdBody: PatchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdBody, options?: RequestInit): Promise<patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse> => {

  return customInstance<patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdResponse>(getPatchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdBody)
  }
);}




export const getPatchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdMutationFetcher = (threeLetterCode: string,
    id: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PatchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdBody }) => {
    return patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersId(threeLetterCode, id, arg, options);
  }
}
export const getPatchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdMutationKey = (threeLetterCode: string,
    id: string,) => [`/api/v1/${threeLetterCode}/apps/giftee_benefit_vouchers/${id}`] as const;

export type PatchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersId>>>

/**
 * @summary Update GifteeBenefitVoucher (mark as used / unused)
 */
export const usePatchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersId = <TError = Errors>(
  threeLetterCode: string,
    id: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersId>>, TError, Key, PatchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdBody, Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdMutationKey(threeLetterCode,id);
  const swrFn = getPatchApiV1ThreeLetterCodeAppsGifteeBenefitVouchersIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsGifteeShopItemsResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsGifteeShopItems200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsGifteeShopItemsResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeAppsGifteeShopItemsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsGifteeShopItemsResponseSuccess = (getApiV1ThreeLetterCodeAppsGifteeShopItemsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsGifteeShopItemsResponseError = (getApiV1ThreeLetterCodeAppsGifteeShopItemsResponse400 | getApiV1ThreeLetterCodeAppsGifteeShopItemsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsGifteeShopItemsResponse = (getApiV1ThreeLetterCodeAppsGifteeShopItemsResponseSuccess | getApiV1ThreeLetterCodeAppsGifteeShopItemsResponseError)

export const getGetApiV1ThreeLetterCodeAppsGifteeShopItemsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsGifteeShopItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/giftee_shop_items?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/giftee_shop_items`
}

/**
 * コンビニ割引の商品一覧を、掲載中の商品のみ人気順（そのパートナーでの注文実績が多い順）で返す。ページネーションヘッダー（Total-Count, Total-Pages 等）を返却する
 * @summary Get giftee shop items
 */
export const getApiV1ThreeLetterCodeAppsGifteeShopItems = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsGifteeShopItemsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsGifteeShopItemsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsGifteeShopItemsResponse>(getGetApiV1ThreeLetterCodeAppsGifteeShopItemsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsGifteeShopItemsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsGifteeShopItemsParams,) => [`/api/v1/${threeLetterCode}/apps/giftee_shop_items`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsGifteeShopItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsGifteeShopItems>>>

/**
 * @summary Get giftee shop items
 */
export const useGetApiV1ThreeLetterCodeAppsGifteeShopItems = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsGifteeShopItemsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsGifteeShopItems>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsGifteeShopItemsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsGifteeShopItems(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsGifteeShopItemsItemCode200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeResponseSuccess = (getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeResponseError = (getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeResponse401 | getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeResponse = (getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeResponseSuccess | getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeResponseError)

export const getGetApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeUrl = (threeLetterCode: string,
    itemCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/giftee_shop_items/${itemCode}`
}

/**
 * コンビニ割引の商品詳細を取得する
 * @summary Get a giftee shop item
 */
export const getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCode = async (threeLetterCode: string,
    itemCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeResponse>(getGetApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeUrl(threeLetterCode,itemCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeKey = (threeLetterCode: string,
    itemCode: string,) => [`/api/v1/${threeLetterCode}/apps/giftee_shop_items/${itemCode}`] as const;

export type GetApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCode>>>

/**
 * @summary Get a giftee shop item
 */
export const useGetApiV1ThreeLetterCodeAppsGifteeShopItemsItemCode = <TError = Errors>(
  threeLetterCode: string,
    itemCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCode>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && itemCode !== null && itemCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsGifteeShopItemsItemCodeKey(threeLetterCode,itemCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsGifteeShopItemsItemCode(threeLetterCode,itemCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsGifteeStoreUserResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsGifteeStoreUser200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsGifteeStoreUserResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsGifteeStoreUserResponseSuccess = (getApiV1ThreeLetterCodeAppsGifteeStoreUserResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsGifteeStoreUserResponseError = (getApiV1ThreeLetterCodeAppsGifteeStoreUserResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsGifteeStoreUserResponse = (getApiV1ThreeLetterCodeAppsGifteeStoreUserResponseSuccess | getApiV1ThreeLetterCodeAppsGifteeStoreUserResponseError)

export const getGetApiV1ThreeLetterCodeAppsGifteeStoreUserUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/giftee_store_user`
}

/**
 * ログインユーザーのGifteeストア利用情報（ログイン情報等）を取得する
 * @summary Get GifteeStoreUser
 */
export const getApiV1ThreeLetterCodeAppsGifteeStoreUser = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsGifteeStoreUserResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsGifteeStoreUserResponse>(getGetApiV1ThreeLetterCodeAppsGifteeStoreUserUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsGifteeStoreUserKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/giftee_store_user`] as const;

export type GetApiV1ThreeLetterCodeAppsGifteeStoreUserQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsGifteeStoreUser>>>

/**
 * @summary Get GifteeStoreUser
 */
export const useGetApiV1ThreeLetterCodeAppsGifteeStoreUser = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsGifteeStoreUser>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsGifteeStoreUserKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsGifteeStoreUser(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponse201 = {
  data: void
  status: 201
}

export type postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponse409 = {
  data: Errors
  status: 409
}

export type postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponse422 = {
  data: void
  status: 422
}

export type postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponseSuccess = (postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponseError = (postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponse401 | postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponse409 | postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponse = (postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponseSuccess | postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponseError)

export const getPostApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesUrl = (threeLetterCode: string,
    storeId: number,) => {




  return `/api/v1/${threeLetterCode}/apps/inesus/stores/${storeId}/usages`
}

/**
 * イネサス店舗での特典利用を記録する
 * @summary Create Inesus Store Usage
 */
export const postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsages = async (threeLetterCode: string,
    storeId: number, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesResponse>(getPostApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesUrl(threeLetterCode,storeId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesMutationFetcher = (threeLetterCode: string,
    storeId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsages(threeLetterCode, storeId, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesMutationKey = (threeLetterCode: string,
    storeId: number,) => [`/api/v1/${threeLetterCode}/apps/inesus/stores/${storeId}/usages`] as const;

export type PostApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsages>>>

/**
 * @summary Create Inesus Store Usage
 */
export const usePostApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsages = <TError = Errors | void>(
  threeLetterCode: string,
    storeId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsages>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsages>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesMutationKey(threeLetterCode,storeId);
  const swrFn = getPostApiV1ThreeLetterCodeAppsInesusStoresStoreIdUsagesMutationFetcher(threeLetterCode,storeId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsInesusStoresResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsInesusStores200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsInesusStoresResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsInesusStoresResponseSuccess = (getApiV1ThreeLetterCodeAppsInesusStoresResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsInesusStoresResponseError = (getApiV1ThreeLetterCodeAppsInesusStoresResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsInesusStoresResponse = (getApiV1ThreeLetterCodeAppsInesusStoresResponseSuccess | getApiV1ThreeLetterCodeAppsInesusStoresResponseError)

export const getGetApiV1ThreeLetterCodeAppsInesusStoresUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/inesus/stores`
}

/**
 * イネサス店舗の一覧を取得する
 * @summary Get inesus stores
 */
export const getApiV1ThreeLetterCodeAppsInesusStores = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsInesusStoresResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsInesusStoresResponse>(getGetApiV1ThreeLetterCodeAppsInesusStoresUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsInesusStoresKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/inesus/stores`] as const;

export type GetApiV1ThreeLetterCodeAppsInesusStoresQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsInesusStores>>>

/**
 * @summary Get inesus stores
 */
export const useGetApiV1ThreeLetterCodeAppsInesusStores = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsInesusStores>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsInesusStoresKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsInesusStores(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsInesusStoresIdResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsInesusStoresId200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsInesusStoresIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsInesusStoresIdResponseSuccess = (getApiV1ThreeLetterCodeAppsInesusStoresIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsInesusStoresIdResponseError = (getApiV1ThreeLetterCodeAppsInesusStoresIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsInesusStoresIdResponse = (getApiV1ThreeLetterCodeAppsInesusStoresIdResponseSuccess | getApiV1ThreeLetterCodeAppsInesusStoresIdResponseError)

export const getGetApiV1ThreeLetterCodeAppsInesusStoresIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/apps/inesus/stores/${id}`
}

/**
 * 指定店舗の詳細情報と当月の特典利用可否を取得する
 * @summary Get inesus store with benefit availability
 */
export const getApiV1ThreeLetterCodeAppsInesusStoresId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsInesusStoresIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsInesusStoresIdResponse>(getGetApiV1ThreeLetterCodeAppsInesusStoresIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsInesusStoresIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/apps/inesus/stores/${id}`] as const;

export type GetApiV1ThreeLetterCodeAppsInesusStoresIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsInesusStoresId>>>

/**
 * @summary Get inesus store with benefit availability
 */
export const useGetApiV1ThreeLetterCodeAppsInesusStoresId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsInesusStoresId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsInesusStoresIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsInesusStoresId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsSignInResponse200 = {
  data: PostApiV1ThreeLetterCodeAppsSignIn200
  status: 200
}

export type postApiV1ThreeLetterCodeAppsSignInResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeAppsSignInResponseSuccess = (postApiV1ThreeLetterCodeAppsSignInResponse200) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsSignInResponseError = (postApiV1ThreeLetterCodeAppsSignInResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsSignInResponse = (postApiV1ThreeLetterCodeAppsSignInResponseSuccess | postApiV1ThreeLetterCodeAppsSignInResponseError)

export const getPostApiV1ThreeLetterCodeAppsSignInUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/sign_in`
}

/**
 * メールアドレス（または電話番号）とパスワードでログインしJWTを取得する
 * @summary Get JWT
 */
export const postApiV1ThreeLetterCodeAppsSignIn = async (threeLetterCode: string,
    requestAppsSession?: RequestAppsSession, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsSignInResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsSignInResponse>(getPostApiV1ThreeLetterCodeAppsSignInUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestAppsSession)
  }
);}




export const getPostApiV1ThreeLetterCodeAppsSignInMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestAppsSession | undefined }) => {
    return postApiV1ThreeLetterCodeAppsSignIn(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsSignInMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/sign_in`] as const;

export type PostApiV1ThreeLetterCodeAppsSignInMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsSignIn>>>

/**
 * @summary Get JWT
 */
export const usePostApiV1ThreeLetterCodeAppsSignIn = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsSignIn>>, TError, Key, RequestAppsSession | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsSignIn>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsSignInMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeAppsSignInMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsLinkUrlsResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsLinkUrls200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsLinkUrlsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsLinkUrlsResponseSuccess = (getApiV1ThreeLetterCodeAppsLinkUrlsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsLinkUrlsResponseError = (getApiV1ThreeLetterCodeAppsLinkUrlsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsLinkUrlsResponse = (getApiV1ThreeLetterCodeAppsLinkUrlsResponseSuccess | getApiV1ThreeLetterCodeAppsLinkUrlsResponseError)

export const getGetApiV1ThreeLetterCodeAppsLinkUrlsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/link_urls`
}

/**
 * 各種リンクURL（ヘルプ・規約等）の一覧を取得する
 * @summary Get LinkUrls
 */
export const getApiV1ThreeLetterCodeAppsLinkUrls = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsLinkUrlsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsLinkUrlsResponse>(getGetApiV1ThreeLetterCodeAppsLinkUrlsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsLinkUrlsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/link_urls`] as const;

export type GetApiV1ThreeLetterCodeAppsLinkUrlsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsLinkUrls>>>

/**
 * @summary Get LinkUrls
 */
export const useGetApiV1ThreeLetterCodeAppsLinkUrls = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsLinkUrls>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsLinkUrlsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsLinkUrls(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsMapsStoresResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsMapsStores200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsMapsStoresResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsMapsStoresResponseSuccess = (getApiV1ThreeLetterCodeAppsMapsStoresResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsMapsStoresResponseError = (getApiV1ThreeLetterCodeAppsMapsStoresResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsMapsStoresResponse = (getApiV1ThreeLetterCodeAppsMapsStoresResponseSuccess | getApiV1ThreeLetterCodeAppsMapsStoresResponseError)

export const getGetApiV1ThreeLetterCodeAppsMapsStoresUrl = (threeLetterCode: string,
    params: GetApiV1ThreeLetterCodeAppsMapsStoresParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/maps/stores?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/maps/stores`
}

/**
 * 地図画面用に指定中心点の半径内にある店舗一覧を取得する
 * @summary Get Stores
 */
export const getApiV1ThreeLetterCodeAppsMapsStores = async (threeLetterCode: string,
    params: GetApiV1ThreeLetterCodeAppsMapsStoresParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsMapsStoresResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsMapsStoresResponse>(getGetApiV1ThreeLetterCodeAppsMapsStoresUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsMapsStoresKey = (threeLetterCode: string,
    params: GetApiV1ThreeLetterCodeAppsMapsStoresParams,) => [`/api/v1/${threeLetterCode}/apps/maps/stores`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsMapsStoresQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsMapsStores>>>

/**
 * @summary Get Stores
 */
export const useGetApiV1ThreeLetterCodeAppsMapsStores = <TError = Errors>(
  threeLetterCode: string,
    params: GetApiV1ThreeLetterCodeAppsMapsStoresParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsMapsStores>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsMapsStoresKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsMapsStores(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsPartnerFeatureFlagsResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsPartnerFeatureFlags200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsPartnerFeatureFlagsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsPartnerFeatureFlagsResponseSuccess = (getApiV1ThreeLetterCodeAppsPartnerFeatureFlagsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsPartnerFeatureFlagsResponseError = (getApiV1ThreeLetterCodeAppsPartnerFeatureFlagsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsPartnerFeatureFlagsResponse = (getApiV1ThreeLetterCodeAppsPartnerFeatureFlagsResponseSuccess | getApiV1ThreeLetterCodeAppsPartnerFeatureFlagsResponseError)

export const getGetApiV1ThreeLetterCodeAppsPartnerFeatureFlagsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/partner_feature_flags`
}

/**
 * ログインユーザーが所属するパートナーの機能フラグ一覧を取得する
 * @summary Get partner feature flags
 */
export const getApiV1ThreeLetterCodeAppsPartnerFeatureFlags = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsPartnerFeatureFlagsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsPartnerFeatureFlagsResponse>(getGetApiV1ThreeLetterCodeAppsPartnerFeatureFlagsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsPartnerFeatureFlagsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/partner_feature_flags`] as const;

export type GetApiV1ThreeLetterCodeAppsPartnerFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsPartnerFeatureFlags>>>

/**
 * @summary Get partner feature flags
 */
export const useGetApiV1ThreeLetterCodeAppsPartnerFeatureFlags = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsPartnerFeatureFlags>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsPartnerFeatureFlagsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsPartnerFeatureFlags(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsPartnersSubdomainResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsPartnersSubdomain200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsPartnersSubdomainResponseSuccess = (getApiV1ThreeLetterCodeAppsPartnersSubdomainResponse200) & {
  headers: Headers;
};
;

export type getApiV1ThreeLetterCodeAppsPartnersSubdomainResponse = (getApiV1ThreeLetterCodeAppsPartnersSubdomainResponseSuccess)

export const getGetApiV1ThreeLetterCodeAppsPartnersSubdomainUrl = (threeLetterCode: string,
    subdomain: string,) => {




  return `/api/v1/${threeLetterCode}/apps/partners/${subdomain}`
}

/**
 * サブドメインに対応するパートナー情報を取得する
 * @summary Get Partner
 */
export const getApiV1ThreeLetterCodeAppsPartnersSubdomain = async (threeLetterCode: string,
    subdomain: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsPartnersSubdomainResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsPartnersSubdomainResponse>(getGetApiV1ThreeLetterCodeAppsPartnersSubdomainUrl(threeLetterCode,subdomain),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsPartnersSubdomainKey = (threeLetterCode: string,
    subdomain: string,) => [`/api/v1/${threeLetterCode}/apps/partners/${subdomain}`] as const;

export type GetApiV1ThreeLetterCodeAppsPartnersSubdomainQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsPartnersSubdomain>>>

/**
 * @summary Get Partner
 */
export const useGetApiV1ThreeLetterCodeAppsPartnersSubdomain = <TError = unknown>(
  threeLetterCode: string,
    subdomain: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsPartnersSubdomain>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && subdomain !== null && subdomain !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsPartnersSubdomainKey(threeLetterCode,subdomain) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsPartnersSubdomain(threeLetterCode,subdomain, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsPrefecturesResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsPrefectures200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsPrefecturesResponseSuccess = (getApiV1ThreeLetterCodeAppsPrefecturesResponse200) & {
  headers: Headers;
};
;

export type getApiV1ThreeLetterCodeAppsPrefecturesResponse = (getApiV1ThreeLetterCodeAppsPrefecturesResponseSuccess)

export const getGetApiV1ThreeLetterCodeAppsPrefecturesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/prefectures`
}

/**
 * 都道府県マスタの一覧を取得する
 * @summary Get Prefectures
 */
export const getApiV1ThreeLetterCodeAppsPrefectures = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsPrefecturesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsPrefecturesResponse>(getGetApiV1ThreeLetterCodeAppsPrefecturesUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsPrefecturesKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/prefectures`] as const;

export type GetApiV1ThreeLetterCodeAppsPrefecturesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsPrefectures>>>

/**
 * @summary Get Prefectures
 */
export const useGetApiV1ThreeLetterCodeAppsPrefectures = <TError = unknown>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsPrefectures>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsPrefecturesKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsPrefectures(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsServicesServiceIdAvailability200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityResponseSuccess = (getApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityResponseError = (getApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityResponse = (getApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityResponseSuccess | getApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityResponseError)

export const getGetApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityUrl = (threeLetterCode: string,
    serviceId: string,) => {




  return `/api/v1/${threeLetterCode}/apps/services/${serviceId}/availability`
}

/**
 * 指定サービスの利用残数および次回利用可能日時を取得する
 * @summary Get service availability
 */
export const getApiV1ThreeLetterCodeAppsServicesServiceIdAvailability = async (threeLetterCode: string,
    serviceId: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityResponse>(getGetApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityUrl(threeLetterCode,serviceId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityKey = (threeLetterCode: string,
    serviceId: string,) => [`/api/v1/${threeLetterCode}/apps/services/${serviceId}/availability`] as const;

export type GetApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsServicesServiceIdAvailability>>>

/**
 * @summary Get service availability
 */
export const useGetApiV1ThreeLetterCodeAppsServicesServiceIdAvailability = <TError = Errors>(
  threeLetterCode: string,
    serviceId: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsServicesServiceIdAvailability>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && serviceId !== null && serviceId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsServicesServiceIdAvailabilityKey(threeLetterCode,serviceId) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsServicesServiceIdAvailability(threeLetterCode,serviceId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatus200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusResponseSuccess = (getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusResponseError = (getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusResponse = (getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusResponseSuccess | getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusResponseError)

export const getGetApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusUrl = (threeLetterCode: string,
    serviceId: string,) => {




  return `/api/v1/${threeLetterCode}/apps/services/${serviceId}/favorite_status`
}

/**
 * 指定サービスのお気に入り登録状況を取得する
 * @summary Get favorite status
 */
export const getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatus = async (threeLetterCode: string,
    serviceId: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusResponse>(getGetApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusUrl(threeLetterCode,serviceId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusKey = (threeLetterCode: string,
    serviceId: string,) => [`/api/v1/${threeLetterCode}/apps/services/${serviceId}/favorite_status`] as const;

export type GetApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatus>>>

/**
 * @summary Get favorite status
 */
export const useGetApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatus = <TError = Errors>(
  threeLetterCode: string,
    serviceId: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatus>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && serviceId !== null && serviceId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatusKey(threeLetterCode,serviceId) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteStatus(threeLetterCode,serviceId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsServicesFavoritesResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsServicesFavorites200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsServicesFavoritesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsServicesFavoritesResponseSuccess = (getApiV1ThreeLetterCodeAppsServicesFavoritesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsServicesFavoritesResponseError = (getApiV1ThreeLetterCodeAppsServicesFavoritesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsServicesFavoritesResponse = (getApiV1ThreeLetterCodeAppsServicesFavoritesResponseSuccess | getApiV1ThreeLetterCodeAppsServicesFavoritesResponseError)

export const getGetApiV1ThreeLetterCodeAppsServicesFavoritesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/services/favorites`
}

/**
 * ログインユーザーがお気に入り登録しているサービス一覧を取得する
 * @summary List UserFavoriteServices
 */
export const getApiV1ThreeLetterCodeAppsServicesFavorites = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsServicesFavoritesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsServicesFavoritesResponse>(getGetApiV1ThreeLetterCodeAppsServicesFavoritesUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsServicesFavoritesKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/services/favorites`] as const;

export type GetApiV1ThreeLetterCodeAppsServicesFavoritesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsServicesFavorites>>>

/**
 * @summary List UserFavoriteServices
 */
export const useGetApiV1ThreeLetterCodeAppsServicesFavorites = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsServicesFavorites>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsServicesFavoritesKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsServicesFavorites(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponse201 = {
  data: PostApiV1ThreeLetterCodeAppsServicesServiceIdFavorite201
  status: 201
}

export type postApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponseSuccess = (postApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponseError = (postApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponse = (postApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponseSuccess | postApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponseError)

export const getPostApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteUrl = (threeLetterCode: string,
    serviceId: string,) => {




  return `/api/v1/${threeLetterCode}/apps/services/${serviceId}/favorite`
}

/**
 * 指定サービスをお気に入りに登録する
 * @summary Create UserFavoriteService
 */
export const postApiV1ThreeLetterCodeAppsServicesServiceIdFavorite = async (threeLetterCode: string,
    serviceId: string, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponse>(getPostApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteUrl(threeLetterCode,serviceId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteMutationFetcher = (threeLetterCode: string,
    serviceId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeAppsServicesServiceIdFavorite(threeLetterCode, serviceId, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteMutationKey = (threeLetterCode: string,
    serviceId: string,) => [`/api/v1/${threeLetterCode}/apps/services/${serviceId}/favorite`] as const;

export type PostApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsServicesServiceIdFavorite>>>

/**
 * @summary Create UserFavoriteService
 */
export const usePostApiV1ThreeLetterCodeAppsServicesServiceIdFavorite = <TError = Errors>(
  threeLetterCode: string,
    serviceId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsServicesServiceIdFavorite>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsServicesServiceIdFavorite>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteMutationKey(threeLetterCode,serviceId);
  const swrFn = getPostApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteMutationFetcher(threeLetterCode,serviceId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponseSuccess = (deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponseError = (deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponse = (deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponseSuccess | deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponseError)

export const getDeleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteUrl = (threeLetterCode: string,
    serviceId: string,) => {




  return `/api/v1/${threeLetterCode}/apps/services/${serviceId}/favorite`
}

/**
 * 指定サービスのお気に入り登録を解除する
 * @summary Delete UserFavoriteService
 */
export const deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavorite = async (threeLetterCode: string,
    serviceId: string, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteResponse>(getDeleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteUrl(threeLetterCode,serviceId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteMutationFetcher = (threeLetterCode: string,
    serviceId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavorite(threeLetterCode, serviceId, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteMutationKey = (threeLetterCode: string,
    serviceId: string,) => [`/api/v1/${threeLetterCode}/apps/services/${serviceId}/favorite`] as const;

export type DeleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavorite>>>

/**
 * @summary Delete UserFavoriteService
 */
export const useDeleteApiV1ThreeLetterCodeAppsServicesServiceIdFavorite = <TError = Errors>(
  threeLetterCode: string,
    serviceId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavorite>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeAppsServicesServiceIdFavorite>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteMutationKey(threeLetterCode,serviceId);
  const swrFn = getDeleteApiV1ThreeLetterCodeAppsServicesServiceIdFavoriteMutationFetcher(threeLetterCode,serviceId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsServicesSearchResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsServicesSearch200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsServicesSearchResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsServicesSearchResponseSuccess = (getApiV1ThreeLetterCodeAppsServicesSearchResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsServicesSearchResponseError = (getApiV1ThreeLetterCodeAppsServicesSearchResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsServicesSearchResponse = (getApiV1ThreeLetterCodeAppsServicesSearchResponseSuccess | getApiV1ThreeLetterCodeAppsServicesSearchResponseError)

export const getGetApiV1ThreeLetterCodeAppsServicesSearchUrl = (threeLetterCode: string,
    params: GetApiV1ThreeLetterCodeAppsServicesSearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/services/search?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/services/search`
}

/**
 * キーワードでサービスを検索する。検索語の表記ゆれ（ひらがな/カタカナ・全半角・大文字小文字）を正規化したうえで、同義語展開・関連度ランキング・タイポ救済を適用する（タイトル・概要・詳細が対象）。`sort=distance` を指定するとあいまい検索の結果を、リクエストの `longitude`/`latitude` から最寄り店舗の距離が近い順に並び替える（店舗のないサービスは末尾）。`sort=hot` を指定すると利用回数（`usage_count`）の多い順に並び替える（同点は更新日新しい順）。`sort=score` または未指定は関連度スコア順となる（既存挙動）
 * @summary Get Services
 */
export const getApiV1ThreeLetterCodeAppsServicesSearch = async (threeLetterCode: string,
    params: GetApiV1ThreeLetterCodeAppsServicesSearchParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsServicesSearchResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsServicesSearchResponse>(getGetApiV1ThreeLetterCodeAppsServicesSearchUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsServicesSearchKey = (threeLetterCode: string,
    params: GetApiV1ThreeLetterCodeAppsServicesSearchParams,) => [`/api/v1/${threeLetterCode}/apps/services/search`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsServicesSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsServicesSearch>>>

/**
 * @summary Get Services
 */
export const useGetApiV1ThreeLetterCodeAppsServicesSearch = <TError = Errors>(
  threeLetterCode: string,
    params: GetApiV1ThreeLetterCodeAppsServicesSearchParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsServicesSearch>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsServicesSearchKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsServicesSearch(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsServicesUsagesResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsServicesUsages200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsServicesUsagesResponseSuccess = (getApiV1ThreeLetterCodeAppsServicesUsagesResponse200) & {
  headers: Headers;
};
;

export type getApiV1ThreeLetterCodeAppsServicesUsagesResponse = (getApiV1ThreeLetterCodeAppsServicesUsagesResponseSuccess)

export const getGetApiV1ThreeLetterCodeAppsServicesUsagesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/services/usages`
}

/**
 * ログインユーザーのサービス利用履歴一覧を取得する
 * @summary Get ServiceUsages
 */
export const getApiV1ThreeLetterCodeAppsServicesUsages = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsServicesUsagesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsServicesUsagesResponse>(getGetApiV1ThreeLetterCodeAppsServicesUsagesUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsServicesUsagesKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/services/usages`] as const;

export type GetApiV1ThreeLetterCodeAppsServicesUsagesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsServicesUsages>>>

/**
 * @summary Get ServiceUsages
 */
export const useGetApiV1ThreeLetterCodeAppsServicesUsages = <TError = unknown>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsServicesUsages>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsServicesUsagesKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsServicesUsages(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsServicesUsagesResponse201 = {
  data: PostApiV1ThreeLetterCodeAppsServicesUsages201
  status: 201
}

export type postApiV1ThreeLetterCodeAppsServicesUsagesResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeAppsServicesUsagesResponse409 = {
  data: Errors
  status: 409
}

export type postApiV1ThreeLetterCodeAppsServicesUsagesResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeAppsServicesUsagesResponseSuccess = (postApiV1ThreeLetterCodeAppsServicesUsagesResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsServicesUsagesResponseError = (postApiV1ThreeLetterCodeAppsServicesUsagesResponse401 | postApiV1ThreeLetterCodeAppsServicesUsagesResponse409 | postApiV1ThreeLetterCodeAppsServicesUsagesResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsServicesUsagesResponse = (postApiV1ThreeLetterCodeAppsServicesUsagesResponseSuccess | postApiV1ThreeLetterCodeAppsServicesUsagesResponseError)

export const getPostApiV1ThreeLetterCodeAppsServicesUsagesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/services/usages`
}

/**
 * 指定サービスの利用記録を作成する
 * @summary Create ServiceUsages
 */
export const postApiV1ThreeLetterCodeAppsServicesUsages = async (threeLetterCode: string,
    requestAppsServiceUsage?: RequestAppsServiceUsage, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsServicesUsagesResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsServicesUsagesResponse>(getPostApiV1ThreeLetterCodeAppsServicesUsagesUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestAppsServiceUsage)
  }
);}




export const getPostApiV1ThreeLetterCodeAppsServicesUsagesMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestAppsServiceUsage | undefined }) => {
    return postApiV1ThreeLetterCodeAppsServicesUsages(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsServicesUsagesMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/services/usages`] as const;

export type PostApiV1ThreeLetterCodeAppsServicesUsagesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsServicesUsages>>>

/**
 * @summary Create ServiceUsages
 */
export const usePostApiV1ThreeLetterCodeAppsServicesUsages = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsServicesUsages>>, TError, Key, RequestAppsServiceUsage | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsServicesUsages>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsServicesUsagesMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeAppsServicesUsagesMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsServicesResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsServices200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsServicesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsServicesResponseSuccess = (getApiV1ThreeLetterCodeAppsServicesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsServicesResponseError = (getApiV1ThreeLetterCodeAppsServicesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsServicesResponse = (getApiV1ThreeLetterCodeAppsServicesResponseSuccess | getApiV1ThreeLetterCodeAppsServicesResponseError)

export const getGetApiV1ThreeLetterCodeAppsServicesUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsServicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/services?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/services`
}

/**
 * サービス一覧を取得する（フィルタ・ページネーション対応）
 * @summary Get Services
 */
export const getApiV1ThreeLetterCodeAppsServices = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsServicesParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsServicesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsServicesResponse>(getGetApiV1ThreeLetterCodeAppsServicesUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsServicesKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsServicesParams,) => [`/api/v1/${threeLetterCode}/apps/services`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsServicesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsServices>>>

/**
 * @summary Get Services
 */
export const useGetApiV1ThreeLetterCodeAppsServices = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsServicesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsServices>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsServicesKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsServices(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsServicesIdResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsServicesId200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsServicesIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsServicesIdResponseSuccess = (getApiV1ThreeLetterCodeAppsServicesIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsServicesIdResponseError = (getApiV1ThreeLetterCodeAppsServicesIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsServicesIdResponse = (getApiV1ThreeLetterCodeAppsServicesIdResponseSuccess | getApiV1ThreeLetterCodeAppsServicesIdResponseError)

export const getGetApiV1ThreeLetterCodeAppsServicesIdUrl = (threeLetterCode: string,
    id: string,) => {




  return `/api/v1/${threeLetterCode}/apps/services/${id}`
}

/**
 * 指定IDのサービス詳細情報を取得する
 * @summary Get service
 */
export const getApiV1ThreeLetterCodeAppsServicesId = async (threeLetterCode: string,
    id: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsServicesIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsServicesIdResponse>(getGetApiV1ThreeLetterCodeAppsServicesIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsServicesIdKey = (threeLetterCode: string,
    id: string,) => [`/api/v1/${threeLetterCode}/apps/services/${id}`] as const;

export type GetApiV1ThreeLetterCodeAppsServicesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsServicesId>>>

/**
 * @summary Get service
 */
export const useGetApiV1ThreeLetterCodeAppsServicesId = <TError = Errors>(
  threeLetterCode: string,
    id: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsServicesId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsServicesIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsServicesId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponse201 = {
  data: void
  status: 201
}

export type postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponse403 = {
  data: Errors
  status: 403
}

export type postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponseSuccess = (postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponseError = (postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponse401 | postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponse403 | postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponse404 | postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponse = (postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponseSuccess | postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponseError)

export const getPostApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersUrl = (threeLetterCode: string,
    stressAssessmentId: number,) => {




  return `/api/v1/${threeLetterCode}/apps/stress_assessments/${stressAssessmentId}/answers`
}

/**
 * ストレスチェックの回答を一括送信する
 * @summary Submit stress assessment answers
 */
export const postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswers = async (threeLetterCode: string,
    stressAssessmentId: number,
    postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersBody?: PostApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersResponse>(getPostApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersUrl(threeLetterCode,stressAssessmentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersBody)
  }
);}




export const getPostApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersMutationFetcher = (threeLetterCode: string,
    stressAssessmentId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersBody | undefined }) => {
    return postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswers(threeLetterCode, stressAssessmentId, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersMutationKey = (threeLetterCode: string,
    stressAssessmentId: number,) => [`/api/v1/${threeLetterCode}/apps/stress_assessments/${stressAssessmentId}/answers`] as const;

export type PostApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswers>>>

/**
 * @summary Submit stress assessment answers
 */
export const usePostApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswers = <TError = Errors>(
  threeLetterCode: string,
    stressAssessmentId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswers>>, TError, Key, PostApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswers>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersMutationKey(threeLetterCode,stressAssessmentId);
  const swrFn = getPostApiV1ThreeLetterCodeAppsStressAssessmentsStressAssessmentIdAnswersMutationFetcher(threeLetterCode,stressAssessmentId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdCategories200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesResponseSuccess = (getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesResponseError = (getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesResponse401 | getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesResponse = (getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesResponseSuccess | getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesResponseError)

export const getGetApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesUrl = (threeLetterCode: string,
    id: string,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/stress_assessments/${id}/categories?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/stress_assessments/${id}/categories`
}

/**
 * ストレスチェックの設問カテゴリ一覧を取得する
 * @summary Get stress assessment categories
 */
export const getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategories = async (threeLetterCode: string,
    id: string,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesResponse>(getGetApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesUrl(threeLetterCode,id,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesKey = (threeLetterCode: string,
    id: string,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesParams,) => [`/api/v1/${threeLetterCode}/apps/stress_assessments/${id}/categories`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategories>>>

/**
 * @summary Get stress assessment categories
 */
export const useGetApiV1ThreeLetterCodeAppsStressAssessmentsIdCategories = <TError = Errors>(
  threeLetterCode: string,
    id: string,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategories>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsStressAssessmentsIdCategoriesKey(threeLetterCode,id,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsStressAssessmentsIdCategories(threeLetterCode,id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestions200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsResponseSuccess = (getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsResponseError = (getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsResponse401 | getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsResponse = (getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsResponseSuccess | getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsResponseError)

export const getGetApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsUrl = (threeLetterCode: string,
    id: string,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/stress_assessments/${id}/questions?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/stress_assessments/${id}/questions`
}

/**
 * ストレスチェックの設問一覧を取得する
 * @summary Get stress assessment questions
 */
export const getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestions = async (threeLetterCode: string,
    id: string,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsResponse>(getGetApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsUrl(threeLetterCode,id,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsKey = (threeLetterCode: string,
    id: string,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsParams,) => [`/api/v1/${threeLetterCode}/apps/stress_assessments/${id}/questions`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestions>>>

/**
 * @summary Get stress assessment questions
 */
export const useGetApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestions = <TError = Errors>(
  threeLetterCode: string,
    id: string,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestions>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestionsKey(threeLetterCode,id,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsStressAssessmentsIdQuestions(threeLetterCode,id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdResult200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponseSuccess = (getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponseError = (getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse401 | getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse403 | getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse = (getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponseSuccess | getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponseError)

export const getGetApiV1ThreeLetterCodeAppsStressAssessmentsIdResultUrl = (threeLetterCode: string,
    id: number,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdResultParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/stress_assessments/${id}/result?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/stress_assessments/${id}/result`
}

/**
 * ログインユーザーのストレスチェック結果を取得する
 * @summary Get stress assessment result
 */
export const getApiV1ThreeLetterCodeAppsStressAssessmentsIdResult = async (threeLetterCode: string,
    id: number,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdResultParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse>(getGetApiV1ThreeLetterCodeAppsStressAssessmentsIdResultUrl(threeLetterCode,id,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsStressAssessmentsIdResultKey = (threeLetterCode: string,
    id: number,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdResultParams,) => [`/api/v1/${threeLetterCode}/apps/stress_assessments/${id}/result`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsStressAssessmentsIdResultQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsStressAssessmentsIdResult>>>

/**
 * @summary Get stress assessment result
 */
export const useGetApiV1ThreeLetterCodeAppsStressAssessmentsIdResult = <TError = Errors>(
  threeLetterCode: string,
    id: number,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsIdResultParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsStressAssessmentsIdResult>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsStressAssessmentsIdResultKey(threeLetterCode,id,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsStressAssessmentsIdResult(threeLetterCode,id,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse204 = {
  data: void
  status: 204
}

export type putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse403 = {
  data: Errors
  status: 403
}

export type putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse404 = {
  data: Errors
  status: 404
}

export type putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponseSuccess = (putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse204) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponseError = (putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse401 | putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse403 | putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse404) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse = (putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponseSuccess | putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponseError)

export const getPutApiV1ThreeLetterCodeAppsStressAssessmentsIdResultUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/apps/stress_assessments/${id}/result`
}

/**
 * ストレスチェック結果に対する医師面接希望の有無を更新する
 * @summary Update stress assessment result
 */
export const putApiV1ThreeLetterCodeAppsStressAssessmentsIdResult = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultBody: PutApiV1ThreeLetterCodeAppsStressAssessmentsIdResultBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse> => {

  return customInstance<putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultResponse>(getPutApiV1ThreeLetterCodeAppsStressAssessmentsIdResultUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeAppsStressAssessmentsIdResultBody)
  }
);}




export const getPutApiV1ThreeLetterCodeAppsStressAssessmentsIdResultMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeAppsStressAssessmentsIdResultBody }) => {
    return putApiV1ThreeLetterCodeAppsStressAssessmentsIdResult(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeAppsStressAssessmentsIdResultMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/apps/stress_assessments/${id}/result`] as const;

export type PutApiV1ThreeLetterCodeAppsStressAssessmentsIdResultMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsStressAssessmentsIdResult>>>

/**
 * @summary Update stress assessment result
 */
export const usePutApiV1ThreeLetterCodeAppsStressAssessmentsIdResult = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsStressAssessmentsIdResult>>, TError, Key, PutApiV1ThreeLetterCodeAppsStressAssessmentsIdResultBody, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsStressAssessmentsIdResult>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeAppsStressAssessmentsIdResultMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodeAppsStressAssessmentsIdResultMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsStressAssessments200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeAppsStressAssessmentsResponseSuccess = (getApiV1ThreeLetterCodeAppsStressAssessmentsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsStressAssessmentsResponseError = (getApiV1ThreeLetterCodeAppsStressAssessmentsResponse401 | getApiV1ThreeLetterCodeAppsStressAssessmentsResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsStressAssessmentsResponse = (getApiV1ThreeLetterCodeAppsStressAssessmentsResponseSuccess | getApiV1ThreeLetterCodeAppsStressAssessmentsResponseError)

export const getGetApiV1ThreeLetterCodeAppsStressAssessmentsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/stress_assessments?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/stress_assessments`
}

/**
 * ログインユーザーが対象のストレスチェック実施一覧を取得する
 * @summary Get stress_assessments
 */
export const getApiV1ThreeLetterCodeAppsStressAssessments = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsStressAssessmentsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsStressAssessmentsResponse>(getGetApiV1ThreeLetterCodeAppsStressAssessmentsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsStressAssessmentsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsParams,) => [`/api/v1/${threeLetterCode}/apps/stress_assessments`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsStressAssessmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsStressAssessments>>>

/**
 * @summary Get stress_assessments
 */
export const useGetApiV1ThreeLetterCodeAppsStressAssessments = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsStressAssessmentsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsStressAssessments>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsStressAssessmentsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsStressAssessments(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsTopBannersResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsTopBanners200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsTopBannersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsTopBannersResponseSuccess = (getApiV1ThreeLetterCodeAppsTopBannersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsTopBannersResponseError = (getApiV1ThreeLetterCodeAppsTopBannersResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsTopBannersResponse = (getApiV1ThreeLetterCodeAppsTopBannersResponseSuccess | getApiV1ThreeLetterCodeAppsTopBannersResponseError)

export const getGetApiV1ThreeLetterCodeAppsTopBannersUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/top_banners`
}

/**
 * トップページに表示するバナーの一覧を取得する
 * @summary Get top_banners
 */
export const getApiV1ThreeLetterCodeAppsTopBanners = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsTopBannersResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsTopBannersResponse>(getGetApiV1ThreeLetterCodeAppsTopBannersUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsTopBannersKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/top_banners`] as const;

export type GetApiV1ThreeLetterCodeAppsTopBannersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsTopBanners>>>

/**
 * @summary Get top_banners
 */
export const useGetApiV1ThreeLetterCodeAppsTopBanners = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsTopBanners>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsTopBannersKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsTopBanners(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsUserGiftsEligibilityResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsUserGiftsEligibility200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsUserGiftsEligibilityResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsUserGiftsEligibilityResponseSuccess = (getApiV1ThreeLetterCodeAppsUserGiftsEligibilityResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsUserGiftsEligibilityResponseError = (getApiV1ThreeLetterCodeAppsUserGiftsEligibilityResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsUserGiftsEligibilityResponse = (getApiV1ThreeLetterCodeAppsUserGiftsEligibilityResponseSuccess | getApiV1ThreeLetterCodeAppsUserGiftsEligibilityResponseError)

export const getGetApiV1ThreeLetterCodeAppsUserGiftsEligibilityUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/user_gifts/eligibility`
}

/**
 * ログインユーザーがギフト取得資格を持つかを判定する
 * @summary Get UserGift::Eligibilities
 */
export const getApiV1ThreeLetterCodeAppsUserGiftsEligibility = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsUserGiftsEligibilityResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsUserGiftsEligibilityResponse>(getGetApiV1ThreeLetterCodeAppsUserGiftsEligibilityUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsUserGiftsEligibilityKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/user_gifts/eligibility`] as const;

export type GetApiV1ThreeLetterCodeAppsUserGiftsEligibilityQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUserGiftsEligibility>>>

/**
 * @summary Get UserGift::Eligibilities
 */
export const useGetApiV1ThreeLetterCodeAppsUserGiftsEligibility = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUserGiftsEligibility>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsUserGiftsEligibilityKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsUserGiftsEligibility(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsResponse201 = {
  data: PostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCards201
  status: 201
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsResponse403 = {
  data: void
  status: 403
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsResponseSuccess = (postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsResponseError = (postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsResponse401 | postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsResponse403) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsResponse = (postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsResponseSuccess | postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsResponseError)

export const getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsUrl = (threeLetterCode: string,
    userGiftId: string,) => {




  return `/api/v1/${threeLetterCode}/apps/user_gifts/${userGiftId}/gift_cards`
}

/**
 * 指定設定のギフトカードを発行しログインユーザーに付与する
 * @summary Create GiftCard
 */
export const postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCards = async (threeLetterCode: string,
    userGiftId: string,
    requestAppsGiftCard?: RequestAppsGiftCard, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsResponse>(getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsUrl(threeLetterCode,userGiftId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestAppsGiftCard)
  }
);}




export const getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsMutationFetcher = (threeLetterCode: string,
    userGiftId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestAppsGiftCard | undefined }) => {
    return postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCards(threeLetterCode, userGiftId, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsMutationKey = (threeLetterCode: string,
    userGiftId: string,) => [`/api/v1/${threeLetterCode}/apps/user_gifts/${userGiftId}/gift_cards`] as const;

export type PostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCards>>>

/**
 * @summary Create GiftCard
 */
export const usePostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCards = <TError = Errors | void>(
  threeLetterCode: string,
    userGiftId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCards>>, TError, Key, RequestAppsGiftCard | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCards>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsMutationKey(threeLetterCode,userGiftId);
  const swrFn = getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGiftCardsMutationFetcher(threeLetterCode,userGiftId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesResponse201 = {
  data: PostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxes201
  status: 201
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesResponse403 = {
  data: void
  status: 403
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesResponseSuccess = (postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesResponseError = (postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesResponse401 | postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesResponse403) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesResponse = (postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesResponseSuccess | postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesResponseError)

export const getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesUrl = (threeLetterCode: string,
    userGiftId: string,) => {




  return `/api/v1/${threeLetterCode}/apps/user_gifts/${userGiftId}/giftee_boxes`
}

/**
 * GifteeBoxを発行しログインユーザーに付与する
 * @summary Create GifteeBox
 */
export const postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxes = async (threeLetterCode: string,
    userGiftId: string, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesResponse>(getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesUrl(threeLetterCode,userGiftId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesMutationFetcher = (threeLetterCode: string,
    userGiftId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxes(threeLetterCode, userGiftId, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesMutationKey = (threeLetterCode: string,
    userGiftId: string,) => [`/api/v1/${threeLetterCode}/apps/user_gifts/${userGiftId}/giftee_boxes`] as const;

export type PostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxes>>>

/**
 * @summary Create GifteeBox
 */
export const usePostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxes = <TError = Errors | void>(
  threeLetterCode: string,
    userGiftId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxes>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxes>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesMutationKey(threeLetterCode,userGiftId);
  const swrFn = getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdGifteeBoxesMutationFetcher(threeLetterCode,userGiftId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsResponse201 = {
  data: PostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydons201
  status: 201
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsResponse403 = {
  data: void
  status: 403
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsResponseSuccess = (postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsResponseError = (postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsResponse401 | postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsResponse403) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsResponse = (postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsResponseSuccess | postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsResponseError)

export const getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsUrl = (threeLetterCode: string,
    userGiftId: number,) => {




  return `/api/v1/${threeLetterCode}/apps/user_gifts/${userGiftId}/paydons`
}

/**
 * Paydonギフトを発行しログインユーザーに付与する
 * @summary Create Paydon
 */
export const postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydons = async (threeLetterCode: string,
    userGiftId: number, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsResponse>(getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsUrl(threeLetterCode,userGiftId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsMutationFetcher = (threeLetterCode: string,
    userGiftId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydons(threeLetterCode, userGiftId, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsMutationKey = (threeLetterCode: string,
    userGiftId: number,) => [`/api/v1/${threeLetterCode}/apps/user_gifts/${userGiftId}/paydons`] as const;

export type PostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydons>>>

/**
 * @summary Create Paydon
 */
export const usePostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydons = <TError = Errors | void>(
  threeLetterCode: string,
    userGiftId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydons>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydons>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsMutationKey(threeLetterCode,userGiftId);
  const swrFn = getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdPaydonsMutationFetcher(threeLetterCode,userGiftId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse201 = {
  data: PostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons201
  status: 201
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse403 = {
  data: void
  status: 403
}

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponseSuccess = (postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponseError = (postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse401 | postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse403) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse = (postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponseSuccess | postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponseError)

export const getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsUrl = (threeLetterCode: string,
    userGiftId: string,) => {




  return `/api/v1/${threeLetterCode}/apps/user_gifts/${userGiftId}/redeemable_store_coupons`
}

/**
 * 地域ギフト（店舗利用型クーポン）を発行しログインユーザーに付与する
 * @summary Create RedeemableStoreCoupon
 */
export const postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons = async (threeLetterCode: string,
    userGiftId: string, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse>(getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsUrl(threeLetterCode,userGiftId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsMutationFetcher = (threeLetterCode: string,
    userGiftId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons(threeLetterCode, userGiftId, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsMutationKey = (threeLetterCode: string,
    userGiftId: string,) => [`/api/v1/${threeLetterCode}/apps/user_gifts/${userGiftId}/redeemable_store_coupons`] as const;

export type PostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons>>>

/**
 * @summary Create RedeemableStoreCoupon
 */
export const usePostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons = <TError = Errors | void>(
  threeLetterCode: string,
    userGiftId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsMutationKey(threeLetterCode,userGiftId);
  const swrFn = getPostApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsMutationFetcher(threeLetterCode,userGiftId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse200 = {
  data: PutApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons200
  status: 200
}

export type putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse403 = {
  data: Errors
  status: 403
}

export type putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponseSuccess = (putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponseError = (putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse401 | putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse403) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse = (putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponseSuccess | putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponseError)

export const getPutApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsUrl = (threeLetterCode: string,
    userGiftId: string,) => {




  return `/api/v1/${threeLetterCode}/apps/user_gifts/${userGiftId}/redeemable_store_coupons`
}

/**
 * 地域ギフトに利用店舗を設定し利用済みとして記録する
 * @summary Update RedeemableStoreCoupon (set store_id and mark as redeemed)
 */
export const putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons = async (threeLetterCode: string,
    userGiftId: string,
    requestAppsUpdateRedeemableStoreCoupon?: RequestAppsUpdateRedeemableStoreCoupon, options?: RequestInit): Promise<putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse> => {

  return customInstance<putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsResponse>(getPutApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsUrl(threeLetterCode,userGiftId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestAppsUpdateRedeemableStoreCoupon)
  }
);}




export const getPutApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsMutationFetcher = (threeLetterCode: string,
    userGiftId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestAppsUpdateRedeemableStoreCoupon | undefined }) => {
    return putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons(threeLetterCode, userGiftId, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsMutationKey = (threeLetterCode: string,
    userGiftId: string,) => [`/api/v1/${threeLetterCode}/apps/user_gifts/${userGiftId}/redeemable_store_coupons`] as const;

export type PutApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons>>>

/**
 * @summary Update RedeemableStoreCoupon (set store_id and mark as redeemed)
 */
export const usePutApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons = <TError = Errors>(
  threeLetterCode: string,
    userGiftId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons>>, TError, Key, RequestAppsUpdateRedeemableStoreCoupon | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCoupons>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsMutationKey(threeLetterCode,userGiftId);
  const swrFn = getPutApiV1ThreeLetterCodeAppsUserGiftsUserGiftIdRedeemableStoreCouponsMutationFetcher(threeLetterCode,userGiftId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsUserGiftsResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsUserGifts200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsUserGiftsResponseSuccess = (getApiV1ThreeLetterCodeAppsUserGiftsResponse200) & {
  headers: Headers;
};
;

export type getApiV1ThreeLetterCodeAppsUserGiftsResponse = (getApiV1ThreeLetterCodeAppsUserGiftsResponseSuccess)

export const getGetApiV1ThreeLetterCodeAppsUserGiftsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsUserGiftsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/user_gifts?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/user_gifts`
}

/**
 * ログインユーザーが受け取ったギフト一覧を取得する（種別・ステータスでの絞り込み対応）
 * @summary Get user_gifts
 */
export const getApiV1ThreeLetterCodeAppsUserGifts = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsUserGiftsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsUserGiftsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsUserGiftsResponse>(getGetApiV1ThreeLetterCodeAppsUserGiftsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsUserGiftsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsUserGiftsParams,) => [`/api/v1/${threeLetterCode}/apps/user_gifts`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsUserGiftsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUserGifts>>>

/**
 * @summary Get user_gifts
 */
export const useGetApiV1ThreeLetterCodeAppsUserGifts = <TError = unknown>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsUserGiftsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUserGifts>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsUserGiftsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsUserGifts(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsUserGiftsResponse201 = {
  data: PostApiV1ThreeLetterCodeAppsUserGifts201
  status: 201
}

export type postApiV1ThreeLetterCodeAppsUserGiftsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeAppsUserGiftsResponse403 = {
  data: Errors
  status: 403
}

export type postApiV1ThreeLetterCodeAppsUserGiftsResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeAppsUserGiftsResponseSuccess = (postApiV1ThreeLetterCodeAppsUserGiftsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsUserGiftsResponseError = (postApiV1ThreeLetterCodeAppsUserGiftsResponse401 | postApiV1ThreeLetterCodeAppsUserGiftsResponse403 | postApiV1ThreeLetterCodeAppsUserGiftsResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsUserGiftsResponse = (postApiV1ThreeLetterCodeAppsUserGiftsResponseSuccess | postApiV1ThreeLetterCodeAppsUserGiftsResponseError)

export const getPostApiV1ThreeLetterCodeAppsUserGiftsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/user_gifts`
}

/**
 * デフォルト設定のギフトをログインユーザーに発行する
 * @summary Create user_gifts
 */
export const postApiV1ThreeLetterCodeAppsUserGifts = async (threeLetterCode: string, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsUserGiftsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsUserGiftsResponse>(getPostApiV1ThreeLetterCodeAppsUserGiftsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeAppsUserGiftsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeAppsUserGifts(threeLetterCode, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsUserGiftsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/user_gifts`] as const;

export type PostApiV1ThreeLetterCodeAppsUserGiftsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGifts>>>

/**
 * @summary Create user_gifts
 */
export const usePostApiV1ThreeLetterCodeAppsUserGifts = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGifts>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserGifts>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsUserGiftsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeAppsUserGiftsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsUsersActivationResponse200 = {
  data: SimpleMessage
  status: 200
}

export type postApiV1ThreeLetterCodeAppsUsersActivationResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeAppsUsersActivationResponseSuccess = (postApiV1ThreeLetterCodeAppsUsersActivationResponse200) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsUsersActivationResponseError = (postApiV1ThreeLetterCodeAppsUsersActivationResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsUsersActivationResponse = (postApiV1ThreeLetterCodeAppsUsersActivationResponseSuccess | postApiV1ThreeLetterCodeAppsUsersActivationResponseError)

export const getPostApiV1ThreeLetterCodeAppsUsersActivationUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/users/activation`
}

/**
 * メール等で配布されたアクティベーションコードの有効性を検証する
 * @summary Verify activation code
 */
export const postApiV1ThreeLetterCodeAppsUsersActivation = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeAppsUsersActivationBody?: PostApiV1ThreeLetterCodeAppsUsersActivationBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsUsersActivationResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsUsersActivationResponse>(getPostApiV1ThreeLetterCodeAppsUsersActivationUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeAppsUsersActivationBody)
  }
);}




export const getPostApiV1ThreeLetterCodeAppsUsersActivationMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeAppsUsersActivationBody | undefined }) => {
    return postApiV1ThreeLetterCodeAppsUsersActivation(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsUsersActivationMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/users/activation`] as const;

export type PostApiV1ThreeLetterCodeAppsUsersActivationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUsersActivation>>>

/**
 * @summary Verify activation code
 */
export const usePostApiV1ThreeLetterCodeAppsUsersActivation = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUsersActivation>>, TError, Key, PostApiV1ThreeLetterCodeAppsUsersActivationBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUsersActivation>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsUsersActivationMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeAppsUsersActivationMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeAppsUsersActivationResponse200 = {
  data: PutApiV1ThreeLetterCodeAppsUsersActivation200
  status: 200
}

export type putApiV1ThreeLetterCodeAppsUsersActivationResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeAppsUsersActivationResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeAppsUsersActivationResponseSuccess = (putApiV1ThreeLetterCodeAppsUsersActivationResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeAppsUsersActivationResponseError = (putApiV1ThreeLetterCodeAppsUsersActivationResponse401 | putApiV1ThreeLetterCodeAppsUsersActivationResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeAppsUsersActivationResponse = (putApiV1ThreeLetterCodeAppsUsersActivationResponseSuccess | putApiV1ThreeLetterCodeAppsUsersActivationResponseError)

export const getPutApiV1ThreeLetterCodeAppsUsersActivationUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/users/activation`
}

/**
 * アクティベーションコードでユーザーを有効化する。
 * 受け付けるログイン方法（電話番号 / メールアドレス）はパートナーの application_configuration.login_method で切り替わる。
 * @summary Activate user with activation code
 */
export const putApiV1ThreeLetterCodeAppsUsersActivation = async (threeLetterCode: string,
    putApiV1ThreeLetterCodeAppsUsersActivationBody?: PutApiV1ThreeLetterCodeAppsUsersActivationBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeAppsUsersActivationResponse> => {

  return customInstance<putApiV1ThreeLetterCodeAppsUsersActivationResponse>(getPutApiV1ThreeLetterCodeAppsUsersActivationUrl(threeLetterCode),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeAppsUsersActivationBody)
  }
);}




export const getPutApiV1ThreeLetterCodeAppsUsersActivationMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeAppsUsersActivationBody | undefined }) => {
    return putApiV1ThreeLetterCodeAppsUsersActivation(threeLetterCode, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeAppsUsersActivationMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/users/activation`] as const;

export type PutApiV1ThreeLetterCodeAppsUsersActivationMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUsersActivation>>>

/**
 * @summary Activate user with activation code
 */
export const usePutApiV1ThreeLetterCodeAppsUsersActivation = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUsersActivation>>, TError, Key, PutApiV1ThreeLetterCodeAppsUsersActivationBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUsersActivation>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeAppsUsersActivationMutationKey(threeLetterCode);
  const swrFn = getPutApiV1ThreeLetterCodeAppsUsersActivationMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1SFRAppsUsersAuthFreeeLoginResponse200 = {
  data: PostApiV1SFRAppsUsersAuthFreeeLogin200
  status: 200
}

export type postApiV1SFRAppsUsersAuthFreeeLoginResponseSuccess = (postApiV1SFRAppsUsersAuthFreeeLoginResponse200) & {
  headers: Headers;
};
;

export type postApiV1SFRAppsUsersAuthFreeeLoginResponse = (postApiV1SFRAppsUsersAuthFreeeLoginResponseSuccess)

export const getPostApiV1SFRAppsUsersAuthFreeeLoginUrl = () => {




  return `/api/v1/SFR/apps/users/auth/freee/login`
}

/**
 * テナント SFR 専用: This API is exclusively for the SFR tenant.
 * @summary Start freee OIDC authentication
 */
export const postApiV1SFRAppsUsersAuthFreeeLogin = async ( options?: RequestInit): Promise<postApiV1SFRAppsUsersAuthFreeeLoginResponse> => {

  return customInstance<postApiV1SFRAppsUsersAuthFreeeLoginResponse>(getPostApiV1SFRAppsUsersAuthFreeeLoginUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1SFRAppsUsersAuthFreeeLoginMutationFetcher = ( options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1SFRAppsUsersAuthFreeeLogin(options);
  }
}
export const getPostApiV1SFRAppsUsersAuthFreeeLoginMutationKey = () => [`/api/v1/SFR/apps/users/auth/freee/login`] as const;

export type PostApiV1SFRAppsUsersAuthFreeeLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1SFRAppsUsersAuthFreeeLogin>>>

/**
 * @summary Start freee OIDC authentication
 */
export const usePostApiV1SFRAppsUsersAuthFreeeLogin = <TError = unknown>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1SFRAppsUsersAuthFreeeLogin>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1SFRAppsUsersAuthFreeeLogin>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1SFRAppsUsersAuthFreeeLoginMutationKey();
  const swrFn = getPostApiV1SFRAppsUsersAuthFreeeLoginMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1SFRAppsUsersAuthFreeeCallbackResponse204 = {
  data: void
  status: 204
}

export type postApiV1SFRAppsUsersAuthFreeeCallbackResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1SFRAppsUsersAuthFreeeCallbackResponseSuccess = (postApiV1SFRAppsUsersAuthFreeeCallbackResponse204) & {
  headers: Headers;
};
export type postApiV1SFRAppsUsersAuthFreeeCallbackResponseError = (postApiV1SFRAppsUsersAuthFreeeCallbackResponse422) & {
  headers: Headers;
};

export type postApiV1SFRAppsUsersAuthFreeeCallbackResponse = (postApiV1SFRAppsUsersAuthFreeeCallbackResponseSuccess | postApiV1SFRAppsUsersAuthFreeeCallbackResponseError)

export const getPostApiV1SFRAppsUsersAuthFreeeCallbackUrl = (params: PostApiV1SFRAppsUsersAuthFreeeCallbackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/SFR/apps/users/auth/freee/callback?${stringifiedParams}` : `/api/v1/SFR/apps/users/auth/freee/callback`
}

/**
 * テナント SFR 専用: This API is exclusively for the SFR tenant.
 * @summary Handle freee OIDC callback
 */
export const postApiV1SFRAppsUsersAuthFreeeCallback = async (params: PostApiV1SFRAppsUsersAuthFreeeCallbackParams, options?: RequestInit): Promise<postApiV1SFRAppsUsersAuthFreeeCallbackResponse> => {

  return customInstance<postApiV1SFRAppsUsersAuthFreeeCallbackResponse>(getPostApiV1SFRAppsUsersAuthFreeeCallbackUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1SFRAppsUsersAuthFreeeCallbackMutationFetcher = (params: PostApiV1SFRAppsUsersAuthFreeeCallbackParams, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1SFRAppsUsersAuthFreeeCallback(params, options);
  }
}
export const getPostApiV1SFRAppsUsersAuthFreeeCallbackMutationKey = (params: PostApiV1SFRAppsUsersAuthFreeeCallbackParams,) => [`/api/v1/SFR/apps/users/auth/freee/callback`, ...(params ? [params]: [])] as const;

export type PostApiV1SFRAppsUsersAuthFreeeCallbackMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1SFRAppsUsersAuthFreeeCallback>>>

/**
 * @summary Handle freee OIDC callback
 */
export const usePostApiV1SFRAppsUsersAuthFreeeCallback = <TError = Errors>(
  params: PostApiV1SFRAppsUsersAuthFreeeCallbackParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1SFRAppsUsersAuthFreeeCallback>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1SFRAppsUsersAuthFreeeCallback>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1SFRAppsUsersAuthFreeeCallbackMutationKey(params);
  const swrFn = getPostApiV1SFRAppsUsersAuthFreeeCallbackMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsUserBankAccountResponse200 = {
  data: BankAccount
  status: 200
}

export type getApiV1ThreeLetterCodeAppsUserBankAccountResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsUserBankAccountResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeAppsUserBankAccountResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeAppsUserBankAccountResponseSuccess = (getApiV1ThreeLetterCodeAppsUserBankAccountResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsUserBankAccountResponseError = (getApiV1ThreeLetterCodeAppsUserBankAccountResponse401 | getApiV1ThreeLetterCodeAppsUserBankAccountResponse403 | getApiV1ThreeLetterCodeAppsUserBankAccountResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsUserBankAccountResponse = (getApiV1ThreeLetterCodeAppsUserBankAccountResponseSuccess | getApiV1ThreeLetterCodeAppsUserBankAccountResponseError)

export const getGetApiV1ThreeLetterCodeAppsUserBankAccountUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/user/bank_account`
}

/**
 * 連携済みの銀行口座情報を取得する
 * @summary Show linked bank account
 */
export const getApiV1ThreeLetterCodeAppsUserBankAccount = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsUserBankAccountResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsUserBankAccountResponse>(getGetApiV1ThreeLetterCodeAppsUserBankAccountUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsUserBankAccountKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/user/bank_account`] as const;

export type GetApiV1ThreeLetterCodeAppsUserBankAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUserBankAccount>>>

/**
 * @summary Show linked bank account
 */
export const useGetApiV1ThreeLetterCodeAppsUserBankAccount = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUserBankAccount>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsUserBankAccountKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsUserBankAccount(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsUserBankAccountResponse201 = {
  data: BankAccount
  status: 201
}

export type postApiV1ThreeLetterCodeAppsUserBankAccountResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeAppsUserBankAccountResponse403 = {
  data: Errors
  status: 403
}

export type postApiV1ThreeLetterCodeAppsUserBankAccountResponse502 = {
  data: Errors
  status: 502
}

export type postApiV1ThreeLetterCodeAppsUserBankAccountResponseSuccess = (postApiV1ThreeLetterCodeAppsUserBankAccountResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsUserBankAccountResponseError = (postApiV1ThreeLetterCodeAppsUserBankAccountResponse401 | postApiV1ThreeLetterCodeAppsUserBankAccountResponse403 | postApiV1ThreeLetterCodeAppsUserBankAccountResponse502) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsUserBankAccountResponse = (postApiV1ThreeLetterCodeAppsUserBankAccountResponseSuccess | postApiV1ThreeLetterCodeAppsUserBankAccountResponseError)

export const getPostApiV1ThreeLetterCodeAppsUserBankAccountUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/user/bank_account`
}

/**
 * TSUBASA 暗証番号認証要求 API を呼び出し、連携手続き中の BankAccount を返す。外部ブラウザで開く URL は X-Bank-Account-Redirect-URL レスポンスヘッダーで返却される
 * @summary Start bank account linking
 */
export const postApiV1ThreeLetterCodeAppsUserBankAccount = async (threeLetterCode: string, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsUserBankAccountResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsUserBankAccountResponse>(getPostApiV1ThreeLetterCodeAppsUserBankAccountUrl(threeLetterCode),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeAppsUserBankAccountMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeAppsUserBankAccount(threeLetterCode, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsUserBankAccountMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/user/bank_account`] as const;

export type PostApiV1ThreeLetterCodeAppsUserBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserBankAccount>>>

/**
 * @summary Start bank account linking
 */
export const usePostApiV1ThreeLetterCodeAppsUserBankAccount = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserBankAccount>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUserBankAccount>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsUserBankAccountMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeAppsUserBankAccountMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type patchApiV1ThreeLetterCodeAppsUserBankAccountResponse200 = {
  data: BankAccount
  status: 200
}

export type patchApiV1ThreeLetterCodeAppsUserBankAccountResponse401 = {
  data: Errors
  status: 401
}

export type patchApiV1ThreeLetterCodeAppsUserBankAccountResponse403 = {
  data: Errors
  status: 403
}

export type patchApiV1ThreeLetterCodeAppsUserBankAccountResponse404 = {
  data: Errors
  status: 404
}

export type patchApiV1ThreeLetterCodeAppsUserBankAccountResponse502 = {
  data: Errors
  status: 502
}

export type patchApiV1ThreeLetterCodeAppsUserBankAccountResponseSuccess = (patchApiV1ThreeLetterCodeAppsUserBankAccountResponse200) & {
  headers: Headers;
};
export type patchApiV1ThreeLetterCodeAppsUserBankAccountResponseError = (patchApiV1ThreeLetterCodeAppsUserBankAccountResponse401 | patchApiV1ThreeLetterCodeAppsUserBankAccountResponse403 | patchApiV1ThreeLetterCodeAppsUserBankAccountResponse404 | patchApiV1ThreeLetterCodeAppsUserBankAccountResponse502) & {
  headers: Headers;
};

export type patchApiV1ThreeLetterCodeAppsUserBankAccountResponse = (patchApiV1ThreeLetterCodeAppsUserBankAccountResponseSuccess | patchApiV1ThreeLetterCodeAppsUserBankAccountResponseError)

export const getPatchApiV1ThreeLetterCodeAppsUserBankAccountUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/user/bank_account`
}

/**
 * TSUBASA 口振受付結果照会 API を呼び出し、口座連携の最新ステータスを返す。リクエストボディは取らず、サーバ側で保持している external_application_id を TSUBASA に送る
 * @summary Verify bank account linkage status
 */
export const patchApiV1ThreeLetterCodeAppsUserBankAccount = async (threeLetterCode: string, options?: RequestInit): Promise<patchApiV1ThreeLetterCodeAppsUserBankAccountResponse> => {

  return customInstance<patchApiV1ThreeLetterCodeAppsUserBankAccountResponse>(getPatchApiV1ThreeLetterCodeAppsUserBankAccountUrl(threeLetterCode),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getPatchApiV1ThreeLetterCodeAppsUserBankAccountMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return patchApiV1ThreeLetterCodeAppsUserBankAccount(threeLetterCode, options);
  }
}
export const getPatchApiV1ThreeLetterCodeAppsUserBankAccountMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/user/bank_account`] as const;

export type PatchApiV1ThreeLetterCodeAppsUserBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeAppsUserBankAccount>>>

/**
 * @summary Verify bank account linkage status
 */
export const usePatchApiV1ThreeLetterCodeAppsUserBankAccount = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeAppsUserBankAccount>>, TError, Key, Arguments, Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeAppsUserBankAccount>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchApiV1ThreeLetterCodeAppsUserBankAccountMutationKey(threeLetterCode);
  const swrFn = getPatchApiV1ThreeLetterCodeAppsUserBankAccountMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsUsersInvitationsInviteesResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsUsersInvitationsInvitees200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsUsersInvitationsInviteesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsUsersInvitationsInviteesResponseSuccess = (getApiV1ThreeLetterCodeAppsUsersInvitationsInviteesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsUsersInvitationsInviteesResponseError = (getApiV1ThreeLetterCodeAppsUsersInvitationsInviteesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsUsersInvitationsInviteesResponse = (getApiV1ThreeLetterCodeAppsUsersInvitationsInviteesResponseSuccess | getApiV1ThreeLetterCodeAppsUsersInvitationsInviteesResponseError)

export const getGetApiV1ThreeLetterCodeAppsUsersInvitationsInviteesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/users/invitations/invitees`
}

/**
 * ログインユーザーが招待した招待先（被招待ユーザー）の一覧を取得する
 * @summary Get Invitees
 */
export const getApiV1ThreeLetterCodeAppsUsersInvitationsInvitees = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsUsersInvitationsInviteesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsUsersInvitationsInviteesResponse>(getGetApiV1ThreeLetterCodeAppsUsersInvitationsInviteesUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsUsersInvitationsInviteesKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/users/invitations/invitees`] as const;

export type GetApiV1ThreeLetterCodeAppsUsersInvitationsInviteesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUsersInvitationsInvitees>>>

/**
 * @summary Get Invitees
 */
export const useGetApiV1ThreeLetterCodeAppsUsersInvitationsInvitees = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUsersInvitationsInvitees>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsUsersInvitationsInviteesKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsUsersInvitationsInvitees(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdResponseSuccess = (deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdResponseError = (deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdResponse = (deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdResponseSuccess | deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdResponseError)

export const getDeleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/apps/users/invitations/invitees/${id}`
}

/**
 * 招待者（inviter）が招待済みの家族（invitee）を削除する。inviteeのUserレコードも物理削除される。
 * @summary Delete Invitee
 */
export const deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdResponse>(getDeleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/apps/users/invitations/invitees/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesId>>>

/**
 * @summary Delete Invitee
 */
export const useDeleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeAppsUsersInvitationsInviteesIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponse201 = {
  data: PostApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrations201
  status: 201
}

export type postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponse403 = {
  data: Errors
  status: 403
}

export type postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponseSuccess = (postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponseError = (postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponse403 | postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponse404 | postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponse = (postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponseSuccess | postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponseError)

export const getPostApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsUrl = (threeLetterCode: string,
    invitationToken: string,) => {




  return `/api/v1/${threeLetterCode}/apps/users/invitations/${invitationToken}/registrations`
}

/**
 * 招待トークン経由で被招待ユーザーを新規登録する
 * @summary Create User
 */
export const postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrations = async (threeLetterCode: string,
    invitationToken: string,
    requestAppsCreateInvitationUser?: RequestAppsCreateInvitationUser, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsResponse>(getPostApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsUrl(threeLetterCode,invitationToken),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestAppsCreateInvitationUser)
  }
);}




export const getPostApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsMutationFetcher = (threeLetterCode: string,
    invitationToken: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestAppsCreateInvitationUser | undefined }) => {
    return postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrations(threeLetterCode, invitationToken, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsMutationKey = (threeLetterCode: string,
    invitationToken: string,) => [`/api/v1/${threeLetterCode}/apps/users/invitations/${invitationToken}/registrations`] as const;

export type PostApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrations>>>

/**
 * @summary Create User
 */
export const usePostApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrations = <TError = Errors>(
  threeLetterCode: string,
    invitationToken: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrations>>, TError, Key, RequestAppsCreateInvitationUser | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrations>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsMutationKey(threeLetterCode,invitationToken);
  const swrFn = getPostApiV1ThreeLetterCodeAppsUsersInvitationsInvitationTokenRegistrationsMutationFetcher(threeLetterCode,invitationToken, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsUsersNotificationsResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsUsersNotifications200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsUsersNotificationsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsUsersNotificationsResponseSuccess = (getApiV1ThreeLetterCodeAppsUsersNotificationsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsUsersNotificationsResponseError = (getApiV1ThreeLetterCodeAppsUsersNotificationsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsUsersNotificationsResponse = (getApiV1ThreeLetterCodeAppsUsersNotificationsResponseSuccess | getApiV1ThreeLetterCodeAppsUsersNotificationsResponseError)

export const getGetApiV1ThreeLetterCodeAppsUsersNotificationsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsUsersNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/users/notifications?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/users/notifications`
}

/**
 * ログインユーザー向けに配信された通知一覧を取得する（カテゴリ絞り込み対応）
 * @summary Get notifications
 */
export const getApiV1ThreeLetterCodeAppsUsersNotifications = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsUsersNotificationsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsUsersNotificationsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsUsersNotificationsResponse>(getGetApiV1ThreeLetterCodeAppsUsersNotificationsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsUsersNotificationsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsUsersNotificationsParams,) => [`/api/v1/${threeLetterCode}/apps/users/notifications`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsUsersNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUsersNotifications>>>

/**
 * @summary Get notifications
 */
export const useGetApiV1ThreeLetterCodeAppsUsersNotifications = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsUsersNotificationsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUsersNotifications>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsUsersNotificationsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsUsersNotifications(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsUsersPasswordResetsResponse201 = {
  data: SimpleMessage
  status: 201
}

export type postApiV1ThreeLetterCodeAppsUsersPasswordResetsResponseSuccess = (postApiV1ThreeLetterCodeAppsUsersPasswordResetsResponse201) & {
  headers: Headers;
};
;

export type postApiV1ThreeLetterCodeAppsUsersPasswordResetsResponse = (postApiV1ThreeLetterCodeAppsUsersPasswordResetsResponseSuccess)

export const getPostApiV1ThreeLetterCodeAppsUsersPasswordResetsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/users/password_resets`
}

/**
 * 常に201を返します。ユーザーが存在しない場合は何もせず、存在した場合はパスワードをリセットしてメールで通知します。
 * @summary Send reset password instruction
 */
export const postApiV1ThreeLetterCodeAppsUsersPasswordResets = async (threeLetterCode: string,
    requestAppsUserPasswordReset?: RequestAppsUserPasswordReset, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsUsersPasswordResetsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsUsersPasswordResetsResponse>(getPostApiV1ThreeLetterCodeAppsUsersPasswordResetsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestAppsUserPasswordReset)
  }
);}




export const getPostApiV1ThreeLetterCodeAppsUsersPasswordResetsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestAppsUserPasswordReset | undefined }) => {
    return postApiV1ThreeLetterCodeAppsUsersPasswordResets(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsUsersPasswordResetsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/users/password_resets`] as const;

export type PostApiV1ThreeLetterCodeAppsUsersPasswordResetsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUsersPasswordResets>>>

/**
 * @summary Send reset password instruction
 */
export const usePostApiV1ThreeLetterCodeAppsUsersPasswordResets = <TError = unknown>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUsersPasswordResets>>, TError, Key, RequestAppsUserPasswordReset | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUsersPasswordResets>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsUsersPasswordResetsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeAppsUsersPasswordResetsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeAppsUsersPasswordResetsResponse200 = {
  data: SimpleMessage
  status: 200
}

export type putApiV1ThreeLetterCodeAppsUsersPasswordResetsResponse404 = {
  data: void
  status: 404
}

export type putApiV1ThreeLetterCodeAppsUsersPasswordResetsResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeAppsUsersPasswordResetsResponseSuccess = (putApiV1ThreeLetterCodeAppsUsersPasswordResetsResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeAppsUsersPasswordResetsResponseError = (putApiV1ThreeLetterCodeAppsUsersPasswordResetsResponse404 | putApiV1ThreeLetterCodeAppsUsersPasswordResetsResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeAppsUsersPasswordResetsResponse = (putApiV1ThreeLetterCodeAppsUsersPasswordResetsResponseSuccess | putApiV1ThreeLetterCodeAppsUsersPasswordResetsResponseError)

export const getPutApiV1ThreeLetterCodeAppsUsersPasswordResetsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/users/password_resets`
}

/**
 * パスワードリセットトークンを用いて新しいパスワードを設定する
 * @summary Update the password
 */
export const putApiV1ThreeLetterCodeAppsUsersPasswordResets = async (threeLetterCode: string,
    putApiV1ThreeLetterCodeAppsUsersPasswordResetsBody?: PutApiV1ThreeLetterCodeAppsUsersPasswordResetsBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeAppsUsersPasswordResetsResponse> => {

  return customInstance<putApiV1ThreeLetterCodeAppsUsersPasswordResetsResponse>(getPutApiV1ThreeLetterCodeAppsUsersPasswordResetsUrl(threeLetterCode),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeAppsUsersPasswordResetsBody)
  }
);}




export const getPutApiV1ThreeLetterCodeAppsUsersPasswordResetsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeAppsUsersPasswordResetsBody | undefined }) => {
    return putApiV1ThreeLetterCodeAppsUsersPasswordResets(threeLetterCode, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeAppsUsersPasswordResetsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/users/password_resets`] as const;

export type PutApiV1ThreeLetterCodeAppsUsersPasswordResetsMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUsersPasswordResets>>>

/**
 * @summary Update the password
 */
export const usePutApiV1ThreeLetterCodeAppsUsersPasswordResets = <TError = void | Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUsersPasswordResets>>, TError, Key, PutApiV1ThreeLetterCodeAppsUsersPasswordResetsBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUsersPasswordResets>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeAppsUsersPasswordResetsMutationKey(threeLetterCode);
  const swrFn = getPutApiV1ThreeLetterCodeAppsUsersPasswordResetsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeAppsUsersPasswordsResponse204 = {
  data: void
  status: 204
}

export type putApiV1ThreeLetterCodeAppsUsersPasswordsResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeAppsUsersPasswordsResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeAppsUsersPasswordsResponseSuccess = (putApiV1ThreeLetterCodeAppsUsersPasswordsResponse204) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeAppsUsersPasswordsResponseError = (putApiV1ThreeLetterCodeAppsUsersPasswordsResponse401 | putApiV1ThreeLetterCodeAppsUsersPasswordsResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeAppsUsersPasswordsResponse = (putApiV1ThreeLetterCodeAppsUsersPasswordsResponseSuccess | putApiV1ThreeLetterCodeAppsUsersPasswordsResponseError)

export const getPutApiV1ThreeLetterCodeAppsUsersPasswordsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/users/passwords`
}

/**
 * ログインユーザーのパスワードを変更する
 * @summary Update password
 */
export const putApiV1ThreeLetterCodeAppsUsersPasswords = async (threeLetterCode: string,
    requestAppsUserPasswordUpdate?: RequestAppsUserPasswordUpdate, options?: RequestInit): Promise<putApiV1ThreeLetterCodeAppsUsersPasswordsResponse> => {

  return customInstance<putApiV1ThreeLetterCodeAppsUsersPasswordsResponse>(getPutApiV1ThreeLetterCodeAppsUsersPasswordsUrl(threeLetterCode),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestAppsUserPasswordUpdate)
  }
);}




export const getPutApiV1ThreeLetterCodeAppsUsersPasswordsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestAppsUserPasswordUpdate | undefined }) => {
    return putApiV1ThreeLetterCodeAppsUsersPasswords(threeLetterCode, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeAppsUsersPasswordsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/users/passwords`] as const;

export type PutApiV1ThreeLetterCodeAppsUsersPasswordsMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUsersPasswords>>>

/**
 * @summary Update password
 */
export const usePutApiV1ThreeLetterCodeAppsUsersPasswords = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUsersPasswords>>, TError, Key, RequestAppsUserPasswordUpdate | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUsersPasswords>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeAppsUsersPasswordsMutationKey(threeLetterCode);
  const swrFn = getPutApiV1ThreeLetterCodeAppsUsersPasswordsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsUserProfileResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsUserProfile200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsUserProfileResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsUserProfileResponseSuccess = (getApiV1ThreeLetterCodeAppsUserProfileResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsUserProfileResponseError = (getApiV1ThreeLetterCodeAppsUserProfileResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsUserProfileResponse = (getApiV1ThreeLetterCodeAppsUserProfileResponseSuccess | getApiV1ThreeLetterCodeAppsUserProfileResponseError)

export const getGetApiV1ThreeLetterCodeAppsUserProfileUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/user/profile`
}

/**
 * ログインユーザーのプロフィール情報を取得する
 * @summary Get User Profile
 */
export const getApiV1ThreeLetterCodeAppsUserProfile = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsUserProfileResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsUserProfileResponse>(getGetApiV1ThreeLetterCodeAppsUserProfileUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsUserProfileKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/user/profile`] as const;

export type GetApiV1ThreeLetterCodeAppsUserProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUserProfile>>>

/**
 * @summary Get User Profile
 */
export const useGetApiV1ThreeLetterCodeAppsUserProfile = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUserProfile>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsUserProfileKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsUserProfile(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeAppsUserProfileResponse200 = {
  data: PutApiV1ThreeLetterCodeAppsUserProfile200
  status: 200
}

export type putApiV1ThreeLetterCodeAppsUserProfileResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeAppsUserProfileResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeAppsUserProfileResponseSuccess = (putApiV1ThreeLetterCodeAppsUserProfileResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeAppsUserProfileResponseError = (putApiV1ThreeLetterCodeAppsUserProfileResponse401 | putApiV1ThreeLetterCodeAppsUserProfileResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeAppsUserProfileResponse = (putApiV1ThreeLetterCodeAppsUserProfileResponseSuccess | putApiV1ThreeLetterCodeAppsUserProfileResponseError)

export const getPutApiV1ThreeLetterCodeAppsUserProfileUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/user/profile`
}

/**
 * ログインユーザーのプロフィール情報を更新する
 * @summary Update User Profile
 */
export const putApiV1ThreeLetterCodeAppsUserProfile = async (threeLetterCode: string,
    requestAppsUserProfileUpdate: RequestAppsUserProfileUpdate, options?: RequestInit): Promise<putApiV1ThreeLetterCodeAppsUserProfileResponse> => {

  return customInstance<putApiV1ThreeLetterCodeAppsUserProfileResponse>(getPutApiV1ThreeLetterCodeAppsUserProfileUrl(threeLetterCode),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestAppsUserProfileUpdate)
  }
);}




export const getPutApiV1ThreeLetterCodeAppsUserProfileMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestAppsUserProfileUpdate }) => {
    return putApiV1ThreeLetterCodeAppsUserProfile(threeLetterCode, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeAppsUserProfileMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/user/profile`] as const;

export type PutApiV1ThreeLetterCodeAppsUserProfileMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUserProfile>>>

/**
 * @summary Update User Profile
 */
export const usePutApiV1ThreeLetterCodeAppsUserProfile = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUserProfile>>, TError, Key, RequestAppsUserProfileUpdate, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUserProfile>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeAppsUserProfileMutationKey(threeLetterCode);
  const swrFn = getPutApiV1ThreeLetterCodeAppsUserProfileMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsUsersPromptsResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsUsersPrompts200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsUsersPromptsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsUsersPromptsResponseSuccess = (getApiV1ThreeLetterCodeAppsUsersPromptsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsUsersPromptsResponseError = (getApiV1ThreeLetterCodeAppsUsersPromptsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsUsersPromptsResponse = (getApiV1ThreeLetterCodeAppsUsersPromptsResponseSuccess | getApiV1ThreeLetterCodeAppsUsersPromptsResponseError)

export const getGetApiV1ThreeLetterCodeAppsUsersPromptsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsUsersPromptsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/apps/users/prompts?${stringifiedParams}` : `/api/v1/${threeLetterCode}/apps/users/prompts`
}

/**
 * ログインユーザー向けに表示する誘導プロンプト一覧を取得する
 * @summary Get user prompts
 */
export const getApiV1ThreeLetterCodeAppsUsersPrompts = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsUsersPromptsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsUsersPromptsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsUsersPromptsResponse>(getGetApiV1ThreeLetterCodeAppsUsersPromptsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsUsersPromptsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsUsersPromptsParams,) => [`/api/v1/${threeLetterCode}/apps/users/prompts`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeAppsUsersPromptsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUsersPrompts>>>

/**
 * @summary Get user prompts
 */
export const useGetApiV1ThreeLetterCodeAppsUsersPrompts = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeAppsUsersPromptsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUsersPrompts>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsUsersPromptsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsUsersPrompts(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponse201 = {
  data: PostApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrations201
  status: 201
}

export type postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponse403 = {
  data: Errors
  status: 403
}

export type postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponseSuccess = (postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponseError = (postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponse403 | postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponse404 | postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponse = (postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponseSuccess | postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponseError)

export const getPostApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsUrl = (threeLetterCode: string,
    userRegistrationUrlToken: string,) => {




  return `/api/v1/${threeLetterCode}/apps/users/${userRegistrationUrlToken}/registrations`
}

/**
 * ユーザー登録用URLトークン経由でユーザーを新規登録する
 * @summary Create User
 */
export const postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrations = async (threeLetterCode: string,
    userRegistrationUrlToken: string,
    requestAppsUserRegistration?: RequestAppsUserRegistration, options?: RequestInit): Promise<postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsResponse>(getPostApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsUrl(threeLetterCode,userRegistrationUrlToken),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestAppsUserRegistration)
  }
);}




export const getPostApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsMutationFetcher = (threeLetterCode: string,
    userRegistrationUrlToken: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestAppsUserRegistration | undefined }) => {
    return postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrations(threeLetterCode, userRegistrationUrlToken, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsMutationKey = (threeLetterCode: string,
    userRegistrationUrlToken: string,) => [`/api/v1/${threeLetterCode}/apps/users/${userRegistrationUrlToken}/registrations`] as const;

export type PostApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrations>>>

/**
 * @summary Create User
 */
export const usePostApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrations = <TError = Errors>(
  threeLetterCode: string,
    userRegistrationUrlToken: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrations>>, TError, Key, RequestAppsUserRegistration | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrations>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsMutationKey(threeLetterCode,userRegistrationUrlToken);
  const swrFn = getPostApiV1ThreeLetterCodeAppsUsersUserRegistrationUrlTokenRegistrationsMutationFetcher(threeLetterCode,userRegistrationUrlToken, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeAppsUserResponse200 = {
  data: GetApiV1ThreeLetterCodeAppsUser200
  status: 200
}

export type getApiV1ThreeLetterCodeAppsUserResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeAppsUserResponseSuccess = (getApiV1ThreeLetterCodeAppsUserResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeAppsUserResponseError = (getApiV1ThreeLetterCodeAppsUserResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeAppsUserResponse = (getApiV1ThreeLetterCodeAppsUserResponseSuccess | getApiV1ThreeLetterCodeAppsUserResponseError)

export const getGetApiV1ThreeLetterCodeAppsUserUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/user`
}

/**
 * ログインユーザー自身の情報を取得する
 * @summary Get User
 */
export const getApiV1ThreeLetterCodeAppsUser = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeAppsUserResponse> => {

  return customInstance<getApiV1ThreeLetterCodeAppsUserResponse>(getGetApiV1ThreeLetterCodeAppsUserUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeAppsUserKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/user`] as const;

export type GetApiV1ThreeLetterCodeAppsUserQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUser>>>

/**
 * @summary Get User
 */
export const useGetApiV1ThreeLetterCodeAppsUser = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeAppsUser>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeAppsUserKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeAppsUser(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeAppsUserResponse200 = {
  data: PutApiV1ThreeLetterCodeAppsUser200
  status: 200
}

export type putApiV1ThreeLetterCodeAppsUserResponseSuccess = (putApiV1ThreeLetterCodeAppsUserResponse200) & {
  headers: Headers;
};
;

export type putApiV1ThreeLetterCodeAppsUserResponse = (putApiV1ThreeLetterCodeAppsUserResponseSuccess)

export const getPutApiV1ThreeLetterCodeAppsUserUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/apps/user`
}

/**
 * ユーザー情報（プッシュ通知トークン等）を更新する
 * @summary Update user
 */
export const putApiV1ThreeLetterCodeAppsUser = async (threeLetterCode: string,
    requestAppsUserUpdate?: RequestAppsUserUpdate, options?: RequestInit): Promise<putApiV1ThreeLetterCodeAppsUserResponse> => {

  return customInstance<putApiV1ThreeLetterCodeAppsUserResponse>(getPutApiV1ThreeLetterCodeAppsUserUrl(threeLetterCode),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestAppsUserUpdate)
  }
);}




export const getPutApiV1ThreeLetterCodeAppsUserMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestAppsUserUpdate | undefined }) => {
    return putApiV1ThreeLetterCodeAppsUser(threeLetterCode, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeAppsUserMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/apps/user`] as const;

export type PutApiV1ThreeLetterCodeAppsUserMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUser>>>

/**
 * @summary Update user
 */
export const usePutApiV1ThreeLetterCodeAppsUser = <TError = unknown>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUser>>, TError, Key, RequestAppsUserUpdate | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeAppsUser>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeAppsUserMutationKey(threeLetterCode);
  const swrFn = getPutApiV1ThreeLetterCodeAppsUserMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsActivationCodeExportResponse200 = {
  data: Blob
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsActivationCodeExportResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsActivationCodeExportResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsActivationCodeExportResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsActivationCodeExportResponseError = (getApiV1ThreeLetterCodeClientAdminsActivationCodeExportResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsActivationCodeExportResponse = (getApiV1ThreeLetterCodeClientAdminsActivationCodeExportResponseSuccess | getApiV1ThreeLetterCodeClientAdminsActivationCodeExportResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsActivationCodeExportUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/activation_code_export`
}

/**
 * 未使用のアクティベーションコードをCSV形式でエクスポートする
 * @summary Export unused activation codes as CSV
 */
export const getApiV1ThreeLetterCodeClientAdminsActivationCodeExport = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsActivationCodeExportResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsActivationCodeExportResponse>(getGetApiV1ThreeLetterCodeClientAdminsActivationCodeExportUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsActivationCodeExportKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/activation_code_export`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsActivationCodeExportQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsActivationCodeExport>>>

/**
 * @summary Export unused activation codes as CSV
 */
export const useGetApiV1ThreeLetterCodeClientAdminsActivationCodeExport = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsActivationCodeExport>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsActivationCodeExportKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsActivationCodeExport(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsApplicationConfigurationResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsApplicationConfiguration200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsApplicationConfigurationResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsApplicationConfigurationResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsApplicationConfigurationResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsApplicationConfigurationResponseError = (getApiV1ThreeLetterCodeClientAdminsApplicationConfigurationResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsApplicationConfigurationResponse = (getApiV1ThreeLetterCodeClientAdminsApplicationConfigurationResponseSuccess | getApiV1ThreeLetterCodeClientAdminsApplicationConfigurationResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsApplicationConfigurationUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/application_configuration`
}

/**
 * アプリケーション設定を取得する
 * @summary Get application_configurations
 */
export const getApiV1ThreeLetterCodeClientAdminsApplicationConfiguration = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsApplicationConfigurationResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsApplicationConfigurationResponse>(getGetApiV1ThreeLetterCodeClientAdminsApplicationConfigurationUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsApplicationConfigurationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/application_configuration`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsApplicationConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsApplicationConfiguration>>>

/**
 * @summary Get application_configurations
 */
export const useGetApiV1ThreeLetterCodeClientAdminsApplicationConfiguration = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsApplicationConfiguration>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsApplicationConfigurationKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsApplicationConfiguration(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsBlobsResponse201 = {
  data: PostApiV1ThreeLetterCodeClientAdminsBlobs201
  status: 201
}

export type postApiV1ThreeLetterCodeClientAdminsBlobsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsBlobsResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeClientAdminsBlobsResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsBlobsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsBlobsResponseError = (postApiV1ThreeLetterCodeClientAdminsBlobsResponse401 | postApiV1ThreeLetterCodeClientAdminsBlobsResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsBlobsResponse = (postApiV1ThreeLetterCodeClientAdminsBlobsResponseSuccess | postApiV1ThreeLetterCodeClientAdminsBlobsResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsBlobsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/blobs`
}

/**
 * ファイルをアップロードする
 * @summary Upload a file
 */
export const postApiV1ThreeLetterCodeClientAdminsBlobs = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeClientAdminsBlobsBody: PostApiV1ThreeLetterCodeClientAdminsBlobsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsBlobsResponse> => {
    const formData = new FormData();
formData.append(`blob[file]`, postApiV1ThreeLetterCodeClientAdminsBlobsBody['blob[file]']);

  return customInstance<postApiV1ThreeLetterCodeClientAdminsBlobsResponse>(getPostApiV1ThreeLetterCodeClientAdminsBlobsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsBlobsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeClientAdminsBlobsBody }) => {
    return postApiV1ThreeLetterCodeClientAdminsBlobs(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsBlobsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/blobs`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsBlobsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsBlobs>>>

/**
 * @summary Upload a file
 */
export const usePostApiV1ThreeLetterCodeClientAdminsBlobs = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsBlobs>>, TError, Key, PostApiV1ThreeLetterCodeClientAdminsBlobsBody, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsBlobs>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsBlobsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsBlobsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeClientAdminsBlobsIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeClientAdminsBlobsIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeClientAdminsBlobsIdResponseSuccess = (deleteApiV1ThreeLetterCodeClientAdminsBlobsIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeClientAdminsBlobsIdResponseError = (deleteApiV1ThreeLetterCodeClientAdminsBlobsIdResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeClientAdminsBlobsIdResponse = (deleteApiV1ThreeLetterCodeClientAdminsBlobsIdResponseSuccess | deleteApiV1ThreeLetterCodeClientAdminsBlobsIdResponseError)

export const getDeleteApiV1ThreeLetterCodeClientAdminsBlobsIdUrl = (threeLetterCode: string,
    id: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/blobs/${id}`
}

/**
 * アップロード済みファイルを削除する
 * @summary Delete a file
 */
export const deleteApiV1ThreeLetterCodeClientAdminsBlobsId = async (threeLetterCode: string,
    id: string, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeClientAdminsBlobsIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeClientAdminsBlobsIdResponse>(getDeleteApiV1ThreeLetterCodeClientAdminsBlobsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeClientAdminsBlobsIdMutationFetcher = (threeLetterCode: string,
    id: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeClientAdminsBlobsId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeClientAdminsBlobsIdMutationKey = (threeLetterCode: string,
    id: string,) => [`/api/v1/${threeLetterCode}/client_admins/blobs/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeClientAdminsBlobsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsBlobsId>>>

/**
 * @summary Delete a file
 */
export const useDeleteApiV1ThreeLetterCodeClientAdminsBlobsId = <TError = Errors>(
  threeLetterCode: string,
    id: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsBlobsId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsBlobsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeClientAdminsBlobsIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeClientAdminsBlobsIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsBranchesResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsBranches200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsBranchesResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeClientAdminsBranchesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsBranchesResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsBranchesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsBranchesResponseError = (getApiV1ThreeLetterCodeClientAdminsBranchesResponse400 | getApiV1ThreeLetterCodeClientAdminsBranchesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsBranchesResponse = (getApiV1ThreeLetterCodeClientAdminsBranchesResponseSuccess | getApiV1ThreeLetterCodeClientAdminsBranchesResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsBranchesUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsBranchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/client_admins/branches?${stringifiedParams}` : `/api/v1/${threeLetterCode}/client_admins/branches`
}

/**
 * 導入企業に紐づく事業所の一覧を取得する
 * @summary Get branches
 */
export const getApiV1ThreeLetterCodeClientAdminsBranches = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsBranchesParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsBranchesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsBranchesResponse>(getGetApiV1ThreeLetterCodeClientAdminsBranchesUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsBranchesKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsBranchesParams,) => [`/api/v1/${threeLetterCode}/client_admins/branches`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeClientAdminsBranchesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsBranches>>>

/**
 * @summary Get branches
 */
export const useGetApiV1ThreeLetterCodeClientAdminsBranches = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsBranchesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsBranches>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsBranchesKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsBranches(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsBranchesResponse201 = {
  data: PostApiV1ThreeLetterCodeClientAdminsBranches201
  status: 201
}

export type postApiV1ThreeLetterCodeClientAdminsBranchesResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsBranchesResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeClientAdminsBranchesResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsBranchesResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsBranchesResponseError = (postApiV1ThreeLetterCodeClientAdminsBranchesResponse401 | postApiV1ThreeLetterCodeClientAdminsBranchesResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsBranchesResponse = (postApiV1ThreeLetterCodeClientAdminsBranchesResponseSuccess | postApiV1ThreeLetterCodeClientAdminsBranchesResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsBranchesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/branches`
}

/**
 * 事業所を新規作成する
 * @summary Create Branch
 */
export const postApiV1ThreeLetterCodeClientAdminsBranches = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeClientAdminsBranchesBody?: PostApiV1ThreeLetterCodeClientAdminsBranchesBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsBranchesResponse> => {

  return customInstance<postApiV1ThreeLetterCodeClientAdminsBranchesResponse>(getPostApiV1ThreeLetterCodeClientAdminsBranchesUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeClientAdminsBranchesBody)
  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsBranchesMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeClientAdminsBranchesBody | undefined }) => {
    return postApiV1ThreeLetterCodeClientAdminsBranches(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsBranchesMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/branches`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsBranchesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsBranches>>>

/**
 * @summary Create Branch
 */
export const usePostApiV1ThreeLetterCodeClientAdminsBranches = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsBranches>>, TError, Key, PostApiV1ThreeLetterCodeClientAdminsBranchesBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsBranches>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsBranchesMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsBranchesMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsBranchesIdResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsBranchesId200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsBranchesIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsBranchesIdResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsBranchesIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsBranchesIdResponseError = (getApiV1ThreeLetterCodeClientAdminsBranchesIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsBranchesIdResponse = (getApiV1ThreeLetterCodeClientAdminsBranchesIdResponseSuccess | getApiV1ThreeLetterCodeClientAdminsBranchesIdResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsBranchesIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/branches/${id}`
}

/**
 * 事業所の詳細を取得する
 * @summary Get branch
 */
export const getApiV1ThreeLetterCodeClientAdminsBranchesId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsBranchesIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsBranchesIdResponse>(getGetApiV1ThreeLetterCodeClientAdminsBranchesIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsBranchesIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/branches/${id}`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsBranchesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsBranchesId>>>

/**
 * @summary Get branch
 */
export const useGetApiV1ThreeLetterCodeClientAdminsBranchesId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsBranchesId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsBranchesIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsBranchesId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeClientAdminsBranchesIdResponse200 = {
  data: PutApiV1ThreeLetterCodeClientAdminsBranchesId200
  status: 200
}

export type putApiV1ThreeLetterCodeClientAdminsBranchesIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeClientAdminsBranchesIdResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeClientAdminsBranchesIdResponseSuccess = (putApiV1ThreeLetterCodeClientAdminsBranchesIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeClientAdminsBranchesIdResponseError = (putApiV1ThreeLetterCodeClientAdminsBranchesIdResponse401 | putApiV1ThreeLetterCodeClientAdminsBranchesIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeClientAdminsBranchesIdResponse = (putApiV1ThreeLetterCodeClientAdminsBranchesIdResponseSuccess | putApiV1ThreeLetterCodeClientAdminsBranchesIdResponseError)

export const getPutApiV1ThreeLetterCodeClientAdminsBranchesIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/branches/${id}`
}

/**
 * 事業所情報を更新する
 * @summary Update branch
 */
export const putApiV1ThreeLetterCodeClientAdminsBranchesId = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodeClientAdminsBranchesIdBody?: PutApiV1ThreeLetterCodeClientAdminsBranchesIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeClientAdminsBranchesIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeClientAdminsBranchesIdResponse>(getPutApiV1ThreeLetterCodeClientAdminsBranchesIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeClientAdminsBranchesIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeClientAdminsBranchesIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeClientAdminsBranchesIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeClientAdminsBranchesId(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeClientAdminsBranchesIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/branches/${id}`] as const;

export type PutApiV1ThreeLetterCodeClientAdminsBranchesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeClientAdminsBranchesId>>>

/**
 * @summary Update branch
 */
export const usePutApiV1ThreeLetterCodeClientAdminsBranchesId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeClientAdminsBranchesId>>, TError, Key, PutApiV1ThreeLetterCodeClientAdminsBranchesIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeClientAdminsBranchesId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeClientAdminsBranchesIdMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodeClientAdminsBranchesIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeClientAdminsBranchesIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeClientAdminsBranchesIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeClientAdminsBranchesIdResponseSuccess = (deleteApiV1ThreeLetterCodeClientAdminsBranchesIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeClientAdminsBranchesIdResponseError = (deleteApiV1ThreeLetterCodeClientAdminsBranchesIdResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeClientAdminsBranchesIdResponse = (deleteApiV1ThreeLetterCodeClientAdminsBranchesIdResponseSuccess | deleteApiV1ThreeLetterCodeClientAdminsBranchesIdResponseError)

export const getDeleteApiV1ThreeLetterCodeClientAdminsBranchesIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/branches/${id}`
}

/**
 * 事業所を削除する
 * @summary Delete branch
 */
export const deleteApiV1ThreeLetterCodeClientAdminsBranchesId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeClientAdminsBranchesIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeClientAdminsBranchesIdResponse>(getDeleteApiV1ThreeLetterCodeClientAdminsBranchesIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeClientAdminsBranchesIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeClientAdminsBranchesId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeClientAdminsBranchesIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/branches/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeClientAdminsBranchesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsBranchesId>>>

/**
 * @summary Delete branch
 */
export const useDeleteApiV1ThreeLetterCodeClientAdminsBranchesId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsBranchesId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsBranchesId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeClientAdminsBranchesIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeClientAdminsBranchesIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponse201 = {
  data: PostApiV1ThreeLetterCodeClientAdminsCardRegistrations201
  status: 201
}

export type postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponse502 = {
  data: Errors
  status: 502
}

export type postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponseError = (postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponse401 | postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponse404 | postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponse502) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponse = (postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponseSuccess | postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsCardRegistrationsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/card_registrations`
}

/**
 * クライアント管理画面のカード変更ステップ用。自社の Stripe Customer にカード保存用の SetupIntent を発行し、Payment Element で使う client_secret を返す。カード番号は BE に流さず ブラウザの Payment Element から Stripe へ直送する。登録された新カードの既定化は setup_intent.succeeded Webhook が行う。カード払いでない等で Stripe Customer が結線されていない企業は 404 を返す
 * @summary Create card registration
 */
export const postApiV1ThreeLetterCodeClientAdminsCardRegistrations = async (threeLetterCode: string, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeClientAdminsCardRegistrationsResponse>(getPostApiV1ThreeLetterCodeClientAdminsCardRegistrationsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsCardRegistrationsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeClientAdminsCardRegistrations(threeLetterCode, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsCardRegistrationsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/card_registrations`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsCardRegistrationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsCardRegistrations>>>

/**
 * @summary Create card registration
 */
export const usePostApiV1ThreeLetterCodeClientAdminsCardRegistrations = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsCardRegistrations>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsCardRegistrations>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsCardRegistrationsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsCardRegistrationsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsClientAdminUsers200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponseError = (getApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse400 | getApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse = (getApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponseSuccess | getApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/client_admins/client_admin_users?${stringifiedParams}` : `/api/v1/${threeLetterCode}/client_admins/client_admin_users`
}

/**
 * 同一導入企業に所属する企業管理者ユーザーの一覧を取得する
 * @summary Get client_admin_users
 */
export const getApiV1ThreeLetterCodeClientAdminsClientAdminUsers = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse>(getGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersParams,) => [`/api/v1/${threeLetterCode}/client_admins/client_admin_users`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientAdminUsers>>>

/**
 * @summary Get client_admin_users
 */
export const useGetApiV1ThreeLetterCodeClientAdminsClientAdminUsers = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientAdminUsers>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsClientAdminUsers(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse201 = {
  data: PostApiV1ThreeLetterCodeClientAdminsClientAdminUsers201
  status: 201
}

export type postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse403 = {
  data: Errors
  status: 403
}

export type postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponseError = (postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse401 | postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse403 | postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse = (postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponseSuccess | postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsClientAdminUsersUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client_admin_users`
}

/**
 * 企業管理者ユーザーを新規作成する
 * @summary Create ClientAdminUser
 */
export const postApiV1ThreeLetterCodeClientAdminsClientAdminUsers = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeClientAdminsClientAdminUsersBody?: PostApiV1ThreeLetterCodeClientAdminsClientAdminUsersBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse> => {

  return customInstance<postApiV1ThreeLetterCodeClientAdminsClientAdminUsersResponse>(getPostApiV1ThreeLetterCodeClientAdminsClientAdminUsersUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeClientAdminsClientAdminUsersBody)
  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsClientAdminUsersMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeClientAdminsClientAdminUsersBody | undefined }) => {
    return postApiV1ThreeLetterCodeClientAdminsClientAdminUsers(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsClientAdminUsersMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/client_admin_users`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsClientAdminUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsClientAdminUsers>>>

/**
 * @summary Create ClientAdminUser
 */
export const usePostApiV1ThreeLetterCodeClientAdminsClientAdminUsers = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsClientAdminUsers>>, TError, Key, PostApiV1ThreeLetterCodeClientAdminsClientAdminUsersBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsClientAdminUsers>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsClientAdminUsersMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsClientAdminUsersMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersId200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponseError = (getApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse = (getApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponseSuccess | getApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client_admin_users/${id}`
}

/**
 * 企業管理者ユーザーの詳細を取得する
 * @summary Get client_admin_user
 */
export const getApiV1ThreeLetterCodeClientAdminsClientAdminUsersId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse>(getGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/client_admin_users/${id}`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientAdminUsersId>>>

/**
 * @summary Get client_admin_user
 */
export const useGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientAdminUsersId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsClientAdminUsersId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse200 = {
  data: PutApiV1ThreeLetterCodeClientAdminsClientAdminUsersId200
  status: 200
}

export type putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponseSuccess = (putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponseError = (putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse401 | putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse = (putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponseSuccess | putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponseError)

export const getPutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client_admin_users/${id}`
}

/**
 * 企業管理者ユーザー情報を更新する
 * @summary Update client_admin_user
 */
export const putApiV1ThreeLetterCodeClientAdminsClientAdminUsersId = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdBody?: PutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse>(getPutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeClientAdminsClientAdminUsersId(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/client_admin_users/${id}`] as const;

export type PutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeClientAdminsClientAdminUsersId>>>

/**
 * @summary Update client_admin_user
 */
export const usePutApiV1ThreeLetterCodeClientAdminsClientAdminUsersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeClientAdminsClientAdminUsersId>>, TError, Key, PutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeClientAdminsClientAdminUsersId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponseSuccess = (deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponseError = (deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse = (deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponseSuccess | deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponseError)

export const getDeleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client_admin_users/${id}`
}

/**
 * 企業管理者ユーザーを削除する
 * @summary Delete client_admin_user
 */
export const deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdResponse>(getDeleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/client_admin_users/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersId>>>

/**
 * @summary Delete client_admin_user
 */
export const useDeleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatistics200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsResponseError = (getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsResponse401 | getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsResponse = (getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsResponseSuccess | getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsUrl = (threeLetterCode: string,
    clientNewsletterId: number,
    params: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/client_admins/client_newsletters/${clientNewsletterId}/statistics?${stringifiedParams}` : `/api/v1/${threeLetterCode}/client_admins/client_newsletters/${clientNewsletterId}/statistics`
}

/**
 * 社内報の既読統計を取得する
 * @summary Get newsletter statistics
 */
export const getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatistics = async (threeLetterCode: string,
    clientNewsletterId: number,
    params: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsResponse>(getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsUrl(threeLetterCode,clientNewsletterId,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsKey = (threeLetterCode: string,
    clientNewsletterId: number,
    params: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsParams,) => [`/api/v1/${threeLetterCode}/client_admins/client_newsletters/${clientNewsletterId}/statistics`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatistics>>>

/**
 * @summary Get newsletter statistics
 */
export const useGetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatistics = <TError = Errors>(
  threeLetterCode: string,
    clientNewsletterId: number,
    params: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatistics>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && clientNewsletterId !== null && clientNewsletterId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsKey(threeLetterCode,clientNewsletterId,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatistics(threeLetterCode,clientNewsletterId,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsers200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponseError = (getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponse400 | getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponse401 | getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponse = (getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponseSuccess | getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersUrl = (threeLetterCode: string,
    clientNewsletterId: number,
    params: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/client_admins/client_newsletters/${clientNewsletterId}/users?${stringifiedParams}` : `/api/v1/${threeLetterCode}/client_admins/client_newsletters/${clientNewsletterId}/users`
}

/**
 * 社内報の既読・未読ユーザー一覧を取得する
 * @summary Get newsletter read users
 */
export const getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsers = async (threeLetterCode: string,
    clientNewsletterId: number,
    params: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersResponse>(getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersUrl(threeLetterCode,clientNewsletterId,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersKey = (threeLetterCode: string,
    clientNewsletterId: number,
    params: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersParams,) => [`/api/v1/${threeLetterCode}/client_admins/client_newsletters/${clientNewsletterId}/users`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsers>>>

/**
 * @summary Get newsletter read users
 */
export const useGetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsers = <TError = Errors>(
  threeLetterCode: string,
    clientNewsletterId: number,
    params: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsers>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && clientNewsletterId !== null && clientNewsletterId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsersKey(threeLetterCode,clientNewsletterId,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdUsers(threeLetterCode,clientNewsletterId,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsClientNewsletters200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponseError = (getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse400 | getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse401 | getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse = (getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponseSuccess | getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/client_admins/client_newsletters?${stringifiedParams}` : `/api/v1/${threeLetterCode}/client_admins/client_newsletters`
}

/**
 * 社内報の一覧を取得する（公開済み・未公開含む、公開日時の降順）
 * @summary Get client newsletters
 */
export const getApiV1ThreeLetterCodeClientAdminsClientNewsletters = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse>(getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersParams,) => [`/api/v1/${threeLetterCode}/client_admins/client_newsletters`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeClientAdminsClientNewslettersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientNewsletters>>>

/**
 * @summary Get client newsletters
 */
export const useGetApiV1ThreeLetterCodeClientAdminsClientNewsletters = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientNewsletters>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsClientNewsletters(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse201 = {
  data: PostApiV1ThreeLetterCodeClientAdminsClientNewsletters201
  status: 201
}

export type postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse403 = {
  data: Errors
  status: 403
}

export type postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponseError = (postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse401 | postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse403 | postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse = (postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponseSuccess | postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsClientNewslettersUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client_newsletters`
}

/**
 * 社内報を新規作成する
 * @summary Create client newsletter
 */
export const postApiV1ThreeLetterCodeClientAdminsClientNewsletters = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeClientAdminsClientNewslettersBody?: PostApiV1ThreeLetterCodeClientAdminsClientNewslettersBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse> => {

  return customInstance<postApiV1ThreeLetterCodeClientAdminsClientNewslettersResponse>(getPostApiV1ThreeLetterCodeClientAdminsClientNewslettersUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeClientAdminsClientNewslettersBody)
  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsClientNewslettersMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeClientAdminsClientNewslettersBody | undefined }) => {
    return postApiV1ThreeLetterCodeClientAdminsClientNewsletters(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsClientNewslettersMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/client_newsletters`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsClientNewslettersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsClientNewsletters>>>

/**
 * @summary Create client newsletter
 */
export const usePostApiV1ThreeLetterCodeClientAdminsClientNewsletters = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsClientNewsletters>>, TError, Key, PostApiV1ThreeLetterCodeClientAdminsClientNewslettersBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsClientNewsletters>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsClientNewslettersMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsClientNewslettersMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersId200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponseError = (getApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse401 | getApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse = (getApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponseSuccess | getApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client_newsletters/${id}`
}

/**
 * 社内報の詳細を取得する
 * @summary Get client newsletter
 */
export const getApiV1ThreeLetterCodeClientAdminsClientNewslettersId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse>(getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/client_newsletters/${id}`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsClientNewslettersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientNewslettersId>>>

/**
 * @summary Get client newsletter
 */
export const useGetApiV1ThreeLetterCodeClientAdminsClientNewslettersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientNewslettersId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsClientNewslettersId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse200 = {
  data: PatchApiV1ThreeLetterCodeClientAdminsClientNewslettersId200
  status: 200
}

export type patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse401 = {
  data: Errors
  status: 401
}

export type patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse403 = {
  data: Errors
  status: 403
}

export type patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponseSuccess = (patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse200) & {
  headers: Headers;
};
export type patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponseError = (patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse401 | patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse403) & {
  headers: Headers;
};

export type patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse = (patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponseSuccess | patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponseError)

export const getPatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client_newsletters/${id}`
}

/**
 * 社内報を更新する
 * @summary Update client newsletter
 */
export const patchApiV1ThreeLetterCodeClientAdminsClientNewslettersId = async (threeLetterCode: string,
    id: number,
    patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdBody?: PatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdBody, options?: RequestInit): Promise<patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse> => {

  return customInstance<patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse>(getPatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdBody)
  }
);}




export const getPatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdBody | undefined }) => {
    return patchApiV1ThreeLetterCodeClientAdminsClientNewslettersId(threeLetterCode, id, arg, options);
  }
}
export const getPatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/client_newsletters/${id}`] as const;

export type PatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeClientAdminsClientNewslettersId>>>

/**
 * @summary Update client newsletter
 */
export const usePatchApiV1ThreeLetterCodeClientAdminsClientNewslettersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeClientAdminsClientNewslettersId>>, TError, Key, PatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdBody | undefined, Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeClientAdminsClientNewslettersId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdMutationKey(threeLetterCode,id);
  const swrFn = getPatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse403 = {
  data: Errors
  status: 403
}

export type deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponseSuccess = (deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponseError = (deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse401 | deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse403) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse = (deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponseSuccess | deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponseError)

export const getDeleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client_newsletters/${id}`
}

/**
 * 社内報を削除する
 * @summary Delete client newsletter
 */
export const deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdResponse>(getDeleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/client_newsletters/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersId>>>

/**
 * @summary Delete client newsletter
 */
export const useDeleteApiV1ThreeLetterCodeClientAdminsClientNewslettersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeClientAdminsClientNewslettersIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsClientPortalItems200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponseError = (getApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse = (getApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponseSuccess | getApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsClientPortalItemsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client_portal_items`
}

/**
 * ポータルアイテムの一覧を取得する（表示順序順）
 * @summary Get client portal items
 */
export const getApiV1ThreeLetterCodeClientAdminsClientPortalItems = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse>(getGetApiV1ThreeLetterCodeClientAdminsClientPortalItemsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsClientPortalItemsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/client_portal_items`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsClientPortalItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientPortalItems>>>

/**
 * @summary Get client portal items
 */
export const useGetApiV1ThreeLetterCodeClientAdminsClientPortalItems = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientPortalItems>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsClientPortalItemsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsClientPortalItems(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse201 = {
  data: PostApiV1ThreeLetterCodeClientAdminsClientPortalItems201
  status: 201
}

export type postApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponseError = (postApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse401 | postApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse = (postApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponseSuccess | postApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsClientPortalItemsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client_portal_items`
}

/**
 * ポータルアイテムを新規作成する
 * @summary Create client portal item
 */
export const postApiV1ThreeLetterCodeClientAdminsClientPortalItems = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeClientAdminsClientPortalItemsBody: PostApiV1ThreeLetterCodeClientAdminsClientPortalItemsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeClientAdminsClientPortalItemsResponse>(getPostApiV1ThreeLetterCodeClientAdminsClientPortalItemsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeClientAdminsClientPortalItemsBody)
  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsClientPortalItemsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeClientAdminsClientPortalItemsBody }) => {
    return postApiV1ThreeLetterCodeClientAdminsClientPortalItems(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsClientPortalItemsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/client_portal_items`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsClientPortalItemsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsClientPortalItems>>>

/**
 * @summary Create client portal item
 */
export const usePostApiV1ThreeLetterCodeClientAdminsClientPortalItems = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsClientPortalItems>>, TError, Key, PostApiV1ThreeLetterCodeClientAdminsClientPortalItemsBody, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsClientPortalItems>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsClientPortalItemsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsClientPortalItemsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsClientPortalItemsId200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponseError = (getApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse401 | getApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse = (getApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponseSuccess | getApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client_portal_items/${id}`
}

/**
 * ポータルアイテムの詳細を取得する
 * @summary Get client portal item
 */
export const getApiV1ThreeLetterCodeClientAdminsClientPortalItemsId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse>(getGetApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/client_portal_items/${id}`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientPortalItemsId>>>

/**
 * @summary Get client portal item
 */
export const useGetApiV1ThreeLetterCodeClientAdminsClientPortalItemsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClientPortalItemsId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsClientPortalItemsId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse200 = {
  data: PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsId200
  status: 200
}

export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse401 = {
  data: Errors
  status: 401
}

export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse404 = {
  data: Errors
  status: 404
}

export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse422 = {
  data: Errors
  status: 422
}

export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponseSuccess = (patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse200) & {
  headers: Headers;
};
export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponseError = (patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse401 | patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse404 | patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse422) & {
  headers: Headers;
};

export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse = (patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponseSuccess | patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponseError)

export const getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client_portal_items/${id}`
}

/**
 * ポータルアイテムを更新する
 * @summary Update client portal item
 */
export const patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsId = async (threeLetterCode: string,
    id: number,
    patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdBody: PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdBody, options?: RequestInit): Promise<patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse> => {

  return customInstance<patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse>(getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdBody)
  }
);}




export const getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdBody }) => {
    return patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsId(threeLetterCode, id, arg, options);
  }
}
export const getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/client_portal_items/${id}`] as const;

export type PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsId>>>

/**
 * @summary Update client portal item
 */
export const usePatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsId>>, TError, Key, PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdBody, Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdMutationKey(threeLetterCode,id);
  const swrFn = getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponseSuccess = (deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponseError = (deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse = (deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponseSuccess | deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponseError)

export const getDeleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client_portal_items/${id}`
}

/**
 * ポータルアイテムを削除する
 * @summary Delete client portal item
 */
export const deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdResponse>(getDeleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/client_portal_items/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsId>>>

/**
 * @summary Delete client portal item
 */
export const useDeleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponse200 = {
  data: PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorder200
  status: 200
}

export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponse400 = {
  data: Errors
  status: 400
}

export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponse401 = {
  data: Errors
  status: 401
}

export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponse404 = {
  data: Errors
  status: 404
}

export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponse422 = {
  data: Errors
  status: 422
}

export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponseSuccess = (patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponse200) & {
  headers: Headers;
};
export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponseError = (patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponse400 | patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponse401 | patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponse404 | patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponse422) & {
  headers: Headers;
};

export type patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponse = (patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponseSuccess | patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponseError)

export const getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client_portal_items/reorder`
}

/**
 * ポータルアイテムの表示順序を並び替える
 * @summary Reorder client portal items
 */
export const patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorder = async (threeLetterCode: string,
    patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderBody: PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderBody, options?: RequestInit): Promise<patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponse> => {

  return customInstance<patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderResponse>(getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderUrl(threeLetterCode),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderBody)
  }
);}




export const getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderBody }) => {
    return patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorder(threeLetterCode, arg, options);
  }
}
export const getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/client_portal_items/reorder`] as const;

export type PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorder>>>

/**
 * @summary Reorder client portal items
 */
export const usePatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorder = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorder>>, TError, Key, PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderBody, Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorder>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderMutationKey(threeLetterCode);
  const swrFn = getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorderMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsClientResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsClient200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsClientResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsClientResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsClientResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsClientResponseError = (getApiV1ThreeLetterCodeClientAdminsClientResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsClientResponse = (getApiV1ThreeLetterCodeClientAdminsClientResponseSuccess | getApiV1ThreeLetterCodeClientAdminsClientResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsClientUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/client`
}

/**
 * ログイン中の管理者が所属する導入企業情報を取得する
 * @summary Get client
 */
export const getApiV1ThreeLetterCodeClientAdminsClient = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsClientResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsClientResponse>(getGetApiV1ThreeLetterCodeClientAdminsClientUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsClientKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/client`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsClientQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClient>>>

/**
 * @summary Get client
 */
export const useGetApiV1ThreeLetterCodeClientAdminsClient = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsClient>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsClientKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsClient(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsLinkUrlsResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsLinkUrls200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsLinkUrlsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsLinkUrlsResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsLinkUrlsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsLinkUrlsResponseError = (getApiV1ThreeLetterCodeClientAdminsLinkUrlsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsLinkUrlsResponse = (getApiV1ThreeLetterCodeClientAdminsLinkUrlsResponseSuccess | getApiV1ThreeLetterCodeClientAdminsLinkUrlsResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsLinkUrlsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/link_urls`
}

/**
 * リンクURL一覧を取得する
 * @summary Get LinkUrls
 */
export const getApiV1ThreeLetterCodeClientAdminsLinkUrls = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsLinkUrlsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsLinkUrlsResponse>(getGetApiV1ThreeLetterCodeClientAdminsLinkUrlsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsLinkUrlsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/link_urls`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsLinkUrlsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsLinkUrls>>>

/**
 * @summary Get LinkUrls
 */
export const useGetApiV1ThreeLetterCodeClientAdminsLinkUrls = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsLinkUrls>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsLinkUrlsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsLinkUrls(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlags200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsResponseError = (getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsResponse = (getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsResponseSuccess | getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/partner_feature_flags`
}

/**
 * パートナーの機能フラグ一覧を取得する
 * @summary Get partner feature flags
 */
export const getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlags = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsResponse>(getGetApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/partner_feature_flags`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlags>>>

/**
 * @summary Get partner feature flags
 */
export const useGetApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlags = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlags>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlags(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsServiceUsagesResponse200ApplicationJson = {
  data: GetApiV1ThreeLetterCodeClientAdminsServiceUsages200One
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsServiceUsagesResponse200TextCsv = {
  data: Blob
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsServiceUsagesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsServiceUsagesResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsServiceUsagesResponse200ApplicationJson | getApiV1ThreeLetterCodeClientAdminsServiceUsagesResponse200TextCsv) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsServiceUsagesResponseError = (getApiV1ThreeLetterCodeClientAdminsServiceUsagesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsServiceUsagesResponse = (getApiV1ThreeLetterCodeClientAdminsServiceUsagesResponseSuccess | getApiV1ThreeLetterCodeClientAdminsServiceUsagesResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsServiceUsagesUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsServiceUsagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/client_admins/service_usages?${stringifiedParams}` : `/api/v1/${threeLetterCode}/client_admins/service_usages`
}

/**
 * サービス利用履歴の一覧を取得する（JSON/CSV切り替え可能）
 * @summary Get service_usages
 */
export const getApiV1ThreeLetterCodeClientAdminsServiceUsages = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsServiceUsagesParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsServiceUsagesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsServiceUsagesResponse>(getGetApiV1ThreeLetterCodeClientAdminsServiceUsagesUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsServiceUsagesKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsServiceUsagesParams,) => [`/api/v1/${threeLetterCode}/client_admins/service_usages`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeClientAdminsServiceUsagesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsServiceUsages>>>

/**
 * @summary Get service_usages
 */
export const useGetApiV1ThreeLetterCodeClientAdminsServiceUsages = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsServiceUsagesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsServiceUsages>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsServiceUsagesKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsServiceUsages(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ClientAdminsSignInResponse200 = {
  data: PostApiV1ClientAdminsSignIn200
  status: 200
}

export type postApiV1ClientAdminsSignInResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ClientAdminsSignInResponse403 = {
  data: Errors
  status: 403
}

export type postApiV1ClientAdminsSignInResponseSuccess = (postApiV1ClientAdminsSignInResponse200) & {
  headers: Headers;
};
export type postApiV1ClientAdminsSignInResponseError = (postApiV1ClientAdminsSignInResponse401 | postApiV1ClientAdminsSignInResponse403) & {
  headers: Headers;
};

export type postApiV1ClientAdminsSignInResponse = (postApiV1ClientAdminsSignInResponseSuccess | postApiV1ClientAdminsSignInResponseError)

export const getPostApiV1ClientAdminsSignInUrl = () => {




  return `/api/v1/client_admins/sign_in`
}

/**
 * 企業管理者としてログインしJWTトークンを取得する
 * @summary Get JWT
 */
export const postApiV1ClientAdminsSignIn = async (postApiV1ClientAdminsSignInBody?: PostApiV1ClientAdminsSignInBody, options?: RequestInit): Promise<postApiV1ClientAdminsSignInResponse> => {

  return customInstance<postApiV1ClientAdminsSignInResponse>(getPostApiV1ClientAdminsSignInUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ClientAdminsSignInBody)
  }
);}




export const getPostApiV1ClientAdminsSignInMutationFetcher = ( options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ClientAdminsSignInBody | undefined }) => {
    return postApiV1ClientAdminsSignIn(arg, options);
  }
}
export const getPostApiV1ClientAdminsSignInMutationKey = () => [`/api/v1/client_admins/sign_in`] as const;

export type PostApiV1ClientAdminsSignInMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ClientAdminsSignIn>>>

/**
 * @summary Get JWT
 */
export const usePostApiV1ClientAdminsSignIn = <TError = Errors>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ClientAdminsSignIn>>, TError, Key, PostApiV1ClientAdminsSignInBody | undefined, Awaited<ReturnType<typeof postApiV1ClientAdminsSignIn>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ClientAdminsSignInMutationKey();
  const swrFn = getPostApiV1ClientAdminsSignInMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatus200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusResponseError = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusResponse401 | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusResponse = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusResponseSuccess | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusUrl = (threeLetterCode: string,
    stressAssessmentId: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/branch_linkage_status`
}

/**
 * ストレスチェックの事業所紐づけ状態を取得する
 * @summary Get branch linkage status for a stress assessment
 */
export const getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatus = async (threeLetterCode: string,
    stressAssessmentId: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusResponse>(getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusUrl(threeLetterCode,stressAssessmentId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusKey = (threeLetterCode: string,
    stressAssessmentId: number,) => [`/api/v1/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/branch_linkage_status`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatus>>>

/**
 * @summary Get branch linkage status for a stress assessment
 */
export const useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatus = <TError = Errors>(
  threeLetterCode: string,
    stressAssessmentId: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatus>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && stressAssessmentId !== null && stressAssessmentId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatusKey(threeLetterCode,stressAssessmentId) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatus(threeLetterCode,stressAssessmentId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStats200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponseError = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponse401 | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponse403 | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponse = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponseSuccess | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsUrl = (threeLetterCode: string,
    stressAssessmentId: number,
    branchId: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/branches/${branchId}/stats`
}

/**
 * ストレスチェックの事業所別回答統計を取得する
 * @summary Get stress assessment branch stats
 */
export const getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStats = async (threeLetterCode: string,
    stressAssessmentId: number,
    branchId: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsResponse>(getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsUrl(threeLetterCode,stressAssessmentId,branchId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsKey = (threeLetterCode: string,
    stressAssessmentId: number,
    branchId: number,) => [`/api/v1/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/branches/${branchId}/stats`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStats>>>

/**
 * @summary Get stress assessment branch stats
 */
export const useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStats = <TError = Errors>(
  threeLetterCode: string,
    stressAssessmentId: number,
    branchId: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStats>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && stressAssessmentId !== null && stressAssessmentId !== undefined && branchId !== null && branchId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStatsKey(threeLetterCode,stressAssessmentId,branchId) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStats(threeLetterCode,stressAssessmentId,branchId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategories200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesResponseError = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesResponse401 | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesResponse = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesResponseSuccess | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesUrl = (threeLetterCode: string,
    id: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/stress_assessments/${id}/categories`
}

/**
 * ストレスチェックの設問カテゴリ一覧を取得する
 * @summary Get stress assessment categories
 */
export const getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategories = async (threeLetterCode: string,
    id: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesResponse>(getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesKey = (threeLetterCode: string,
    id: string,) => [`/api/v1/${threeLetterCode}/client_admins/stress_assessments/${id}/categories`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategories>>>

/**
 * @summary Get stress assessment categories
 */
export const useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategories = <TError = Errors>(
  threeLetterCode: string,
    id: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategories>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategoriesKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategories(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersResponse204 = {
  data: void
  status: 204
}

export type postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersResponse204) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersResponseError = (postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersResponse = (postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersResponseSuccess | postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersUrl = (threeLetterCode: string,
    stressAssessmentId: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/reminders`
}

/**
 * ストレスチェック未回答者にリマインダーメールを送信する
 * @summary Send reminders to unanswered users
 */
export const postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdReminders = async (threeLetterCode: string,
    stressAssessmentId: number, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersResponse> => {

  return customInstance<postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersResponse>(getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersUrl(threeLetterCode,stressAssessmentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersMutationFetcher = (threeLetterCode: string,
    stressAssessmentId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdReminders(threeLetterCode, stressAssessmentId, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersMutationKey = (threeLetterCode: string,
    stressAssessmentId: number,) => [`/api/v1/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/reminders`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdReminders>>>

/**
 * @summary Send reminders to unanswered users
 */
export const usePostApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdReminders = <TError = Errors>(
  threeLetterCode: string,
    stressAssessmentId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdReminders>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdReminders>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersMutationKey(threeLetterCode,stressAssessmentId);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdRemindersMutationFetcher(threeLetterCode,stressAssessmentId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResults200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponseError = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponse400 | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponse401 | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponse = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponseSuccess | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsUrl = (threeLetterCode: string,
    stressAssessmentId: number,
    params?: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/results?${stringifiedParams}` : `/api/v1/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/results`
}

/**
 * ストレスチェック結果の一覧を取得する
 * @summary Get stress assessment results
 */
export const getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResults = async (threeLetterCode: string,
    stressAssessmentId: number,
    params?: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsResponse>(getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsUrl(threeLetterCode,stressAssessmentId,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsKey = (threeLetterCode: string,
    stressAssessmentId: number,
    params?: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsParams,) => [`/api/v1/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/results`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResults>>>

/**
 * @summary Get stress assessment results
 */
export const useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResults = <TError = Errors>(
  threeLetterCode: string,
    stressAssessmentId: number,
    params?: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResults>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && stressAssessmentId !== null && stressAssessmentId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsKey(threeLetterCode,stressAssessmentId,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResults(threeLetterCode,stressAssessmentId,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsId200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdResponseError = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdResponse401 | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdResponse = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdResponseSuccess | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdUrl = (threeLetterCode: string,
    stressAssessmentId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/results/${id}`
}

/**
 * ストレスチェック結果の詳細を取得する
 * @summary Get stress assessment result detail
 */
export const getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsId = async (threeLetterCode: string,
    stressAssessmentId: number,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdResponse>(getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdUrl(threeLetterCode,stressAssessmentId,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdKey = (threeLetterCode: string,
    stressAssessmentId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/results/${id}`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsId>>>

/**
 * @summary Get stress assessment result detail
 */
export const useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsId = <TError = Errors>(
  threeLetterCode: string,
    stressAssessmentId: number,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && stressAssessmentId !== null && stressAssessmentId !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsIdKey(threeLetterCode,stressAssessmentId,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsId(threeLetterCode,stressAssessmentId,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummary200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponseError = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponse401 | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponse403 | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponse = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponseSuccess | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryUrl = (threeLetterCode: string,
    id: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/stress_assessments/${id}/summary`
}

/**
 * ストレスチェックの集計サマリーを取得する
 * @summary Get stress assessment summary
 */
export const getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummary = async (threeLetterCode: string,
    id: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryResponse>(getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryKey = (threeLetterCode: string,
    id: string,) => [`/api/v1/${threeLetterCode}/client_admins/stress_assessments/${id}/summary`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummary>>>

/**
 * @summary Get stress assessment summary
 */
export const useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummary = <TError = Errors>(
  threeLetterCode: string,
    id: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummary>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummaryKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummary(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswers200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersResponseError = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersResponse401 | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersResponse = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersResponseSuccess | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersUrl = (threeLetterCode: string,
    stressAssessmentId: number,
    userId: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/users/${userId}/answers`
}

/**
 * 指定ユーザーのストレスチェック回答一覧を取得する
 * @summary Get stress assessment answers
 */
export const getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswers = async (threeLetterCode: string,
    stressAssessmentId: number,
    userId: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersResponse>(getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersUrl(threeLetterCode,stressAssessmentId,userId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersKey = (threeLetterCode: string,
    stressAssessmentId: number,
    userId: number,) => [`/api/v1/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/users/${userId}/answers`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswers>>>

/**
 * @summary Get stress assessment answers
 */
export const useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswers = <TError = Errors>(
  threeLetterCode: string,
    stressAssessmentId: number,
    userId: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswers>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && stressAssessmentId !== null && stressAssessmentId !== undefined && userId !== null && userId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswersKey(threeLetterCode,stressAssessmentId,userId) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswers(threeLetterCode,stressAssessmentId,userId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsStressAssessments200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponseError = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse400 | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse = (getApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponseSuccess | getApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/client_admins/stress_assessments?${stringifiedParams}` : `/api/v1/${threeLetterCode}/client_admins/stress_assessments`
}

/**
 * ストレスチェック実施の一覧を取得する
 * @summary List stress assessments
 */
export const getApiV1ThreeLetterCodeClientAdminsStressAssessments = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse>(getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsParams,) => [`/api/v1/${threeLetterCode}/client_admins/stress_assessments`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessments>>>

/**
 * @summary List stress assessments
 */
export const useGetApiV1ThreeLetterCodeClientAdminsStressAssessments = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressAssessments>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsStressAssessments(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse201 = {
  data: PostApiV1ThreeLetterCodeClientAdminsStressAssessments201
  status: 201
}

export type postApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponseError = (postApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse401 | postApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse = (postApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponseSuccess | postApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/stress_assessments`
}

/**
 * ストレスチェックを新規作成する
 * @summary Create stress assessment
 */
export const postApiV1ThreeLetterCodeClientAdminsStressAssessments = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeClientAdminsStressAssessmentsBody?: PostApiV1ThreeLetterCodeClientAdminsStressAssessmentsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeClientAdminsStressAssessmentsResponse>(getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeClientAdminsStressAssessmentsBody)
  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeClientAdminsStressAssessmentsBody | undefined }) => {
    return postApiV1ThreeLetterCodeClientAdminsStressAssessments(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/stress_assessments`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsStressAssessmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsStressAssessments>>>

/**
 * @summary Create stress assessment
 */
export const usePostApiV1ThreeLetterCodeClientAdminsStressAssessments = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsStressAssessments>>, TError, Key, PostApiV1ThreeLetterCodeClientAdminsStressAssessmentsBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsStressAssessments>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsStressCheckSchedule200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponseError = (getApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse = (getApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponseSuccess | getApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsStressCheckScheduleUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/stress_check_schedule`
}

/**
 * 現在アクティブなストレスチェックスケジュールを取得する。存在しない場合は null を返す。
 * @summary Get current stress check schedule
 */
export const getApiV1ThreeLetterCodeClientAdminsStressCheckSchedule = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse>(getGetApiV1ThreeLetterCodeClientAdminsStressCheckScheduleUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsStressCheckScheduleKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/stress_check_schedule`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsStressCheckScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressCheckSchedule>>>

/**
 * @summary Get current stress check schedule
 */
export const useGetApiV1ThreeLetterCodeClientAdminsStressCheckSchedule = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStressCheckSchedule>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsStressCheckScheduleKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsStressCheckSchedule(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse201 = {
  data: PostApiV1ThreeLetterCodeClientAdminsStressCheckSchedule201
  status: 201
}

export type postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponseError = (postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse400 | postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse401 | postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse = (postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponseSuccess | postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsStressCheckScheduleUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/stress_check_schedule`
}

/**
 * ストレスチェックスケジュールを作成する。既存のアクティブスケジュールは置き換えられる。
 * @summary Create stress check schedule
 */
export const postApiV1ThreeLetterCodeClientAdminsStressCheckSchedule = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleBody?: PostApiV1ThreeLetterCodeClientAdminsStressCheckScheduleBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse> => {

  return customInstance<postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse>(getPostApiV1ThreeLetterCodeClientAdminsStressCheckScheduleUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeClientAdminsStressCheckScheduleBody)
  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsStressCheckScheduleMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeClientAdminsStressCheckScheduleBody | undefined }) => {
    return postApiV1ThreeLetterCodeClientAdminsStressCheckSchedule(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsStressCheckScheduleMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/stress_check_schedule`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsStressCheckScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsStressCheckSchedule>>>

/**
 * @summary Create stress check schedule
 */
export const usePostApiV1ThreeLetterCodeClientAdminsStressCheckSchedule = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsStressCheckSchedule>>, TError, Key, PostApiV1ThreeLetterCodeClientAdminsStressCheckScheduleBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsStressCheckSchedule>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsStressCheckScheduleMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsStressCheckScheduleMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponseSuccess = (deleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponseError = (deleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse = (deleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponseSuccess | deleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponseError)

export const getDeleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/stress_check_schedule`
}

/**
 * 現在アクティブなスケジュールをアーカイブする（archived_at をセット）。
 * @summary Archive current stress check schedule
 */
export const deleteApiV1ThreeLetterCodeClientAdminsStressCheckSchedule = async (threeLetterCode: string, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleResponse>(getDeleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleUrl(threeLetterCode),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeClientAdminsStressCheckSchedule(threeLetterCode, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/stress_check_schedule`] as const;

export type DeleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsStressCheckSchedule>>>

/**
 * @summary Archive current stress check schedule
 */
export const useDeleteApiV1ThreeLetterCodeClientAdminsStressCheckSchedule = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsStressCheckSchedule>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsStressCheckSchedule>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleMutationKey(threeLetterCode);
  const swrFn = getDeleteApiV1ThreeLetterCodeClientAdminsStressCheckScheduleMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsStripeCreditCard200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponse502 = {
  data: Errors
  status: 502
}

export type getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponseError = (getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponse401 | getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponse404 | getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponse502) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponse = (getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponseSuccess | getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsStripeCreditCardUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/stripe_credit_card`
}

/**
 * クライアント管理画面のお支払い方法表示用。自社の Stripe Customer に設定されている既定カードの情報（ブランド・下4桁・有効期限）を Stripe から取得して返す。カード情報は自社 DB に保持せず Stripe を正とする。カード払いでない等で Stripe Customer が結線されていない企業、および既定カードが未設定（カード登録直後で Webhook 未反映等）の場合は 404 を返す
 * @summary Get stripe credit card
 */
export const getApiV1ThreeLetterCodeClientAdminsStripeCreditCard = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsStripeCreditCardResponse>(getGetApiV1ThreeLetterCodeClientAdminsStripeCreditCardUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsStripeCreditCardKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/stripe_credit_card`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsStripeCreditCardQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStripeCreditCard>>>

/**
 * @summary Get stripe credit card
 */
export const useGetApiV1ThreeLetterCodeClientAdminsStripeCreditCard = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsStripeCreditCard>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsStripeCreditCardKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsStripeCreditCard(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRows200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsResponseError = (getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsResponse401 | getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsResponse = (getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsResponseSuccess | getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsUrl = (threeLetterCode: string,
    userBulkCreationRequestId: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/user_bulk_creation_requests/${userBulkCreationRequestId}/user_bulk_creation_rows`
}

/**
 * ユーザー一括登録の行データ一覧を取得する
 * @summary Get user bulk creation rows
 */
export const getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRows = async (threeLetterCode: string,
    userBulkCreationRequestId: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsResponse>(getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsUrl(threeLetterCode,userBulkCreationRequestId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsKey = (threeLetterCode: string,
    userBulkCreationRequestId: number,) => [`/api/v1/${threeLetterCode}/client_admins/user_bulk_creation_requests/${userBulkCreationRequestId}/user_bulk_creation_rows`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRows>>>

/**
 * @summary Get user bulk creation rows
 */
export const useGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRows = <TError = Errors>(
  threeLetterCode: string,
    userBulkCreationRequestId: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRows>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && userBulkCreationRequestId !== null && userBulkCreationRequestId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRowsKey(threeLetterCode,userBulkCreationRequestId) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUserBulkCreationRequestIdUserBulkCreationRows(threeLetterCode,userBulkCreationRequestId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequests200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsResponseError = (getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsResponse400 | getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsResponse = (getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsResponseSuccess | getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/client_admins/user_bulk_creation_requests?${stringifiedParams}` : `/api/v1/${threeLetterCode}/client_admins/user_bulk_creation_requests`
}

/**
 * ユーザー一括登録リクエストの一覧を取得する
 * @summary index
 */
export const getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequests = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsResponse>(getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsParams,) => [`/api/v1/${threeLetterCode}/client_admins/user_bulk_creation_requests`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequests>>>

/**
 * @summary index
 */
export const useGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequests = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequests>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequests(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponseError = (getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse = (getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponseSuccess | getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/user_bulk_creation_requests/${id}`
}

/**
 * ユーザー一括登録リクエストの詳細を取得する
 * @summary Get UserBulkCreationRequest
 */
export const getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse>(getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/user_bulk_creation_requests/${id}`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId>>>

/**
 * @summary Get UserBulkCreationRequest
 */
export const useGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse200 = {
  data: PatchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId200
  status: 200
}

export type patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse401 = {
  data: Errors
  status: 401
}

export type patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse422 = {
  data: Errors
  status: 422
}

export type patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponseSuccess = (patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse200) & {
  headers: Headers;
};
export type patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponseError = (patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse401 | patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse422) & {
  headers: Headers;
};

export type patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse = (patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponseSuccess | patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponseError)

export const getPatchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdUrl = (threeLetterCode: string,
    id: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/user_bulk_creation_requests/${id}`
}

/**
 * ユーザー一括登録リクエストの実行予定日時を更新する
 * @summary Update UserBulkCreationRequest
 */
export const patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId = async (threeLetterCode: string,
    id: string,
    patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdBody?: PatchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdBody, options?: RequestInit): Promise<patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse> => {

  return customInstance<patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdResponse>(getPatchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdBody)
  }
);}




export const getPatchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdMutationFetcher = (threeLetterCode: string,
    id: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PatchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdBody | undefined }) => {
    return patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId(threeLetterCode, id, arg, options);
  }
}
export const getPatchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdMutationKey = (threeLetterCode: string,
    id: string,) => [`/api/v1/${threeLetterCode}/client_admins/user_bulk_creation_requests/${id}`] as const;

export type PatchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId>>>

/**
 * @summary Update UserBulkCreationRequest
 */
export const usePatchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId = <TError = Errors>(
  threeLetterCode: string,
    id: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId>>, TError, Key, PatchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdBody | undefined, Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdMutationKey(threeLetterCode,id);
  const swrFn = getPatchApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelResponse204 = {
  data: void
  status: 204
}

export type postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelResponse204) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelResponseError = (postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelResponse401 | postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelResponse = (postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelResponseSuccess | postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/user_bulk_creation_requests/${id}/cancel`
}

/**
 * ユーザー一括登録リクエストをキャンセルする
 * @summary Cancel UserBulkCreationRequest
 */
export const postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancel = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelResponse> => {

  return customInstance<postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelResponse>(getPostApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelUrl(threeLetterCode,id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancel(threeLetterCode, id, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/user_bulk_creation_requests/${id}/cancel`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancel>>>

/**
 * @summary Cancel UserBulkCreationRequest
 */
export const usePostApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancel = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancel>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancel>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelMutationKey(threeLetterCode,id);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancelMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsResponse200ApplicationJson = {
  data: GetApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogs200One
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsResponse200TextCsv = {
  data: Blob
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsResponse200ApplicationJson | getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsResponse200TextCsv) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsResponseError = (getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsResponse = (getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsResponseSuccess | getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/client_admins/user_daily_first_access_logs?${stringifiedParams}` : `/api/v1/${threeLetterCode}/client_admins/user_daily_first_access_logs`
}

/**
 * ユーザーの日次初回アクセスログ一覧を取得する（JSON/CSV切り替え可能）
 * @summary Get users
 */
export const getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogs = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsResponse>(getGetApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsParams,) => [`/api/v1/${threeLetterCode}/client_admins/user_daily_first_access_logs`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogs>>>

/**
 * @summary Get users
 */
export const useGetApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogs = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogs>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsUserDailyFirstAccessLogs(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsResponse201 = {
  data: PostApiV1ThreeLetterCodeClientAdminsUsersBulkCreations201
  status: 201
}

export type postApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsResponseError = (postApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsResponse400 | postApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsResponse = (postApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsResponseSuccess | postApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/users/bulk_creations`
}

/**
 * CSVファイルによるユーザーの一括登録を行う
 * @summary create
 */
export const postApiV1ThreeLetterCodeClientAdminsUsersBulkCreations = async (threeLetterCode: string,
    requestClientAdminsBulkCreation: RequestClientAdminsBulkCreation, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsResponse> => {
    const formData = new FormData();
formData.append(`file`, requestClientAdminsBulkCreation.file);
formData.append(`selected_option`, requestClientAdminsBulkCreation.selected_option);
if(requestClientAdminsBulkCreation.scheduled_date !== undefined && requestClientAdminsBulkCreation.scheduled_date !== null) {
 formData.append(`scheduled_date`, requestClientAdminsBulkCreation.scheduled_date);
 }
if(requestClientAdminsBulkCreation.scheduled_hour !== undefined && requestClientAdminsBulkCreation.scheduled_hour !== null) {
 formData.append(`scheduled_hour`, requestClientAdminsBulkCreation.scheduled_hour);
 }

  return customInstance<postApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsResponse>(getPostApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestClientAdminsBulkCreation }) => {
    return postApiV1ThreeLetterCodeClientAdminsUsersBulkCreations(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/users/bulk_creations`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsersBulkCreations>>>

/**
 * @summary create
 */
export const usePostApiV1ThreeLetterCodeClientAdminsUsersBulkCreations = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsersBulkCreations>>, TError, Key, RequestClientAdminsBulkCreation, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsersBulkCreations>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsUsersBulkCreationsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsResponse201 = {
  data: PostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletions201
  status: 201
}

export type postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsResponseError = (postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsResponse400 | postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsResponse = (postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsResponseSuccess | postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/users/bulk_deletions`
}

/**
 * CSVファイルによるユーザーの一括削除を行う
 * @summary Bulk delete users via CSV
 */
export const postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletions = async (threeLetterCode: string,
    requestClientAdminsBulkDeletion: RequestClientAdminsBulkDeletion, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsResponse> => {
    const formData = new FormData();
formData.append(`file`, requestClientAdminsBulkDeletion.file);

formData.append(`selected_option`, requestClientAdminsBulkDeletion.selected_option);

if(requestClientAdminsBulkDeletion.scheduled_date !== undefined && requestClientAdminsBulkDeletion.scheduled_date !== null) {
 formData.append(`scheduled_date`, requestClientAdminsBulkDeletion.scheduled_date);
 }

if(requestClientAdminsBulkDeletion.scheduled_hour !== undefined && requestClientAdminsBulkDeletion.scheduled_hour !== null) {
 formData.append(`scheduled_hour`, requestClientAdminsBulkDeletion.scheduled_hour);
 }

  return customInstance<postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsResponse>(getPostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestClientAdminsBulkDeletion }) => {
    return postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletions(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/users/bulk_deletions`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletions>>>

/**
 * @summary Bulk delete users via CSV
 */
export const usePostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletions = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletions>>, TError, Key, RequestClientAdminsBulkDeletion, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsersBulkDeletions>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersResponse201 = {
  data: PostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginReminders201
  status: 201
}

export type postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersResponseError = (postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersResponse = (postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersResponseSuccess | postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/users/bulk_login_reminders`
}

/**
 * 未ログインユーザー全員にログインリマインダーメールを一括送信する
 * @summary create
 */
export const postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginReminders = async (threeLetterCode: string, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersResponse> => {

  return customInstance<postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersResponse>(getPostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersUrl(threeLetterCode),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginReminders(threeLetterCode, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/users/bulk_login_reminders`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginReminders>>>

/**
 * @summary create
 */
export const usePostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginReminders = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginReminders>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsersBulkLoginReminders>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersResponse201 = {
  data: PostApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginReminders201
  status: 201
}

export type postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersResponseError = (postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersResponse = (postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersResponseSuccess | postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersUrl = (threeLetterCode: string,
    userId: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/users/${userId}/login_reminders`
}

/**
 * 指定ユーザーにログイン情報メールを送信する
 * @summary Send login information
 */
export const postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginReminders = async (threeLetterCode: string,
    userId: number, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersResponse> => {

  return customInstance<postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersResponse>(getPostApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersUrl(threeLetterCode,userId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersMutationFetcher = (threeLetterCode: string,
    userId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginReminders(threeLetterCode, userId, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersMutationKey = (threeLetterCode: string,
    userId: number,) => [`/api/v1/${threeLetterCode}/client_admins/users/${userId}/login_reminders`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginReminders>>>

/**
 * @summary Send login information
 */
export const usePostApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginReminders = <TError = Errors>(
  threeLetterCode: string,
    userId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginReminders>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginReminders>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersMutationKey(threeLetterCode,userId);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersMutationFetcher(threeLetterCode,userId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsUsersUserIdProfile200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileResponseError = (getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileResponse = (getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileResponseSuccess | getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileUrl = (threeLetterCode: string,
    userId: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/users/${userId}/profile`
}

/**
 * 指定ユーザーのプロフィール情報を取得する
 * @summary Get User Profile
 */
export const getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfile = async (threeLetterCode: string,
    userId: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileResponse>(getGetApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileUrl(threeLetterCode,userId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileKey = (threeLetterCode: string,
    userId: number,) => [`/api/v1/${threeLetterCode}/client_admins/users/${userId}/profile`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfile>>>

/**
 * @summary Get User Profile
 */
export const useGetApiV1ThreeLetterCodeClientAdminsUsersUserIdProfile = <TError = Errors>(
  threeLetterCode: string,
    userId: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfile>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && userId !== null && userId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsUsersUserIdProfileKey(threeLetterCode,userId) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsUsersUserIdProfile(threeLetterCode,userId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsUsersResponse200ApplicationJson = {
  data: GetApiV1ThreeLetterCodeClientAdminsUsers200One
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsUsersResponse200TextCsv = {
  data: Blob
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsUsersResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeClientAdminsUsersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsUsersResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsUsersResponse200ApplicationJson | getApiV1ThreeLetterCodeClientAdminsUsersResponse200TextCsv) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsUsersResponseError = (getApiV1ThreeLetterCodeClientAdminsUsersResponse400 | getApiV1ThreeLetterCodeClientAdminsUsersResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsUsersResponse = (getApiV1ThreeLetterCodeClientAdminsUsersResponseSuccess | getApiV1ThreeLetterCodeClientAdminsUsersResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsUsersUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["external_user_ids[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/client_admins/users?${stringifiedParams}` : `/api/v1/${threeLetterCode}/client_admins/users`
}

/**
 * 導入企業に所属するユーザーの一覧を取得する（JSON/CSV切り替え可能）
 * @summary Get users
 */
export const getApiV1ThreeLetterCodeClientAdminsUsers = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsUsersParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsUsersResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsUsersResponse>(getGetApiV1ThreeLetterCodeClientAdminsUsersUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsUsersKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsUsersParams,) => [`/api/v1/${threeLetterCode}/client_admins/users`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeClientAdminsUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsUsers>>>

/**
 * @summary Get users
 */
export const useGetApiV1ThreeLetterCodeClientAdminsUsers = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeClientAdminsUsersParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsUsers>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsUsersKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsUsers(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeClientAdminsUsersResponse201 = {
  data: PostApiV1ThreeLetterCodeClientAdminsUsers201
  status: 201
}

export type postApiV1ThreeLetterCodeClientAdminsUsersResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeClientAdminsUsersResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeClientAdminsUsersResponseSuccess = (postApiV1ThreeLetterCodeClientAdminsUsersResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeClientAdminsUsersResponseError = (postApiV1ThreeLetterCodeClientAdminsUsersResponse401 | postApiV1ThreeLetterCodeClientAdminsUsersResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeClientAdminsUsersResponse = (postApiV1ThreeLetterCodeClientAdminsUsersResponseSuccess | postApiV1ThreeLetterCodeClientAdminsUsersResponseError)

export const getPostApiV1ThreeLetterCodeClientAdminsUsersUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/client_admins/users`
}

/**
 * ユーザーを新規作成する
 * @summary Create User
 */
export const postApiV1ThreeLetterCodeClientAdminsUsers = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeClientAdminsUsersBody?: PostApiV1ThreeLetterCodeClientAdminsUsersBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeClientAdminsUsersResponse> => {

  return customInstance<postApiV1ThreeLetterCodeClientAdminsUsersResponse>(getPostApiV1ThreeLetterCodeClientAdminsUsersUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeClientAdminsUsersBody)
  }
);}




export const getPostApiV1ThreeLetterCodeClientAdminsUsersMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeClientAdminsUsersBody | undefined }) => {
    return postApiV1ThreeLetterCodeClientAdminsUsers(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeClientAdminsUsersMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/client_admins/users`] as const;

export type PostApiV1ThreeLetterCodeClientAdminsUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsers>>>

/**
 * @summary Create User
 */
export const usePostApiV1ThreeLetterCodeClientAdminsUsers = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsers>>, TError, Key, PostApiV1ThreeLetterCodeClientAdminsUsersBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeClientAdminsUsers>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeClientAdminsUsersMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeClientAdminsUsersMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeClientAdminsUsersIdResponse200 = {
  data: GetApiV1ThreeLetterCodeClientAdminsUsersId200
  status: 200
}

export type getApiV1ThreeLetterCodeClientAdminsUsersIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeClientAdminsUsersIdResponseSuccess = (getApiV1ThreeLetterCodeClientAdminsUsersIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeClientAdminsUsersIdResponseError = (getApiV1ThreeLetterCodeClientAdminsUsersIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeClientAdminsUsersIdResponse = (getApiV1ThreeLetterCodeClientAdminsUsersIdResponseSuccess | getApiV1ThreeLetterCodeClientAdminsUsersIdResponseError)

export const getGetApiV1ThreeLetterCodeClientAdminsUsersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/users/${id}`
}

/**
 * ユーザーの詳細を取得する
 * @summary Get user
 */
export const getApiV1ThreeLetterCodeClientAdminsUsersId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeClientAdminsUsersIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeClientAdminsUsersIdResponse>(getGetApiV1ThreeLetterCodeClientAdminsUsersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeClientAdminsUsersIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/users/${id}`] as const;

export type GetApiV1ThreeLetterCodeClientAdminsUsersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsUsersId>>>

/**
 * @summary Get user
 */
export const useGetApiV1ThreeLetterCodeClientAdminsUsersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeClientAdminsUsersId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeClientAdminsUsersIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeClientAdminsUsersId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeClientAdminsUsersIdResponse200 = {
  data: PutApiV1ThreeLetterCodeClientAdminsUsersId200
  status: 200
}

export type putApiV1ThreeLetterCodeClientAdminsUsersIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeClientAdminsUsersIdResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeClientAdminsUsersIdResponseSuccess = (putApiV1ThreeLetterCodeClientAdminsUsersIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeClientAdminsUsersIdResponseError = (putApiV1ThreeLetterCodeClientAdminsUsersIdResponse401 | putApiV1ThreeLetterCodeClientAdminsUsersIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeClientAdminsUsersIdResponse = (putApiV1ThreeLetterCodeClientAdminsUsersIdResponseSuccess | putApiV1ThreeLetterCodeClientAdminsUsersIdResponseError)

export const getPutApiV1ThreeLetterCodeClientAdminsUsersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/users/${id}`
}

/**
 * ユーザー情報を更新する
 * @summary Update user
 */
export const putApiV1ThreeLetterCodeClientAdminsUsersId = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodeClientAdminsUsersIdBody?: PutApiV1ThreeLetterCodeClientAdminsUsersIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeClientAdminsUsersIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeClientAdminsUsersIdResponse>(getPutApiV1ThreeLetterCodeClientAdminsUsersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeClientAdminsUsersIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeClientAdminsUsersIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeClientAdminsUsersIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeClientAdminsUsersId(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeClientAdminsUsersIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/users/${id}`] as const;

export type PutApiV1ThreeLetterCodeClientAdminsUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeClientAdminsUsersId>>>

/**
 * @summary Update user
 */
export const usePutApiV1ThreeLetterCodeClientAdminsUsersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeClientAdminsUsersId>>, TError, Key, PutApiV1ThreeLetterCodeClientAdminsUsersIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeClientAdminsUsersId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeClientAdminsUsersIdMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodeClientAdminsUsersIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeClientAdminsUsersIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeClientAdminsUsersIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeClientAdminsUsersIdResponseSuccess = (deleteApiV1ThreeLetterCodeClientAdminsUsersIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeClientAdminsUsersIdResponseError = (deleteApiV1ThreeLetterCodeClientAdminsUsersIdResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeClientAdminsUsersIdResponse = (deleteApiV1ThreeLetterCodeClientAdminsUsersIdResponseSuccess | deleteApiV1ThreeLetterCodeClientAdminsUsersIdResponseError)

export const getDeleteApiV1ThreeLetterCodeClientAdminsUsersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/client_admins/users/${id}`
}

/**
 * ユーザーを削除する
 * @summary Delete user
 */
export const deleteApiV1ThreeLetterCodeClientAdminsUsersId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeClientAdminsUsersIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeClientAdminsUsersIdResponse>(getDeleteApiV1ThreeLetterCodeClientAdminsUsersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeClientAdminsUsersIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeClientAdminsUsersId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeClientAdminsUsersIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/client_admins/users/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeClientAdminsUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsUsersId>>>

/**
 * @summary Delete user
 */
export const useDeleteApiV1ThreeLetterCodeClientAdminsUsersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsUsersId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeClientAdminsUsersId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeClientAdminsUsersIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeClientAdminsUsersIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeCompanyAdminsCompanyResponse200 = {
  data: GetApiV1ThreeLetterCodeCompanyAdminsCompany200
  status: 200
}

export type getApiV1ThreeLetterCodeCompanyAdminsCompanyResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeCompanyAdminsCompanyResponseSuccess = (getApiV1ThreeLetterCodeCompanyAdminsCompanyResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeCompanyAdminsCompanyResponseError = (getApiV1ThreeLetterCodeCompanyAdminsCompanyResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeCompanyAdminsCompanyResponse = (getApiV1ThreeLetterCodeCompanyAdminsCompanyResponseSuccess | getApiV1ThreeLetterCodeCompanyAdminsCompanyResponseError)

export const getGetApiV1ThreeLetterCodeCompanyAdminsCompanyUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/company_admins/company`
}

/**
 * ログイン中の掲載企業管理者が所属する掲載企業の情報を取得する
 * @summary Get company
 */
export const getApiV1ThreeLetterCodeCompanyAdminsCompany = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeCompanyAdminsCompanyResponse> => {

  return customInstance<getApiV1ThreeLetterCodeCompanyAdminsCompanyResponse>(getGetApiV1ThreeLetterCodeCompanyAdminsCompanyUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeCompanyAdminsCompanyKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/company_admins/company`] as const;

export type GetApiV1ThreeLetterCodeCompanyAdminsCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeCompanyAdminsCompany>>>

/**
 * @summary Get company
 */
export const useGetApiV1ThreeLetterCodeCompanyAdminsCompany = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeCompanyAdminsCompany>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeCompanyAdminsCompanyKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeCompanyAdminsCompany(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1DEFCompanyAdminsCompanyDepositsProvisionalResponse200 = {
  data: GetApiV1DEFCompanyAdminsCompanyDepositsProvisional200
  status: 200
}

export type getApiV1DEFCompanyAdminsCompanyDepositsProvisionalResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1DEFCompanyAdminsCompanyDepositsProvisionalResponseSuccess = (getApiV1DEFCompanyAdminsCompanyDepositsProvisionalResponse200) & {
  headers: Headers;
};
export type getApiV1DEFCompanyAdminsCompanyDepositsProvisionalResponseError = (getApiV1DEFCompanyAdminsCompanyDepositsProvisionalResponse401) & {
  headers: Headers;
};

export type getApiV1DEFCompanyAdminsCompanyDepositsProvisionalResponse = (getApiV1DEFCompanyAdminsCompanyDepositsProvisionalResponseSuccess | getApiV1DEFCompanyAdminsCompanyDepositsProvisionalResponseError)

export const getGetApiV1DEFCompanyAdminsCompanyDepositsProvisionalUrl = () => {




  return `/api/v1/DEF/company_admins/company_deposits/provisional`
}

/**
 * 当月の暫定入金額を取得する（確定前の集計結果）
 * @summary Get provisional deposit amount
 */
export const getApiV1DEFCompanyAdminsCompanyDepositsProvisional = async ( options?: RequestInit): Promise<getApiV1DEFCompanyAdminsCompanyDepositsProvisionalResponse> => {

  return customInstance<getApiV1DEFCompanyAdminsCompanyDepositsProvisionalResponse>(getGetApiV1DEFCompanyAdminsCompanyDepositsProvisionalUrl(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1DEFCompanyAdminsCompanyDepositsProvisionalKey = () => [`/api/v1/DEF/company_admins/company_deposits/provisional`] as const;

export type GetApiV1DEFCompanyAdminsCompanyDepositsProvisionalQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1DEFCompanyAdminsCompanyDepositsProvisional>>>

/**
 * @summary Get provisional deposit amount
 */
export const useGetApiV1DEFCompanyAdminsCompanyDepositsProvisional = <TError = Errors>(
   options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1DEFCompanyAdminsCompanyDepositsProvisional>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1DEFCompanyAdminsCompanyDepositsProvisionalKey() : null);
  const swrFn = () => getApiV1DEFCompanyAdminsCompanyDepositsProvisional(requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsResponse200ApplicationJson = {
  data: GetApiV1ThreeLetterCodeCompanyAdminsCompanyDeposits200One
  status: 200
}

export type getApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsResponse200TextCsv = {
  data: Blob
  status: 200
}

export type getApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsResponseSuccess = (getApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsResponse200ApplicationJson | getApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsResponse200TextCsv) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsResponseError = (getApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsResponse = (getApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsResponseSuccess | getApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsResponseError)

export const getGetApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/company_admins/company_deposits?${stringifiedParams}` : `/api/v1/${threeLetterCode}/company_admins/company_deposits`
}

/**
 * 掲載企業管理者が所属する掲載企業の入金履歴を取得する（JSON/CSV形式対応）
 * @summary Get company_deposits
 */
export const getApiV1ThreeLetterCodeCompanyAdminsCompanyDeposits = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsResponse>(getGetApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsParams,) => [`/api/v1/${threeLetterCode}/company_admins/company_deposits`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeCompanyAdminsCompanyDeposits>>>

/**
 * @summary Get company_deposits
 */
export const useGetApiV1ThreeLetterCodeCompanyAdminsCompanyDeposits = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeCompanyAdminsCompanyDeposits>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeCompanyAdminsCompanyDepositsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeCompanyAdminsCompanyDeposits(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponse201 = {
  data: void
  status: 201
}

export type postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponse403 = {
  data: Errors
  status: 403
}

export type postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponseSuccess = (postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponseError = (postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponse401 | postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponse403 | postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponse404) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponse = (postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponseSuccess | postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponseError)

export const getPostApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsUrl = (threeLetterCode: string,
    redeemableStoreCouponId: number,) => {




  return `/api/v1/${threeLetterCode}/company_admins/redeemable_store_coupons/${redeemableStoreCouponId}/cancellations`
}

/**
 * 指定した地域ギフト（店舗利用型クーポン）をキャンセルする
 * @summary Create redeemable_store_coupon cancellation
 */
export const postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellations = async (threeLetterCode: string,
    redeemableStoreCouponId: number, options?: RequestInit): Promise<postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsResponse>(getPostApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsUrl(threeLetterCode,redeemableStoreCouponId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsMutationFetcher = (threeLetterCode: string,
    redeemableStoreCouponId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellations(threeLetterCode, redeemableStoreCouponId, options);
  }
}
export const getPostApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsMutationKey = (threeLetterCode: string,
    redeemableStoreCouponId: number,) => [`/api/v1/${threeLetterCode}/company_admins/redeemable_store_coupons/${redeemableStoreCouponId}/cancellations`] as const;

export type PostApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellations>>>

/**
 * @summary Create redeemable_store_coupon cancellation
 */
export const usePostApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellations = <TError = Errors>(
  threeLetterCode: string,
    redeemableStoreCouponId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellations>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellations>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsMutationKey(threeLetterCode,redeemableStoreCouponId);
  const swrFn = getPostApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsRedeemableStoreCouponIdCancellationsMutationFetcher(threeLetterCode,redeemableStoreCouponId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsResponse200 = {
  data: GetApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCoupons200
  status: 200
}

export type getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsResponseSuccess = (getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsResponseError = (getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsResponse = (getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsResponseSuccess | getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsResponseError)

export const getGetApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/company_admins/redeemable_store_coupons?${stringifiedParams}` : `/api/v1/${threeLetterCode}/company_admins/redeemable_store_coupons`
}

/**
 * 掲載企業管理者が所属する掲載企業に紐づく利用済み地域ギフト（店舗利用型クーポン）の一覧を取得する
 * @summary Get redeemable_store_coupons
 */
export const getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCoupons = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsResponse>(getGetApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsParams,) => [`/api/v1/${threeLetterCode}/company_admins/redeemable_store_coupons`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCoupons>>>

/**
 * @summary Get redeemable_store_coupons
 */
export const useGetApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCoupons = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCoupons>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCouponsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeCompanyAdminsRedeemableStoreCoupons(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1CompanyAdminsSignInResponse200 = {
  data: PostApiV1CompanyAdminsSignIn200
  status: 200
}

export type postApiV1CompanyAdminsSignInResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1CompanyAdminsSignInResponseSuccess = (postApiV1CompanyAdminsSignInResponse200) & {
  headers: Headers;
};
export type postApiV1CompanyAdminsSignInResponseError = (postApiV1CompanyAdminsSignInResponse401) & {
  headers: Headers;
};

export type postApiV1CompanyAdminsSignInResponse = (postApiV1CompanyAdminsSignInResponseSuccess | postApiV1CompanyAdminsSignInResponseError)

export const getPostApiV1CompanyAdminsSignInUrl = () => {




  return `/api/v1/company_admins/sign_in`
}

/**
 * 掲載企業管理者のメールアドレスとパスワードで認証し、JWTトークンを取得する
 * @summary Get JWT
 */
export const postApiV1CompanyAdminsSignIn = async (postApiV1CompanyAdminsSignInBody?: PostApiV1CompanyAdminsSignInBody, options?: RequestInit): Promise<postApiV1CompanyAdminsSignInResponse> => {

  return customInstance<postApiV1CompanyAdminsSignInResponse>(getPostApiV1CompanyAdminsSignInUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1CompanyAdminsSignInBody)
  }
);}




export const getPostApiV1CompanyAdminsSignInMutationFetcher = ( options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1CompanyAdminsSignInBody | undefined }) => {
    return postApiV1CompanyAdminsSignIn(arg, options);
  }
}
export const getPostApiV1CompanyAdminsSignInMutationKey = () => [`/api/v1/company_admins/sign_in`] as const;

export type PostApiV1CompanyAdminsSignInMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1CompanyAdminsSignIn>>>

/**
 * @summary Get JWT
 */
export const usePostApiV1CompanyAdminsSignIn = <TError = Errors>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1CompanyAdminsSignIn>>, TError, Key, PostApiV1CompanyAdminsSignInBody | undefined, Awaited<ReturnType<typeof postApiV1CompanyAdminsSignIn>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1CompanyAdminsSignInMutationKey();
  const swrFn = getPostApiV1CompanyAdminsSignInMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1CompanyAdminsSignOutResponse401 = {
  data: void
  status: 401
}

;
export type deleteApiV1CompanyAdminsSignOutResponseError = (deleteApiV1CompanyAdminsSignOutResponse401) & {
  headers: Headers;
};

export type deleteApiV1CompanyAdminsSignOutResponse = (deleteApiV1CompanyAdminsSignOutResponseError)

export const getDeleteApiV1CompanyAdminsSignOutUrl = () => {




  return `/api/v1/company_admins/sign_out`
}

/**
 * 掲載企業管理者のセッションを終了し、JWTトークンを無効化する
 * @summary Sign out
 */
export const deleteApiV1CompanyAdminsSignOut = async ( options?: RequestInit): Promise<deleteApiV1CompanyAdminsSignOutResponse> => {

  return customInstance<deleteApiV1CompanyAdminsSignOutResponse>(getDeleteApiV1CompanyAdminsSignOutUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1CompanyAdminsSignOutMutationFetcher = ( options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1CompanyAdminsSignOut(options);
  }
}
export const getDeleteApiV1CompanyAdminsSignOutMutationKey = () => [`/api/v1/company_admins/sign_out`] as const;

export type DeleteApiV1CompanyAdminsSignOutMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1CompanyAdminsSignOut>>>

/**
 * @summary Sign out
 */
export const useDeleteApiV1CompanyAdminsSignOut = <TError = void>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1CompanyAdminsSignOut>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1CompanyAdminsSignOut>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1CompanyAdminsSignOutMutationKey();
  const swrFn = getDeleteApiV1CompanyAdminsSignOutMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersResponse201 = {
  data: PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsers201
  status: 201
}

export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersResponseSuccess = (postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersResponseError = (postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersResponse = (postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersResponseSuccess | postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersResponseError)

export const getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersUrl = (threeLetterCode: string,
    externalClientId: string,) => {




  return `/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/admin_users`
}

/**
 * 企業管理者ユーザーを新規作成する
 * @summary Create client admin user
 */
export const postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsers = async (threeLetterCode: string,
    externalClientId: string,
    postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersBody?: PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersResponse> => {

  return customInstance<postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersResponse>(getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersUrl(threeLetterCode,externalClientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersBody)
  }
);}




export const getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersMutationFetcher = (threeLetterCode: string,
    externalClientId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersBody | undefined }) => {
    return postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsers(threeLetterCode, externalClientId, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersMutationKey = (threeLetterCode: string,
    externalClientId: string,) => [`/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/admin_users`] as const;

export type PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsers>>>

/**
 * @summary Create client admin user
 */
export const usePostApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsers = <TError = Errors>(
  threeLetterCode: string,
    externalClientId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsers>>, TError, Key, PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsers>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersMutationKey(threeLetterCode,externalClientId);
  const swrFn = getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersMutationFetcher(threeLetterCode,externalClientId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse200 = {
  data: GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId200
  status: 200
}

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponseSuccess = (getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponseError = (getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse401 | getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse = (getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponseSuccess | getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponseError)

export const getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdUrl = (threeLetterCode: string,
    externalClientId: string,
    externalClientAdminUserId: string,) => {




  return `/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/admin_users/${externalClientAdminUserId}`
}

/**
 * 指定した企業管理者ユーザーの詳細を取得する
 * @summary Get client_admin_user
 */
export const getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId = async (threeLetterCode: string,
    externalClientId: string,
    externalClientAdminUserId: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse>(getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdUrl(threeLetterCode,externalClientId,externalClientAdminUserId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdKey = (threeLetterCode: string,
    externalClientId: string,
    externalClientAdminUserId: string,) => [`/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/admin_users/${externalClientAdminUserId}`] as const;

export type GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId>>>

/**
 * @summary Get client_admin_user
 */
export const useGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId = <TError = Errors>(
  threeLetterCode: string,
    externalClientId: string,
    externalClientAdminUserId: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && externalClientId !== null && externalClientId !== undefined && externalClientAdminUserId !== null && externalClientAdminUserId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdKey(threeLetterCode,externalClientId,externalClientAdminUserId) : null);
  const swrFn = () => getApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId(threeLetterCode,externalClientId,externalClientAdminUserId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse200 = {
  data: PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId200
  status: 200
}

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse404 = {
  data: Errors
  status: 404
}

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponseSuccess = (putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponseError = (putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse401 | putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse404 | putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse = (putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponseSuccess | putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponseError)

export const getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdUrl = (threeLetterCode: string,
    externalClientId: string,
    externalClientAdminUserId: string,) => {




  return `/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/admin_users/${externalClientAdminUserId}`
}

/**
 * 指定した企業管理者ユーザーの情報を更新する
 * @summary Update client_admin_user
 */
export const putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId = async (threeLetterCode: string,
    externalClientId: string,
    externalClientAdminUserId: string,
    putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdBody?: PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse>(getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdUrl(threeLetterCode,externalClientId,externalClientAdminUserId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdMutationFetcher = (threeLetterCode: string,
    externalClientId: string,
    externalClientAdminUserId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId(threeLetterCode, externalClientId, externalClientAdminUserId, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdMutationKey = (threeLetterCode: string,
    externalClientId: string,
    externalClientAdminUserId: string,) => [`/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/admin_users/${externalClientAdminUserId}`] as const;

export type PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId>>>

/**
 * @summary Update client_admin_user
 */
export const usePutApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId = <TError = Errors>(
  threeLetterCode: string,
    externalClientId: string,
    externalClientAdminUserId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId>>, TError, Key, PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdMutationKey(threeLetterCode,externalClientId,externalClientAdminUserId);
  const swrFn = getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdMutationFetcher(threeLetterCode,externalClientId,externalClientAdminUserId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse404 = {
  data: Errors
  status: 404
}

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponseSuccess = (deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponseError = (deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse401 | deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse404) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse = (deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponseSuccess | deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponseError)

export const getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdUrl = (threeLetterCode: string,
    externalClientId: string,
    externalClientAdminUserId: string,) => {




  return `/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/admin_users/${externalClientAdminUserId}`
}

/**
 * 指定した企業管理者ユーザーを無効化する
 * @summary Disable client_admin_user
 */
export const deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId = async (threeLetterCode: string,
    externalClientId: string,
    externalClientAdminUserId: string, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdResponse>(getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdUrl(threeLetterCode,externalClientId,externalClientAdminUserId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdMutationFetcher = (threeLetterCode: string,
    externalClientId: string,
    externalClientAdminUserId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId(threeLetterCode, externalClientId, externalClientAdminUserId, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdMutationKey = (threeLetterCode: string,
    externalClientId: string,
    externalClientAdminUserId: string,) => [`/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/admin_users/${externalClientAdminUserId}`] as const;

export type DeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId>>>

/**
 * @summary Disable client_admin_user
 */
export const useDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId = <TError = Errors>(
  threeLetterCode: string,
    externalClientId: string,
    externalClientAdminUserId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdMutationKey(threeLetterCode,externalClientId,externalClientAdminUserId);
  const swrFn = getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdAdminUsersExternalClientAdminUserIdMutationFetcher(threeLetterCode,externalClientId,externalClientAdminUserId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateResponse200 = {
  data: PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivate200
  status: 200
}

export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateResponseSuccess = (postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateResponse200) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateResponseError = (postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateResponse401 | postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateResponse404) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateResponse = (postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateResponseSuccess | postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateResponseError)

export const getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateUrl = (threeLetterCode: string,
    externalClientId: string,) => {




  return `/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/reactivate`
}

/**
 * 無効化された導入企業を再有効化する
 * @summary Reactivate client
 */
export const postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivate = async (threeLetterCode: string,
    externalClientId: string, options?: RequestInit): Promise<postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateResponse> => {

  return customInstance<postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateResponse>(getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateUrl(threeLetterCode,externalClientId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateMutationFetcher = (threeLetterCode: string,
    externalClientId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivate(threeLetterCode, externalClientId, options);
  }
}
export const getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateMutationKey = (threeLetterCode: string,
    externalClientId: string,) => [`/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/reactivate`] as const;

export type PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivate>>>

/**
 * @summary Reactivate client
 */
export const usePostApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivate = <TError = Errors>(
  threeLetterCode: string,
    externalClientId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivate>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivate>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateMutationKey(threeLetterCode,externalClientId);
  const swrFn = getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdReactivateMutationFetcher(threeLetterCode,externalClientId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponse204 = {
  data: void
  status: 204
}

export type postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponse422 = {
  data: PostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreations422
  status: 422
}

export type postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponseSuccess = (postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponse204) & {
  headers: Headers;
};
export type postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponseError = (postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponse401 | postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponse404 | postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponse422) & {
  headers: Headers;
};

export type postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponse = (postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponseSuccess | postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponseError)

export const getPostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsUrl = (externalClientId: string,) => {




  return `/api/v1/SFR/externals/clients/${externalClientId}/users/bulk_creations`
}

/**
 * テナント SFR 専用: ユーザーを一括作成する（最大100件）。課金開始日（billable_from）を指定可能（省略時は作成日が設定される）
 * @summary Bulk create users
 */
export const postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreations = async (externalClientId: string,
    postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsBody?: PostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsBody, options?: RequestInit): Promise<postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponse> => {

  return customInstance<postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsResponse>(getPostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsUrl(externalClientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsBody)
  }
);}




export const getPostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsMutationFetcher = (externalClientId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsBody | undefined }) => {
    return postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreations(externalClientId, arg, options);
  }
}
export const getPostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsMutationKey = (externalClientId: string,) => [`/api/v1/SFR/externals/clients/${externalClientId}/users/bulk_creations`] as const;

export type PostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreations>>>

/**
 * @summary Bulk create users
 */
export const usePostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreations = <TError = Errors | PostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreations422>(
  externalClientId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreations>>, TError, Key, PostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsBody | undefined, Awaited<ReturnType<typeof postApiV1SFRExternalsClientsExternalClientIdUsersBulkCreations>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsMutationKey(externalClientId);
  const swrFn = getPostApiV1SFRExternalsClientsExternalClientIdUsersBulkCreationsMutationFetcher(externalClientId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse200 = {
  data: GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers200
  status: 200
}

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponseSuccess = (getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponseError = (getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse400 | getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse = (getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponseSuccess | getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponseError)

export const getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersUrl = (threeLetterCode: string,
    externalClientId: string,
    params?: GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["external_user_ids[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/users?${stringifiedParams}` : `/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/users`
}

/**
 * 指定した導入企業に所属するユーザー一覧を取得する
 * @summary Get users
 */
export const getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers = async (threeLetterCode: string,
    externalClientId: string,
    params?: GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse> => {

  return customInstance<getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse>(getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersUrl(threeLetterCode,externalClientId,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersKey = (threeLetterCode: string,
    externalClientId: string,
    params?: GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersParams,) => [`/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/users`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers>>>

/**
 * @summary Get users
 */
export const useGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers = <TError = Errors>(
  threeLetterCode: string,
    externalClientId: string,
    params?: GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && externalClientId !== null && externalClientId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersKey(threeLetterCode,externalClientId,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers(threeLetterCode,externalClientId,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse201 = {
  data: PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers201
  status: 201
}

export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponseSuccess = (postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponseError = (postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse401 | postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse = (postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponseSuccess | postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponseError)

export const getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersUrl = (threeLetterCode: string,
    externalClientId: string,) => {




  return `/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/users`
}

/**
 * 指定した導入企業にユーザーを新規作成する。課金開始日（billable_from）を指定可能（省略時は作成日が設定される）
 * @summary Create user
 */
export const postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers = async (threeLetterCode: string,
    externalClientId: string,
    postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersBody?: PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse> => {

  return customInstance<postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersResponse>(getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersUrl(threeLetterCode,externalClientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersBody)
  }
);}




export const getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersMutationFetcher = (threeLetterCode: string,
    externalClientId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersBody | undefined }) => {
    return postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers(threeLetterCode, externalClientId, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersMutationKey = (threeLetterCode: string,
    externalClientId: string,) => [`/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/users`] as const;

export type PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers>>>

/**
 * @summary Create user
 */
export const usePostApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers = <TError = Errors>(
  threeLetterCode: string,
    externalClientId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers>>, TError, Key, PostApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsers>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersMutationKey(threeLetterCode,externalClientId);
  const swrFn = getPostApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersMutationFetcher(threeLetterCode,externalClientId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse200 = {
  data: GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId200
  status: 200
}

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponseSuccess = (getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponseError = (getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse401 | getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse = (getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponseSuccess | getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponseError)

export const getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdUrl = (threeLetterCode: string,
    externalClientId: string,
    externalUserId: string,) => {




  return `/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/users/${externalUserId}`
}

/**
 * 指定したユーザーの詳細情報を取得する
 * @summary Get user
 */
export const getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId = async (threeLetterCode: string,
    externalClientId: string,
    externalUserId: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse>(getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdUrl(threeLetterCode,externalClientId,externalUserId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdKey = (threeLetterCode: string,
    externalClientId: string,
    externalUserId: string,) => [`/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/users/${externalUserId}`] as const;

export type GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId>>>

/**
 * @summary Get user
 */
export const useGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId = <TError = Errors>(
  threeLetterCode: string,
    externalClientId: string,
    externalUserId: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && externalClientId !== null && externalClientId !== undefined && externalUserId !== null && externalUserId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdKey(threeLetterCode,externalClientId,externalUserId) : null);
  const swrFn = () => getApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId(threeLetterCode,externalClientId,externalUserId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse200 = {
  data: PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId200
  status: 200
}

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse404 = {
  data: Errors
  status: 404
}

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponseSuccess = (putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponseError = (putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse401 | putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse404 | putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse = (putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponseSuccess | putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponseError)

export const getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdUrl = (threeLetterCode: string,
    externalClientId: string,
    externalUserId: string,) => {




  return `/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/users/${externalUserId}`
}

/**
 * 指定したユーザーの情報を更新する
 * @summary Update user
 */
export const putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId = async (threeLetterCode: string,
    externalClientId: string,
    externalUserId: string,
    putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdBody?: PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse>(getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdUrl(threeLetterCode,externalClientId,externalUserId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdMutationFetcher = (threeLetterCode: string,
    externalClientId: string,
    externalUserId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId(threeLetterCode, externalClientId, externalUserId, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdMutationKey = (threeLetterCode: string,
    externalClientId: string,
    externalUserId: string,) => [`/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/users/${externalUserId}`] as const;

export type PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId>>>

/**
 * @summary Update user
 */
export const usePutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId = <TError = Errors>(
  threeLetterCode: string,
    externalClientId: string,
    externalUserId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId>>, TError, Key, PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdMutationKey(threeLetterCode,externalClientId,externalUserId);
  const swrFn = getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdMutationFetcher(threeLetterCode,externalClientId,externalUserId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse404 = {
  data: Errors
  status: 404
}

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponseSuccess = (deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponseError = (deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse401 | deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse404) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse = (deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponseSuccess | deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponseError)

export const getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdUrl = (threeLetterCode: string,
    externalClientId: string,
    externalUserId: string,) => {




  return `/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/users/${externalUserId}`
}

/**
 * 指定したユーザーを無効化する
 * @summary Disable user
 */
export const deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId = async (threeLetterCode: string,
    externalClientId: string,
    externalUserId: string, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdResponse>(getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdUrl(threeLetterCode,externalClientId,externalUserId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdMutationFetcher = (threeLetterCode: string,
    externalClientId: string,
    externalUserId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId(threeLetterCode, externalClientId, externalUserId, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdMutationKey = (threeLetterCode: string,
    externalClientId: string,
    externalUserId: string,) => [`/api/v1/${threeLetterCode}/externals/clients/${externalClientId}/users/${externalUserId}`] as const;

export type DeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId>>>

/**
 * @summary Disable user
 */
export const useDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId = <TError = Errors>(
  threeLetterCode: string,
    externalClientId: string,
    externalUserId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdMutationKey(threeLetterCode,externalClientId,externalUserId);
  const swrFn = getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUsersExternalUserIdMutationFetcher(threeLetterCode,externalClientId,externalUserId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeExternalsClientsResponse200ApplicationJson = {
  data: GetApiV1ThreeLetterCodeExternalsClients200One
  status: 200
}

export type getApiV1ThreeLetterCodeExternalsClientsResponse200TextCsv = {
  data: Blob
  status: 200
}

export type getApiV1ThreeLetterCodeExternalsClientsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeExternalsClientsResponseSuccess = (getApiV1ThreeLetterCodeExternalsClientsResponse200ApplicationJson | getApiV1ThreeLetterCodeExternalsClientsResponse200TextCsv) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeExternalsClientsResponseError = (getApiV1ThreeLetterCodeExternalsClientsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeExternalsClientsResponse = (getApiV1ThreeLetterCodeExternalsClientsResponseSuccess | getApiV1ThreeLetterCodeExternalsClientsResponseError)

export const getGetApiV1ThreeLetterCodeExternalsClientsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeExternalsClientsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/externals/clients?${stringifiedParams}` : `/api/v1/${threeLetterCode}/externals/clients`
}

/**
 * 導入企業一覧を取得する（JSON / CSV 形式対応）
 * @summary Get clients
 */
export const getApiV1ThreeLetterCodeExternalsClients = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeExternalsClientsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeExternalsClientsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeExternalsClientsResponse>(getGetApiV1ThreeLetterCodeExternalsClientsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeExternalsClientsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeExternalsClientsParams,) => [`/api/v1/${threeLetterCode}/externals/clients`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeExternalsClientsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeExternalsClients>>>

/**
 * @summary Get clients
 */
export const useGetApiV1ThreeLetterCodeExternalsClients = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeExternalsClientsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeExternalsClients>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeExternalsClientsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeExternalsClients(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeExternalsClientsResponse201 = {
  data: PostApiV1ThreeLetterCodeExternalsClients201
  status: 201
}

export type postApiV1ThreeLetterCodeExternalsClientsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeExternalsClientsResponseSuccess = (postApiV1ThreeLetterCodeExternalsClientsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeExternalsClientsResponseError = (postApiV1ThreeLetterCodeExternalsClientsResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeExternalsClientsResponse = (postApiV1ThreeLetterCodeExternalsClientsResponseSuccess | postApiV1ThreeLetterCodeExternalsClientsResponseError)

export const getPostApiV1ThreeLetterCodeExternalsClientsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/externals/clients`
}

/**
 * 導入企業を新規作成する
 * @summary Create client
 */
export const postApiV1ThreeLetterCodeExternalsClients = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeExternalsClientsBody?: PostApiV1ThreeLetterCodeExternalsClientsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeExternalsClientsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeExternalsClientsResponse>(getPostApiV1ThreeLetterCodeExternalsClientsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeExternalsClientsBody)
  }
);}




export const getPostApiV1ThreeLetterCodeExternalsClientsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeExternalsClientsBody | undefined }) => {
    return postApiV1ThreeLetterCodeExternalsClients(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeExternalsClientsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/externals/clients`] as const;

export type PostApiV1ThreeLetterCodeExternalsClientsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsClients>>>

/**
 * @summary Create client
 */
export const usePostApiV1ThreeLetterCodeExternalsClients = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsClients>>, TError, Key, PostApiV1ThreeLetterCodeExternalsClientsBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsClients>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeExternalsClientsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeExternalsClientsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse200 = {
  data: GetApiV1ThreeLetterCodeExternalsClientsExternalClientId200
  status: 200
}

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponseSuccess = (getApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse200) & {
  headers: Headers;
};
;

export type getApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse = (getApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponseSuccess)

export const getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUrl = (threeLetterCode: string,
    externalClientId: string,) => {




  return `/api/v1/${threeLetterCode}/externals/clients/${externalClientId}`
}

/**
 * 指定した導入企業の詳細情報を取得する
 * @summary Show client
 */
export const getApiV1ThreeLetterCodeExternalsClientsExternalClientId = async (threeLetterCode: string,
    externalClientId: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse>(getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdUrl(threeLetterCode,externalClientId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdKey = (threeLetterCode: string,
    externalClientId: string,) => [`/api/v1/${threeLetterCode}/externals/clients/${externalClientId}`] as const;

export type GetApiV1ThreeLetterCodeExternalsClientsExternalClientIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeExternalsClientsExternalClientId>>>

/**
 * @summary Show client
 */
export const useGetApiV1ThreeLetterCodeExternalsClientsExternalClientId = <TError = unknown>(
  threeLetterCode: string,
    externalClientId: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeExternalsClientsExternalClientId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && externalClientId !== null && externalClientId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeExternalsClientsExternalClientIdKey(threeLetterCode,externalClientId) : null);
  const swrFn = () => getApiV1ThreeLetterCodeExternalsClientsExternalClientId(threeLetterCode,externalClientId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse200 = {
  data: PutApiV1ThreeLetterCodeExternalsClientsExternalClientId200
  status: 200
}

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse404 = {
  data: Errors
  status: 404
}

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponseSuccess = (putApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponseError = (putApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse404) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse = (putApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponseSuccess | putApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponseError)

export const getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUrl = (threeLetterCode: string,
    externalClientId: string,) => {




  return `/api/v1/${threeLetterCode}/externals/clients/${externalClientId}`
}

/**
 * 指定した導入企業の情報を更新する
 * @summary Update client
 */
export const putApiV1ThreeLetterCodeExternalsClientsExternalClientId = async (threeLetterCode: string,
    externalClientId: string,
    putApiV1ThreeLetterCodeExternalsClientsExternalClientIdBody?: PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse>(getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdUrl(threeLetterCode,externalClientId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeExternalsClientsExternalClientIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdMutationFetcher = (threeLetterCode: string,
    externalClientId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeExternalsClientsExternalClientId(threeLetterCode, externalClientId, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdMutationKey = (threeLetterCode: string,
    externalClientId: string,) => [`/api/v1/${threeLetterCode}/externals/clients/${externalClientId}`] as const;

export type PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeExternalsClientsExternalClientId>>>

/**
 * @summary Update client
 */
export const usePutApiV1ThreeLetterCodeExternalsClientsExternalClientId = <TError = Errors>(
  threeLetterCode: string,
    externalClientId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeExternalsClientsExternalClientId>>, TError, Key, PutApiV1ThreeLetterCodeExternalsClientsExternalClientIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeExternalsClientsExternalClientId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdMutationKey(threeLetterCode,externalClientId);
  const swrFn = getPutApiV1ThreeLetterCodeExternalsClientsExternalClientIdMutationFetcher(threeLetterCode,externalClientId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse404 = {
  data: Errors
  status: 404
}

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponseSuccess = (deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponseError = (deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse401 | deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse404) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse = (deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponseSuccess | deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponseError)

export const getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUrl = (threeLetterCode: string,
    externalClientId: string,) => {




  return `/api/v1/${threeLetterCode}/externals/clients/${externalClientId}`
}

/**
 * 指定した導入企業を無効化（論理削除）する
 * @summary Delete client
 */
export const deleteApiV1ThreeLetterCodeExternalsClientsExternalClientId = async (threeLetterCode: string,
    externalClientId: string, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdResponse>(getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdUrl(threeLetterCode,externalClientId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdMutationFetcher = (threeLetterCode: string,
    externalClientId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeExternalsClientsExternalClientId(threeLetterCode, externalClientId, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdMutationKey = (threeLetterCode: string,
    externalClientId: string,) => [`/api/v1/${threeLetterCode}/externals/clients/${externalClientId}`] as const;

export type DeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeExternalsClientsExternalClientId>>>

/**
 * @summary Delete client
 */
export const useDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientId = <TError = Errors>(
  threeLetterCode: string,
    externalClientId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeExternalsClientsExternalClientId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeExternalsClientsExternalClientId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdMutationKey(threeLetterCode,externalClientId);
  const swrFn = getDeleteApiV1ThreeLetterCodeExternalsClientsExternalClientIdMutationFetcher(threeLetterCode,externalClientId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeExternalsGiftPlansResponse200 = {
  data: GetApiV1ThreeLetterCodeExternalsGiftPlans200
  status: 200
}

export type getApiV1ThreeLetterCodeExternalsGiftPlansResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeExternalsGiftPlansResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeExternalsGiftPlansResponseSuccess = (getApiV1ThreeLetterCodeExternalsGiftPlansResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeExternalsGiftPlansResponseError = (getApiV1ThreeLetterCodeExternalsGiftPlansResponse400 | getApiV1ThreeLetterCodeExternalsGiftPlansResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeExternalsGiftPlansResponse = (getApiV1ThreeLetterCodeExternalsGiftPlansResponseSuccess | getApiV1ThreeLetterCodeExternalsGiftPlansResponseError)

export const getGetApiV1ThreeLetterCodeExternalsGiftPlansUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeExternalsGiftPlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/externals/gift_plans?${stringifiedParams}` : `/api/v1/${threeLetterCode}/externals/gift_plans`
}

/**
 * ギフトプラン一覧を取得する
 * @summary Get gift_plans
 */
export const getApiV1ThreeLetterCodeExternalsGiftPlans = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeExternalsGiftPlansParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeExternalsGiftPlansResponse> => {

  return customInstance<getApiV1ThreeLetterCodeExternalsGiftPlansResponse>(getGetApiV1ThreeLetterCodeExternalsGiftPlansUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeExternalsGiftPlansKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeExternalsGiftPlansParams,) => [`/api/v1/${threeLetterCode}/externals/gift_plans`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeExternalsGiftPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeExternalsGiftPlans>>>

/**
 * @summary Get gift_plans
 */
export const useGetApiV1ThreeLetterCodeExternalsGiftPlans = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeExternalsGiftPlansParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeExternalsGiftPlans>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeExternalsGiftPlansKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeExternalsGiftPlans(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeExternalsGifteePlansResponse200 = {
  data: GetApiV1ThreeLetterCodeExternalsGifteePlans200
  status: 200
}

export type getApiV1ThreeLetterCodeExternalsGifteePlansResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeExternalsGifteePlansResponseSuccess = (getApiV1ThreeLetterCodeExternalsGifteePlansResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeExternalsGifteePlansResponseError = (getApiV1ThreeLetterCodeExternalsGifteePlansResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeExternalsGifteePlansResponse = (getApiV1ThreeLetterCodeExternalsGifteePlansResponseSuccess | getApiV1ThreeLetterCodeExternalsGifteePlansResponseError)

export const getGetApiV1ThreeLetterCodeExternalsGifteePlansUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/externals/giftee_plans`
}

/**
 * Gifteeプラン一覧を取得する
 * @summary Get giftee_plans
 */
export const getApiV1ThreeLetterCodeExternalsGifteePlans = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeExternalsGifteePlansResponse> => {

  return customInstance<getApiV1ThreeLetterCodeExternalsGifteePlansResponse>(getGetApiV1ThreeLetterCodeExternalsGifteePlansUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeExternalsGifteePlansKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/externals/giftee_plans`] as const;

export type GetApiV1ThreeLetterCodeExternalsGifteePlansQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeExternalsGifteePlans>>>

/**
 * @summary Get giftee_plans
 */
export const useGetApiV1ThreeLetterCodeExternalsGifteePlans = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeExternalsGifteePlans>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeExternalsGifteePlansKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeExternalsGifteePlans(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesResponse200 = {
  data: PostApiV1ThreeLetterCodeExternalsPaydonsStatusUpdates200
  status: 200
}

export type postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesResponseSuccess = (postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesResponse200) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesResponseError = (postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesResponse400 | postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesResponse = (postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesResponseSuccess | postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesResponseError)

export const getPostApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/externals/paydons/status_updates`
}

/**
 * Paydon（報酬コード）のステータスを一括更新する（最大50件）
 * @summary Update paydon statuses
 */
export const postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdates = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesBody?: PostApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesResponse> => {

  return customInstance<postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesResponse>(getPostApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesBody)
  }
);}




export const getPostApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesBody | undefined }) => {
    return postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdates(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/externals/paydons/status_updates`] as const;

export type PostApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdates>>>

/**
 * @summary Update paydon statuses
 */
export const usePostApiV1ThreeLetterCodeExternalsPaydonsStatusUpdates = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdates>>, TError, Key, PostApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeExternalsPaydonsStatusUpdates>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeExternalsPaydonsStatusUpdatesMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeFreeeCallbackResponse200 = {
  data: SimpleMessage
  status: 200
}

export type getApiV1ThreeLetterCodeFreeeCallbackResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeFreeeCallbackResponse422 = {
  data: Errors
  status: 422
}

export type getApiV1ThreeLetterCodeFreeeCallbackResponseSuccess = (getApiV1ThreeLetterCodeFreeeCallbackResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeFreeeCallbackResponseError = (getApiV1ThreeLetterCodeFreeeCallbackResponse400 | getApiV1ThreeLetterCodeFreeeCallbackResponse422) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeFreeeCallbackResponse = (getApiV1ThreeLetterCodeFreeeCallbackResponseSuccess | getApiV1ThreeLetterCodeFreeeCallbackResponseError)

export const getGetApiV1ThreeLetterCodeFreeeCallbackUrl = (threeLetterCode: string,
    params: GetApiV1ThreeLetterCodeFreeeCallbackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/freee/callback?${stringifiedParams}` : `/api/v1/${threeLetterCode}/freee/callback`
}

/**
 * freee 会計/請求書 API の OAuth 認可リダイレクトを受け、認可コードをトークンに交換して保存する。認証不要（初回連携・再認可時に内部運用者が手動で通る導線）。取得したトークンの事業所が想定と異なる場合は保存せず拒否する
 * @summary Receive freee OAuth callback
 */
export const getApiV1ThreeLetterCodeFreeeCallback = async (threeLetterCode: string,
    params: GetApiV1ThreeLetterCodeFreeeCallbackParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeFreeeCallbackResponse> => {

  return customInstance<getApiV1ThreeLetterCodeFreeeCallbackResponse>(getGetApiV1ThreeLetterCodeFreeeCallbackUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeFreeeCallbackKey = (threeLetterCode: string,
    params: GetApiV1ThreeLetterCodeFreeeCallbackParams,) => [`/api/v1/${threeLetterCode}/freee/callback`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeFreeeCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeFreeeCallback>>>

/**
 * @summary Receive freee OAuth callback
 */
export const useGetApiV1ThreeLetterCodeFreeeCallback = <TError = Errors>(
  threeLetterCode: string,
    params: GetApiV1ThreeLetterCodeFreeeCallbackParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeFreeeCallback>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeFreeeCallbackKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeFreeeCallback(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsAgreementsResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsAgreements200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsAgreementsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsAgreementsResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsAgreementsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsAgreementsResponseError = (getApiV1ThreeLetterCodeInternalAdminsAgreementsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsAgreementsResponse = (getApiV1ThreeLetterCodeInternalAdminsAgreementsResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsAgreementsResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsAgreementsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/agreements`
}

/**
 * 同意項目（利用規約等）の一覧を取得する
 * @summary Get agreements
 */
export const getApiV1ThreeLetterCodeInternalAdminsAgreements = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsAgreementsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsAgreementsResponse>(getGetApiV1ThreeLetterCodeInternalAdminsAgreementsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsAgreementsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/agreements`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsAgreementsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsAgreements>>>

/**
 * @summary Get agreements
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsAgreements = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsAgreements>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsAgreementsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsAgreements(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsAgreementsResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsAgreements201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsAgreementsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsAgreementsResponse422 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsAgreements422
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsAgreementsResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsAgreementsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsAgreementsResponseError = (postApiV1ThreeLetterCodeInternalAdminsAgreementsResponse401 | postApiV1ThreeLetterCodeInternalAdminsAgreementsResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsAgreementsResponse = (postApiV1ThreeLetterCodeInternalAdminsAgreementsResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsAgreementsResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsAgreementsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/agreements`
}

/**
 * 同意項目を新規作成する
 * @summary Create agreement
 */
export const postApiV1ThreeLetterCodeInternalAdminsAgreements = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeInternalAdminsAgreementsBody?: PostApiV1ThreeLetterCodeInternalAdminsAgreementsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsAgreementsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsAgreementsResponse>(getPostApiV1ThreeLetterCodeInternalAdminsAgreementsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsAgreementsBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsAgreementsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsAgreementsBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsAgreements(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsAgreementsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/agreements`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsAgreementsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsAgreements>>>

/**
 * @summary Create agreement
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsAgreements = <TError = Errors | PostApiV1ThreeLetterCodeInternalAdminsAgreements422>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsAgreements>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsAgreementsBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsAgreements>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsAgreementsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsAgreementsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsAgreementsId200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponseError = (getApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse = (getApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsAgreementsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/agreements/${id}`
}

/**
 * 同意項目の詳細を取得する
 * @summary Get agreement
 */
export const getApiV1ThreeLetterCodeInternalAdminsAgreementsId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse>(getGetApiV1ThreeLetterCodeInternalAdminsAgreementsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsAgreementsIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/agreements/${id}`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsAgreementsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsAgreementsId>>>

/**
 * @summary Get agreement
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsAgreementsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsAgreementsId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsAgreementsIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsAgreementsId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse200 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsAgreementsId200
  status: 200
}

export type putApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse422 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsAgreementsId422
  status: 422
}

export type putApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponseSuccess = (putApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponseError = (putApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse401 | putApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse = (putApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponseSuccess | putApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponseError)

export const getPutApiV1ThreeLetterCodeInternalAdminsAgreementsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/agreements/${id}`
}

/**
 * 同意項目を更新する
 * @summary Update agreement
 */
export const putApiV1ThreeLetterCodeInternalAdminsAgreementsId = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodeInternalAdminsAgreementsIdBody?: PutApiV1ThreeLetterCodeInternalAdminsAgreementsIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse>(getPutApiV1ThreeLetterCodeInternalAdminsAgreementsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeInternalAdminsAgreementsIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeInternalAdminsAgreementsIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeInternalAdminsAgreementsIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeInternalAdminsAgreementsId(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeInternalAdminsAgreementsIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/agreements/${id}`] as const;

export type PutApiV1ThreeLetterCodeInternalAdminsAgreementsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsAgreementsId>>>

/**
 * @summary Update agreement
 */
export const usePutApiV1ThreeLetterCodeInternalAdminsAgreementsId = <TError = Errors | PutApiV1ThreeLetterCodeInternalAdminsAgreementsId422>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsAgreementsId>>, TError, Key, PutApiV1ThreeLetterCodeInternalAdminsAgreementsIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsAgreementsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeInternalAdminsAgreementsIdMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodeInternalAdminsAgreementsIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponseSuccess = (deleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponseError = (deleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse = (deleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponseSuccess | deleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponseError)

export const getDeleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/agreements/${id}`
}

/**
 * 同意項目を削除する
 * @summary Delete agreement
 */
export const deleteApiV1ThreeLetterCodeInternalAdminsAgreementsId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdResponse>(getDeleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeInternalAdminsAgreementsId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/agreements/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsAgreementsId>>>

/**
 * @summary Delete agreement
 */
export const useDeleteApiV1ThreeLetterCodeInternalAdminsAgreementsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsAgreementsId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsAgreementsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeInternalAdminsAgreementsIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsAttachments201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponse403 = {
  data: Errors
  status: 403
}

export type postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponseError = (postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponse401 | postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponse403 | postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponse = (postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsAttachmentsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/attachments`
}

/**
 * 画像ファイルをリソースに添付する
 * @summary Create attachment
 */
export const postApiV1ThreeLetterCodeInternalAdminsAttachments = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeInternalAdminsAttachmentsBody?: PostApiV1ThreeLetterCodeInternalAdminsAttachmentsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsAttachmentsResponse>(getPostApiV1ThreeLetterCodeInternalAdminsAttachmentsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsAttachmentsBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsAttachmentsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsAttachmentsBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsAttachments(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsAttachmentsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/attachments`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsAttachmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsAttachments>>>

/**
 * @summary Create attachment
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsAttachments = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsAttachments>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsAttachmentsBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsAttachments>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsAttachmentsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsAttachmentsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdResponseSuccess = (deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdResponseError = (deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdResponse = (deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdResponseSuccess | deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdResponseError)

export const getDeleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/attachments/${id}`
}

/**
 * 添付ファイルを削除する
 * @summary Delete attachment
 */
export const deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdResponse>(getDeleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/attachments/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsId>>>

/**
 * @summary Delete attachment
 */
export const useDeleteApiV1ThreeLetterCodeInternalAdminsAttachmentsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsAttachmentsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeInternalAdminsAttachmentsIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsCategoriesResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsCategories200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsCategoriesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsCategoriesResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsCategoriesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsCategoriesResponseError = (getApiV1ThreeLetterCodeInternalAdminsCategoriesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsCategoriesResponse = (getApiV1ThreeLetterCodeInternalAdminsCategoriesResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsCategoriesResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsCategoriesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/categories`
}

/**
 * サービスカテゴリの一覧を取得する
 * @summary Get categories
 */
export const getApiV1ThreeLetterCodeInternalAdminsCategories = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsCategoriesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsCategoriesResponse>(getGetApiV1ThreeLetterCodeInternalAdminsCategoriesUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsCategoriesKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/categories`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsCategories>>>

/**
 * @summary Get categories
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsCategories = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsCategories>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsCategoriesKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsCategories(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsCategoriesResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsCategories201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsCategoriesResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsCategoriesResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsCategoriesResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsCategoriesResponseError = (postApiV1ThreeLetterCodeInternalAdminsCategoriesResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsCategoriesResponse = (postApiV1ThreeLetterCodeInternalAdminsCategoriesResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsCategoriesResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsCategoriesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/categories`
}

/**
 * サービスカテゴリを新規作成する
 * @summary Create category
 */
export const postApiV1ThreeLetterCodeInternalAdminsCategories = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeInternalAdminsCategoriesBody?: PostApiV1ThreeLetterCodeInternalAdminsCategoriesBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsCategoriesResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsCategoriesResponse>(getPostApiV1ThreeLetterCodeInternalAdminsCategoriesUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsCategoriesBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsCategoriesMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsCategoriesBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsCategories(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsCategoriesMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/categories`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsCategories>>>

/**
 * @summary Create category
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsCategories = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsCategories>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsCategoriesBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsCategories>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsCategoriesMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsCategoriesMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse200 = {
  data: PatchApiV1ThreeLetterCodeInternalAdminsCategoriesId200
  status: 200
}

export type patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse401 = {
  data: Errors
  status: 401
}

export type patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse422 = {
  data: PatchApiV1ThreeLetterCodeInternalAdminsCategoriesId422
  status: 422
}

export type patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponseSuccess = (patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse200) & {
  headers: Headers;
};
export type patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponseError = (patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse401 | patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse422) & {
  headers: Headers;
};

export type patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse = (patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponseSuccess | patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponseError)

export const getPatchApiV1ThreeLetterCodeInternalAdminsCategoriesIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/categories/${id}`
}

/**
 * サービスカテゴリを更新する
 * @summary Update category
 */
export const patchApiV1ThreeLetterCodeInternalAdminsCategoriesId = async (threeLetterCode: string,
    id: number,
    patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdBody?: PatchApiV1ThreeLetterCodeInternalAdminsCategoriesIdBody, options?: RequestInit): Promise<patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse> => {

  return customInstance<patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse>(getPatchApiV1ThreeLetterCodeInternalAdminsCategoriesIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchApiV1ThreeLetterCodeInternalAdminsCategoriesIdBody)
  }
);}




export const getPatchApiV1ThreeLetterCodeInternalAdminsCategoriesIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PatchApiV1ThreeLetterCodeInternalAdminsCategoriesIdBody | undefined }) => {
    return patchApiV1ThreeLetterCodeInternalAdminsCategoriesId(threeLetterCode, id, arg, options);
  }
}
export const getPatchApiV1ThreeLetterCodeInternalAdminsCategoriesIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/categories/${id}`] as const;

export type PatchApiV1ThreeLetterCodeInternalAdminsCategoriesIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsCategoriesId>>>

/**
 * @summary Update category
 */
export const usePatchApiV1ThreeLetterCodeInternalAdminsCategoriesId = <TError = Errors | PatchApiV1ThreeLetterCodeInternalAdminsCategoriesId422>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsCategoriesId>>, TError, Key, PatchApiV1ThreeLetterCodeInternalAdminsCategoriesIdBody | undefined, Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsCategoriesId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchApiV1ThreeLetterCodeInternalAdminsCategoriesIdMutationKey(threeLetterCode,id);
  const swrFn = getPatchApiV1ThreeLetterCodeInternalAdminsCategoriesIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse422 = {
  data: DeleteApiV1ThreeLetterCodeInternalAdminsCategoriesId422
  status: 422
}

export type deleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponseSuccess = (deleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponseError = (deleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse401 | deleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse422) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse = (deleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponseSuccess | deleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponseError)

export const getDeleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/categories/${id}`
}

/**
 * サービスカテゴリを削除する
 * @summary Delete category
 */
export const deleteApiV1ThreeLetterCodeInternalAdminsCategoriesId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdResponse>(getDeleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeInternalAdminsCategoriesId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/categories/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsCategoriesId>>>

/**
 * @summary Delete category
 */
export const useDeleteApiV1ThreeLetterCodeInternalAdminsCategoriesId = <TError = Errors | DeleteApiV1ThreeLetterCodeInternalAdminsCategoriesId422>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsCategoriesId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsCategoriesId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeInternalAdminsCategoriesIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsClientApplicationsResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsClientApplications200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsClientApplicationsResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeInternalAdminsClientApplicationsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsClientApplicationsResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsClientApplicationsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsClientApplicationsResponseError = (getApiV1ThreeLetterCodeInternalAdminsClientApplicationsResponse400 | getApiV1ThreeLetterCodeInternalAdminsClientApplicationsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsClientApplicationsResponse = (getApiV1ThreeLetterCodeInternalAdminsClientApplicationsResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsClientApplicationsResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsClientApplicationsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsClientApplicationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["status[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/internal_admins/client_applications?${stringifiedParams}` : `/api/v1/${threeLetterCode}/internal_admins/client_applications`
}

/**
 * 申し込み一覧を取得する（全テナント横断・UNION ALL）
 * @summary Get client applications
 */
export const getApiV1ThreeLetterCodeInternalAdminsClientApplications = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsClientApplicationsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsClientApplicationsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsClientApplicationsResponse>(getGetApiV1ThreeLetterCodeInternalAdminsClientApplicationsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsClientApplicationsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsClientApplicationsParams,) => [`/api/v1/${threeLetterCode}/internal_admins/client_applications`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsClientApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsClientApplications>>>

/**
 * @summary Get client applications
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsClientApplications = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsClientApplicationsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsClientApplications>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsClientApplicationsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsClientApplications(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse200 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKey200
  status: 200
}

export type putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse400 = {
  data: Errors
  status: 400
}

export type putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseSuccess = (putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseError = (putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse400 | putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse401) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse = (putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseSuccess | putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseError)

export const getPutApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyUrl = (threeLetterCode: string,
    clientId: number,
    featureKey: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/clients/${clientId}/client_feature_flags/${featureKey}`
}

/**
 * 導入企業の機能フラグを有効にする
 * @summary Enable a client feature flag
 */
export const putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKey = async (threeLetterCode: string,
    clientId: number,
    featureKey: string, options?: RequestInit): Promise<putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse> => {

  return customInstance<putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse>(getPutApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyUrl(threeLetterCode,clientId,featureKey),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getPutApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationFetcher = (threeLetterCode: string,
    clientId: number,
    featureKey: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKey(threeLetterCode, clientId, featureKey, options);
  }
}
export const getPutApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationKey = (threeLetterCode: string,
    clientId: number,
    featureKey: string,) => [`/api/v1/${threeLetterCode}/internal_admins/clients/${clientId}/client_feature_flags/${featureKey}`] as const;

export type PutApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKey>>>

/**
 * @summary Enable a client feature flag
 */
export const usePutApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKey = <TError = Errors>(
  threeLetterCode: string,
    clientId: number,
    featureKey: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKey>>, TError, Key, Arguments, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKey>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationKey(threeLetterCode,clientId,featureKey);
  const swrFn = getPutApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationFetcher(threeLetterCode,clientId,featureKey, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseSuccess = (deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseError = (deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse = (deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseSuccess | deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseError)

export const getDeleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyUrl = (threeLetterCode: string,
    clientId: number,
    featureKey: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/clients/${clientId}/client_feature_flags/${featureKey}`
}

/**
 * 導入企業の機能フラグを無効にする
 * @summary Disable a client feature flag
 */
export const deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKey = async (threeLetterCode: string,
    clientId: number,
    featureKey: string, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse>(getDeleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyUrl(threeLetterCode,clientId,featureKey),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationFetcher = (threeLetterCode: string,
    clientId: number,
    featureKey: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKey(threeLetterCode, clientId, featureKey, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationKey = (threeLetterCode: string,
    clientId: number,
    featureKey: string,) => [`/api/v1/${threeLetterCode}/internal_admins/clients/${clientId}/client_feature_flags/${featureKey}`] as const;

export type DeleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKey>>>

/**
 * @summary Disable a client feature flag
 */
export const useDeleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKey = <TError = Errors>(
  threeLetterCode: string,
    clientId: number,
    featureKey: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKey>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKey>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationKey(threeLetterCode,clientId,featureKey);
  const swrFn = getDeleteApiV1ThreeLetterCodeInternalAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationFetcher(threeLetterCode,clientId,featureKey, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponse200 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsClientsClientIdStates200
  status: 200
}

export type putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponse400 = {
  data: Errors
  status: 400
}

export type putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponseSuccess = (putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponseError = (putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponse400 | putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponse401 | putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponse = (putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponseSuccess | putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponseError)

export const getPutApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesUrl = (threeLetterCode: string,
    clientId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/clients/${clientId}/states`
}

/**
 * 導入企業の有効・無効状態を切り替える
 * @summary Update client enable state
 */
export const putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStates = async (threeLetterCode: string,
    clientId: number,
    putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesBody?: PutApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponse> => {

  return customInstance<putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesResponse>(getPutApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesUrl(threeLetterCode,clientId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesBody)
  }
);}




export const getPutApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesMutationFetcher = (threeLetterCode: string,
    clientId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesBody | undefined }) => {
    return putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStates(threeLetterCode, clientId, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesMutationKey = (threeLetterCode: string,
    clientId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/clients/${clientId}/states`] as const;

export type PutApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStates>>>

/**
 * @summary Update client enable state
 */
export const usePutApiV1ThreeLetterCodeInternalAdminsClientsClientIdStates = <TError = Errors>(
  threeLetterCode: string,
    clientId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStates>>, TError, Key, PutApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsClientsClientIdStates>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesMutationKey(threeLetterCode,clientId);
  const swrFn = getPutApiV1ThreeLetterCodeInternalAdminsClientsClientIdStatesMutationFetcher(threeLetterCode,clientId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsClientsResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsClients201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsClientsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsClientsResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsClientsResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsClientsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsClientsResponseError = (postApiV1ThreeLetterCodeInternalAdminsClientsResponse401 | postApiV1ThreeLetterCodeInternalAdminsClientsResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsClientsResponse = (postApiV1ThreeLetterCodeInternalAdminsClientsResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsClientsResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsClientsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/clients`
}

/**
 * 導入企業を新規作成する
 * @summary Create client
 */
export const postApiV1ThreeLetterCodeInternalAdminsClients = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeInternalAdminsClientsBody?: PostApiV1ThreeLetterCodeInternalAdminsClientsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsClientsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsClientsResponse>(getPostApiV1ThreeLetterCodeInternalAdminsClientsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsClientsBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsClientsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsClientsBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsClients(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsClientsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/clients`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsClientsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsClients>>>

/**
 * @summary Create client
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsClients = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsClients>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsClientsBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsClients>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsClientsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsClientsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsClientsIdResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsClientsId200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsClientsIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsClientsIdResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeInternalAdminsClientsIdResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsClientsIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsClientsIdResponseError = (getApiV1ThreeLetterCodeInternalAdminsClientsIdResponse401 | getApiV1ThreeLetterCodeInternalAdminsClientsIdResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsClientsIdResponse = (getApiV1ThreeLetterCodeInternalAdminsClientsIdResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsClientsIdResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsClientsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/clients/${id}`
}

/**
 * 導入企業の詳細を取得する
 * @summary Show client
 */
export const getApiV1ThreeLetterCodeInternalAdminsClientsId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsClientsIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsClientsIdResponse>(getGetApiV1ThreeLetterCodeInternalAdminsClientsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsClientsIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/clients/${id}`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsClientsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsClientsId>>>

/**
 * @summary Show client
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsClientsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsClientsId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsClientsIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsClientsId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeInternalAdminsClientsIdResponse200 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsClientsId200
  status: 200
}

export type putApiV1ThreeLetterCodeInternalAdminsClientsIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeInternalAdminsClientsIdResponse404 = {
  data: Errors
  status: 404
}

export type putApiV1ThreeLetterCodeInternalAdminsClientsIdResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeInternalAdminsClientsIdResponseSuccess = (putApiV1ThreeLetterCodeInternalAdminsClientsIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeInternalAdminsClientsIdResponseError = (putApiV1ThreeLetterCodeInternalAdminsClientsIdResponse401 | putApiV1ThreeLetterCodeInternalAdminsClientsIdResponse404 | putApiV1ThreeLetterCodeInternalAdminsClientsIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeInternalAdminsClientsIdResponse = (putApiV1ThreeLetterCodeInternalAdminsClientsIdResponseSuccess | putApiV1ThreeLetterCodeInternalAdminsClientsIdResponseError)

export const getPutApiV1ThreeLetterCodeInternalAdminsClientsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/clients/${id}`
}

/**
 * 導入企業情報を更新する
 * @summary Update client
 */
export const putApiV1ThreeLetterCodeInternalAdminsClientsId = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodeInternalAdminsClientsIdBody?: PutApiV1ThreeLetterCodeInternalAdminsClientsIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeInternalAdminsClientsIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeInternalAdminsClientsIdResponse>(getPutApiV1ThreeLetterCodeInternalAdminsClientsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeInternalAdminsClientsIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeInternalAdminsClientsIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeInternalAdminsClientsIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeInternalAdminsClientsId(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeInternalAdminsClientsIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/clients/${id}`] as const;

export type PutApiV1ThreeLetterCodeInternalAdminsClientsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsClientsId>>>

/**
 * @summary Update client
 */
export const usePutApiV1ThreeLetterCodeInternalAdminsClientsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsClientsId>>, TError, Key, PutApiV1ThreeLetterCodeInternalAdminsClientsIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsClientsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeInternalAdminsClientsIdMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodeInternalAdminsClientsIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesResponse200 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStates200
  status: 200
}

export type putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesResponseSuccess = (putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesResponseError = (putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesResponse401 | putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesResponse = (putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesResponseSuccess | putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesResponseError)

export const getPutApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesUrl = (threeLetterCode: string,
    companyId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/companies/${companyId}/states`
}

/**
 * 掲載企業の有効・無効状態を切り替える
 * @summary Update company enable
 */
export const putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStates = async (threeLetterCode: string,
    companyId: number,
    putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesBody?: PutApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesResponse> => {

  return customInstance<putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesResponse>(getPutApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesUrl(threeLetterCode,companyId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesBody)
  }
);}




export const getPutApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesMutationFetcher = (threeLetterCode: string,
    companyId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesBody | undefined }) => {
    return putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStates(threeLetterCode, companyId, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesMutationKey = (threeLetterCode: string,
    companyId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/companies/${companyId}/states`] as const;

export type PutApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStates>>>

/**
 * @summary Update company enable
 */
export const usePutApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStates = <TError = Errors>(
  threeLetterCode: string,
    companyId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStates>>, TError, Key, PutApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStates>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesMutationKey(threeLetterCode,companyId);
  const swrFn = getPutApiV1ThreeLetterCodeInternalAdminsCompaniesCompanyIdStatesMutationFetcher(threeLetterCode,companyId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsCompaniesResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsCompanies200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsCompaniesResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeInternalAdminsCompaniesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsCompaniesResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsCompaniesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsCompaniesResponseError = (getApiV1ThreeLetterCodeInternalAdminsCompaniesResponse400 | getApiV1ThreeLetterCodeInternalAdminsCompaniesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsCompaniesResponse = (getApiV1ThreeLetterCodeInternalAdminsCompaniesResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsCompaniesResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsCompaniesUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsCompaniesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/internal_admins/companies?${stringifiedParams}` : `/api/v1/${threeLetterCode}/internal_admins/companies`
}

/**
 * 掲載企業の一覧を取得する。ページネーションヘッダー（Total-Count, Total-Pages 等）を返却する
 * @summary Get companies
 */
export const getApiV1ThreeLetterCodeInternalAdminsCompanies = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsCompaniesParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsCompaniesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsCompaniesResponse>(getGetApiV1ThreeLetterCodeInternalAdminsCompaniesUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsCompaniesKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsCompaniesParams,) => [`/api/v1/${threeLetterCode}/internal_admins/companies`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsCompanies>>>

/**
 * @summary Get companies
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsCompanies = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsCompaniesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsCompanies>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsCompaniesKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsCompanies(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsCompaniesResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsCompanies201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsCompaniesResponse422 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsCompanies422
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsCompaniesResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsCompaniesResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsCompaniesResponseError = (postApiV1ThreeLetterCodeInternalAdminsCompaniesResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsCompaniesResponse = (postApiV1ThreeLetterCodeInternalAdminsCompaniesResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsCompaniesResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsCompaniesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/companies`
}

/**
 * 掲載企業を新規作成する
 * @summary Create company
 */
export const postApiV1ThreeLetterCodeInternalAdminsCompanies = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeInternalAdminsCompaniesBody?: PostApiV1ThreeLetterCodeInternalAdminsCompaniesBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsCompaniesResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsCompaniesResponse>(getPostApiV1ThreeLetterCodeInternalAdminsCompaniesUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsCompaniesBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsCompaniesMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsCompaniesBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsCompanies(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsCompaniesMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/companies`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsCompanies>>>

/**
 * @summary Create company
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsCompanies = <TError = PostApiV1ThreeLetterCodeInternalAdminsCompanies422>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsCompanies>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsCompaniesBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsCompanies>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsCompaniesMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsCompaniesMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsCompaniesId200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponse200) & {
  headers: Headers;
};
;

export type getApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponse = (getApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponseSuccess)

export const getGetApiV1ThreeLetterCodeInternalAdminsCompaniesIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/companies/${id}`
}

/**
 * 掲載企業の詳細を取得する
 * @summary Get company
 */
export const getApiV1ThreeLetterCodeInternalAdminsCompaniesId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponse>(getGetApiV1ThreeLetterCodeInternalAdminsCompaniesIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsCompaniesIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/companies/${id}`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsCompaniesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsCompaniesId>>>

/**
 * @summary Get company
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsCompaniesId = <TError = unknown>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsCompaniesId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsCompaniesIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsCompaniesId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponse200 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsCompaniesId200
  status: 200
}

export type putApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponse422 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsCompaniesId422
  status: 422
}

export type putApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponseSuccess = (putApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponseError = (putApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponse401 | putApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponse = (putApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponseSuccess | putApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponseError)

export const getPutApiV1ThreeLetterCodeInternalAdminsCompaniesIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/companies/${id}`
}

/**
 * 掲載企業の情報を更新する
 * @summary Update company
 */
export const putApiV1ThreeLetterCodeInternalAdminsCompaniesId = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodeInternalAdminsCompaniesIdBody?: PutApiV1ThreeLetterCodeInternalAdminsCompaniesIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeInternalAdminsCompaniesIdResponse>(getPutApiV1ThreeLetterCodeInternalAdminsCompaniesIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeInternalAdminsCompaniesIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeInternalAdminsCompaniesIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeInternalAdminsCompaniesIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeInternalAdminsCompaniesId(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeInternalAdminsCompaniesIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/companies/${id}`] as const;

export type PutApiV1ThreeLetterCodeInternalAdminsCompaniesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsCompaniesId>>>

/**
 * @summary Update company
 */
export const usePutApiV1ThreeLetterCodeInternalAdminsCompaniesId = <TError = Errors | PutApiV1ThreeLetterCodeInternalAdminsCompaniesId422>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsCompaniesId>>, TError, Key, PutApiV1ThreeLetterCodeInternalAdminsCompaniesIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsCompaniesId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeInternalAdminsCompaniesIdMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodeInternalAdminsCompaniesIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsFeaturedIdsResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsFeaturedIds200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsFeaturedIdsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsFeaturedIdsResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsFeaturedIdsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsFeaturedIdsResponseError = (getApiV1ThreeLetterCodeInternalAdminsFeaturedIdsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsFeaturedIdsResponse = (getApiV1ThreeLetterCodeInternalAdminsFeaturedIdsResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsFeaturedIdsResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsFeaturedIdsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/featured/ids`
}

/**
 * おすすめサービス・カテゴリのID一覧を取得する
 * @summary Featured ids
 */
export const getApiV1ThreeLetterCodeInternalAdminsFeaturedIds = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsFeaturedIdsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsFeaturedIdsResponse>(getGetApiV1ThreeLetterCodeInternalAdminsFeaturedIdsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsFeaturedIdsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/featured/ids`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsFeaturedIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsFeaturedIds>>>

/**
 * @summary Featured ids
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsFeaturedIds = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsFeaturedIds>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsFeaturedIdsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsFeaturedIds(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsGiftTypesResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsGiftTypes200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsGiftTypesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsGiftTypesResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsGiftTypesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsGiftTypesResponseError = (getApiV1ThreeLetterCodeInternalAdminsGiftTypesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsGiftTypesResponse = (getApiV1ThreeLetterCodeInternalAdminsGiftTypesResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsGiftTypesResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsGiftTypesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/gift_types`
}

/**
 * ギフト種別の一覧を取得する
 * @summary Get gift_types
 */
export const getApiV1ThreeLetterCodeInternalAdminsGiftTypes = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsGiftTypesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsGiftTypesResponse>(getGetApiV1ThreeLetterCodeInternalAdminsGiftTypesUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsGiftTypesKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/gift_types`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsGiftTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsGiftTypes>>>

/**
 * @summary Get gift_types
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsGiftTypes = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsGiftTypes>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsGiftTypesKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsGiftTypes(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponse200ApplicationJson = {
  data: GetApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrders200One
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponse200TextCsv = {
  data: Blob
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponse422 = {
  data: Errors
  status: 422
}

export type getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponse200ApplicationJson | getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponse200TextCsv) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponseError = (getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponse400 | getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponse401 | getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponse422) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponse = (getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/internal_admins/giftee_benefit_orders?${stringifiedParams}` : `/api/v1/${threeLetterCode}/internal_admins/giftee_benefit_orders`
}

/**
 * コンビニ割引の注文明細一覧を取得する（全テナント横断・UNION ALL、JSON/CSV切り替え可能）
 * @summary Get giftee benefit orders
 */
export const getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrders = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersResponse>(getGetApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersParams,) => [`/api/v1/${threeLetterCode}/internal_admins/giftee_benefit_orders`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrders>>>

/**
 * @summary Get giftee benefit orders
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrders = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrders>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrdersKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsGifteeBenefitOrders(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsGifteePlansResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsGifteePlans200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsGifteePlansResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsGifteePlansResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsGifteePlansResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsGifteePlansResponseError = (getApiV1ThreeLetterCodeInternalAdminsGifteePlansResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsGifteePlansResponse = (getApiV1ThreeLetterCodeInternalAdminsGifteePlansResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsGifteePlansResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsGifteePlansUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/giftee_plans`
}

/**
 * Gifteeプランの一覧を取得する
 * @summary Get giftee_plans
 */
export const getApiV1ThreeLetterCodeInternalAdminsGifteePlans = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsGifteePlansResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsGifteePlansResponse>(getGetApiV1ThreeLetterCodeInternalAdminsGifteePlansUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsGifteePlansKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/giftee_plans`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsGifteePlansQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsGifteePlans>>>

/**
 * @summary Get giftee_plans
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsGifteePlans = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsGifteePlans>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsGifteePlansKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsGifteePlans(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsLinkUrls200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponseError = (getApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse = (getApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsLinkUrlsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/link_urls`
}

/**
 * リンクURLの一覧を取得する
 * @summary Get link URLs
 */
export const getApiV1ThreeLetterCodeInternalAdminsLinkUrls = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse>(getGetApiV1ThreeLetterCodeInternalAdminsLinkUrlsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsLinkUrlsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/link_urls`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsLinkUrlsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsLinkUrls>>>

/**
 * @summary Get link URLs
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsLinkUrls = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsLinkUrls>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsLinkUrlsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsLinkUrls(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsLinkUrls201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse422 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsLinkUrls422
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponseError = (postApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse401 | postApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse = (postApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsLinkUrlsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/link_urls`
}

/**
 * リンクURLを新規作成する
 * @summary Create link URL
 */
export const postApiV1ThreeLetterCodeInternalAdminsLinkUrls = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeInternalAdminsLinkUrlsBody?: PostApiV1ThreeLetterCodeInternalAdminsLinkUrlsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsLinkUrlsResponse>(getPostApiV1ThreeLetterCodeInternalAdminsLinkUrlsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsLinkUrlsBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsLinkUrlsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsLinkUrlsBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsLinkUrls(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsLinkUrlsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/link_urls`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsLinkUrlsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsLinkUrls>>>

/**
 * @summary Create link URL
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsLinkUrls = <TError = Errors | PostApiV1ThreeLetterCodeInternalAdminsLinkUrls422>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsLinkUrls>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsLinkUrlsBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsLinkUrls>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsLinkUrlsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsLinkUrlsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsLinkUrlsId200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponseError = (getApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse = (getApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/link_urls/${id}`
}

/**
 * リンクURLの詳細を取得する
 * @summary Get link URL
 */
export const getApiV1ThreeLetterCodeInternalAdminsLinkUrlsId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse>(getGetApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/link_urls/${id}`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsLinkUrlsId>>>

/**
 * @summary Get link URL
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsLinkUrlsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsLinkUrlsId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsLinkUrlsId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse200 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsLinkUrlsId200
  status: 200
}

export type putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse422 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsLinkUrlsId422
  status: 422
}

export type putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponseSuccess = (putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponseError = (putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse401 | putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse = (putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponseSuccess | putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponseError)

export const getPutApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/link_urls/${id}`
}

/**
 * リンクURLを更新する
 * @summary Update link URL
 */
export const putApiV1ThreeLetterCodeInternalAdminsLinkUrlsId = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdBody?: PutApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse>(getPutApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeInternalAdminsLinkUrlsId(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/link_urls/${id}`] as const;

export type PutApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsLinkUrlsId>>>

/**
 * @summary Update link URL
 */
export const usePutApiV1ThreeLetterCodeInternalAdminsLinkUrlsId = <TError = Errors | PutApiV1ThreeLetterCodeInternalAdminsLinkUrlsId422>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsLinkUrlsId>>, TError, Key, PutApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsLinkUrlsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponseSuccess = (deleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse204) & {
  headers: Headers;
};
;

export type deleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse = (deleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponseSuccess)

export const getDeleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/link_urls/${id}`
}

/**
 * リンクURLを削除する
 * @summary Delete link URL
 */
export const deleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdResponse>(getDeleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/link_urls/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsId>>>

/**
 * @summary Delete link URL
 */
export const useDeleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsId = <TError = unknown>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeInternalAdminsLinkUrlsIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1InternalAdminsNotificationsResponse401 = {
  data: Errors
  status: 401
}

;
export type postApiV1InternalAdminsNotificationsResponseError = (postApiV1InternalAdminsNotificationsResponse401) & {
  headers: Headers;
};

export type postApiV1InternalAdminsNotificationsResponse = (postApiV1InternalAdminsNotificationsResponseError)

export const getPostApiV1InternalAdminsNotificationsUrl = () => {




  return `/api/v1/internal_admins/notifications`
}

/**
 * 複数パートナーに一括プッシュ通知を作成する
 * @summary Create bulk notification
 */
export const postApiV1InternalAdminsNotifications = async (postApiV1InternalAdminsNotificationsBody?: PostApiV1InternalAdminsNotificationsBody, options?: RequestInit): Promise<postApiV1InternalAdminsNotificationsResponse> => {

  return customInstance<postApiV1InternalAdminsNotificationsResponse>(getPostApiV1InternalAdminsNotificationsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1InternalAdminsNotificationsBody)
  }
);}




export const getPostApiV1InternalAdminsNotificationsMutationFetcher = ( options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1InternalAdminsNotificationsBody | undefined }) => {
    return postApiV1InternalAdminsNotifications(arg, options);
  }
}
export const getPostApiV1InternalAdminsNotificationsMutationKey = () => [`/api/v1/internal_admins/notifications`] as const;

export type PostApiV1InternalAdminsNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1InternalAdminsNotifications>>>

/**
 * @summary Create bulk notification
 */
export const usePostApiV1InternalAdminsNotifications = <TError = Errors>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1InternalAdminsNotifications>>, TError, Key, PostApiV1InternalAdminsNotificationsBody | undefined, Awaited<ReturnType<typeof postApiV1InternalAdminsNotifications>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1InternalAdminsNotificationsMutationKey();
  const swrFn = getPostApiV1InternalAdminsNotificationsMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partner_admin_users`
}

/**
 * パートナー管理者ユーザーの一覧を取得する
 * @summary Get partner_admin_users
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/partner_admin_users`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers>>>

/**
 * @summary Get partner_admin_users
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponseError = (postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse401 | postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse = (postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partner_admin_users`
}

/**
 * パートナー管理者ユーザーを新規作成する
 * @summary Create PartnerAdminUser
 */
export const postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersBody?: PostApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersResponse>(getPostApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/partner_admin_users`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers>>>

/**
 * @summary Create PartnerAdminUser
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsers>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partner_admin_users/${id}`
}

/**
 * パートナー管理者ユーザーの詳細を取得する
 * @summary Get partner_admin_user
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partner_admin_users/${id}`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId>>>

/**
 * @summary Get partner_admin_user
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse200 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId200
  status: 200
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponseSuccess = (putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponseError = (putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse401 | putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse = (putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponseSuccess | putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponseError)

export const getPutApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partner_admin_users/${id}`
}

/**
 * パートナー管理者ユーザー情報を更新する
 * @summary Update partner_admin_user
 */
export const putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdBody?: PutApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse>(getPutApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partner_admin_users/${id}`] as const;

export type PutApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId>>>

/**
 * @summary Update partner_admin_user
 */
export const usePutApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId>>, TError, Key, PutApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponseSuccess = (deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponseError = (deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse = (deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponseSuccess | deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponseError)

export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partner_admin_users/${id}`
}

/**
 * パートナー管理者ユーザーを削除する
 * @summary Delete partner_admin_user
 */
export const deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdResponse>(getDeleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partner_admin_users/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId>>>

/**
 * @summary Delete partner_admin_user
 */
export const useDeleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeInternalAdminsPartnerAdminUsersIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponse200 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorder200
  status: 200
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponse400 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorder400
  status: 400
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponse404 = {
  data: Errors
  status: 404
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponse422 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorder422
  status: 422
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponseSuccess = (putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponseError = (putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponse400 | putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponse401 | putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponse404 | putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponse = (putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponseSuccess | putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponseError)

export const getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderUrl = (threeLetterCode: string,
    partnerId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_application_agreements/reorder`
}

/**
 * Client 企業向け利用申込フォームに表示する同意項目の並び順を更新する。指定された ID の配列順に sort_order を 1 から再採番する。配列には現存する全ての同意項目の ID を重複なく含める必要がある。
 * @summary Reorder client application agreements
 */
export const putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorder = async (threeLetterCode: string,
    partnerId: number,
    putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderBody?: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponse> => {

  return customInstance<putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderResponse>(getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderUrl(threeLetterCode,partnerId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderBody)
  }
);}




export const getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderMutationFetcher = (threeLetterCode: string,
    partnerId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderBody | undefined }) => {
    return putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorder(threeLetterCode, partnerId, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderMutationKey = (threeLetterCode: string,
    partnerId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_application_agreements/reorder`] as const;

export type PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorder>>>

/**
 * @summary Reorder client application agreements
 */
export const usePutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorder = <TError = PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorder400 | Errors | PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorder422>(
  threeLetterCode: string,
    partnerId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorder>>, TError, Key, PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorder>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderMutationKey(threeLetterCode,partnerId);
  const swrFn = getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsReorderMutationFetcher(threeLetterCode,partnerId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse401 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsUrl = (threeLetterCode: string,
    partnerId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_application_agreements`
}

/**
 * Client 企業向け利用申込フォームに表示する同意項目の一覧を取得する（sort_order 昇順）
 * @summary Get client application agreements
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements = async (threeLetterCode: string,
    partnerId: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsUrl(threeLetterCode,partnerId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsKey = (threeLetterCode: string,
    partnerId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_application_agreements`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements>>>

/**
 * @summary Get client application agreements
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && partnerId !== null && partnerId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsKey(threeLetterCode,partnerId) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements(threeLetterCode,partnerId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse422 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements422
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponseError = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse401 | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse404 | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsUrl = (threeLetterCode: string,
    partnerId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_application_agreements`
}

/**
 * Client 企業向け利用申込フォームに表示する同意項目を新規作成する
 * @summary Create client application agreement
 */
export const postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements = async (threeLetterCode: string,
    partnerId: number,
    postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsBody?: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsResponse>(getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsUrl(threeLetterCode,partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsMutationFetcher = (threeLetterCode: string,
    partnerId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements(threeLetterCode, partnerId, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsMutationKey = (threeLetterCode: string,
    partnerId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_application_agreements`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements>>>

/**
 * @summary Create client application agreement
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements = <TError = Errors | PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements422>(
  threeLetterCode: string,
    partnerId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreements>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsMutationKey(threeLetterCode,partnerId);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsMutationFetcher(threeLetterCode,partnerId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse401 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdUrl = (threeLetterCode: string,
    partnerId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_application_agreements/${id}`
}

/**
 * Client 企業向け利用申込フォームに表示する同意項目の詳細を取得する
 * @summary Get client application agreement
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId = async (threeLetterCode: string,
    partnerId: number,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdUrl(threeLetterCode,partnerId,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdKey = (threeLetterCode: string,
    partnerId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_application_agreements/${id}`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId>>>

/**
 * @summary Get client application agreement
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && partnerId !== null && partnerId !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdKey(threeLetterCode,partnerId,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId(threeLetterCode,partnerId,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse200 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId200
  status: 200
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse404 = {
  data: Errors
  status: 404
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse422 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId422
  status: 422
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponseSuccess = (putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponseError = (putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse401 | putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse404 | putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse = (putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponseSuccess | putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponseError)

export const getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdUrl = (threeLetterCode: string,
    partnerId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_application_agreements/${id}`
}

/**
 * Client 企業向け利用申込フォームに表示する同意項目を更新する
 * @summary Update client application agreement
 */
export const putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId = async (threeLetterCode: string,
    partnerId: number,
    id: number,
    putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdBody?: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse>(getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdUrl(threeLetterCode,partnerId,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdMutationFetcher = (threeLetterCode: string,
    partnerId: number,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId(threeLetterCode, partnerId, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdMutationKey = (threeLetterCode: string,
    partnerId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_application_agreements/${id}`] as const;

export type PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId>>>

/**
 * @summary Update client application agreement
 */
export const usePutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId = <TError = Errors | PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId422>(
  threeLetterCode: string,
    partnerId: number,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId>>, TError, Key, PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdMutationKey(threeLetterCode,partnerId,id);
  const swrFn = getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdMutationFetcher(threeLetterCode,partnerId,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse404 = {
  data: Errors
  status: 404
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponseSuccess = (deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponseError = (deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse401 | deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse404) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse = (deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponseSuccess | deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponseError)

export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdUrl = (threeLetterCode: string,
    partnerId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_application_agreements/${id}`
}

/**
 * Client 企業向け利用申込フォームに表示する同意項目を削除する
 * @summary Delete client application agreement
 */
export const deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId = async (threeLetterCode: string,
    partnerId: number,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdResponse>(getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdUrl(threeLetterCode,partnerId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdMutationFetcher = (threeLetterCode: string,
    partnerId: number,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId(threeLetterCode, partnerId, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdMutationKey = (threeLetterCode: string,
    partnerId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_application_agreements/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId>>>

/**
 * @summary Delete client application agreement
 */
export const useDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdMutationKey(threeLetterCode,partnerId,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationAgreementsIdMutationFetcher(threeLetterCode,partnerId,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponse200 = {
  data: PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApprove200
  status: 200
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponse401 = {
  data: Errors
  status: 401
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponse404 = {
  data: Errors
  status: 404
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponse409 = {
  data: Errors
  status: 409
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponse422 = {
  data: Errors
  status: 422
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponseSuccess = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponse200) & {
  headers: Headers;
};
export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponseError = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponse401 | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponse404 | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponse409 | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponse422) & {
  headers: Headers;
};

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponse = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponseSuccess | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponseError)

export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveUrl = (threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_applications/${clientApplicationId}/approve`
}

/**
 * 指定された ID の申し込みを承認したレスポンスを返す。承認できるのは承認待ちの申し込みのみで、承認済・却下済の申し込みは現在のリソース状態と競合するため 409 を返す。担当者情報の検証に失敗した場合は 422 を返す。法人番号が既存企業と重複する場合は同一企業の複数契約として承認し、既存企業と同じ Corporation に紐付ける。
 * @summary Approve a client application
 */
export const patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApprove = async (threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number, options?: RequestInit): Promise<patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponse> => {

  return customInstance<patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveResponse>(getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveUrl(threeLetterCode,partnerId,clientApplicationId),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveMutationFetcher = (threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApprove(threeLetterCode, partnerId, clientApplicationId, options);
  }
}
export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveMutationKey = (threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_applications/${clientApplicationId}/approve`] as const;

export type PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApprove>>>

/**
 * @summary Approve a client application
 */
export const usePatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApprove = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApprove>>, TError, Key, Arguments, Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApprove>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveMutationKey(threeLetterCode,partnerId,clientApplicationId);
  const swrFn = getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdApproveMutationFetcher(threeLetterCode,partnerId,clientApplicationId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponse200 = {
  data: PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPending200
  status: 200
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponse401 = {
  data: Errors
  status: 401
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponse404 = {
  data: Errors
  status: 404
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponse409 = {
  data: Errors
  status: 409
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponseSuccess = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponse200) & {
  headers: Headers;
};
export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponseError = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponse401 | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponse404 | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponse409) & {
  headers: Headers;
};

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponse = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponseSuccess | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponseError)

export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingUrl = (threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_applications/${clientApplicationId}/pending`
}

/**
 * 指定された ID の申し込みの却下/承認を取り消し、pending に戻したレスポンスを返す。pending の取り消しは現在のリソース状態と競合するため 409 を返す
 * @summary Cancel rejection or approval of a client application
 */
export const patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPending = async (threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number, options?: RequestInit): Promise<patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponse> => {

  return customInstance<patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingResponse>(getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingUrl(threeLetterCode,partnerId,clientApplicationId),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingMutationFetcher = (threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPending(threeLetterCode, partnerId, clientApplicationId, options);
  }
}
export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingMutationKey = (threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_applications/${clientApplicationId}/pending`] as const;

export type PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPending>>>

/**
 * @summary Cancel rejection or approval of a client application
 */
export const usePatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPending = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPending>>, TError, Key, Arguments, Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPending>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingMutationKey(threeLetterCode,partnerId,clientApplicationId);
  const swrFn = getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdPendingMutationFetcher(threeLetterCode,partnerId,clientApplicationId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponse200 = {
  data: PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdReject200
  status: 200
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponse401 = {
  data: Errors
  status: 401
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponse404 = {
  data: Errors
  status: 404
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponse409 = {
  data: Errors
  status: 409
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponseSuccess = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponse200) & {
  headers: Headers;
};
export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponseError = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponse401 | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponse404 | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponse409) & {
  headers: Headers;
};

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponse = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponseSuccess | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponseError)

export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectUrl = (threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_applications/${clientApplicationId}/reject`
}

/**
 * 指定された ID の申し込みを却下したレスポンスを返す。却下できるのは承認待ちの申し込みのみで、承認済・却下済の申し込みは現在のリソース状態と競合するため 409 を返す
 * @summary Reject a client application
 */
export const patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdReject = async (threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number, options?: RequestInit): Promise<patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponse> => {

  return customInstance<patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectResponse>(getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectUrl(threeLetterCode,partnerId,clientApplicationId),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectMutationFetcher = (threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdReject(threeLetterCode, partnerId, clientApplicationId, options);
  }
}
export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectMutationKey = (threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_applications/${clientApplicationId}/reject`] as const;

export type PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdReject>>>

/**
 * @summary Reject a client application
 */
export const usePatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdReject = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    clientApplicationId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdReject>>, TError, Key, Arguments, Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdReject>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectMutationKey(threeLetterCode,partnerId,clientApplicationId);
  const swrFn = getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsClientApplicationIdRejectMutationFetcher(threeLetterCode,partnerId,clientApplicationId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse401 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdUrl = (threeLetterCode: string,
    partnerId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_applications/${id}`
}

/**
 * 指定された Partner のテナントスキーマに切り替えて、ID の申し込み詳細を取得する。別テナントの ID は 404 になる
 * @summary Get a client application
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId = async (threeLetterCode: string,
    partnerId: number,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdUrl(threeLetterCode,partnerId,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdKey = (threeLetterCode: string,
    partnerId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_applications/${id}`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId>>>

/**
 * @summary Get a client application
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && partnerId !== null && partnerId !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdKey(threeLetterCode,partnerId,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId(threeLetterCode,partnerId,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse200 = {
  data: PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId200
  status: 200
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse401 = {
  data: Errors
  status: 401
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse404 = {
  data: Errors
  status: 404
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse409 = {
  data: Errors
  status: 409
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse422 = {
  data: Errors
  status: 422
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponseSuccess = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse200) & {
  headers: Headers;
};
export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponseError = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse401 | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse404 | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse409 | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse422) & {
  headers: Headers;
};

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponseSuccess | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponseError)

export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdUrl = (threeLetterCode: string,
    partnerId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_applications/${id}`
}

/**
 * 指定された Partner のテナントスキーマに切り替えて、ID の申し込みを更新する。approved 状態は更新不可（409）。application_number / status は更新不可（リクエスト本文に指定しても無視される）
 * @summary Update a client application
 */
export const patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId = async (threeLetterCode: string,
    partnerId: number,
    id: number,
    patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdBody?: PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdBody, options?: RequestInit): Promise<patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse> => {

  return customInstance<patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdResponse>(getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdUrl(threeLetterCode,partnerId,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdBody)
  }
);}




export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdMutationFetcher = (threeLetterCode: string,
    partnerId: number,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdBody | undefined }) => {
    return patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId(threeLetterCode, partnerId, id, arg, options);
  }
}
export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdMutationKey = (threeLetterCode: string,
    partnerId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_applications/${id}`] as const;

export type PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId>>>

/**
 * @summary Update a client application
 */
export const usePatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId>>, TError, Key, PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdBody | undefined, Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdMutationKey(threeLetterCode,partnerId,id);
  const swrFn = getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientApplicationsIdMutationFetcher(threeLetterCode,partnerId,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContracts200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponse400 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponse401 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsUrl = (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_contracts?${stringifiedParams}` : `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_contracts`
}

/**
 * パートナー配下の全クライアント企業の契約期間一覧を取得する。利用企業名・契約プラン名で部分一致検索でき、ページネーションヘッダー（Total-Count, Total-Pages 等）を返却する
 * @summary List client contracts across clients
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContracts = async (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsUrl(threeLetterCode,partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsKey = (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsParams,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_contracts`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContracts>>>

/**
 * @summary List client contracts across clients
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContracts = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContracts>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && partnerId !== null && partnerId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsKey(threeLetterCode,partnerId,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContracts(threeLetterCode,partnerId,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsId200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdResponse401 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdUrl = (threeLetterCode: string,
    partnerId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_contracts/${id}`
}

/**
 * クライアント企業の契約期間の詳細を取得する。詳細画面・編集画面向けに、作成日時・更新日時を含む
 * @summary Show a client contract
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsId = async (threeLetterCode: string,
    partnerId: number,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdUrl(threeLetterCode,partnerId,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdKey = (threeLetterCode: string,
    partnerId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/client_contracts/${id}`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsId>>>

/**
 * @summary Show a client contract
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsId = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && partnerId !== null && partnerId !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsIdKey(threeLetterCode,partnerId,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientContractsId(threeLetterCode,partnerId,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse401 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsUrl = (threeLetterCode: string,
    partnerId: number,
    clientId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/clients/${clientId}/client_contracts?${stringifiedParams}` : `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/clients/${clientId}/client_contracts`
}

/**
 * クライアント企業の契約期間一覧を取得する
 * @summary List client contracts
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts = async (threeLetterCode: string,
    partnerId: number,
    clientId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsUrl(threeLetterCode,partnerId,clientId,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsKey = (threeLetterCode: string,
    partnerId: number,
    clientId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsParams,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/clients/${clientId}/client_contracts`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts>>>

/**
 * @summary List client contracts
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    clientId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && partnerId !== null && partnerId !== undefined && clientId !== null && clientId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsKey(threeLetterCode,partnerId,clientId,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts(threeLetterCode,partnerId,clientId,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponseError = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse401 | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse404 | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsUrl = (threeLetterCode: string,
    partnerId: number,
    clientId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/clients/${clientId}/client_contracts`
}

/**
 * クライアント企業に契約期間を作成する。同一企業で期間が重複する契約（有効契約2件目を含む）は作成できない
 * @summary Create client contract
 */
export const postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts = async (threeLetterCode: string,
    partnerId: number,
    clientId: number,
    postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsBody?: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsResponse>(getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsUrl(threeLetterCode,partnerId,clientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsMutationFetcher = (threeLetterCode: string,
    partnerId: number,
    clientId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts(threeLetterCode, partnerId, clientId, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsMutationKey = (threeLetterCode: string,
    partnerId: number,
    clientId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/clients/${clientId}/client_contracts`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts>>>

/**
 * @summary Create client contract
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    clientId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContracts>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsMutationKey(threeLetterCode,partnerId,clientId);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsMutationFetcher(threeLetterCode,partnerId,clientId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse200 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsId200
  status: 200
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse404 = {
  data: Errors
  status: 404
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponseSuccess = (putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponseError = (putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse401 | putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse404 | putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse = (putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponseSuccess | putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponseError)

export const getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdUrl = (threeLetterCode: string,
    partnerId: number,
    clientId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/clients/${clientId}/client_contracts/${id}`
}

/**
 * クライアント企業の契約期間（契約プラン・開始日・終了日）を修正する。期間重複・有効契約2件目・期間逆転は作成時と同様にエラーになる。契約開始後（開始日が当日以前）は契約プランと開始日を変更できず、終了日のみ変更できる。契約開始後の終了日は当日以降の日付のみ指定できる
 * @summary Update client contract
 */
export const putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsId = async (threeLetterCode: string,
    partnerId: number,
    clientId: number,
    id: number,
    putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdBody?: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse>(getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdUrl(threeLetterCode,partnerId,clientId,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdMutationFetcher = (threeLetterCode: string,
    partnerId: number,
    clientId: number,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsId(threeLetterCode, partnerId, clientId, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdMutationKey = (threeLetterCode: string,
    partnerId: number,
    clientId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/clients/${clientId}/client_contracts/${id}`] as const;

export type PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsId>>>

/**
 * @summary Update client contract
 */
export const usePutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsId = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    clientId: number,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsId>>, TError, Key, PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdMutationKey(threeLetterCode,partnerId,clientId,id);
  const swrFn = getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdMutationFetcher(threeLetterCode,partnerId,clientId,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse404 = {
  data: Errors
  status: 404
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse422 = {
  data: Errors
  status: 422
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponseSuccess = (deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponseError = (deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse401 | deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse404 | deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse422) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse = (deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponseSuccess | deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponseError)

export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdUrl = (threeLetterCode: string,
    partnerId: number,
    clientId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/clients/${clientId}/client_contracts/${id}`
}

/**
 * クライアント企業の契約期間を削除する。削除できるのは契約開始前（契約開始日が未来）の契約期間のみ
 * @summary Delete client contract
 */
export const deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsId = async (threeLetterCode: string,
    partnerId: number,
    clientId: number,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdResponse>(getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdUrl(threeLetterCode,partnerId,clientId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdMutationFetcher = (threeLetterCode: string,
    partnerId: number,
    clientId: number,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsId(threeLetterCode, partnerId, clientId, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdMutationKey = (threeLetterCode: string,
    partnerId: number,
    clientId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/clients/${clientId}/client_contracts/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsId>>>

/**
 * @summary Delete client contract
 */
export const useDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsId = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    clientId: number,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdMutationKey(threeLetterCode,partnerId,clientId,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsClientIdClientContractsIdMutationFetcher(threeLetterCode,partnerId,clientId,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClients200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponse400 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponse401 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsUrl = (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/clients?${stringifiedParams}` : `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/clients`
}

/**
 * パートナー配下の利用企業（クライアント企業）一覧を取得する。企業契約期間の新規作成で選択する利用企業のドロップダウン向け。企業名で部分一致検索でき、ページネーションヘッダー（Total-Count, Total-Pages 等）を返却する
 * @summary List clients
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClients = async (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsUrl(threeLetterCode,partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsKey = (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsParams,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/clients`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClients>>>

/**
 * @summary List clients
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClients = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClients>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && partnerId !== null && partnerId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClientsKey(threeLetterCode,partnerId,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdClients(threeLetterCode,partnerId,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse400 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse401 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansUrl = (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/contract_plans?${stringifiedParams}` : `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/contract_plans`
}

/**
 * 契約プランの一覧を取得する。廃止済みプランも含めて返却し、ページネーションヘッダー（Total-Count, Total-Pages 等）を返却する
 * @summary List contract plans
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans = async (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansUrl(threeLetterCode,partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansKey = (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansParams,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/contract_plans`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans>>>

/**
 * @summary List contract plans
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && partnerId !== null && partnerId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansKey(threeLetterCode,partnerId,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans(threeLetterCode,partnerId,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponseError = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse401 | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse404 | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansUrl = (threeLetterCode: string,
    partnerId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/contract_plans`
}

/**
 * 契約プランを新規作成する。単価3種・税率は作成後に変更できない
 * @summary Create contract plan
 */
export const postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans = async (threeLetterCode: string,
    partnerId: number,
    postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansBody?: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansResponse>(getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansUrl(threeLetterCode,partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansMutationFetcher = (threeLetterCode: string,
    partnerId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans(threeLetterCode, partnerId, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansMutationKey = (threeLetterCode: string,
    partnerId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/contract_plans`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans>>>

/**
 * @summary Create contract plan
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlans>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansMutationKey(threeLetterCode,partnerId);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansMutationFetcher(threeLetterCode,partnerId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse401 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdUrl = (threeLetterCode: string,
    partnerId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/contract_plans/${id}`
}

/**
 * 契約プランの詳細を取得する。パートナー販売手数料・Leafea収益単価などの内部金額情報を含む
 * @summary Show contract plan
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId = async (threeLetterCode: string,
    partnerId: number,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdUrl(threeLetterCode,partnerId,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdKey = (threeLetterCode: string,
    partnerId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/contract_plans/${id}`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId>>>

/**
 * @summary Show contract plan
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && partnerId !== null && partnerId !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdKey(threeLetterCode,partnerId,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId(threeLetterCode,partnerId,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse200 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId200
  status: 200
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse404 = {
  data: Errors
  status: 404
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponseSuccess = (putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponseError = (putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse401 | putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse404 | putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse = (putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponseSuccess | putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponseError)

export const getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdUrl = (threeLetterCode: string,
    partnerId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/contract_plans/${id}`
}

/**
 * 契約プランのプラン名・廃止状態を更新する。ギフトプラン・単価3種・税率・種別は変更できない（リクエストに含めても無視される）。廃止したプランは新規の契約期間で選択できなくなるが、既存の契約期間には影響しない
 * @summary Update contract plan
 */
export const putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId = async (threeLetterCode: string,
    partnerId: number,
    id: number,
    putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdBody?: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdResponse>(getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdUrl(threeLetterCode,partnerId,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdMutationFetcher = (threeLetterCode: string,
    partnerId: number,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId(threeLetterCode, partnerId, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdMutationKey = (threeLetterCode: string,
    partnerId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/contract_plans/${id}`] as const;

export type PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId>>>

/**
 * @summary Update contract plan
 */
export const usePutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId>>, TError, Key, PutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdMutationKey(threeLetterCode,partnerId,id);
  const swrFn = getPutApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdContractPlansIdMutationFetcher(threeLetterCode,partnerId,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse400 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansUrl = (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/gift_plans?${stringifiedParams}` : `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/gift_plans`
}

/**
 * ギフトプランの一覧を取得する
 * @summary Get gift_plans
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans = async (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansUrl(threeLetterCode,partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansKey = (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansParams,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/gift_plans`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans>>>

/**
 * @summary Get gift_plans
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && partnerId !== null && partnerId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansKey(threeLetterCode,partnerId,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans(threeLetterCode,partnerId,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse422 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans422
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponseError = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse401 | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansUrl = (threeLetterCode: string,
    partnerId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/gift_plans`
}

/**
 * ギフトプランを新規作成する
 * @summary Create gift_plan
 */
export const postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans = async (threeLetterCode: string,
    partnerId: number,
    postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansBody?: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansResponse>(getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansUrl(threeLetterCode,partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansMutationFetcher = (threeLetterCode: string,
    partnerId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans(threeLetterCode, partnerId, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansMutationKey = (threeLetterCode: string,
    partnerId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/gift_plans`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans>>>

/**
 * @summary Create gift_plan
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans = <TError = Errors | PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans422>(
  threeLetterCode: string,
    partnerId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlans>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansMutationKey(threeLetterCode,partnerId);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansMutationFetcher(threeLetterCode,partnerId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse404 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId404
  status: 404
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse401 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdUrl = (threeLetterCode: string,
    partnerId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/gift_plans/${id}`
}

/**
 * ギフトプランの詳細を取得する
 * @summary Get gift_plan
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId = async (threeLetterCode: string,
    partnerId: number,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdUrl(threeLetterCode,partnerId,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdKey = (threeLetterCode: string,
    partnerId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/gift_plans/${id}`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId>>>

/**
 * @summary Get gift_plan
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId = <TError = Errors | GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId404>(
  threeLetterCode: string,
    partnerId: number,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && partnerId !== null && partnerId !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdKey(threeLetterCode,partnerId,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId(threeLetterCode,partnerId,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse422 = {
  data: DeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId422
  status: 422
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponseSuccess = (deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponseError = (deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse401 | deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse422) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse = (deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponseSuccess | deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponseError)

export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdUrl = (threeLetterCode: string,
    partnerId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/gift_plans/${id}`
}

/**
 * ギフトプランを削除する。契約プラン・申し込み・クライアントから参照されている場合は削除できない
 * @summary Delete gift_plan
 */
export const deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId = async (threeLetterCode: string,
    partnerId: number,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdResponse>(getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdUrl(threeLetterCode,partnerId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdMutationFetcher = (threeLetterCode: string,
    partnerId: number,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId(threeLetterCode, partnerId, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdMutationKey = (threeLetterCode: string,
    partnerId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/gift_plans/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId>>>

/**
 * @summary Delete gift_plan
 */
export const useDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId = <TError = Errors | DeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId422>(
  threeLetterCode: string,
    partnerId: number,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdMutationKey(threeLetterCode,partnerId,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdGiftPlansIdMutationFetcher(threeLetterCode,partnerId,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreation201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponseError = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponse401 | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponse404 | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponse = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationUrl = (threeLetterCode: string,
    partnerId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/partner_branches/bulk_creation`
}

/**
 * CSV ファイルで PartnerBranch（取引店舗 / 拠点）を一括 upsert する。必須ヘッダーは name と name_kana。name が enable=true の既存レコードと一致する場合は name_kana を更新し、一致しなければ新規作成する。enable=false のレコードは更新対象とせず新規作成扱い。同一 CSV 内で name が重複する場合、およびいずれかの行でバリデーションエラーが発生した場合は全件ロールバックされ、行番号付きのエラーメッセージを返す。成功時はインポート（upsert）した件数（CSV の処理行数）を返す
 * @summary Create partner branches in bulk
 */
export const postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreation = async (threeLetterCode: string,
    partnerId: number,
    requestInternalAdminsPartnerBranchesBulkCreationCsvFile: RequestInternalAdminsPartnerBranchesBulkCreationCsvFile, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponse> => {
    const formData = new FormData();
formData.append(`file`, requestInternalAdminsPartnerBranchesBulkCreationCsvFile.file);

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationResponse>(getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationUrl(threeLetterCode,partnerId),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationMutationFetcher = (threeLetterCode: string,
    partnerId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestInternalAdminsPartnerBranchesBulkCreationCsvFile }) => {
    return postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreation(threeLetterCode, partnerId, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationMutationKey = (threeLetterCode: string,
    partnerId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/partner_branches/bulk_creation`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreation>>>

/**
 * @summary Create partner branches in bulk
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreation = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreation>>, TError, Key, RequestInternalAdminsPartnerBranchesBulkCreationCsvFile, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreation>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationMutationKey(threeLetterCode,partnerId);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBulkCreationMutationFetcher(threeLetterCode,partnerId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse200ApplicationJson = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches200One
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse200TextCsv = {
  data: Blob
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse200ApplicationJson | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse200TextCsv) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse400 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse401 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesUrl = (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/partner_branches?${stringifiedParams}` : `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/partner_branches`
}

/**
 * PartnerBranch（取引店舗 / 拠点）の一覧を取得する（JSON/CSV切り替え可能）。JSON ではページネーションヘッダー（Total-Count, Total-Pages 等）を返却する。CSV は一括登録用テンプレートとして利用でき、enable=true の全件を name_kana 昇順で出力する
 * @summary Get partner branches
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches = async (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesUrl(threeLetterCode,partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesKey = (threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesParams,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/partner_branches`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches>>>

/**
 * @summary Get partner branches
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && partnerId !== null && partnerId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesKey(threeLetterCode,partnerId,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches(threeLetterCode,partnerId,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponseError = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse401 | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse404 | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse = (postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesUrl = (threeLetterCode: string,
    partnerId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/partner_branches`
}

/**
 * PartnerBranch（取引店舗 / 拠点）を新規作成する
 * @summary Create partner branch
 */
export const postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches = async (threeLetterCode: string,
    partnerId: number,
    postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBody?: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesResponse>(getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesUrl(threeLetterCode,partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesMutationFetcher = (threeLetterCode: string,
    partnerId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches(threeLetterCode, partnerId, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesMutationKey = (threeLetterCode: string,
    partnerId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/partner_branches`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches>>>

/**
 * @summary Create partner branch
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranches>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesMutationKey(threeLetterCode,partnerId);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesMutationFetcher(threeLetterCode,partnerId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse401 | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdUrl = (threeLetterCode: string,
    partnerId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/partner_branches/${id}`
}

/**
 * PartnerBranch（取引店舗 / 拠点）の詳細を取得する
 * @summary Get partner branch
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId = async (threeLetterCode: string,
    partnerId: number,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdUrl(threeLetterCode,partnerId,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdKey = (threeLetterCode: string,
    partnerId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/partner_branches/${id}`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId>>>

/**
 * @summary Get partner branch
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && partnerId !== null && partnerId !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdKey(threeLetterCode,partnerId,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId(threeLetterCode,partnerId,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse200 = {
  data: PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId200
  status: 200
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse401 = {
  data: Errors
  status: 401
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse404 = {
  data: Errors
  status: 404
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse422 = {
  data: Errors
  status: 422
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponseSuccess = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse200) & {
  headers: Headers;
};
export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponseError = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse401 | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse404 | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse422) & {
  headers: Headers;
};

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse = (patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponseSuccess | patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponseError)

export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdUrl = (threeLetterCode: string,
    partnerId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/partner_branches/${id}`
}

/**
 * PartnerBranch（取引店舗 / 拠点）を更新する
 * @summary Update partner branch
 */
export const patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId = async (threeLetterCode: string,
    partnerId: number,
    id: number,
    patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdBody?: PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdBody, options?: RequestInit): Promise<patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse> => {

  return customInstance<patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse>(getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdUrl(threeLetterCode,partnerId,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdBody)
  }
);}




export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdMutationFetcher = (threeLetterCode: string,
    partnerId: number,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdBody | undefined }) => {
    return patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId(threeLetterCode, partnerId, id, arg, options);
  }
}
export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdMutationKey = (threeLetterCode: string,
    partnerId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/partner_branches/${id}`] as const;

export type PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId>>>

/**
 * @summary Update partner branch
 */
export const usePatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId>>, TError, Key, PatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdBody | undefined, Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdMutationKey(threeLetterCode,partnerId,id);
  const swrFn = getPatchApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdMutationFetcher(threeLetterCode,partnerId,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse404 = {
  data: Errors
  status: 404
}

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponseSuccess = (deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponseError = (deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse401 | deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse404) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse = (deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponseSuccess | deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponseError)

export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdUrl = (threeLetterCode: string,
    partnerId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/partner_branches/${id}`
}

/**
 * PartnerBranch（取引店舗 / 拠点）を削除する。実体は enable を false に切り替えるだけで物理削除はしない。これは過去の申し込みが「当時紐づいていた取引店舗」として本レコードを参照しているため、参照を切らない目的
 * @summary Delete partner branch
 */
export const deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId = async (threeLetterCode: string,
    partnerId: number,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdResponse>(getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdUrl(threeLetterCode,partnerId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdMutationFetcher = (threeLetterCode: string,
    partnerId: number,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId(threeLetterCode, partnerId, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdMutationKey = (threeLetterCode: string,
    partnerId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${partnerId}/partner_branches/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId>>>

/**
 * @summary Delete partner branch
 */
export const useDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId = <TError = Errors>(
  threeLetterCode: string,
    partnerId: number,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdMutationKey(threeLetterCode,partnerId,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeInternalAdminsPartnersPartnerIdPartnerBranchesIdMutationFetcher(threeLetterCode,partnerId,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartners200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersResponse400 | getApiV1ThreeLetterCodeInternalAdminsPartnersResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/internal_admins/partners?${stringifiedParams}` : `/api/v1/${threeLetterCode}/internal_admins/partners`
}

/**
 * パートナーの一覧を取得する
 * @summary Get partners
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartners = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersParams,) => [`/api/v1/${threeLetterCode}/internal_admins/partners`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartners>>>

/**
 * @summary Get partners
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartners = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsPartnersParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartners>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartners(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsPartnersResponse401 = {
  data: Errors
  status: 401
}

;
export type postApiV1ThreeLetterCodeInternalAdminsPartnersResponseError = (postApiV1ThreeLetterCodeInternalAdminsPartnersResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsPartnersResponse = (postApiV1ThreeLetterCodeInternalAdminsPartnersResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners`
}

/**
 * パートナーを新規作成する
 * @summary Create Partner
 */
export const postApiV1ThreeLetterCodeInternalAdminsPartners = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeInternalAdminsPartnersBody?: PostApiV1ThreeLetterCodeInternalAdminsPartnersBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsPartnersResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsPartnersResponse>(getPostApiV1ThreeLetterCodeInternalAdminsPartnersUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsPartnersBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsPartnersBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsPartners(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsPartnersMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/partners`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsPartnersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartners>>>

/**
 * @summary Create Partner
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsPartners = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartners>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsPartnersBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsPartners>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsPartnersMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsPartnersMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersIdResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsPartnersId200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsPartnersIdResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsPartnersIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsPartnersIdResponseError = (getApiV1ThreeLetterCodeInternalAdminsPartnersIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsPartnersIdResponse = (getApiV1ThreeLetterCodeInternalAdminsPartnersIdResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsPartnersIdResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${id}`
}

/**
 * パートナーの詳細を取得する
 * @summary Get partner
 */
export const getApiV1ThreeLetterCodeInternalAdminsPartnersId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsPartnersIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsPartnersIdResponse>(getGetApiV1ThreeLetterCodeInternalAdminsPartnersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsPartnersIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${id}`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsPartnersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersId>>>

/**
 * @summary Get partner
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsPartnersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsPartnersId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsPartnersIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsPartnersId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersIdResponse401 = {
  data: Errors
  status: 401
}

;
export type patchApiV1ThreeLetterCodeInternalAdminsPartnersIdResponseError = (patchApiV1ThreeLetterCodeInternalAdminsPartnersIdResponse401) & {
  headers: Headers;
};

export type patchApiV1ThreeLetterCodeInternalAdminsPartnersIdResponse = (patchApiV1ThreeLetterCodeInternalAdminsPartnersIdResponseError)

export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/partners/${id}`
}

/**
 * パートナー情報を更新する
 * @summary Update Partner
 */
export const patchApiV1ThreeLetterCodeInternalAdminsPartnersId = async (threeLetterCode: string,
    id: number,
    patchApiV1ThreeLetterCodeInternalAdminsPartnersIdBody?: PatchApiV1ThreeLetterCodeInternalAdminsPartnersIdBody, options?: RequestInit): Promise<patchApiV1ThreeLetterCodeInternalAdminsPartnersIdResponse> => {

  return customInstance<patchApiV1ThreeLetterCodeInternalAdminsPartnersIdResponse>(getPatchApiV1ThreeLetterCodeInternalAdminsPartnersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchApiV1ThreeLetterCodeInternalAdminsPartnersIdBody)
  }
);}




export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PatchApiV1ThreeLetterCodeInternalAdminsPartnersIdBody | undefined }) => {
    return patchApiV1ThreeLetterCodeInternalAdminsPartnersId(threeLetterCode, id, arg, options);
  }
}
export const getPatchApiV1ThreeLetterCodeInternalAdminsPartnersIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/partners/${id}`] as const;

export type PatchApiV1ThreeLetterCodeInternalAdminsPartnersIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersId>>>

/**
 * @summary Update Partner
 */
export const usePatchApiV1ThreeLetterCodeInternalAdminsPartnersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersId>>, TError, Key, PatchApiV1ThreeLetterCodeInternalAdminsPartnersIdBody | undefined, Awaited<ReturnType<typeof patchApiV1ThreeLetterCodeInternalAdminsPartnersId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchApiV1ThreeLetterCodeInternalAdminsPartnersIdMutationKey(threeLetterCode,id);
  const swrFn = getPatchApiV1ThreeLetterCodeInternalAdminsPartnersIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponseError = (getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse = (getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesUrl = (threeLetterCode: string,
    serviceId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/services/${serviceId}/partner_restrict_services`
}

/**
 * @summary List partner restrict services
 */
export const getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices = async (threeLetterCode: string,
    serviceId: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse>(getGetApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesUrl(threeLetterCode,serviceId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesKey = (threeLetterCode: string,
    serviceId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/services/${serviceId}/partner_restrict_services`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices>>>

/**
 * @summary List partner restrict services
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices = <TError = Errors>(
  threeLetterCode: string,
    serviceId: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && serviceId !== null && serviceId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesKey(threeLetterCode,serviceId) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices(threeLetterCode,serviceId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponseError = (postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse400 | postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse401 | postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse = (postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesUrl = (threeLetterCode: string,
    serviceId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/services/${serviceId}/partner_restrict_services`
}

/**
 * @summary Create partner restrict services
 */
export const postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices = async (threeLetterCode: string,
    serviceId: number,
    postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesBody?: PostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesResponse>(getPostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesUrl(threeLetterCode,serviceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesMutationFetcher = (threeLetterCode: string,
    serviceId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices(threeLetterCode, serviceId, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesMutationKey = (threeLetterCode: string,
    serviceId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/services/${serviceId}/partner_restrict_services`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices>>>

/**
 * @summary Create partner restrict services
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices = <TError = Errors>(
  threeLetterCode: string,
    serviceId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServices>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesMutationKey(threeLetterCode,serviceId);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesMutationFetcher(threeLetterCode,serviceId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdResponseSuccess = (deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdResponseError = (deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdResponse = (deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdResponseSuccess | deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdResponseError)

export const getDeleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdUrl = (threeLetterCode: string,
    serviceId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/services/${serviceId}/partner_restrict_services/${id}`
}

/**
 * @summary Destroy partner restrict service
 */
export const deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesId = async (threeLetterCode: string,
    serviceId: number,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdResponse>(getDeleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdUrl(threeLetterCode,serviceId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdMutationFetcher = (threeLetterCode: string,
    serviceId: number,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesId(threeLetterCode, serviceId, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdMutationKey = (threeLetterCode: string,
    serviceId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/services/${serviceId}/partner_restrict_services/${id}`] as const;

export type DeleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesId>>>

/**
 * @summary Destroy partner restrict service
 */
export const useDeleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesId = <TError = Errors>(
  threeLetterCode: string,
    serviceId: number,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdMutationKey(threeLetterCode,serviceId,id);
  const swrFn = getDeleteApiV1ThreeLetterCodeInternalAdminsServicesServiceIdPartnerRestrictServicesIdMutationFetcher(threeLetterCode,serviceId,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsServicesResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsServices200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsServicesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsServicesResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsServicesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsServicesResponseError = (getApiV1ThreeLetterCodeInternalAdminsServicesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsServicesResponse = (getApiV1ThreeLetterCodeInternalAdminsServicesResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsServicesResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsServicesUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsServicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/internal_admins/services?${stringifiedParams}` : `/api/v1/${threeLetterCode}/internal_admins/services`
}

/**
 * 福利厚生サービスの一覧を取得する
 * @summary Get services
 */
export const getApiV1ThreeLetterCodeInternalAdminsServices = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsServicesParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsServicesResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsServicesResponse>(getGetApiV1ThreeLetterCodeInternalAdminsServicesUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsServicesKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsServicesParams,) => [`/api/v1/${threeLetterCode}/internal_admins/services`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsServicesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsServices>>>

/**
 * @summary Get services
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsServices = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsServicesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsServices>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsServicesKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsServices(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsServicesResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsServices201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsServicesResponse422 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsServices422
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsServicesResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsServicesResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsServicesResponseError = (postApiV1ThreeLetterCodeInternalAdminsServicesResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsServicesResponse = (postApiV1ThreeLetterCodeInternalAdminsServicesResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsServicesResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsServicesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/services`
}

/**
 * 福利厚生サービスをサービスメニュー付きで新規作成する
 * @summary Create service with service menus
 */
export const postApiV1ThreeLetterCodeInternalAdminsServices = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeInternalAdminsServicesBody?: PostApiV1ThreeLetterCodeInternalAdminsServicesBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsServicesResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsServicesResponse>(getPostApiV1ThreeLetterCodeInternalAdminsServicesUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsServicesBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsServicesMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsServicesBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsServices(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsServicesMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/services`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsServicesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsServices>>>

/**
 * @summary Create service with service menus
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsServices = <TError = PostApiV1ThreeLetterCodeInternalAdminsServices422>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsServices>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsServicesBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsServices>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsServicesMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsServicesMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsServicesIdResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsServicesId200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsServicesIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsServicesIdResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsServicesIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsServicesIdResponseError = (getApiV1ThreeLetterCodeInternalAdminsServicesIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsServicesIdResponse = (getApiV1ThreeLetterCodeInternalAdminsServicesIdResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsServicesIdResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsServicesIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/services/${id}`
}

/**
 * 福利厚生サービスの詳細を取得する
 * @summary Get service
 */
export const getApiV1ThreeLetterCodeInternalAdminsServicesId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsServicesIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsServicesIdResponse>(getGetApiV1ThreeLetterCodeInternalAdminsServicesIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsServicesIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/services/${id}`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsServicesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsServicesId>>>

/**
 * @summary Get service
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsServicesId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsServicesId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsServicesIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsServicesId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeInternalAdminsServicesIdResponse200 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsServicesId200
  status: 200
}

export type putApiV1ThreeLetterCodeInternalAdminsServicesIdResponse422 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsServicesId422
  status: 422
}

export type putApiV1ThreeLetterCodeInternalAdminsServicesIdResponseSuccess = (putApiV1ThreeLetterCodeInternalAdminsServicesIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeInternalAdminsServicesIdResponseError = (putApiV1ThreeLetterCodeInternalAdminsServicesIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeInternalAdminsServicesIdResponse = (putApiV1ThreeLetterCodeInternalAdminsServicesIdResponseSuccess | putApiV1ThreeLetterCodeInternalAdminsServicesIdResponseError)

export const getPutApiV1ThreeLetterCodeInternalAdminsServicesIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/services/${id}`
}

/**
 * 福利厚生サービスをサービスメニュー付きで更新する（メニュー削除時は_destroy: 1、更新時はid指定）
 * @summary Update service with service menus
 */
export const putApiV1ThreeLetterCodeInternalAdminsServicesId = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodeInternalAdminsServicesIdBody?: PutApiV1ThreeLetterCodeInternalAdminsServicesIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeInternalAdminsServicesIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeInternalAdminsServicesIdResponse>(getPutApiV1ThreeLetterCodeInternalAdminsServicesIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeInternalAdminsServicesIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeInternalAdminsServicesIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeInternalAdminsServicesIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeInternalAdminsServicesId(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeInternalAdminsServicesIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/services/${id}`] as const;

export type PutApiV1ThreeLetterCodeInternalAdminsServicesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsServicesId>>>

/**
 * @summary Update service with service menus
 */
export const usePutApiV1ThreeLetterCodeInternalAdminsServicesId = <TError = PutApiV1ThreeLetterCodeInternalAdminsServicesId422>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsServicesId>>, TError, Key, PutApiV1ThreeLetterCodeInternalAdminsServicesIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsServicesId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeInternalAdminsServicesIdMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodeInternalAdminsServicesIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1InternalAdminsSignInResponse200 = {
  data: PostApiV1InternalAdminsSignIn200
  status: 200
}

export type postApiV1InternalAdminsSignInResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1InternalAdminsSignInResponseSuccess = (postApiV1InternalAdminsSignInResponse200) & {
  headers: Headers;
};
export type postApiV1InternalAdminsSignInResponseError = (postApiV1InternalAdminsSignInResponse401) & {
  headers: Headers;
};

export type postApiV1InternalAdminsSignInResponse = (postApiV1InternalAdminsSignInResponseSuccess | postApiV1InternalAdminsSignInResponseError)

export const getPostApiV1InternalAdminsSignInUrl = () => {




  return `/api/v1/internal_admins/sign_in`
}

/**
 * 内部管理者のメールアドレスとパスワードで認証し、JWTトークンを取得する
 * @summary Get JWT
 */
export const postApiV1InternalAdminsSignIn = async (postApiV1InternalAdminsSignInBody?: PostApiV1InternalAdminsSignInBody, options?: RequestInit): Promise<postApiV1InternalAdminsSignInResponse> => {

  return customInstance<postApiV1InternalAdminsSignInResponse>(getPostApiV1InternalAdminsSignInUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1InternalAdminsSignInBody)
  }
);}




export const getPostApiV1InternalAdminsSignInMutationFetcher = ( options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1InternalAdminsSignInBody | undefined }) => {
    return postApiV1InternalAdminsSignIn(arg, options);
  }
}
export const getPostApiV1InternalAdminsSignInMutationKey = () => [`/api/v1/internal_admins/sign_in`] as const;

export type PostApiV1InternalAdminsSignInMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1InternalAdminsSignIn>>>

/**
 * @summary Get JWT
 */
export const usePostApiV1InternalAdminsSignIn = <TError = Errors>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1InternalAdminsSignIn>>, TError, Key, PostApiV1InternalAdminsSignInBody | undefined, Awaited<ReturnType<typeof postApiV1InternalAdminsSignIn>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1InternalAdminsSignInMutationKey();
  const swrFn = getPostApiV1InternalAdminsSignInMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1InternalAdminsSignOutResponse401 = {
  data: void
  status: 401
}

;
export type deleteApiV1InternalAdminsSignOutResponseError = (deleteApiV1InternalAdminsSignOutResponse401) & {
  headers: Headers;
};

export type deleteApiV1InternalAdminsSignOutResponse = (deleteApiV1InternalAdminsSignOutResponseError)

export const getDeleteApiV1InternalAdminsSignOutUrl = () => {




  return `/api/v1/internal_admins/sign_out`
}

/**
 * 内部管理者のセッションを無効化してログアウトする
 * @summary Sign out
 */
export const deleteApiV1InternalAdminsSignOut = async ( options?: RequestInit): Promise<deleteApiV1InternalAdminsSignOutResponse> => {

  return customInstance<deleteApiV1InternalAdminsSignOutResponse>(getDeleteApiV1InternalAdminsSignOutUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1InternalAdminsSignOutMutationFetcher = ( options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1InternalAdminsSignOut(options);
  }
}
export const getDeleteApiV1InternalAdminsSignOutMutationKey = () => [`/api/v1/internal_admins/sign_out`] as const;

export type DeleteApiV1InternalAdminsSignOutMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1InternalAdminsSignOut>>>

/**
 * @summary Sign out
 */
export const useDeleteApiV1InternalAdminsSignOut = <TError = void>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1InternalAdminsSignOut>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1InternalAdminsSignOut>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1InternalAdminsSignOutMutationKey();
  const swrFn = getDeleteApiV1InternalAdminsSignOutMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistration201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponseError = (postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponse400 | postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponse401 | postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponse = (postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/stores/bulk_registration`
}

/**
 * CSVファイル（サービスID / サービス名 / 店舗名 / 住所 / 緯度 / 経度 / ステータス）で店舗を一括登録する
 * @summary Create stores in bulk
 */
export const postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistration = async (threeLetterCode: string,
    requestInternalAdminsStoresBulkRegistrationCsvFile: RequestInternalAdminsStoresBulkRegistrationCsvFile, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponse> => {
    const formData = new FormData();
formData.append(`file`, requestInternalAdminsStoresBulkRegistrationCsvFile.file);

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationResponse>(getPostApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationUrl(threeLetterCode),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestInternalAdminsStoresBulkRegistrationCsvFile }) => {
    return postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistration(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/stores/bulk_registration`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistration>>>

/**
 * @summary Create stores in bulk
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistration = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistration>>, TError, Key, RequestInternalAdminsStoresBulkRegistrationCsvFile, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistration>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsStoresBulkRegistrationMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateResponse200 = {
  data: Blob
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateResponseError = (getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateResponse = (getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/internal_admins/stores/csv_template?${stringifiedParams}` : `/api/v1/${threeLetterCode}/internal_admins/stores/csv_template`
}

/**
 * 店舗一括登録用のCSVテンプレートをダウンロードする。
 * ヘッダー行に加え、記入例となるサンプル行を含む。
 * encoding パラメータで UTF-8（既定）か Windows-31J かを切り替えられる。
 * @summary Download stores bulk creation CSV template
 */
export const getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplate = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateResponse>(getGetApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateParams,) => [`/api/v1/${threeLetterCode}/internal_admins/stores/csv_template`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplate>>>

/**
 * @summary Download stores bulk creation CSV template
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplate = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplate>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplateKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsStoresCsvTemplate(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreation201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationResponseError = (postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationResponse400 | postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationResponse = (postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationUrl = (threeLetterCode: string,
    serviceId: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/services/${serviceId}/stores_bulk_creation`
}

/**
 * CSVファイルで店舗を一括登録する
 * @summary Create stores in bulk
 */
export const postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreation = async (threeLetterCode: string,
    serviceId: number,
    requestInternalAdminsStoresBulkCreationCsvFile: RequestInternalAdminsStoresBulkCreationCsvFile, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationResponse> => {
    const formData = new FormData();
formData.append(`file`, requestInternalAdminsStoresBulkCreationCsvFile.file);

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationResponse>(getPostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationUrl(threeLetterCode,serviceId),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationMutationFetcher = (threeLetterCode: string,
    serviceId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestInternalAdminsStoresBulkCreationCsvFile }) => {
    return postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreation(threeLetterCode, serviceId, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationMutationKey = (threeLetterCode: string,
    serviceId: number,) => [`/api/v1/${threeLetterCode}/internal_admins/services/${serviceId}/stores_bulk_creation`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreation>>>

/**
 * @summary Create stores in bulk
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreation = <TError = Errors>(
  threeLetterCode: string,
    serviceId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreation>>, TError, Key, RequestInternalAdminsStoresBulkCreationCsvFile, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreation>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationMutationKey(threeLetterCode,serviceId);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsServicesServiceIdStoresBulkCreationMutationFetcher(threeLetterCode,serviceId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsStoresResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsStores200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsStoresResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodeInternalAdminsStoresResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsStoresResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsStoresResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsStoresResponseError = (getApiV1ThreeLetterCodeInternalAdminsStoresResponse400 | getApiV1ThreeLetterCodeInternalAdminsStoresResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsStoresResponse = (getApiV1ThreeLetterCodeInternalAdminsStoresResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsStoresResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsStoresUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsStoresParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/internal_admins/stores?${stringifiedParams}` : `/api/v1/${threeLetterCode}/internal_admins/stores`
}

/**
 * 店舗の一覧を取得する
 * @summary Get stores
 */
export const getApiV1ThreeLetterCodeInternalAdminsStores = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsStoresParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsStoresResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsStoresResponse>(getGetApiV1ThreeLetterCodeInternalAdminsStoresUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsStoresKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsStoresParams,) => [`/api/v1/${threeLetterCode}/internal_admins/stores`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsStoresQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsStores>>>

/**
 * @summary Get stores
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsStores = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodeInternalAdminsStoresParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsStores>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsStoresKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsStores(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsStoresResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsStores201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsStoresResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsStoresResponse422 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsStores422
  status: 422
}

export type postApiV1ThreeLetterCodeInternalAdminsStoresResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsStoresResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsStoresResponseError = (postApiV1ThreeLetterCodeInternalAdminsStoresResponse401 | postApiV1ThreeLetterCodeInternalAdminsStoresResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsStoresResponse = (postApiV1ThreeLetterCodeInternalAdminsStoresResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsStoresResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsStoresUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/stores`
}

/**
 * 店舗を新規作成する
 * @summary Create store
 */
export const postApiV1ThreeLetterCodeInternalAdminsStores = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeInternalAdminsStoresBody?: PostApiV1ThreeLetterCodeInternalAdminsStoresBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsStoresResponse> => {

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsStoresResponse>(getPostApiV1ThreeLetterCodeInternalAdminsStoresUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeInternalAdminsStoresBody)
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsStoresMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeInternalAdminsStoresBody | undefined }) => {
    return postApiV1ThreeLetterCodeInternalAdminsStores(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsStoresMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/stores`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsStoresMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsStores>>>

/**
 * @summary Create store
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsStores = <TError = Errors | PostApiV1ThreeLetterCodeInternalAdminsStores422>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsStores>>, TError, Key, PostApiV1ThreeLetterCodeInternalAdminsStoresBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsStores>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsStoresMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsStoresMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeInternalAdminsStoresIdResponse200 = {
  data: GetApiV1ThreeLetterCodeInternalAdminsStoresId200
  status: 200
}

export type getApiV1ThreeLetterCodeInternalAdminsStoresIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeInternalAdminsStoresIdResponseSuccess = (getApiV1ThreeLetterCodeInternalAdminsStoresIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeInternalAdminsStoresIdResponseError = (getApiV1ThreeLetterCodeInternalAdminsStoresIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeInternalAdminsStoresIdResponse = (getApiV1ThreeLetterCodeInternalAdminsStoresIdResponseSuccess | getApiV1ThreeLetterCodeInternalAdminsStoresIdResponseError)

export const getGetApiV1ThreeLetterCodeInternalAdminsStoresIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/stores/${id}`
}

/**
 * 店舗の詳細を取得する
 * @summary Get store
 */
export const getApiV1ThreeLetterCodeInternalAdminsStoresId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodeInternalAdminsStoresIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodeInternalAdminsStoresIdResponse>(getGetApiV1ThreeLetterCodeInternalAdminsStoresIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeInternalAdminsStoresIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/stores/${id}`] as const;

export type GetApiV1ThreeLetterCodeInternalAdminsStoresIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsStoresId>>>

/**
 * @summary Get store
 */
export const useGetApiV1ThreeLetterCodeInternalAdminsStoresId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeInternalAdminsStoresId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeInternalAdminsStoresIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodeInternalAdminsStoresId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodeInternalAdminsStoresIdResponse200 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsStoresId200
  status: 200
}

export type putApiV1ThreeLetterCodeInternalAdminsStoresIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodeInternalAdminsStoresIdResponse422 = {
  data: PutApiV1ThreeLetterCodeInternalAdminsStoresId422
  status: 422
}

export type putApiV1ThreeLetterCodeInternalAdminsStoresIdResponseSuccess = (putApiV1ThreeLetterCodeInternalAdminsStoresIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodeInternalAdminsStoresIdResponseError = (putApiV1ThreeLetterCodeInternalAdminsStoresIdResponse401 | putApiV1ThreeLetterCodeInternalAdminsStoresIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodeInternalAdminsStoresIdResponse = (putApiV1ThreeLetterCodeInternalAdminsStoresIdResponseSuccess | putApiV1ThreeLetterCodeInternalAdminsStoresIdResponseError)

export const getPutApiV1ThreeLetterCodeInternalAdminsStoresIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/stores/${id}`
}

/**
 * 店舗情報を更新する
 * @summary Update store
 */
export const putApiV1ThreeLetterCodeInternalAdminsStoresId = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodeInternalAdminsStoresIdBody?: PutApiV1ThreeLetterCodeInternalAdminsStoresIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodeInternalAdminsStoresIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodeInternalAdminsStoresIdResponse>(getPutApiV1ThreeLetterCodeInternalAdminsStoresIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodeInternalAdminsStoresIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodeInternalAdminsStoresIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodeInternalAdminsStoresIdBody | undefined }) => {
    return putApiV1ThreeLetterCodeInternalAdminsStoresId(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodeInternalAdminsStoresIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/internal_admins/stores/${id}`] as const;

export type PutApiV1ThreeLetterCodeInternalAdminsStoresIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsStoresId>>>

/**
 * @summary Update store
 */
export const usePutApiV1ThreeLetterCodeInternalAdminsStoresId = <TError = Errors | PutApiV1ThreeLetterCodeInternalAdminsStoresId422>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsStoresId>>, TError, Key, PutApiV1ThreeLetterCodeInternalAdminsStoresIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodeInternalAdminsStoresId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodeInternalAdminsStoresIdMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodeInternalAdminsStoresIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponse201 = {
  data: PostApiV1ThreeLetterCodeInternalAdminsUsersBulkCreations201
  status: 201
}

export type postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponseSuccess = (postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponseError = (postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponse400 | postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponse401 | postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponse404) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponse = (postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponseSuccess | postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponseError)

export const getPostApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/internal_admins/users/bulk_creations`
}

/**
 * CSVファイルでユーザーを一括登録する
 * @summary users bulk creations
 */
export const postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreations = async (threeLetterCode: string,
    requestInternalAdminsUsersBulkCreation: RequestInternalAdminsUsersBulkCreation, options?: RequestInit): Promise<postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponse> => {
    const formData = new FormData();
formData.append(`file`, requestInternalAdminsUsersBulkCreation.file);

formData.append(`client_id`, requestInternalAdminsUsersBulkCreation.client_id.toString())

formData.append(`selected_option`, requestInternalAdminsUsersBulkCreation.selected_option);

if(requestInternalAdminsUsersBulkCreation.scheduled_date !== undefined && requestInternalAdminsUsersBulkCreation.scheduled_date !== null) {
 formData.append(`scheduled_date`, requestInternalAdminsUsersBulkCreation.scheduled_date);
 }

if(requestInternalAdminsUsersBulkCreation.scheduled_hour !== undefined && requestInternalAdminsUsersBulkCreation.scheduled_hour !== null) {
 formData.append(`scheduled_hour`, requestInternalAdminsUsersBulkCreation.scheduled_hour);
 }

  return customInstance<postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsResponse>(getPostApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getPostApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: RequestInternalAdminsUsersBulkCreation }) => {
    return postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreations(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/internal_admins/users/bulk_creations`] as const;

export type PostApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreations>>>

/**
 * @summary users bulk creations
 */
export const usePostApiV1ThreeLetterCodeInternalAdminsUsersBulkCreations = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreations>>, TError, Key, RequestInternalAdminsUsersBulkCreation, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeInternalAdminsUsersBulkCreations>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeInternalAdminsUsersBulkCreationsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsApplicationConfiguration200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationResponseError = (getApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationResponse = (getApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/application_configuration`
}

/**
 * パートナーのアプリケーション設定を取得する
 * @summary Get application_configurations
 */
export const getApiV1ThreeLetterCodePartnerAdminsApplicationConfiguration = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationResponse>(getGetApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/partner_admins/application_configuration`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsApplicationConfiguration>>>

/**
 * @summary Get application_configurations
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsApplicationConfiguration = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsApplicationConfiguration>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsApplicationConfigurationKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsApplicationConfiguration(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponse200ApplicationJson = {
  data: GetApiV1ThreeLetterCodePartnerAdminsBankAccounts200One
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponse200TextCsv = {
  data: Blob
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponse200ApplicationJson | getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponse200TextCsv) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponseError = (getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponse400 | getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponse401 | getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponse403) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponse = (getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsBankAccountsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsBankAccountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["user_ids[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/bank_accounts?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/bank_accounts`
}

/**
 * 自パートナー配下の口座連携済みユーザーの口座情報一覧を取得する（JSON/CSV対応）。連携日時（linked_at）の降順でソートされる（新しい連携が先頭）。JSON はページネーション対応。CSV は全件を一括出力する。
 * @summary Get linked bank accounts
 */
export const getApiV1ThreeLetterCodePartnerAdminsBankAccounts = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsBankAccountsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsBankAccountsResponse>(getGetApiV1ThreeLetterCodePartnerAdminsBankAccountsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsBankAccountsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsBankAccountsParams,) => [`/api/v1/${threeLetterCode}/partner_admins/bank_accounts`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsBankAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsBankAccounts>>>

/**
 * @summary Get linked bank accounts
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsBankAccounts = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsBankAccountsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsBankAccounts>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsBankAccountsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsBankAccounts(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsCategoriesResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsCategories200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsCategoriesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsCategoriesResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsCategoriesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsCategoriesResponseError = (getApiV1ThreeLetterCodePartnerAdminsCategoriesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsCategoriesResponse = (getApiV1ThreeLetterCodePartnerAdminsCategoriesResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsCategoriesResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsCategoriesUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsCategoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/categories?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/categories`
}

/**
 * パートナーに紐づくカテゴリ一覧を取得する
 * @summary Get categories
 */
export const getApiV1ThreeLetterCodePartnerAdminsCategories = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsCategoriesParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsCategoriesResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsCategoriesResponse>(getGetApiV1ThreeLetterCodePartnerAdminsCategoriesUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsCategoriesKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsCategoriesParams,) => [`/api/v1/${threeLetterCode}/partner_admins/categories`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsCategories>>>

/**
 * @summary Get categories
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsCategories = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsCategoriesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsCategories>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsCategoriesKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsCategories(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsClientAdminUsers200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponseError = (getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse = (getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/client_admin_users?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/client_admin_users`
}

/**
 * 企業管理者ユーザーの一覧を取得する
 * @summary Get client_admin_users
 */
export const getApiV1ThreeLetterCodePartnerAdminsClientAdminUsers = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse>(getGetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersParams,) => [`/api/v1/${threeLetterCode}/partner_admins/client_admin_users`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientAdminUsers>>>

/**
 * @summary Get client_admin_users
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsClientAdminUsers = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientAdminUsers>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsClientAdminUsers(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse201 = {
  data: PostApiV1ThreeLetterCodePartnerAdminsClientAdminUsers201
  status: 201
}

export type postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponseSuccess = (postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponseError = (postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse401 | postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse = (postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponseSuccess | postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponseError)

export const getPostApiV1ThreeLetterCodePartnerAdminsClientAdminUsersUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/client_admin_users`
}

/**
 * 企業管理者ユーザーを新規作成する
 * @summary Create ClientAdminUser
 */
export const postApiV1ThreeLetterCodePartnerAdminsClientAdminUsers = async (threeLetterCode: string,
    postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersBody?: PostApiV1ThreeLetterCodePartnerAdminsClientAdminUsersBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse> => {

  return customInstance<postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersResponse>(getPostApiV1ThreeLetterCodePartnerAdminsClientAdminUsersUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodePartnerAdminsClientAdminUsersBody)
  }
);}




export const getPostApiV1ThreeLetterCodePartnerAdminsClientAdminUsersMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodePartnerAdminsClientAdminUsersBody | undefined }) => {
    return postApiV1ThreeLetterCodePartnerAdminsClientAdminUsers(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodePartnerAdminsClientAdminUsersMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/partner_admins/client_admin_users`] as const;

export type PostApiV1ThreeLetterCodePartnerAdminsClientAdminUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsClientAdminUsers>>>

/**
 * @summary Create ClientAdminUser
 */
export const usePostApiV1ThreeLetterCodePartnerAdminsClientAdminUsers = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsClientAdminUsers>>, TError, Key, PostApiV1ThreeLetterCodePartnerAdminsClientAdminUsersBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsClientAdminUsers>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodePartnerAdminsClientAdminUsersMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodePartnerAdminsClientAdminUsersMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponseError = (getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse = (getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/client_admin_users/${id}`
}

/**
 * 企業管理者ユーザーの詳細を取得する
 * @summary Get client_admin_user
 */
export const getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse>(getGetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/client_admin_users/${id}`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId>>>

/**
 * @summary Get client_admin_user
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse200 = {
  data: PutApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId200
  status: 200
}

export type putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponseSuccess = (putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponseError = (putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse401 | putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse = (putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponseSuccess | putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponseError)

export const getPutApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/client_admin_users/${id}`
}

/**
 * 企業管理者ユーザーの情報を更新する
 * @summary Update client_admin_user
 */
export const putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdBody?: PutApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse>(getPutApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdBody | undefined }) => {
    return putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/client_admin_users/${id}`] as const;

export type PutApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId>>>

/**
 * @summary Update client_admin_user
 */
export const usePutApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId>>, TError, Key, PutApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponseSuccess = (deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponseError = (deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse = (deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponseSuccess | deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponseError)

export const getDeleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/client_admin_users/${id}`
}

/**
 * 企業管理者ユーザーを削除する
 * @summary Delete client_admin_user
 */
export const deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdResponse>(getDeleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/client_admin_users/${id}`] as const;

export type DeleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId>>>

/**
 * @summary Delete client_admin_user
 */
export const useDeleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodePartnerAdminsClientAdminUsersIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsClientContractsResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsClientContracts200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsClientContractsResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodePartnerAdminsClientContractsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsClientContractsResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsClientContractsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsClientContractsResponseError = (getApiV1ThreeLetterCodePartnerAdminsClientContractsResponse400 | getApiV1ThreeLetterCodePartnerAdminsClientContractsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsClientContractsResponse = (getApiV1ThreeLetterCodePartnerAdminsClientContractsResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsClientContractsResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsClientContractsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientContractsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/client_contracts?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/client_contracts`
}

/**
 * 自パートナー配下の全クライアント企業の契約期間一覧を取得する。利用企業名・契約プラン名で部分一致検索でき、ページネーションヘッダー（Total-Count, Total-Pages 等）を返却する。契約プラン情報に内部金額情報（パートナー販売手数料・Leafea収益単価）は含まれない
 * @summary List client contracts across clients
 */
export const getApiV1ThreeLetterCodePartnerAdminsClientContracts = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientContractsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsClientContractsResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsClientContractsResponse>(getGetApiV1ThreeLetterCodePartnerAdminsClientContractsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsClientContractsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientContractsParams,) => [`/api/v1/${threeLetterCode}/partner_admins/client_contracts`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsClientContractsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientContracts>>>

/**
 * @summary List client contracts across clients
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsClientContracts = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientContractsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientContracts>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsClientContractsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsClientContracts(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsResponseError = (getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsResponse = (getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/client_feature_flags`
}

/**
 * 導入企業に設定可能な機能フラグキーの一覧を取得する
 * @summary Get client feature flag keys
 */
export const getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsResponse>(getGetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/partner_admins/client_feature_flags`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags>>>

/**
 * @summary Get client feature flag keys
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportResponse200 = {
  data: Blob
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportResponseError = (getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportResponse = (getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportUrl = (threeLetterCode: string,
    clientId: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/activation_code_export`
}

/**
 * 未使用のアクティベーションコードをCSVでダウンロードする
 * @summary Download unused activation codes as CSV
 */
export const getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExport = async (threeLetterCode: string,
    clientId: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportResponse>(getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportUrl(threeLetterCode,clientId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportKey = (threeLetterCode: string,
    clientId: number,) => [`/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/activation_code_export`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExport>>>

/**
 * @summary Download unused activation codes as CSV
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExport = <TError = Errors>(
  threeLetterCode: string,
    clientId: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExport>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && clientId !== null && clientId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExportKey(threeLetterCode,clientId) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsClientsClientIdActivationCodeExport(threeLetterCode,clientId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationResponse202 = {
  data: PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreation202
  status: 202
}

export type postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationResponseSuccess = (postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationResponse202) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationResponseError = (postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationResponse400 | postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationResponse = (postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationResponseSuccess | postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationResponseError)

export const getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationUrl = (threeLetterCode: string,
    clientId: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/bulk_activation_code_creation`
}

/**
 * アクティベーションコード付きのユーザーを一括作成する
 * @summary Bulk create users with activation codes
 */
export const postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreation = async (threeLetterCode: string,
    clientId: number,
    postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationBody?: PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationResponse> => {

  return customInstance<postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationResponse>(getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationUrl(threeLetterCode,clientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationBody)
  }
);}




export const getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationMutationFetcher = (threeLetterCode: string,
    clientId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationBody | undefined }) => {
    return postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreation(threeLetterCode, clientId, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationMutationKey = (threeLetterCode: string,
    clientId: number,) => [`/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/bulk_activation_code_creation`] as const;

export type PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreation>>>

/**
 * @summary Bulk create users with activation codes
 */
export const usePostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreation = <TError = Errors>(
  threeLetterCode: string,
    clientId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreation>>, TError, Key, PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreation>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationMutationKey(threeLetterCode,clientId);
  const swrFn = getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationMutationFetcher(threeLetterCode,clientId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponseError = (getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse401 | getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse = (getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsUrl = (threeLetterCode: string,
    clientId: number,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_contracts?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_contracts`
}

/**
 * 自パートナー配下のクライアント企業の契約期間一覧を取得する。契約プラン情報に内部金額情報（パートナー販売手数料・Leafea収益単価）は含まれない
 * @summary List client contracts
 */
export const getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts = async (threeLetterCode: string,
    clientId: number,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse>(getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsUrl(threeLetterCode,clientId,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsKey = (threeLetterCode: string,
    clientId: number,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsParams,) => [`/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_contracts`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts>>>

/**
 * @summary List client contracts
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts = <TError = Errors>(
  threeLetterCode: string,
    clientId: number,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && clientId !== null && clientId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsKey(threeLetterCode,clientId,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts(threeLetterCode,clientId,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse201 = {
  data: PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts201
  status: 201
}

export type postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse404 = {
  data: Errors
  status: 404
}

export type postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponseSuccess = (postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponseError = (postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse401 | postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse404 | postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse = (postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponseSuccess | postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponseError)

export const getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsUrl = (threeLetterCode: string,
    clientId: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_contracts`
}

/**
 * 自パートナー配下のクライアント企業に契約期間を作成する。同一企業で期間が重複する契約（有効契約2件目を含む）は作成できない
 * @summary Create client contract
 */
export const postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts = async (threeLetterCode: string,
    clientId: number,
    postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsBody?: PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse> => {

  return customInstance<postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsResponse>(getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsUrl(threeLetterCode,clientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsBody)
  }
);}




export const getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsMutationFetcher = (threeLetterCode: string,
    clientId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsBody | undefined }) => {
    return postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts(threeLetterCode, clientId, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsMutationKey = (threeLetterCode: string,
    clientId: number,) => [`/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_contracts`] as const;

export type PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts>>>

/**
 * @summary Create client contract
 */
export const usePostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts = <TError = Errors>(
  threeLetterCode: string,
    clientId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts>>, TError, Key, PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsMutationKey(threeLetterCode,clientId);
  const swrFn = getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsMutationFetcher(threeLetterCode,clientId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponseError = (getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse401 | getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse = (getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdUrl = (threeLetterCode: string,
    clientId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_contracts/${id}`
}

/**
 * 自パートナー配下のクライアント企業の契約期間を1件取得する。契約プラン情報に内部金額情報（パートナー販売手数料・Leafea収益単価）は含まれない
 * @summary Show client contract
 */
export const getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId = async (threeLetterCode: string,
    clientId: number,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse>(getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdUrl(threeLetterCode,clientId,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdKey = (threeLetterCode: string,
    clientId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_contracts/${id}`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId>>>

/**
 * @summary Show client contract
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId = <TError = Errors>(
  threeLetterCode: string,
    clientId: number,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && clientId !== null && clientId !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdKey(threeLetterCode,clientId,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId(threeLetterCode,clientId,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse200 = {
  data: PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId200
  status: 200
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse404 = {
  data: Errors
  status: 404
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponseSuccess = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponseError = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse401 | putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse404 | putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponseSuccess | putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponseError)

export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdUrl = (threeLetterCode: string,
    clientId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_contracts/${id}`
}

/**
 * 自パートナー配下のクライアント企業の契約期間（契約プラン・開始日・終了日）を修正する。期間重複・有効契約2件目・期間逆転は作成時と同様にエラーになる。契約開始後（開始日が当日以前）は契約プランと開始日を変更できず、終了日のみ変更できる。契約開始後の終了日は当日以降の日付のみ指定できる
 * @summary Update client contract
 */
export const putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId = async (threeLetterCode: string,
    clientId: number,
    id: number,
    putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdBody?: PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse>(getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdUrl(threeLetterCode,clientId,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdMutationFetcher = (threeLetterCode: string,
    clientId: number,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdBody | undefined }) => {
    return putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId(threeLetterCode, clientId, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdMutationKey = (threeLetterCode: string,
    clientId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_contracts/${id}`] as const;

export type PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId>>>

/**
 * @summary Update client contract
 */
export const usePutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId = <TError = Errors>(
  threeLetterCode: string,
    clientId: number,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId>>, TError, Key, PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdMutationKey(threeLetterCode,clientId,id);
  const swrFn = getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdMutationFetcher(threeLetterCode,clientId,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse404 = {
  data: Errors
  status: 404
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse422 = {
  data: Errors
  status: 422
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponseSuccess = (deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponseError = (deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse401 | deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse404 | deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse422) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse = (deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponseSuccess | deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponseError)

export const getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdUrl = (threeLetterCode: string,
    clientId: number,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_contracts/${id}`
}

/**
 * 自パートナー配下のクライアント企業の契約期間を削除する。削除できるのは契約開始前（契約開始日が未来）の契約期間のみ
 * @summary Delete client contract
 */
export const deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId = async (threeLetterCode: string,
    clientId: number,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdResponse>(getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdUrl(threeLetterCode,clientId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdMutationFetcher = (threeLetterCode: string,
    clientId: number,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId(threeLetterCode, clientId, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdMutationKey = (threeLetterCode: string,
    clientId: number,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_contracts/${id}`] as const;

export type DeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId>>>

/**
 * @summary Delete client contract
 */
export const useDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId = <TError = Errors>(
  threeLetterCode: string,
    clientId: number,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdMutationKey(threeLetterCode,clientId,id);
  const swrFn = getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdMutationFetcher(threeLetterCode,clientId,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse200 = {
  data: PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKey200
  status: 200
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse400 = {
  data: Errors
  status: 400
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseSuccess = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseError = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse400 | putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse401) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseSuccess | putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseError)

export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyUrl = (threeLetterCode: string,
    clientId: number,
    featureKey: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_feature_flags/${featureKey}`
}

/**
 * 導入企業の機能フラグを有効にする
 * @summary Enable a client feature flag
 */
export const putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKey = async (threeLetterCode: string,
    clientId: number,
    featureKey: string, options?: RequestInit): Promise<putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse> => {

  return customInstance<putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse>(getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyUrl(threeLetterCode,clientId,featureKey),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationFetcher = (threeLetterCode: string,
    clientId: number,
    featureKey: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKey(threeLetterCode, clientId, featureKey, options);
  }
}
export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationKey = (threeLetterCode: string,
    clientId: number,
    featureKey: string,) => [`/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_feature_flags/${featureKey}`] as const;

export type PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKey>>>

/**
 * @summary Enable a client feature flag
 */
export const usePutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKey = <TError = Errors>(
  threeLetterCode: string,
    clientId: number,
    featureKey: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKey>>, TError, Key, Arguments, Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKey>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationKey(threeLetterCode,clientId,featureKey);
  const swrFn = getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationFetcher(threeLetterCode,clientId,featureKey, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseSuccess = (deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseError = (deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse = (deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseSuccess | deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponseError)

export const getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyUrl = (threeLetterCode: string,
    clientId: number,
    featureKey: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_feature_flags/${featureKey}`
}

/**
 * 導入企業の機能フラグを無効にする
 * @summary Disable a client feature flag
 */
export const deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKey = async (threeLetterCode: string,
    clientId: number,
    featureKey: string, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyResponse>(getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyUrl(threeLetterCode,clientId,featureKey),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationFetcher = (threeLetterCode: string,
    clientId: number,
    featureKey: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKey(threeLetterCode, clientId, featureKey, options);
  }
}
export const getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationKey = (threeLetterCode: string,
    clientId: number,
    featureKey: string,) => [`/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/client_feature_flags/${featureKey}`] as const;

export type DeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKey>>>

/**
 * @summary Disable a client feature flag
 */
export const useDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKey = <TError = Errors>(
  threeLetterCode: string,
    clientId: number,
    featureKey: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKey>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKey>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationKey(threeLetterCode,clientId,featureKey);
  const swrFn = getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientFeatureFlagsFeatureKeyMutationFetcher(threeLetterCode,clientId,featureKey, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponse200 = {
  data: PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCredit200
  status: 200
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponse403 = {
  data: Errors
  status: 403
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponse409 = {
  data: Errors
  status: 409
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponseSuccess = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponseError = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponse401 | putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponse403 | putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponse409 | putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponse = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponseSuccess | putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponseError)

export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditUrl = (threeLetterCode: string,
    clientId: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/grant_credit`
}

/**
 * 導入企業への与信を実行する
 * @summary Grant credit to a client
 */
export const putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCredit = async (threeLetterCode: string,
    clientId: number, options?: RequestInit): Promise<putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponse> => {

  return customInstance<putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditResponse>(getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditUrl(threeLetterCode,clientId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditMutationFetcher = (threeLetterCode: string,
    clientId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCredit(threeLetterCode, clientId, options);
  }
}
export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditMutationKey = (threeLetterCode: string,
    clientId: number,) => [`/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/grant_credit`] as const;

export type PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCredit>>>

/**
 * @summary Grant credit to a client
 */
export const usePutApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCredit = <TError = Errors>(
  threeLetterCode: string,
    clientId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCredit>>, TError, Key, Arguments, Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCredit>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditMutationKey(threeLetterCode,clientId);
  const swrFn = getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditMutationFetcher(threeLetterCode,clientId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountResponse200 = {
  data: PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCount200
  status: 200
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountResponse404 = {
  data: Errors
  status: 404
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountResponseSuccess = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountResponseError = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountResponse401 | putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountResponse404) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountResponse = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountResponseSuccess | putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountResponseError)

export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountUrl = (threeLetterCode: string,
    clientId: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/user_slot_count`
}

/**
 * 導入企業のユーザー登録枠数を更新する
 * @summary Update
 */
export const putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCount = async (threeLetterCode: string,
    clientId: number,
    putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountBody?: PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountResponse> => {

  return customInstance<putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountResponse>(getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountUrl(threeLetterCode,clientId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountBody)
  }
);}




export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountMutationFetcher = (threeLetterCode: string,
    clientId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountBody | undefined }) => {
    return putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCount(threeLetterCode, clientId, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountMutationKey = (threeLetterCode: string,
    clientId: number,) => [`/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}/user_slot_count`] as const;

export type PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCount>>>

/**
 * @summary Update
 */
export const usePutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCount = <TError = Errors>(
  threeLetterCode: string,
    clientId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCount>>, TError, Key, PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCount>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountMutationKey(threeLetterCode,clientId);
  const swrFn = getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUserSlotCountMutationFetcher(threeLetterCode,clientId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsResponse200ApplicationJson = {
  data: GetApiV1ThreeLetterCodePartnerAdminsClients200One
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsResponse200TextCsv = {
  data: Blob
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsClientsResponse200ApplicationJson | getApiV1ThreeLetterCodePartnerAdminsClientsResponse200TextCsv) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsClientsResponseError = (getApiV1ThreeLetterCodePartnerAdminsClientsResponse400 | getApiV1ThreeLetterCodePartnerAdminsClientsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsClientsResponse = (getApiV1ThreeLetterCodePartnerAdminsClientsResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsClientsResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsClientsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/clients?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/clients`
}

/**
 * 導入企業一覧を取得する（JSON/CSV対応）。JSON ではページネーションヘッダー（Total-Count, Total-Pages 等）を返却する
 * @summary Get clients
 */
export const getApiV1ThreeLetterCodePartnerAdminsClients = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsClientsResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsClientsResponse>(getGetApiV1ThreeLetterCodePartnerAdminsClientsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsClientsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientsParams,) => [`/api/v1/${threeLetterCode}/partner_admins/clients`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsClientsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClients>>>

/**
 * @summary Get clients
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsClients = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsClientsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClients>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsClientsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsClients(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodePartnerAdminsClientsResponse201 = {
  data: PostApiV1ThreeLetterCodePartnerAdminsClients201
  status: 201
}

export type postApiV1ThreeLetterCodePartnerAdminsClientsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodePartnerAdminsClientsResponseSuccess = (postApiV1ThreeLetterCodePartnerAdminsClientsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodePartnerAdminsClientsResponseError = (postApiV1ThreeLetterCodePartnerAdminsClientsResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodePartnerAdminsClientsResponse = (postApiV1ThreeLetterCodePartnerAdminsClientsResponseSuccess | postApiV1ThreeLetterCodePartnerAdminsClientsResponseError)

export const getPostApiV1ThreeLetterCodePartnerAdminsClientsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/clients`
}

/**
 * 導入企業を新規作成する
 * @summary Create client
 */
export const postApiV1ThreeLetterCodePartnerAdminsClients = async (threeLetterCode: string,
    postApiV1ThreeLetterCodePartnerAdminsClientsBody?: PostApiV1ThreeLetterCodePartnerAdminsClientsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodePartnerAdminsClientsResponse> => {

  return customInstance<postApiV1ThreeLetterCodePartnerAdminsClientsResponse>(getPostApiV1ThreeLetterCodePartnerAdminsClientsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodePartnerAdminsClientsBody)
  }
);}




export const getPostApiV1ThreeLetterCodePartnerAdminsClientsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodePartnerAdminsClientsBody | undefined }) => {
    return postApiV1ThreeLetterCodePartnerAdminsClients(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodePartnerAdminsClientsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/partner_admins/clients`] as const;

export type PostApiV1ThreeLetterCodePartnerAdminsClientsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsClients>>>

/**
 * @summary Create client
 */
export const usePostApiV1ThreeLetterCodePartnerAdminsClients = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsClients>>, TError, Key, PostApiV1ThreeLetterCodePartnerAdminsClientsBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsClients>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodePartnerAdminsClientsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodePartnerAdminsClientsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse200) & {
  headers: Headers;
};
;

export type getApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse = (getApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponseSuccess)

export const getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdUrl = (threeLetterCode: string,
    clientId: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}`
}

/**
 * 導入企業の詳細を取得する
 * @summary Show client
 */
export const getApiV1ThreeLetterCodePartnerAdminsClientsClientId = async (threeLetterCode: string,
    clientId: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse>(getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdUrl(threeLetterCode,clientId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdKey = (threeLetterCode: string,
    clientId: string,) => [`/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientsClientId>>>

/**
 * @summary Show client
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsClientsClientId = <TError = unknown>(
  threeLetterCode: string,
    clientId: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsClientsClientId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && clientId !== null && clientId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdKey(threeLetterCode,clientId) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsClientsClientId(threeLetterCode,clientId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse200 = {
  data: PutApiV1ThreeLetterCodePartnerAdminsClientsClientId200
  status: 200
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse404 = {
  data: Errors
  status: 404
}

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponseSuccess = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponseError = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse404) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse = (putApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponseSuccess | putApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponseError)

export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUrl = (threeLetterCode: string,
    clientId: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}`
}

/**
 * 導入企業の情報を更新する
 * @summary Update client
 */
export const putApiV1ThreeLetterCodePartnerAdminsClientsClientId = async (threeLetterCode: string,
    clientId: string,
    putApiV1ThreeLetterCodePartnerAdminsClientsClientIdBody?: PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse>(getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdUrl(threeLetterCode,clientId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodePartnerAdminsClientsClientIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationFetcher = (threeLetterCode: string,
    clientId: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdBody | undefined }) => {
    return putApiV1ThreeLetterCodePartnerAdminsClientsClientId(threeLetterCode, clientId, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationKey = (threeLetterCode: string,
    clientId: string,) => [`/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}`] as const;

export type PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientId>>>

/**
 * @summary Update client
 */
export const usePutApiV1ThreeLetterCodePartnerAdminsClientsClientId = <TError = Errors>(
  threeLetterCode: string,
    clientId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientId>>, TError, Key, PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsClientsClientId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationKey(threeLetterCode,clientId);
  const swrFn = getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationFetcher(threeLetterCode,clientId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse400 = {
  data: Errors
  status: 400
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse404 = {
  data: Errors
  status: 404
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse422 = {
  data: Errors
  status: 422
}

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponseSuccess = (deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponseError = (deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse400 | deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse401 | deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse404 | deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse422) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse = (deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponseSuccess | deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponseError)

export const getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdUrl = (threeLetterCode: string,
    clientId: string,
    params: DeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}`
}

/**
 * 導入企業を削除（無効化）する。解約理由（reason）は必須。
 * @summary Delete client
 */
export const deleteApiV1ThreeLetterCodePartnerAdminsClientsClientId = async (threeLetterCode: string,
    clientId: string,
    params: DeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdParams, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdResponse>(getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdUrl(threeLetterCode,clientId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationFetcher = (threeLetterCode: string,
    clientId: string,
    params: DeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdParams, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodePartnerAdminsClientsClientId(threeLetterCode, clientId, params, options);
  }
}
export const getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationKey = (threeLetterCode: string,
    clientId: string,
    params: DeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdParams,) => [`/api/v1/${threeLetterCode}/partner_admins/clients/${clientId}`, ...(params ? [params]: [])] as const;

export type DeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsClientsClientId>>>

/**
 * @summary Delete client
 */
export const useDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientId = <TError = Errors>(
  threeLetterCode: string,
    clientId: string,
    params: DeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsClientsClientId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsClientsClientId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationKey(threeLetterCode,clientId,params);
  const swrFn = getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationFetcher(threeLetterCode,clientId,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsContractPlansResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsContractPlans200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsContractPlansResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodePartnerAdminsContractPlansResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsContractPlansResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsContractPlansResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsContractPlansResponseError = (getApiV1ThreeLetterCodePartnerAdminsContractPlansResponse400 | getApiV1ThreeLetterCodePartnerAdminsContractPlansResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsContractPlansResponse = (getApiV1ThreeLetterCodePartnerAdminsContractPlansResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsContractPlansResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsContractPlansUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsContractPlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/contract_plans?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/contract_plans`
}

/**
 * 契約プランの一覧を取得する。廃止済みプランは含めず、ページネーションヘッダー（Total-Count, Total-Pages 等）を返却する。パートナー販売手数料・Leafea収益単価などの内部金額情報は含まれない
 * @summary List contract plans
 */
export const getApiV1ThreeLetterCodePartnerAdminsContractPlans = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsContractPlansParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsContractPlansResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsContractPlansResponse>(getGetApiV1ThreeLetterCodePartnerAdminsContractPlansUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsContractPlansKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsContractPlansParams,) => [`/api/v1/${threeLetterCode}/partner_admins/contract_plans`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsContractPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsContractPlans>>>

/**
 * @summary List contract plans
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsContractPlans = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsContractPlansParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsContractPlans>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsContractPlansKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsContractPlans(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsContractPlansIdResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsContractPlansId200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsContractPlansIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsContractPlansIdResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodePartnerAdminsContractPlansIdResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsContractPlansIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsContractPlansIdResponseError = (getApiV1ThreeLetterCodePartnerAdminsContractPlansIdResponse401 | getApiV1ThreeLetterCodePartnerAdminsContractPlansIdResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsContractPlansIdResponse = (getApiV1ThreeLetterCodePartnerAdminsContractPlansIdResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsContractPlansIdResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsContractPlansIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/contract_plans/${id}`
}

/**
 * 契約プランの詳細を取得する。パートナー販売手数料・Leafea収益単価などの内部金額情報は含まれない
 * @summary Show contract plan
 */
export const getApiV1ThreeLetterCodePartnerAdminsContractPlansId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsContractPlansIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsContractPlansIdResponse>(getGetApiV1ThreeLetterCodePartnerAdminsContractPlansIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsContractPlansIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/contract_plans/${id}`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsContractPlansIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsContractPlansId>>>

/**
 * @summary Show contract plan
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsContractPlansId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsContractPlansId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsContractPlansIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsContractPlansId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponseError = (getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponse = (getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/custom_field_definitions?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/custom_field_definitions`
}

/**
 * カスタムフィールド定義の一覧を取得する
 * @summary Get custom field definitions
 */
export const getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponse>(getGetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsParams,) => [`/api/v1/${threeLetterCode}/partner_admins/custom_field_definitions`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions>>>

/**
 * @summary Get custom field definitions
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponse401 = {
  data: Errors
  status: 401
}

;
export type postApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponseError = (postApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponse = (postApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponseError)

export const getPostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsUrl = (threeLetterCode: string,
    params?: PostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/custom_field_definitions?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/custom_field_definitions`
}

/**
 * カスタムフィールド定義を新規作成する
 * @summary Create custom field definition
 */
export const postApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions = async (threeLetterCode: string,
    postApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsBody?: PostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsBody,
    params?: PostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsParams, options?: RequestInit): Promise<postApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponse> => {

  return customInstance<postApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsResponse>(getPostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsBody)
  }
);}




export const getPostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsMutationFetcher = (threeLetterCode: string,
    params?: PostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsParams, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsBody | undefined }) => {
    return postApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions(threeLetterCode, arg, params, options);
  }
}
export const getPostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsMutationKey = (threeLetterCode: string,
    params?: PostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsParams,) => [`/api/v1/${threeLetterCode}/partner_admins/custom_field_definitions`, ...(params ? [params]: [])] as const;

export type PostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions>>>

/**
 * @summary Create custom field definition
 */
export const usePostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions = <TError = Errors>(
  threeLetterCode: string,
    params?: PostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsParams, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions>>, TError, Key, PostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsMutationKey(threeLetterCode,params);
  const swrFn = getPostApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsMutationFetcher(threeLetterCode,params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponseError = (getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse = (getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/custom_field_definitions/${id}`
}

/**
 * カスタムフィールド定義の詳細を取得する
 * @summary Get custom field definition
 */
export const getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse>(getGetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/custom_field_definitions/${id}`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId>>>

/**
 * @summary Get custom field definition
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse401 = {
  data: Errors
  status: 401
}

;
export type putApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponseError = (putApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse401) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse = (putApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponseError)

export const getPutApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/custom_field_definitions/${id}`
}

/**
 * カスタムフィールド定義を更新する
 * @summary Update custom field definition
 */
export const putApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdBody?: PutApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse>(getPutApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdBody | undefined }) => {
    return putApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/custom_field_definitions/${id}`] as const;

export type PutApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId>>>

/**
 * @summary Update custom field definition
 */
export const usePutApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId>>, TError, Key, PutApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponseSuccess = (deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponseError = (deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse = (deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponseSuccess | deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponseError)

export const getDeleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/custom_field_definitions/${id}`
}

/**
 * カスタムフィールド定義を削除する
 * @summary Delete custom field definition
 */
export const deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdResponse>(getDeleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/custom_field_definitions/${id}`] as const;

export type DeleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId>>>

/**
 * @summary Delete custom field definition
 */
export const useDeleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsGiftPlansResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsGiftPlans200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsGiftPlansResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodePartnerAdminsGiftPlansResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsGiftPlansResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsGiftPlansResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsGiftPlansResponseError = (getApiV1ThreeLetterCodePartnerAdminsGiftPlansResponse400 | getApiV1ThreeLetterCodePartnerAdminsGiftPlansResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsGiftPlansResponse = (getApiV1ThreeLetterCodePartnerAdminsGiftPlansResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsGiftPlansResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsGiftPlansUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsGiftPlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/gift_plans?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/gift_plans`
}

/**
 * ギフトプランの一覧を取得する
 * @summary Get gift_plans
 */
export const getApiV1ThreeLetterCodePartnerAdminsGiftPlans = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsGiftPlansParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsGiftPlansResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsGiftPlansResponse>(getGetApiV1ThreeLetterCodePartnerAdminsGiftPlansUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsGiftPlansKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsGiftPlansParams,) => [`/api/v1/${threeLetterCode}/partner_admins/gift_plans`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsGiftPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsGiftPlans>>>

/**
 * @summary Get gift_plans
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsGiftPlans = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsGiftPlansParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsGiftPlans>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsGiftPlansKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsGiftPlans(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsGifteePlansResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsGifteePlans200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsGifteePlansResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsGifteePlansResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsGifteePlansResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsGifteePlansResponseError = (getApiV1ThreeLetterCodePartnerAdminsGifteePlansResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsGifteePlansResponse = (getApiV1ThreeLetterCodePartnerAdminsGifteePlansResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsGifteePlansResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsGifteePlansUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/giftee_plans`
}

/**
 * Gifteeプランの一覧を取得する
 * @summary Get giftee_plans
 */
export const getApiV1ThreeLetterCodePartnerAdminsGifteePlans = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsGifteePlansResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsGifteePlansResponse>(getGetApiV1ThreeLetterCodePartnerAdminsGifteePlansUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsGifteePlansKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/partner_admins/giftee_plans`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsGifteePlansQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsGifteePlans>>>

/**
 * @summary Get giftee_plans
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsGifteePlans = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsGifteePlans>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsGifteePlansKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsGifteePlans(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsGroupsResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsGroups200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsGroupsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsGroupsResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsGroupsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsGroupsResponseError = (getApiV1ThreeLetterCodePartnerAdminsGroupsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsGroupsResponse = (getApiV1ThreeLetterCodePartnerAdminsGroupsResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsGroupsResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsGroupsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/groups`
}

/**
 * グループの一覧を取得する
 * @summary Get groups
 */
export const getApiV1ThreeLetterCodePartnerAdminsGroups = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsGroupsResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsGroupsResponse>(getGetApiV1ThreeLetterCodePartnerAdminsGroupsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsGroupsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/partner_admins/groups`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsGroups>>>

/**
 * @summary Get groups
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsGroups = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsGroups>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsGroupsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsGroups(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodePartnerAdminsGroupsResponse201 = {
  data: PostApiV1ThreeLetterCodePartnerAdminsGroups201
  status: 201
}

export type postApiV1ThreeLetterCodePartnerAdminsGroupsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodePartnerAdminsGroupsResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodePartnerAdminsGroupsResponseSuccess = (postApiV1ThreeLetterCodePartnerAdminsGroupsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodePartnerAdminsGroupsResponseError = (postApiV1ThreeLetterCodePartnerAdminsGroupsResponse401 | postApiV1ThreeLetterCodePartnerAdminsGroupsResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodePartnerAdminsGroupsResponse = (postApiV1ThreeLetterCodePartnerAdminsGroupsResponseSuccess | postApiV1ThreeLetterCodePartnerAdminsGroupsResponseError)

export const getPostApiV1ThreeLetterCodePartnerAdminsGroupsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/groups`
}

/**
 * グループを新規作成する
 * @summary Create a group
 */
export const postApiV1ThreeLetterCodePartnerAdminsGroups = async (threeLetterCode: string,
    postApiV1ThreeLetterCodePartnerAdminsGroupsBody?: PostApiV1ThreeLetterCodePartnerAdminsGroupsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodePartnerAdminsGroupsResponse> => {

  return customInstance<postApiV1ThreeLetterCodePartnerAdminsGroupsResponse>(getPostApiV1ThreeLetterCodePartnerAdminsGroupsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodePartnerAdminsGroupsBody)
  }
);}




export const getPostApiV1ThreeLetterCodePartnerAdminsGroupsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodePartnerAdminsGroupsBody | undefined }) => {
    return postApiV1ThreeLetterCodePartnerAdminsGroups(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodePartnerAdminsGroupsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/partner_admins/groups`] as const;

export type PostApiV1ThreeLetterCodePartnerAdminsGroupsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsGroups>>>

/**
 * @summary Create a group
 */
export const usePostApiV1ThreeLetterCodePartnerAdminsGroups = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsGroups>>, TError, Key, PostApiV1ThreeLetterCodePartnerAdminsGroupsBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsGroups>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodePartnerAdminsGroupsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodePartnerAdminsGroupsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsGroupsId200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsGroupsIdResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsGroupsIdResponseError = (getApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse = (getApiV1ThreeLetterCodePartnerAdminsGroupsIdResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsGroupsIdResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsGroupsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/groups/${id}`
}

/**
 * グループの詳細を取得する
 * @summary Show a group
 */
export const getApiV1ThreeLetterCodePartnerAdminsGroupsId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse>(getGetApiV1ThreeLetterCodePartnerAdminsGroupsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsGroupsIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/groups/${id}`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsGroupsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsGroupsId>>>

/**
 * @summary Show a group
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsGroupsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsGroupsId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsGroupsIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsGroupsId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse200 = {
  data: PutApiV1ThreeLetterCodePartnerAdminsGroupsId200
  status: 200
}

export type putApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodePartnerAdminsGroupsIdResponseSuccess = (putApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodePartnerAdminsGroupsIdResponseError = (putApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse401 | putApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse = (putApiV1ThreeLetterCodePartnerAdminsGroupsIdResponseSuccess | putApiV1ThreeLetterCodePartnerAdminsGroupsIdResponseError)

export const getPutApiV1ThreeLetterCodePartnerAdminsGroupsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/groups/${id}`
}

/**
 * グループの情報を更新する
 * @summary Update a group
 */
export const putApiV1ThreeLetterCodePartnerAdminsGroupsId = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodePartnerAdminsGroupsIdBody?: PutApiV1ThreeLetterCodePartnerAdminsGroupsIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse>(getPutApiV1ThreeLetterCodePartnerAdminsGroupsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodePartnerAdminsGroupsIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodePartnerAdminsGroupsIdBody | undefined }) => {
    return putApiV1ThreeLetterCodePartnerAdminsGroupsId(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/groups/${id}`] as const;

export type PutApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsGroupsId>>>

/**
 * @summary Update a group
 */
export const usePutApiV1ThreeLetterCodePartnerAdminsGroupsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsGroupsId>>, TError, Key, PutApiV1ThreeLetterCodePartnerAdminsGroupsIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsGroupsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodePartnerAdminsGroupsIdResponseSuccess = (deleteApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodePartnerAdminsGroupsIdResponseError = (deleteApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse = (deleteApiV1ThreeLetterCodePartnerAdminsGroupsIdResponseSuccess | deleteApiV1ThreeLetterCodePartnerAdminsGroupsIdResponseError)

export const getDeleteApiV1ThreeLetterCodePartnerAdminsGroupsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/groups/${id}`
}

/**
 * グループを削除する
 * @summary Delete a group
 */
export const deleteApiV1ThreeLetterCodePartnerAdminsGroupsId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodePartnerAdminsGroupsIdResponse>(getDeleteApiV1ThreeLetterCodePartnerAdminsGroupsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodePartnerAdminsGroupsId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/groups/${id}`] as const;

export type DeleteApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsGroupsId>>>

/**
 * @summary Delete a group
 */
export const useDeleteApiV1ThreeLetterCodePartnerAdminsGroupsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsGroupsId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsGroupsId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsers200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersResponseError = (getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersResponse = (getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersUrl = (threeLetterCode: string,
    notificationId: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/notifications/${notificationId}/notification_users`
}

/**
 * 通知の配信対象ユーザー一覧を取得する
 * @summary Get notification users
 */
export const getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsers = async (threeLetterCode: string,
    notificationId: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersResponse>(getGetApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersUrl(threeLetterCode,notificationId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersKey = (threeLetterCode: string,
    notificationId: number,) => [`/api/v1/${threeLetterCode}/partner_admins/notifications/${notificationId}/notification_users`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsers>>>

/**
 * @summary Get notification users
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsers = <TError = Errors>(
  threeLetterCode: string,
    notificationId: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsers>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && notificationId !== null && notificationId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsersKey(threeLetterCode,notificationId) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsNotificationsNotificationIdNotificationUsers(threeLetterCode,notificationId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsNotificationsResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsNotifications200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsNotificationsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsNotificationsResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsNotificationsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsNotificationsResponseError = (getApiV1ThreeLetterCodePartnerAdminsNotificationsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsNotificationsResponse = (getApiV1ThreeLetterCodePartnerAdminsNotificationsResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsNotificationsResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsNotificationsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/notifications`
}

/**
 * 配信済みのプッシュ通知一覧を取得する
 * @summary Get delivered notifications
 */
export const getApiV1ThreeLetterCodePartnerAdminsNotifications = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsNotificationsResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsNotificationsResponse>(getGetApiV1ThreeLetterCodePartnerAdminsNotificationsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsNotificationsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/partner_admins/notifications`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsNotifications>>>

/**
 * @summary Get delivered notifications
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsNotifications = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsNotifications>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsNotificationsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsNotifications(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodePartnerAdminsNotificationsResponseDefault = {
  data: unknown
  status: number
}

;
export type postApiV1ThreeLetterCodePartnerAdminsNotificationsResponseError = (postApiV1ThreeLetterCodePartnerAdminsNotificationsResponseDefault) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodePartnerAdminsNotificationsResponse = (postApiV1ThreeLetterCodePartnerAdminsNotificationsResponseError)

export const getPostApiV1ThreeLetterCodePartnerAdminsNotificationsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/notifications`
}

/**
 * プッシュ通知を新規作成する
 * @summary Create a notification
 */
export const postApiV1ThreeLetterCodePartnerAdminsNotifications = async (threeLetterCode: string,
    postApiV1ThreeLetterCodePartnerAdminsNotificationsBody?: PostApiV1ThreeLetterCodePartnerAdminsNotificationsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodePartnerAdminsNotificationsResponse> => {

  return customInstance<postApiV1ThreeLetterCodePartnerAdminsNotificationsResponse>(getPostApiV1ThreeLetterCodePartnerAdminsNotificationsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodePartnerAdminsNotificationsBody)
  }
);}




export const getPostApiV1ThreeLetterCodePartnerAdminsNotificationsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodePartnerAdminsNotificationsBody | undefined }) => {
    return postApiV1ThreeLetterCodePartnerAdminsNotifications(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodePartnerAdminsNotificationsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/partner_admins/notifications`] as const;

export type PostApiV1ThreeLetterCodePartnerAdminsNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsNotifications>>>

/**
 * @summary Create a notification
 */
export const usePostApiV1ThreeLetterCodePartnerAdminsNotifications = <TError = unknown>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsNotifications>>, TError, Key, PostApiV1ThreeLetterCodePartnerAdminsNotificationsBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsNotifications>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodePartnerAdminsNotificationsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodePartnerAdminsNotificationsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsNotificationsIdResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsNotificationsId200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsNotificationsIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsNotificationsIdResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsNotificationsIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsNotificationsIdResponseError = (getApiV1ThreeLetterCodePartnerAdminsNotificationsIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsNotificationsIdResponse = (getApiV1ThreeLetterCodePartnerAdminsNotificationsIdResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsNotificationsIdResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsNotificationsIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/notifications/${id}`
}

/**
 * プッシュ通知の詳細を取得する
 * @summary Show notification
 */
export const getApiV1ThreeLetterCodePartnerAdminsNotificationsId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsNotificationsIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsNotificationsIdResponse>(getGetApiV1ThreeLetterCodePartnerAdminsNotificationsIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsNotificationsIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/notifications/${id}`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsNotificationsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsNotificationsId>>>

/**
 * @summary Show notification
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsNotificationsId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsNotificationsId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsNotificationsIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsNotificationsId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsers200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersResponseError = (getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersResponse = (getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/partner_admin_users`
}

/**
 * パートナー管理者ユーザーの一覧を取得する
 * @summary Get Partner admin users
 */
export const getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsers = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersResponse>(getGetApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/partner_admins/partner_admin_users`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsers>>>

/**
 * @summary Get Partner admin users
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsers = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsers>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsersKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsPartnerAdminUsers(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsPartnerBranchesResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsPartnerBranches200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsPartnerBranchesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsPartnerBranchesResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsPartnerBranchesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsPartnerBranchesResponseError = (getApiV1ThreeLetterCodePartnerAdminsPartnerBranchesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsPartnerBranchesResponse = (getApiV1ThreeLetterCodePartnerAdminsPartnerBranchesResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsPartnerBranchesResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsPartnerBranchesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/partner_branches`
}

/**
 * 取引店舗 / 拠点の一覧を取得する（enable: true のみ返却、id と name のみ、name_kana 昇順）
 * @summary Get partner branches
 */
export const getApiV1ThreeLetterCodePartnerAdminsPartnerBranches = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsPartnerBranchesResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsPartnerBranchesResponse>(getGetApiV1ThreeLetterCodePartnerAdminsPartnerBranchesUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsPartnerBranchesKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/partner_admins/partner_branches`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsPartnerBranchesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsPartnerBranches>>>

/**
 * @summary Get partner branches
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsPartnerBranches = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsPartnerBranches>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsPartnerBranchesKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsPartnerBranches(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsResponseError = (getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsResponse = (getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/partner_feature_flags`
}

/**
 * パートナーの機能フラグ一覧を取得する
 * @summary Get partner feature flags
 */
export const getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsResponse>(getGetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/partner_admins/partner_feature_flags`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags>>>

/**
 * @summary Get partner feature flags
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsServiceUsagesResponse200ApplicationJson = {
  data: GetApiV1ThreeLetterCodePartnerAdminsServiceUsages200One
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsServiceUsagesResponse200TextCsv = {
  data: Blob
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsServiceUsagesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsServiceUsagesResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsServiceUsagesResponse200ApplicationJson | getApiV1ThreeLetterCodePartnerAdminsServiceUsagesResponse200TextCsv) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsServiceUsagesResponseError = (getApiV1ThreeLetterCodePartnerAdminsServiceUsagesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsServiceUsagesResponse = (getApiV1ThreeLetterCodePartnerAdminsServiceUsagesResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsServiceUsagesResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsServiceUsagesUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsServiceUsagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/service_usages?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/service_usages`
}

/**
 * サービス利用履歴の一覧を取得する（JSON/CSV対応）
 * @summary Get service_usages
 */
export const getApiV1ThreeLetterCodePartnerAdminsServiceUsages = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsServiceUsagesParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsServiceUsagesResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsServiceUsagesResponse>(getGetApiV1ThreeLetterCodePartnerAdminsServiceUsagesUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsServiceUsagesKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsServiceUsagesParams,) => [`/api/v1/${threeLetterCode}/partner_admins/service_usages`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsServiceUsagesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsServiceUsages>>>

/**
 * @summary Get service_usages
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsServiceUsages = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsServiceUsagesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsServiceUsages>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsServiceUsagesKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsServiceUsages(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsServicesResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsServices200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsServicesResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsServicesResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsServicesResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsServicesResponseError = (getApiV1ThreeLetterCodePartnerAdminsServicesResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsServicesResponse = (getApiV1ThreeLetterCodePartnerAdminsServicesResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsServicesResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsServicesUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsServicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/services?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/services`
}

/**
 * 福利厚生サービスの一覧を取得する
 * @summary Get services
 */
export const getApiV1ThreeLetterCodePartnerAdminsServices = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsServicesParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsServicesResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsServicesResponse>(getGetApiV1ThreeLetterCodePartnerAdminsServicesUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsServicesKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsServicesParams,) => [`/api/v1/${threeLetterCode}/partner_admins/services`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsServicesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsServices>>>

/**
 * @summary Get services
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsServices = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsServicesParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsServices>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsServicesKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsServices(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsServicesIdResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsServicesId200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsServicesIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsServicesIdResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsServicesIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsServicesIdResponseError = (getApiV1ThreeLetterCodePartnerAdminsServicesIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsServicesIdResponse = (getApiV1ThreeLetterCodePartnerAdminsServicesIdResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsServicesIdResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsServicesIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/services/${id}`
}

/**
 * 福利厚生サービスの詳細を取得する
 * @summary Get service
 */
export const getApiV1ThreeLetterCodePartnerAdminsServicesId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsServicesIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsServicesIdResponse>(getGetApiV1ThreeLetterCodePartnerAdminsServicesIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsServicesIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/services/${id}`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsServicesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsServicesId>>>

/**
 * @summary Get service
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsServicesId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsServicesId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsServicesIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsServicesId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1PartnerAdminsSignInResponse200 = {
  data: PostApiV1PartnerAdminsSignIn200
  status: 200
}

export type postApiV1PartnerAdminsSignInResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1PartnerAdminsSignInResponseSuccess = (postApiV1PartnerAdminsSignInResponse200) & {
  headers: Headers;
};
export type postApiV1PartnerAdminsSignInResponseError = (postApiV1PartnerAdminsSignInResponse401) & {
  headers: Headers;
};

export type postApiV1PartnerAdminsSignInResponse = (postApiV1PartnerAdminsSignInResponseSuccess | postApiV1PartnerAdminsSignInResponseError)

export const getPostApiV1PartnerAdminsSignInUrl = () => {




  return `/api/v1/partner_admins/sign_in`
}

/**
 * パートナー管理者としてログインし、JWTトークンを取得する
 * @summary Get JWT
 */
export const postApiV1PartnerAdminsSignIn = async (postApiV1PartnerAdminsSignInBody?: PostApiV1PartnerAdminsSignInBody, options?: RequestInit): Promise<postApiV1PartnerAdminsSignInResponse> => {

  return customInstance<postApiV1PartnerAdminsSignInResponse>(getPostApiV1PartnerAdminsSignInUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1PartnerAdminsSignInBody)
  }
);}




export const getPostApiV1PartnerAdminsSignInMutationFetcher = ( options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1PartnerAdminsSignInBody | undefined }) => {
    return postApiV1PartnerAdminsSignIn(arg, options);
  }
}
export const getPostApiV1PartnerAdminsSignInMutationKey = () => [`/api/v1/partner_admins/sign_in`] as const;

export type PostApiV1PartnerAdminsSignInMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1PartnerAdminsSignIn>>>

/**
 * @summary Get JWT
 */
export const usePostApiV1PartnerAdminsSignIn = <TError = Errors>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1PartnerAdminsSignIn>>, TError, Key, PostApiV1PartnerAdminsSignInBody | undefined, Awaited<ReturnType<typeof postApiV1PartnerAdminsSignIn>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1PartnerAdminsSignInMutationKey();
  const swrFn = getPostApiV1PartnerAdminsSignInMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsTopBannersResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsTopBanners200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsTopBannersResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodePartnerAdminsTopBannersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsTopBannersResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsTopBannersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsTopBannersResponseError = (getApiV1ThreeLetterCodePartnerAdminsTopBannersResponse400 | getApiV1ThreeLetterCodePartnerAdminsTopBannersResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsTopBannersResponse = (getApiV1ThreeLetterCodePartnerAdminsTopBannersResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsTopBannersResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsTopBannersUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsTopBannersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/top_banners?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/top_banners`
}

/**
 * トップバナーの一覧を取得する
 * @summary Get top_banners
 */
export const getApiV1ThreeLetterCodePartnerAdminsTopBanners = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsTopBannersParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsTopBannersResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsTopBannersResponse>(getGetApiV1ThreeLetterCodePartnerAdminsTopBannersUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsTopBannersKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsTopBannersParams,) => [`/api/v1/${threeLetterCode}/partner_admins/top_banners`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsTopBannersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsTopBanners>>>

/**
 * @summary Get top_banners
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsTopBanners = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsTopBannersParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsTopBanners>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsTopBannersKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsTopBanners(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodePartnerAdminsTopBannersResponse401 = {
  data: Errors
  status: 401
}

;
export type postApiV1ThreeLetterCodePartnerAdminsTopBannersResponseError = (postApiV1ThreeLetterCodePartnerAdminsTopBannersResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodePartnerAdminsTopBannersResponse = (postApiV1ThreeLetterCodePartnerAdminsTopBannersResponseError)

export const getPostApiV1ThreeLetterCodePartnerAdminsTopBannersUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/top_banners`
}

/**
 * トップバナーを新規作成する
 * @summary Create a top_banner
 */
export const postApiV1ThreeLetterCodePartnerAdminsTopBanners = async (threeLetterCode: string,
    postApiV1ThreeLetterCodePartnerAdminsTopBannersBody?: PostApiV1ThreeLetterCodePartnerAdminsTopBannersBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodePartnerAdminsTopBannersResponse> => {

  return customInstance<postApiV1ThreeLetterCodePartnerAdminsTopBannersResponse>(getPostApiV1ThreeLetterCodePartnerAdminsTopBannersUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodePartnerAdminsTopBannersBody)
  }
);}




export const getPostApiV1ThreeLetterCodePartnerAdminsTopBannersMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodePartnerAdminsTopBannersBody | undefined }) => {
    return postApiV1ThreeLetterCodePartnerAdminsTopBanners(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodePartnerAdminsTopBannersMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/partner_admins/top_banners`] as const;

export type PostApiV1ThreeLetterCodePartnerAdminsTopBannersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsTopBanners>>>

/**
 * @summary Create a top_banner
 */
export const usePostApiV1ThreeLetterCodePartnerAdminsTopBanners = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsTopBanners>>, TError, Key, PostApiV1ThreeLetterCodePartnerAdminsTopBannersBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsTopBanners>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodePartnerAdminsTopBannersMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodePartnerAdminsTopBannersMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsTopBannersId200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponseError = (getApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse = (getApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsTopBannersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/top_banners/${id}`
}

/**
 * トップバナーの詳細を取得する
 * @summary Show a top_banner
 */
export const getApiV1ThreeLetterCodePartnerAdminsTopBannersId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse>(getGetApiV1ThreeLetterCodePartnerAdminsTopBannersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsTopBannersIdKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/top_banners/${id}`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsTopBannersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsTopBannersId>>>

/**
 * @summary Show a top_banner
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsTopBannersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsTopBannersId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && id !== null && id !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsTopBannersIdKey(threeLetterCode,id) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsTopBannersId(threeLetterCode,id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse401 = {
  data: Errors
  status: 401
}

;
export type putApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponseError = (putApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse401) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse = (putApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponseError)

export const getPutApiV1ThreeLetterCodePartnerAdminsTopBannersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/top_banners/${id}`
}

/**
 * トップバナーを更新する
 * @summary Update a top_banner
 */
export const putApiV1ThreeLetterCodePartnerAdminsTopBannersId = async (threeLetterCode: string,
    id: number,
    putApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody?: PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse>(getPutApiV1ThreeLetterCodePartnerAdminsTopBannersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody | undefined }) => {
    return putApiV1ThreeLetterCodePartnerAdminsTopBannersId(threeLetterCode, id, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/top_banners/${id}`] as const;

export type PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsTopBannersId>>>

/**
 * @summary Update a top_banner
 */
export const usePutApiV1ThreeLetterCodePartnerAdminsTopBannersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsTopBannersId>>, TError, Key, PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody | undefined, Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsTopBannersId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationKey(threeLetterCode,id);
  const swrFn = getPutApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponseSuccess = (deleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponseError = (deleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse401) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse = (deleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponseSuccess | deleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponseError)

export const getDeleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdUrl = (threeLetterCode: string,
    id: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/top_banners/${id}`
}

/**
 * トップバナーを削除する
 * @summary Delete a top_banner
 */
export const deleteApiV1ThreeLetterCodePartnerAdminsTopBannersId = async (threeLetterCode: string,
    id: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdResponse>(getDeleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdUrl(threeLetterCode,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationFetcher = (threeLetterCode: string,
    id: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodePartnerAdminsTopBannersId(threeLetterCode, id, options);
  }
}
export const getDeleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationKey = (threeLetterCode: string,
    id: number,) => [`/api/v1/${threeLetterCode}/partner_admins/top_banners/${id}`] as const;

export type DeleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsTopBannersId>>>

/**
 * @summary Delete a top_banner
 */
export const useDeleteApiV1ThreeLetterCodePartnerAdminsTopBannersId = <TError = Errors>(
  threeLetterCode: string,
    id: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsTopBannersId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsTopBannersId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationKey(threeLetterCode,id);
  const swrFn = getDeleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationFetcher(threeLetterCode,id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsResponse200ApplicationJson = {
  data: GetApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogs200One
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsResponse200TextCsv = {
  data: Blob
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsResponse200ApplicationJson | getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsResponse200TextCsv) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsResponseError = (getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsResponse = (getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/user_daily_first_access_logs?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/user_daily_first_access_logs`
}

/**
 * ユーザーの日次初回アクセスログ一覧を取得する（JSON/CSV対応）
 * @summary Get users
 */
export const getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogs = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsResponse>(getGetApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsParams,) => [`/api/v1/${threeLetterCode}/partner_admins/user_daily_first_access_logs`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogs>>>

/**
 * @summary Get users
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogs = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogs>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogsKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsUserDailyFirstAccessLogs(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccount200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponse403 = {
  data: Errors
  status: 403
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponseError = (getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponse401 | getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponse403 | getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponse = (getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountUrl = (threeLetterCode: string,
    userId: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/users/${userId}/bank_account`
}

/**
 * 自パートナー配下の指定ユーザーの口座連携情報を取得する。対象ユーザーが存在しない、口座を持たない、口座が pending または failed の場合はいずれも 404 を返す。
 * @summary Show linked bank account
 */
export const getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccount = async (threeLetterCode: string,
    userId: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountResponse>(getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountUrl(threeLetterCode,userId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountKey = (threeLetterCode: string,
    userId: number,) => [`/api/v1/${threeLetterCode}/partner_admins/users/${userId}/bank_account`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccount>>>

/**
 * @summary Show linked bank account
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccount = <TError = Errors>(
  threeLetterCode: string,
    userId: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccount>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && userId !== null && userId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccountKey(threeLetterCode,userId) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccount(threeLetterCode,userId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileResponseError = (getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileResponse = (getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileUrl = (threeLetterCode: string,
    userId: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/users/${userId}/profile`
}

/**
 * 指定ユーザーのプロフィール情報を取得する
 * @summary Get User Profile
 */
export const getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile = async (threeLetterCode: string,
    userId: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileResponse>(getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileUrl(threeLetterCode,userId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileKey = (threeLetterCode: string,
    userId: number,) => [`/api/v1/${threeLetterCode}/partner_admins/users/${userId}/profile`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile>>>

/**
 * @summary Get User Profile
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile = <TError = Errors>(
  threeLetterCode: string,
    userId: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && userId !== null && userId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileKey(threeLetterCode,userId) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile(threeLetterCode,userId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsUsers200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersResponse400 = {
  data: Errors
  status: 400
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsUsersResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsUsersResponseError = (getApiV1ThreeLetterCodePartnerAdminsUsersResponse400 | getApiV1ThreeLetterCodePartnerAdminsUsersResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsUsersResponse = (getApiV1ThreeLetterCodePartnerAdminsUsersResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsUsersResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsUsersUrl = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["external_user_ids[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/partner_admins/users?${stringifiedParams}` : `/api/v1/${threeLetterCode}/partner_admins/users`
}

/**
 * ユーザー一覧を取得する（ページネーション対応）
 * @summary Get users
 */
export const getApiV1ThreeLetterCodePartnerAdminsUsers = async (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsUsersParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsUsersResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsUsersResponse>(getGetApiV1ThreeLetterCodePartnerAdminsUsersUrl(threeLetterCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsUsersKey = (threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsUsersParams,) => [`/api/v1/${threeLetterCode}/partner_admins/users`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsUsers>>>

/**
 * @summary Get users
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsUsers = <TError = Errors>(
  threeLetterCode: string,
    params?: GetApiV1ThreeLetterCodePartnerAdminsUsersParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsUsers>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsUsersKey(threeLetterCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsUsers(threeLetterCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodePartnerAdminsUsersResponse201 = {
  data: PostApiV1ThreeLetterCodePartnerAdminsUsers201
  status: 201
}

export type postApiV1ThreeLetterCodePartnerAdminsUsersResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodePartnerAdminsUsersResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodePartnerAdminsUsersResponseSuccess = (postApiV1ThreeLetterCodePartnerAdminsUsersResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodePartnerAdminsUsersResponseError = (postApiV1ThreeLetterCodePartnerAdminsUsersResponse401 | postApiV1ThreeLetterCodePartnerAdminsUsersResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodePartnerAdminsUsersResponse = (postApiV1ThreeLetterCodePartnerAdminsUsersResponseSuccess | postApiV1ThreeLetterCodePartnerAdminsUsersResponseError)

export const getPostApiV1ThreeLetterCodePartnerAdminsUsersUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/users`
}

/**
 * ユーザーを新規作成する
 * @summary Create user
 */
export const postApiV1ThreeLetterCodePartnerAdminsUsers = async (threeLetterCode: string,
    postApiV1ThreeLetterCodePartnerAdminsUsersBody?: PostApiV1ThreeLetterCodePartnerAdminsUsersBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodePartnerAdminsUsersResponse> => {

  return customInstance<postApiV1ThreeLetterCodePartnerAdminsUsersResponse>(getPostApiV1ThreeLetterCodePartnerAdminsUsersUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodePartnerAdminsUsersBody)
  }
);}




export const getPostApiV1ThreeLetterCodePartnerAdminsUsersMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodePartnerAdminsUsersBody | undefined }) => {
    return postApiV1ThreeLetterCodePartnerAdminsUsers(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodePartnerAdminsUsersMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/partner_admins/users`] as const;

export type PostApiV1ThreeLetterCodePartnerAdminsUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsUsers>>>

/**
 * @summary Create user
 */
export const usePostApiV1ThreeLetterCodePartnerAdminsUsers = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsUsers>>, TError, Key, PostApiV1ThreeLetterCodePartnerAdminsUsersBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodePartnerAdminsUsers>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodePartnerAdminsUsersMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodePartnerAdminsUsersMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse200 = {
  data: GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200
  status: 200
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse404 = {
  data: Errors
  status: 404
}

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponseSuccess = (getApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponseError = (getApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse401 | getApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse404) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse = (getApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponseSuccess | getApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponseError)

export const getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdUrl = (threeLetterCode: string,
    userId: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/users/${userId}`
}

/**
 * ユーザーの詳細を取得する
 * @summary Get user
 */
export const getApiV1ThreeLetterCodePartnerAdminsUsersUserId = async (threeLetterCode: string,
    userId: number, options?: RequestInit): Promise<getApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse> => {

  return customInstance<getApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse>(getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdUrl(threeLetterCode,userId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdKey = (threeLetterCode: string,
    userId: number,) => [`/api/v1/${threeLetterCode}/partner_admins/users/${userId}`] as const;

export type GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsUsersUserId>>>

/**
 * @summary Get user
 */
export const useGetApiV1ThreeLetterCodePartnerAdminsUsersUserId = <TError = Errors>(
  threeLetterCode: string,
    userId: number, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePartnerAdminsUsersUserId>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && userId !== null && userId !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdKey(threeLetterCode,userId) : null);
  const swrFn = () => getApiV1ThreeLetterCodePartnerAdminsUsersUserId(threeLetterCode,userId, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse200 = {
  data: PutApiV1ThreeLetterCodePartnerAdminsUsersUserId200
  status: 200
}

export type putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse401 = {
  data: Errors
  status: 401
}

export type putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse404 = {
  data: Errors
  status: 404
}

export type putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse422 = {
  data: Errors
  status: 422
}

export type putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponseSuccess = (putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse200) & {
  headers: Headers;
};
export type putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponseError = (putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse401 | putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse404 | putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse422) & {
  headers: Headers;
};

export type putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse = (putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponseSuccess | putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponseError)

export const getPutApiV1ThreeLetterCodePartnerAdminsUsersUserIdUrl = (threeLetterCode: string,
    userId: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/users/${userId}`
}

/**
 * ユーザーの情報を更新する
 * @summary Update user
 */
export const putApiV1ThreeLetterCodePartnerAdminsUsersUserId = async (threeLetterCode: string,
    userId: number,
    putApiV1ThreeLetterCodePartnerAdminsUsersUserIdBody: PutApiV1ThreeLetterCodePartnerAdminsUsersUserIdBody, options?: RequestInit): Promise<putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse> => {

  return customInstance<putApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse>(getPutApiV1ThreeLetterCodePartnerAdminsUsersUserIdUrl(threeLetterCode,userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putApiV1ThreeLetterCodePartnerAdminsUsersUserIdBody)
  }
);}




export const getPutApiV1ThreeLetterCodePartnerAdminsUsersUserIdMutationFetcher = (threeLetterCode: string,
    userId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PutApiV1ThreeLetterCodePartnerAdminsUsersUserIdBody }) => {
    return putApiV1ThreeLetterCodePartnerAdminsUsersUserId(threeLetterCode, userId, arg, options);
  }
}
export const getPutApiV1ThreeLetterCodePartnerAdminsUsersUserIdMutationKey = (threeLetterCode: string,
    userId: number,) => [`/api/v1/${threeLetterCode}/partner_admins/users/${userId}`] as const;

export type PutApiV1ThreeLetterCodePartnerAdminsUsersUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsUsersUserId>>>

/**
 * @summary Update user
 */
export const usePutApiV1ThreeLetterCodePartnerAdminsUsersUserId = <TError = Errors>(
  threeLetterCode: string,
    userId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsUsersUserId>>, TError, Key, PutApiV1ThreeLetterCodePartnerAdminsUsersUserIdBody, Awaited<ReturnType<typeof putApiV1ThreeLetterCodePartnerAdminsUsersUserId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutApiV1ThreeLetterCodePartnerAdminsUsersUserIdMutationKey(threeLetterCode,userId);
  const swrFn = getPutApiV1ThreeLetterCodePartnerAdminsUsersUserIdMutationFetcher(threeLetterCode,userId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type deleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse401 = {
  data: Errors
  status: 401
}

export type deleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse404 = {
  data: Errors
  status: 404
}

export type deleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponseSuccess = (deleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse204) & {
  headers: Headers;
};
export type deleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponseError = (deleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse401 | deleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse404) & {
  headers: Headers;
};

export type deleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse = (deleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponseSuccess | deleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponseError)

export const getDeleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdUrl = (threeLetterCode: string,
    userId: number,) => {




  return `/api/v1/${threeLetterCode}/partner_admins/users/${userId}`
}

/**
 * ユーザーを無効化する
 * @summary Disable user
 */
export const deleteApiV1ThreeLetterCodePartnerAdminsUsersUserId = async (threeLetterCode: string,
    userId: number, options?: RequestInit): Promise<deleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse> => {

  return customInstance<deleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdResponse>(getDeleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdUrl(threeLetterCode,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdMutationFetcher = (threeLetterCode: string,
    userId: number, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return deleteApiV1ThreeLetterCodePartnerAdminsUsersUserId(threeLetterCode, userId, options);
  }
}
export const getDeleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdMutationKey = (threeLetterCode: string,
    userId: number,) => [`/api/v1/${threeLetterCode}/partner_admins/users/${userId}`] as const;

export type DeleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsUsersUserId>>>

/**
 * @summary Disable user
 */
export const useDeleteApiV1ThreeLetterCodePartnerAdminsUsersUserId = <TError = Errors>(
  threeLetterCode: string,
    userId: number, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsUsersUserId>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteApiV1ThreeLetterCodePartnerAdminsUsersUserId>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdMutationKey(threeLetterCode,userId);
  const swrFn = getDeleteApiV1ThreeLetterCodePartnerAdminsUsersUserIdMutationFetcher(threeLetterCode,userId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodePublicCardRegistrationsResponse201 = {
  data: PostApiV1ThreeLetterCodePublicCardRegistrations201
  status: 201
}

export type postApiV1ThreeLetterCodePublicCardRegistrationsResponse502 = {
  data: Errors
  status: 502
}

export type postApiV1ThreeLetterCodePublicCardRegistrationsResponseSuccess = (postApiV1ThreeLetterCodePublicCardRegistrationsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodePublicCardRegistrationsResponseError = (postApiV1ThreeLetterCodePublicCardRegistrationsResponse502) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodePublicCardRegistrationsResponse = (postApiV1ThreeLetterCodePublicCardRegistrationsResponseSuccess | postApiV1ThreeLetterCodePublicCardRegistrationsResponseError)

export const getPostApiV1ThreeLetterCodePublicCardRegistrationsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/public/card_registrations`
}

/**
 * 申込フローのカード入力ステップ用（認証不要）。企業課金アカウントに Stripe Customer を作成し、カード保存用の SetupIntent を発行して client_secret を返す。カード番号は BE に流さず ブラウザの Payment Element から Stripe へ直送する。IP あたり 15 分で 10 回のレート制限を適用する
 * @summary Create card registration
 */
export const postApiV1ThreeLetterCodePublicCardRegistrations = async (threeLetterCode: string, options?: RequestInit): Promise<postApiV1ThreeLetterCodePublicCardRegistrationsResponse> => {

  return customInstance<postApiV1ThreeLetterCodePublicCardRegistrationsResponse>(getPostApiV1ThreeLetterCodePublicCardRegistrationsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodePublicCardRegistrationsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodePublicCardRegistrations(threeLetterCode, options);
  }
}
export const getPostApiV1ThreeLetterCodePublicCardRegistrationsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/public/card_registrations`] as const;

export type PostApiV1ThreeLetterCodePublicCardRegistrationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePublicCardRegistrations>>>

/**
 * @summary Create card registration
 */
export const usePostApiV1ThreeLetterCodePublicCardRegistrations = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePublicCardRegistrations>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodePublicCardRegistrations>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodePublicCardRegistrationsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodePublicCardRegistrationsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePublicClientApplicationAgreementsResponse200 = {
  data: GetApiV1ThreeLetterCodePublicClientApplicationAgreements200
  status: 200
}

export type getApiV1ThreeLetterCodePublicClientApplicationAgreementsResponseSuccess = (getApiV1ThreeLetterCodePublicClientApplicationAgreementsResponse200) & {
  headers: Headers;
};
;

export type getApiV1ThreeLetterCodePublicClientApplicationAgreementsResponse = (getApiV1ThreeLetterCodePublicClientApplicationAgreementsResponseSuccess)

export const getGetApiV1ThreeLetterCodePublicClientApplicationAgreementsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/public/client_application_agreements`
}

/**
 * Client 企業向け利用申込フォーム用の同意項目一覧を取得する（認証不要、sort_order 昇順）
 * @summary Get client application agreements
 */
export const getApiV1ThreeLetterCodePublicClientApplicationAgreements = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodePublicClientApplicationAgreementsResponse> => {

  return customInstance<getApiV1ThreeLetterCodePublicClientApplicationAgreementsResponse>(getGetApiV1ThreeLetterCodePublicClientApplicationAgreementsUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePublicClientApplicationAgreementsKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/public/client_application_agreements`] as const;

export type GetApiV1ThreeLetterCodePublicClientApplicationAgreementsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePublicClientApplicationAgreements>>>

/**
 * @summary Get client application agreements
 */
export const useGetApiV1ThreeLetterCodePublicClientApplicationAgreements = <TError = unknown>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePublicClientApplicationAgreements>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePublicClientApplicationAgreementsKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodePublicClientApplicationAgreements(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodePublicClientApplicationsResponse201 = {
  data: PostApiV1ThreeLetterCodePublicClientApplications201
  status: 201
}

export type postApiV1ThreeLetterCodePublicClientApplicationsResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1ThreeLetterCodePublicClientApplicationsResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodePublicClientApplicationsResponse502 = {
  data: Errors
  status: 502
}

export type postApiV1ThreeLetterCodePublicClientApplicationsResponseSuccess = (postApiV1ThreeLetterCodePublicClientApplicationsResponse201) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodePublicClientApplicationsResponseError = (postApiV1ThreeLetterCodePublicClientApplicationsResponse400 | postApiV1ThreeLetterCodePublicClientApplicationsResponse422 | postApiV1ThreeLetterCodePublicClientApplicationsResponse502) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodePublicClientApplicationsResponse = (postApiV1ThreeLetterCodePublicClientApplicationsResponseSuccess | postApiV1ThreeLetterCodePublicClientApplicationsResponseError)

export const getPostApiV1ThreeLetterCodePublicClientApplicationsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/public/client_applications`
}

/**
 * 申し込みフォームの確認画面から送信された内容で ClientApplication を新規作成する（認証不要）。IP あたり 15 分で 10 回のレート制限を適用する
 * @summary Create client application
 */
export const postApiV1ThreeLetterCodePublicClientApplications = async (threeLetterCode: string,
    postApiV1ThreeLetterCodePublicClientApplicationsBody?: PostApiV1ThreeLetterCodePublicClientApplicationsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodePublicClientApplicationsResponse> => {

  return customInstance<postApiV1ThreeLetterCodePublicClientApplicationsResponse>(getPostApiV1ThreeLetterCodePublicClientApplicationsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodePublicClientApplicationsBody)
  }
);}




export const getPostApiV1ThreeLetterCodePublicClientApplicationsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodePublicClientApplicationsBody | undefined }) => {
    return postApiV1ThreeLetterCodePublicClientApplications(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodePublicClientApplicationsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/public/client_applications`] as const;

export type PostApiV1ThreeLetterCodePublicClientApplicationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePublicClientApplications>>>

/**
 * @summary Create client application
 */
export const usePostApiV1ThreeLetterCodePublicClientApplications = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePublicClientApplications>>, TError, Key, PostApiV1ThreeLetterCodePublicClientApplicationsBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodePublicClientApplications>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodePublicClientApplicationsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodePublicClientApplicationsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePublicContractPlansResponse200 = {
  data: GetApiV1ThreeLetterCodePublicContractPlans200
  status: 200
}

export type getApiV1ThreeLetterCodePublicContractPlansResponseSuccess = (getApiV1ThreeLetterCodePublicContractPlansResponse200) & {
  headers: Headers;
};
;

export type getApiV1ThreeLetterCodePublicContractPlansResponse = (getApiV1ThreeLetterCodePublicContractPlansResponseSuccess)

export const getGetApiV1ThreeLetterCodePublicContractPlansUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/public/contract_plans`
}

/**
 * 申込フォーム向けに契約プランの一覧を取得する（認証不要）。廃止済みプランと custom プランは含まない
 * @summary List contract plans
 */
export const getApiV1ThreeLetterCodePublicContractPlans = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodePublicContractPlansResponse> => {

  return customInstance<getApiV1ThreeLetterCodePublicContractPlansResponse>(getGetApiV1ThreeLetterCodePublicContractPlansUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePublicContractPlansKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/public/contract_plans`] as const;

export type GetApiV1ThreeLetterCodePublicContractPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePublicContractPlans>>>

/**
 * @summary List contract plans
 */
export const useGetApiV1ThreeLetterCodePublicContractPlans = <TError = unknown>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePublicContractPlans>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePublicContractPlansKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodePublicContractPlans(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse200 = {
  data: JpostSearchcode
  status: 200
}

export type getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse400 = {
  data: GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode400
  status: 400
}

export type getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse401 = {
  data: GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode401
  status: 401
}

export type getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse404 = {
  data: GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode404
  status: 404
}

export type getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse500 = {
  data: GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode500
  status: 500
}

export type getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse502 = {
  data: Errors
  status: 502
}

export type getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse504 = {
  data: Errors
  status: 504
}

export type getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponseSuccess = (getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse200) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponseError = (getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse400 | getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse401 | getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse404 | getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse500 | getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse502 | getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse504) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse = (getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponseSuccess | getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponseError)

export const getGetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeUrl = (threeLetterCode: string,
    searchCode: string,
    params?: GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${threeLetterCode}/public/jpost/searchcode/${searchCode}?${stringifiedParams}` : `/api/v1/${threeLetterCode}/public/jpost/searchcode/${searchCode}`
}

/**
 * 日本郵便デジタルアドレス API のコード番号検索を透過 proxy するエンドポイント（認証不要）。事前に /api/v1/{three_letter_code}/public/jpost/token で取得した JWT を Authorization: Bearer で渡す。
 * @summary Search address by JPost search code
 */
export const getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode = async (threeLetterCode: string,
    searchCode: string,
    params?: GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeParams, options?: RequestInit): Promise<getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse> => {

  return customInstance<getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeResponse>(getGetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeUrl(threeLetterCode,searchCode,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeKey = (threeLetterCode: string,
    searchCode: string,
    params?: GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeParams,) => [`/api/v1/${threeLetterCode}/public/jpost/searchcode/${searchCode}`, ...(params ? [params]: [])] as const;

export type GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode>>>

/**
 * @summary Search address by JPost search code
 */
export const useGetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode = <TError = GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode400 | GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode401 | GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode404 | GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode500 | Errors>(
  threeLetterCode: string,
    searchCode: string,
    params?: GetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && searchCode !== null && searchCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePublicJpostSearchcodeSearchCodeKey(threeLetterCode,searchCode,params) : null);
  const swrFn = () => getApiV1ThreeLetterCodePublicJpostSearchcodeSearchCode(threeLetterCode,searchCode,params, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodePublicJpostTokenResponse200 = {
  data: JpostToken
  status: 200
}

export type postApiV1ThreeLetterCodePublicJpostTokenResponse502 = {
  data: Errors
  status: 502
}

export type postApiV1ThreeLetterCodePublicJpostTokenResponse504 = {
  data: Errors
  status: 504
}

export type postApiV1ThreeLetterCodePublicJpostTokenResponseSuccess = (postApiV1ThreeLetterCodePublicJpostTokenResponse200) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodePublicJpostTokenResponseError = (postApiV1ThreeLetterCodePublicJpostTokenResponse502 | postApiV1ThreeLetterCodePublicJpostTokenResponse504) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodePublicJpostTokenResponse = (postApiV1ThreeLetterCodePublicJpostTokenResponseSuccess | postApiV1ThreeLetterCodePublicJpostTokenResponseError)

export const getPostApiV1ThreeLetterCodePublicJpostTokenUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/public/jpost/token`
}

/**
 * JPost API のアクセストークンを発行して返却する（認証不要）
 * @summary Issue JPost API token
 */
export const postApiV1ThreeLetterCodePublicJpostToken = async (threeLetterCode: string, options?: RequestInit): Promise<postApiV1ThreeLetterCodePublicJpostTokenResponse> => {

  return customInstance<postApiV1ThreeLetterCodePublicJpostTokenResponse>(getPostApiV1ThreeLetterCodePublicJpostTokenUrl(threeLetterCode),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiV1ThreeLetterCodePublicJpostTokenMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, __: { arg: Arguments }) => {
    return postApiV1ThreeLetterCodePublicJpostToken(threeLetterCode, options);
  }
}
export const getPostApiV1ThreeLetterCodePublicJpostTokenMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/public/jpost/token`] as const;

export type PostApiV1ThreeLetterCodePublicJpostTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePublicJpostToken>>>

/**
 * @summary Issue JPost API token
 */
export const usePostApiV1ThreeLetterCodePublicJpostToken = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodePublicJpostToken>>, TError, Key, Arguments, Awaited<ReturnType<typeof postApiV1ThreeLetterCodePublicJpostToken>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodePublicJpostTokenMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodePublicJpostTokenMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePublicPartnerBranchesResponse200 = {
  data: GetApiV1ThreeLetterCodePublicPartnerBranches200
  status: 200
}

export type getApiV1ThreeLetterCodePublicPartnerBranchesResponseSuccess = (getApiV1ThreeLetterCodePublicPartnerBranchesResponse200) & {
  headers: Headers;
};
;

export type getApiV1ThreeLetterCodePublicPartnerBranchesResponse = (getApiV1ThreeLetterCodePublicPartnerBranchesResponseSuccess)

export const getGetApiV1ThreeLetterCodePublicPartnerBranchesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/public/partner_branches`
}

/**
 * 取引店舗 / 拠点の一覧を取得する（認証不要、enable: true のみ返却、id と name のみ、name_kana 昇順）
 * @summary Get partner branches
 */
export const getApiV1ThreeLetterCodePublicPartnerBranches = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodePublicPartnerBranchesResponse> => {

  return customInstance<getApiV1ThreeLetterCodePublicPartnerBranchesResponse>(getGetApiV1ThreeLetterCodePublicPartnerBranchesUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePublicPartnerBranchesKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/public/partner_branches`] as const;

export type GetApiV1ThreeLetterCodePublicPartnerBranchesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePublicPartnerBranches>>>

/**
 * @summary Get partner branches
 */
export const useGetApiV1ThreeLetterCodePublicPartnerBranches = <TError = unknown>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePublicPartnerBranches>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePublicPartnerBranchesKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodePublicPartnerBranches(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePublicPartnersSubdomainResponse200 = {
  data: GetApiV1ThreeLetterCodePublicPartnersSubdomain200
  status: 200
}

export type getApiV1ThreeLetterCodePublicPartnersSubdomainResponseSuccess = (getApiV1ThreeLetterCodePublicPartnersSubdomainResponse200) & {
  headers: Headers;
};
;

export type getApiV1ThreeLetterCodePublicPartnersSubdomainResponse = (getApiV1ThreeLetterCodePublicPartnersSubdomainResponseSuccess)

export const getGetApiV1ThreeLetterCodePublicPartnersSubdomainUrl = (threeLetterCode: string,
    subdomain: string,) => {




  return `/api/v1/${threeLetterCode}/public/partners/${subdomain}`
}

/**
 * サブドメインに対応するパートナー情報を取得する（認証不要）
 * @summary Get Partner
 */
export const getApiV1ThreeLetterCodePublicPartnersSubdomain = async (threeLetterCode: string,
    subdomain: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodePublicPartnersSubdomainResponse> => {

  return customInstance<getApiV1ThreeLetterCodePublicPartnersSubdomainResponse>(getGetApiV1ThreeLetterCodePublicPartnersSubdomainUrl(threeLetterCode,subdomain),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePublicPartnersSubdomainKey = (threeLetterCode: string,
    subdomain: string,) => [`/api/v1/${threeLetterCode}/public/partners/${subdomain}`] as const;

export type GetApiV1ThreeLetterCodePublicPartnersSubdomainQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePublicPartnersSubdomain>>>

/**
 * @summary Get Partner
 */
export const useGetApiV1ThreeLetterCodePublicPartnersSubdomain = <TError = unknown>(
  threeLetterCode: string,
    subdomain: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePublicPartnersSubdomain>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined && subdomain !== null && subdomain !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePublicPartnersSubdomainKey(threeLetterCode,subdomain) : null);
  const swrFn = () => getApiV1ThreeLetterCodePublicPartnersSubdomain(threeLetterCode,subdomain, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodePublicPrefecturesResponse200 = {
  data: GetApiV1ThreeLetterCodePublicPrefectures200
  status: 200
}

export type getApiV1ThreeLetterCodePublicPrefecturesResponseSuccess = (getApiV1ThreeLetterCodePublicPrefecturesResponse200) & {
  headers: Headers;
};
;

export type getApiV1ThreeLetterCodePublicPrefecturesResponse = (getApiV1ThreeLetterCodePublicPrefecturesResponseSuccess)

export const getGetApiV1ThreeLetterCodePublicPrefecturesUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/public/prefectures`
}

/**
 * 都道府県マスタの一覧を取得する（認証不要）
 * @summary Get Prefectures
 */
export const getApiV1ThreeLetterCodePublicPrefectures = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodePublicPrefecturesResponse> => {

  return customInstance<getApiV1ThreeLetterCodePublicPrefecturesResponse>(getGetApiV1ThreeLetterCodePublicPrefecturesUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodePublicPrefecturesKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/public/prefectures`] as const;

export type GetApiV1ThreeLetterCodePublicPrefecturesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePublicPrefectures>>>

/**
 * @summary Get Prefectures
 */
export const useGetApiV1ThreeLetterCodePublicPrefectures = <TError = unknown>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodePublicPrefectures>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodePublicPrefecturesKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodePublicPrefectures(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1SdksOtpVerificationsResponse200 = {
  data: PostApiV1SdksOtpVerifications200
  status: 200
}

export type postApiV1SdksOtpVerificationsResponse204 = {
  data: void
  status: 204
}

export type postApiV1SdksOtpVerificationsResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1SdksOtpVerificationsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1SdksOtpVerificationsResponseSuccess = (postApiV1SdksOtpVerificationsResponse200 | postApiV1SdksOtpVerificationsResponse204) & {
  headers: Headers;
};
export type postApiV1SdksOtpVerificationsResponseError = (postApiV1SdksOtpVerificationsResponse400 | postApiV1SdksOtpVerificationsResponse401) & {
  headers: Headers;
};

export type postApiV1SdksOtpVerificationsResponse = (postApiV1SdksOtpVerificationsResponseSuccess | postApiV1SdksOtpVerificationsResponseError)

export const getPostApiV1SdksOtpVerificationsUrl = () => {




  return `/api/v1/sdks/otp_verifications`
}

/**
 * OTP コードを検証し、ユーザーが存在すれば JWT を発行、存在しなければアカウント作成用 UUID を返却する
 * @summary Verify an OTP
 */
export const postApiV1SdksOtpVerifications = async (postApiV1SdksOtpVerificationsBody?: PostApiV1SdksOtpVerificationsBody, options?: RequestInit): Promise<postApiV1SdksOtpVerificationsResponse> => {

  return customInstance<postApiV1SdksOtpVerificationsResponse>(getPostApiV1SdksOtpVerificationsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1SdksOtpVerificationsBody)
  }
);}




export const getPostApiV1SdksOtpVerificationsMutationFetcher = ( options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1SdksOtpVerificationsBody | undefined }) => {
    return postApiV1SdksOtpVerifications(arg, options);
  }
}
export const getPostApiV1SdksOtpVerificationsMutationKey = () => [`/api/v1/sdks/otp_verifications`] as const;

export type PostApiV1SdksOtpVerificationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1SdksOtpVerifications>>>

/**
 * @summary Verify an OTP
 */
export const usePostApiV1SdksOtpVerifications = <TError = Errors>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1SdksOtpVerifications>>, TError, Key, PostApiV1SdksOtpVerificationsBody | undefined, Awaited<ReturnType<typeof postApiV1SdksOtpVerifications>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1SdksOtpVerificationsMutationKey();
  const swrFn = getPostApiV1SdksOtpVerificationsMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1SdksOtpsResponse201 = {
  data: PostApiV1SdksOtps201
  status: 201
}

export type postApiV1SdksOtpsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1SdksOtpsResponseSuccess = (postApiV1SdksOtpsResponse201) & {
  headers: Headers;
};
export type postApiV1SdksOtpsResponseError = (postApiV1SdksOtpsResponse401) & {
  headers: Headers;
};

export type postApiV1SdksOtpsResponse = (postApiV1SdksOtpsResponseSuccess | postApiV1SdksOtpsResponseError)

export const getPostApiV1SdksOtpsUrl = () => {




  return `/api/v1/sdks/otps`
}

/**
 * メールアドレスまたは電話番号宛にワンタイムパスワードを送信する
 * @summary Send an OTP
 */
export const postApiV1SdksOtps = async (postApiV1SdksOtpsBody?: PostApiV1SdksOtpsBody, options?: RequestInit): Promise<postApiV1SdksOtpsResponse> => {

  return customInstance<postApiV1SdksOtpsResponse>(getPostApiV1SdksOtpsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1SdksOtpsBody)
  }
);}




export const getPostApiV1SdksOtpsMutationFetcher = ( options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1SdksOtpsBody | undefined }) => {
    return postApiV1SdksOtps(arg, options);
  }
}
export const getPostApiV1SdksOtpsMutationKey = () => [`/api/v1/sdks/otps`] as const;

export type PostApiV1SdksOtpsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1SdksOtps>>>

/**
 * @summary Send an OTP
 */
export const usePostApiV1SdksOtps = <TError = Errors>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1SdksOtps>>, TError, Key, PostApiV1SdksOtpsBody | undefined, Awaited<ReturnType<typeof postApiV1SdksOtps>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1SdksOtpsMutationKey();
  const swrFn = getPostApiV1SdksOtpsMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1SdksPartnerResponse200 = {
  data: GetApiV1SdksPartner200
  status: 200
}

export type getApiV1SdksPartnerResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1SdksPartnerResponseSuccess = (getApiV1SdksPartnerResponse200) & {
  headers: Headers;
};
export type getApiV1SdksPartnerResponseError = (getApiV1SdksPartnerResponse401) & {
  headers: Headers;
};

export type getApiV1SdksPartnerResponse = (getApiV1SdksPartnerResponseSuccess | getApiV1SdksPartnerResponseError)

export const getGetApiV1SdksPartnerUrl = () => {




  return `/api/v1/sdks/partner`
}

/**
 * SDK API トークンに紐づくパートナーの識別コードを取得する
 * @summary Three letter code
 */
export const getApiV1SdksPartner = async ( options?: RequestInit): Promise<getApiV1SdksPartnerResponse> => {

  return customInstance<getApiV1SdksPartnerResponse>(getGetApiV1SdksPartnerUrl(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1SdksPartnerKey = () => [`/api/v1/sdks/partner`] as const;

export type GetApiV1SdksPartnerQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1SdksPartner>>>

/**
 * @summary Three letter code
 */
export const useGetApiV1SdksPartner = <TError = Errors>(
   options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1SdksPartner>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1SdksPartnerKey() : null);
  const swrFn = () => getApiV1SdksPartner(requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type getApiV1ThreeLetterCodeSdksUsersVerificationResponse204 = {
  data: void
  status: 204
}

export type getApiV1ThreeLetterCodeSdksUsersVerificationResponse401 = {
  data: Errors
  status: 401
}

export type getApiV1ThreeLetterCodeSdksUsersVerificationResponseSuccess = (getApiV1ThreeLetterCodeSdksUsersVerificationResponse204) & {
  headers: Headers;
};
export type getApiV1ThreeLetterCodeSdksUsersVerificationResponseError = (getApiV1ThreeLetterCodeSdksUsersVerificationResponse401) & {
  headers: Headers;
};

export type getApiV1ThreeLetterCodeSdksUsersVerificationResponse = (getApiV1ThreeLetterCodeSdksUsersVerificationResponseSuccess | getApiV1ThreeLetterCodeSdksUsersVerificationResponseError)

export const getGetApiV1ThreeLetterCodeSdksUsersVerificationUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/sdks/users/verification`
}

/**
 * JWT トークンの有効性および導入企業の有効状態を検証する
 * @summary Verify user
 */
export const getApiV1ThreeLetterCodeSdksUsersVerification = async (threeLetterCode: string, options?: RequestInit): Promise<getApiV1ThreeLetterCodeSdksUsersVerificationResponse> => {

  return customInstance<getApiV1ThreeLetterCodeSdksUsersVerificationResponse>(getGetApiV1ThreeLetterCodeSdksUsersVerificationUrl(threeLetterCode),
  {
    ...options,
    method: 'GET'


  }
);}




export const getGetApiV1ThreeLetterCodeSdksUsersVerificationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/sdks/users/verification`] as const;

export type GetApiV1ThreeLetterCodeSdksUsersVerificationQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeSdksUsersVerification>>>

/**
 * @summary Verify user
 */
export const useGetApiV1ThreeLetterCodeSdksUsersVerification = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getApiV1ThreeLetterCodeSdksUsersVerification>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof customInstance> }
) => {
  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && threeLetterCode !== null && threeLetterCode !== undefined
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetApiV1ThreeLetterCodeSdksUsersVerificationKey(threeLetterCode) : null);
  const swrFn = () => getApiV1ThreeLetterCodeSdksUsersVerification(threeLetterCode, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeSdksUsersResponse200 = {
  data: PostApiV1ThreeLetterCodeSdksUsers200
  status: 200
}

export type postApiV1ThreeLetterCodeSdksUsersResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1ThreeLetterCodeSdksUsersResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeSdksUsersResponse422 = {
  data: Errors
  status: 422
}

export type postApiV1ThreeLetterCodeSdksUsersResponseSuccess = (postApiV1ThreeLetterCodeSdksUsersResponse200) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeSdksUsersResponseError = (postApiV1ThreeLetterCodeSdksUsersResponse400 | postApiV1ThreeLetterCodeSdksUsersResponse401 | postApiV1ThreeLetterCodeSdksUsersResponse422) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeSdksUsersResponse = (postApiV1ThreeLetterCodeSdksUsersResponseSuccess | postApiV1ThreeLetterCodeSdksUsersResponseError)

export const getPostApiV1ThreeLetterCodeSdksUsersUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/sdks/users`
}

/**
 * OTP 検証済みセッションを使用して SDK ユーザーを新規作成し、JWT を発行する
 * @summary Create SDK user
 */
export const postApiV1ThreeLetterCodeSdksUsers = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeSdksUsersBody?: PostApiV1ThreeLetterCodeSdksUsersBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeSdksUsersResponse> => {

  return customInstance<postApiV1ThreeLetterCodeSdksUsersResponse>(getPostApiV1ThreeLetterCodeSdksUsersUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeSdksUsersBody)
  }
);}




export const getPostApiV1ThreeLetterCodeSdksUsersMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeSdksUsersBody | undefined }) => {
    return postApiV1ThreeLetterCodeSdksUsers(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeSdksUsersMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/sdks/users`] as const;

export type PostApiV1ThreeLetterCodeSdksUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeSdksUsers>>>

/**
 * @summary Create SDK user
 */
export const usePostApiV1ThreeLetterCodeSdksUsers = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeSdksUsers>>, TError, Key, PostApiV1ThreeLetterCodeSdksUsersBody | undefined, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeSdksUsers>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeSdksUsersMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeSdksUsersMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1SlackClientApplicationInteractionsResponse200 = {
  data: void
  status: 200
}

export type postApiV1SlackClientApplicationInteractionsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1SlackClientApplicationInteractionsResponseSuccess = (postApiV1SlackClientApplicationInteractionsResponse200) & {
  headers: Headers;
};
export type postApiV1SlackClientApplicationInteractionsResponseError = (postApiV1SlackClientApplicationInteractionsResponse401) & {
  headers: Headers;
};

export type postApiV1SlackClientApplicationInteractionsResponse = (postApiV1SlackClientApplicationInteractionsResponseSuccess | postApiV1SlackClientApplicationInteractionsResponseError)

export const getPostApiV1SlackClientApplicationInteractionsUrl = () => {




  return `/api/v1/slack/client_application_interactions`
}

/**
 * 申込(ClientApplication)の承認/却下ボタン(block_actions)のクリックを受け取る受け口。
 * Slack は実際には application/x-www-form-urlencoded で payload フィールドを送るが、
 * 署名検証は生ボディの HMAC のみに依存するため形式は問わない。
 * @summary Receive Slack client application interactivity (block_actions)
 */
export const postApiV1SlackClientApplicationInteractions = async (postApiV1SlackClientApplicationInteractionsBody: PostApiV1SlackClientApplicationInteractionsBody, options?: RequestInit): Promise<postApiV1SlackClientApplicationInteractionsResponse> => {

  return customInstance<postApiV1SlackClientApplicationInteractionsResponse>(getPostApiV1SlackClientApplicationInteractionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1SlackClientApplicationInteractionsBody)
  }
);}




export const getPostApiV1SlackClientApplicationInteractionsMutationFetcher = ( options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1SlackClientApplicationInteractionsBody }) => {
    return postApiV1SlackClientApplicationInteractions(arg, options);
  }
}
export const getPostApiV1SlackClientApplicationInteractionsMutationKey = () => [`/api/v1/slack/client_application_interactions`] as const;

export type PostApiV1SlackClientApplicationInteractionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1SlackClientApplicationInteractions>>>

/**
 * @summary Receive Slack client application interactivity (block_actions)
 */
export const usePostApiV1SlackClientApplicationInteractions = <TError = Errors>(
   options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1SlackClientApplicationInteractions>>, TError, Key, PostApiV1SlackClientApplicationInteractionsBody, Awaited<ReturnType<typeof postApiV1SlackClientApplicationInteractions>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1SlackClientApplicationInteractionsMutationKey();
  const swrFn = getPostApiV1SlackClientApplicationInteractionsMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsResponse202 = {
  data: PostApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletions202
  status: 202
}

export type postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsResponse401 = {
  data: Errors
  status: 401
}

export type postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsResponseSuccess = (postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsResponse202) & {
  headers: Headers;
};
export type postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsResponseError = (postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsResponse401) & {
  headers: Headers;
};

export type postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsResponse = (postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsResponseSuccess | postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsResponseError)

export const getPostApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsUrl = (threeLetterCode: string,) => {




  return `/api/v1/${threeLetterCode}/webhooks/giftee_store_users/registration_completions`
}

/**
 * Gifteeストアユーザー登録完了CSVのS3キーを受け取り、非同期で取り込み処理を開始する
 * @summary Notify registration completed CSV key
 */
export const postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletions = async (threeLetterCode: string,
    postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsBody: PostApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsBody, options?: RequestInit): Promise<postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsResponse> => {

  return customInstance<postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsResponse>(getPostApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsUrl(threeLetterCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsBody)
  }
);}




export const getPostApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsMutationFetcher = (threeLetterCode: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsBody }) => {
    return postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletions(threeLetterCode, arg, options);
  }
}
export const getPostApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsMutationKey = (threeLetterCode: string,) => [`/api/v1/${threeLetterCode}/webhooks/giftee_store_users/registration_completions`] as const;

export type PostApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletions>>>

/**
 * @summary Notify registration completed CSV key
 */
export const usePostApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletions = <TError = Errors>(
  threeLetterCode: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletions>>, TError, Key, PostApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsBody, Awaited<ReturnType<typeof postApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletions>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsMutationKey(threeLetterCode);
  const swrFn = getPostApiV1ThreeLetterCodeWebhooksGifteeStoreUsersRegistrationCompletionsMutationFetcher(threeLetterCode, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export type postApiV1WebhooksStripeAccountResponse200 = {
  data: void
  status: 200
}

export type postApiV1WebhooksStripeAccountResponse400 = {
  data: Errors
  status: 400
}

export type postApiV1WebhooksStripeAccountResponse404 = {
  data: void
  status: 404
}

export type postApiV1WebhooksStripeAccountResponseSuccess = (postApiV1WebhooksStripeAccountResponse200) & {
  headers: Headers;
};
export type postApiV1WebhooksStripeAccountResponseError = (postApiV1WebhooksStripeAccountResponse400 | postApiV1WebhooksStripeAccountResponse404) & {
  headers: Headers;
};

export type postApiV1WebhooksStripeAccountResponse = (postApiV1WebhooksStripeAccountResponseSuccess | postApiV1WebhooksStripeAccountResponseError)

export const getPostApiV1WebhooksStripeAccountUrl = (account: string,) => {




  return `/api/v1/webhooks/stripe/${account}`
}

/**
 * Stripe Webhook の受け口。企業/従業員でアカウント（＝署名シークレット）が分かれるため account ごとに別 URL で受ける。
 * 署名検証（Stripe-Signature）が認証を兼ね、通常認証・three_letter_code を持たない。署名検証 →
 * (account, event.id) での冪等記録 → payload の metadata.three_letter_code でテナントを解決 → ジョブ投入、を行う。
 * 未知テナントや冪等済みイベントも副作用なく 200 を返す（Stripe のリトライを誘発しないため）。未知/未設定 account は 404。
 * @summary Receive a Stripe webhook event
 */
export const postApiV1WebhooksStripeAccount = async (account: string,
    postApiV1WebhooksStripeAccountBody: PostApiV1WebhooksStripeAccountBody, options?: RequestInit): Promise<postApiV1WebhooksStripeAccountResponse> => {

  return customInstance<postApiV1WebhooksStripeAccountResponse>(getPostApiV1WebhooksStripeAccountUrl(account),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiV1WebhooksStripeAccountBody)
  }
);}




export const getPostApiV1WebhooksStripeAccountMutationFetcher = (account: string, options?: SecondParameter<typeof customInstance>) => {
  return (_: Key, { arg }: { arg: PostApiV1WebhooksStripeAccountBody }) => {
    return postApiV1WebhooksStripeAccount(account, arg, options);
  }
}
export const getPostApiV1WebhooksStripeAccountMutationKey = (account: string,) => [`/api/v1/webhooks/stripe/${account}`] as const;

export type PostApiV1WebhooksStripeAccountMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1WebhooksStripeAccount>>>

/**
 * @summary Receive a Stripe webhook event
 */
export const usePostApiV1WebhooksStripeAccount = <TError = Errors | void>(
  account: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof postApiV1WebhooksStripeAccount>>, TError, Key, PostApiV1WebhooksStripeAccountBody, Awaited<ReturnType<typeof postApiV1WebhooksStripeAccount>>> & { swrKey?: string }, request?: SecondParameter<typeof customInstance>}
) => {

  const {swr: swrOptions, request: requestOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPostApiV1WebhooksStripeAccountMutationKey(account);
  const swrFn = getPostApiV1WebhooksStripeAccountMutationFetcher(account, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}
